// Do not change this file, it is managed by the original file in the backend repo `jonni-backend/shared`
import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { amplifyFetcher } from '@jonni/shared/graphql/amplifyFetcher';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
};

export type As_coords = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type As_pdfData = {
  pdfTextCoords: Array<InputMaybe<Array<InputMaybe<As_textCoords>>>>;
  pdfType: Scalars['String']['input'];
};

export type As_textCoords = {
  coords: As_coords;
  text: Scalars['String']['input'];
};

export type AccountantSignTaxAuthorityAndBituahLeumiDocumentsInput = {
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
};

export type AccountantSignTaxAuthorityAndBituahLeumiDocumentsOutput = {
  __typename: 'AccountantSignTaxAuthorityAndBituahLeumiDocumentsOutput';
  data: Scalars['Boolean']['output'];
};

export type AccountantSignVatBusinessCreationDocumentInput = {
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
};

export type AccountantSignVatBusinessCreationDocumentOutput = {
  __typename: 'AccountantSignVatBusinessCreationDocumentOutput';
  data: Scalars['Boolean']['output'];
};

export enum ActivitiesTabs {
  ALL = 'ALL',
  EXPENSES = 'EXPENSES',
  INCOMES = 'INCOMES'
}

export type AddCreditsInput = {
  credits: Scalars['Float']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  type: CreditTypeEnum;
  userId: Scalars['ID']['input'];
};

export type AddCreditsOutput = {
  __typename: 'AddCreditsOutput';
  creditType: CreditTypeEnum;
  credits: Scalars['Float']['output'];
  userId: Scalars['ID']['output'];
};

export type AddDiscountPhoneNumberInput = {
  mobile: Scalars['String']['input'];
  planType?: InputMaybe<PlanType>;
  planTypeFree?: InputMaybe<PlanType>;
};

export type AddDiscountPhoneNumberOutput = {
  __typename: 'AddDiscountPhoneNumberOutput';
  mobile: Scalars['String']['output'];
  planType?: Maybe<PlanType>;
  planTypeFree?: Maybe<PlanType>;
};

export type AddNewStaffInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<StaffTypes>;
};

export type AddNewStaffOutput = {
  __typename: 'AddNewStaffOutput';
  data: Scalars['Boolean']['output'];
};

export type AnnualReportFieldFileBase64ContentsOutput = {
  __typename: 'AnnualReportFieldFileBase64ContentsOutput';
  base64FileContents: Scalars['String']['output'];
};

export type AnnualReportFieldsFilesMap = {
  __typename: 'AnnualReportFieldsFilesMap';
  fileNames: Array<Scalars['String']['output']>;
  formFieldPath: Scalars['String']['output'];
};

export type AnnualReportForList = {
  __typename: 'AnnualReportForList';
  businessId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastBusinessInteractionAt?: Maybe<Scalars['String']['output']>;
  status: AnnualReportStatus;
  year: Scalars['Int']['output'];
};

export type AnnualReportGetOneInput = {
  businessId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type AnnualReportListBoInput = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AnnualReportStatus>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type AnnualReportListMobileInput = {
  businessId: Scalars['ID']['input'];
};

export type AnnualReportListOutput = {
  __typename: 'AnnualReportListOutput';
  items: Array<AnnualReportForList>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type AnnualReportRecord = {
  __typename: 'AnnualReportRecord';
  businessId: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  formBo?: Maybe<Scalars['AWSJSON']['output']>;
  formMobile?: Maybe<Scalars['AWSJSON']['output']>;
  id: Scalars['ID']['output'];
  lockedAt?: Maybe<Scalars['String']['output']>;
  lockedBy?: Maybe<Scalars['String']['output']>;
  status: AnnualReportStatus;
  year: Scalars['Int']['output'];
};

export type AnnualReportRemoveFieldFileBoInput = {
  businessId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  formFieldPath: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type AnnualReportRemoveFieldFileMobileInput = {
  businessId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  formFieldPath: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type AnnualReportReviewAnnualReportBoInput = {
  businessId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
  status: AnnualReportStatus;
  year: Scalars['Int']['input'];
};

export type AnnualReportSpecificFieldFileMobileInput = {
  businessId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  formFieldPath: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export enum AnnualReportStatus {
  ACCOUNTANT_APPROVED = 'ACCOUNTANT_APPROVED',
  AUTHORITIES_REPORTED = 'AUTHORITIES_REPORTED',
  BUSINESS_DRAFT = 'BUSINESS_DRAFT',
  INITIALIZED = 'INITIALIZED',
  PENDING_ACCOUNTANT_REVIEW = 'PENDING_ACCOUNTANT_REVIEW',
  PENDING_BUSINESS_RESPONSE = 'PENDING_BUSINESS_RESPONSE'
}

export type AnnualReportSuccessBooleanOutput = {
  __typename: 'AnnualReportSuccessBooleanOutput';
  success: Scalars['Boolean']['output'];
};

export type AnnualReportUploadFieldFileBoInput = {
  base64FileContents: Scalars['String']['input'];
  businessId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  formFieldPath: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type AnnualReportUploadFieldFileMobileInput = {
  base64FileContents: Scalars['String']['input'];
  businessId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  formFieldPath: Scalars['String']['input'];
  year: Scalars['Int']['input'];
};

export type AnnualReportUploadFieldFileOutput = {
  __typename: 'AnnualReportUploadFieldFileOutput';
  newFileName: Scalars['String']['output'];
};

export type AnnualReportValidateAndSubmitFormBoInput = {
  businessId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type AnnualReportValidateAndSubmitFormMobileInput = {
  businessId: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};

export type AnnualReportValidateAndSubmitStepsBoInput = {
  businessId: Scalars['ID']['input'];
  formInput: Scalars['AWSJSON']['input'];
  year: Scalars['Int']['input'];
};

export type AnnualReportValidateAndSubmitStepsMobileInput = {
  businessId: Scalars['ID']['input'];
  formInput: Scalars['AWSJSON']['input'];
  year: Scalars['Int']['input'];
};

export type AnnualReportWithFilesBoOutput = {
  __typename: 'AnnualReportWithFilesBoOutput';
  businessId: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  fieldsFilesMap: Array<AnnualReportFieldsFilesMap>;
  formBo?: Maybe<Scalars['AWSJSON']['output']>;
  formMobile?: Maybe<Scalars['AWSJSON']['output']>;
  id: Scalars['ID']['output'];
  lastBusinessInteractionAt?: Maybe<Scalars['String']['output']>;
  lockedAt?: Maybe<Scalars['String']['output']>;
  lockedBy?: Maybe<Scalars['String']['output']>;
  status: AnnualReportStatus;
  year: Scalars['Int']['output'];
};

export type AnnualReportWithFilesMobileOutput = {
  __typename: 'AnnualReportWithFilesMobileOutput';
  businessId: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  fieldsFilesMap: Array<AnnualReportFieldsFilesMap>;
  formMobile?: Maybe<Scalars['AWSJSON']['output']>;
  id: Scalars['ID']['output'];
  lastBusinessInteractionAt?: Maybe<Scalars['String']['output']>;
  lockedAt?: Maybe<Scalars['String']['output']>;
  lockedBy?: Maybe<Scalars['String']['output']>;
  status: AnnualReportStatus;
  year: Scalars['Int']['output'];
};

export type ApproveBusinessExpenseData = {
  __typename: 'ApproveBusinessExpenseData';
  id: Scalars['ID']['output'];
  isDuplicate: Scalars['Boolean']['output'];
};

export type ApproveBusinessExpenseInput = {
  businessId: Scalars['ID']['input'];
  checkDuplicate: Scalars['Boolean']['input'];
  currency: Scalars['String']['input'];
  currencyRate: Scalars['Float']['input'];
  deductedTax: Scalars['Float']['input'];
  deductedVat: Scalars['Float']['input'];
  expenseDate: Scalars['String']['input'];
  expenseId: Scalars['ID']['input'];
  expenseNumber: Scalars['String']['input'];
  expenseTotalAmount: Scalars['Float']['input'];
  expenseType: Scalars['String']['input'];
  isToUpdateWithoutApproval: Scalars['Boolean']['input'];
  items: Array<BusinessExpenseItemInput>;
  price: Scalars['Float']['input'];
  priceIncludingVat: Scalars['Float']['input'];
  providerId: Scalars['ID']['input'];
  vat: Scalars['Float']['input'];
};

export type ApproveBusinessExpenseOutput = {
  __typename: 'ApproveBusinessExpenseOutput';
  data: ApproveBusinessExpenseData;
  status: OperationStatus;
};

export type ApproveBusinessInput = {
  advancePercentage?: InputMaybe<Scalars['Float']['input']>;
  bituahLeumiType: BusinessBituahLeumiType;
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
};

export type ApproveBusinessOutput = {
  __typename: 'ApproveBusinessOutput';
  data: Scalars['Boolean']['output'];
};

export type ApproveRepresentationInput = {
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
};

export type ApproveRepresentationOutput = {
  __typename: 'ApproveRepresentationOutput';
  data: Scalars['Boolean']['output'];
};

export type ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsInput = {
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
};

export type ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsOutput = {
  __typename: 'ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsOutput';
  data: Scalars['Boolean']['output'];
};

export type ApproveSignaturesOnVatBusinessCreationDocumentInput = {
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
};

export type ApproveSignaturesOnVatBusinessCreationDocumentOutput = {
  __typename: 'ApproveSignaturesOnVatBusinessCreationDocumentOutput';
  data: Scalars['Boolean']['output'];
};

export type AutoSignInput = {
  base64Image: Scalars['String']['input'];
  businessId: Scalars['String']['input'];
  pdfsData: Array<As_pdfData>;
  stage: Scalars['String']['input'];
};

export type AutoSignOutput = {
  __typename: 'AutoSignOutput';
  data: Array<PdfDataOutput>;
};

export enum AverageWorkingHoursOptions {
  HOURS_1_11 = 'HOURS_1_11',
  HOURS_12_19 = 'HOURS_12_19',
  HOURS_20PLUS = 'HOURS_20PLUS'
}

export type BankDetails = {
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankBranch?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Translations>;
};

export enum BankDocumentType {
  ACCOUNT_OWNERSHIP = 'ACCOUNT_OWNERSHIP',
  CANCELLED_CHECK = 'CANCELLED_CHECK'
}

export enum BillingsChartOrder {
  MAX = 'MAX',
  ONE_YEAR = 'ONE_YEAR',
  YTD = 'YTD'
}

export type Business = {
  __typename: 'Business';
  accountantId?: Maybe<Scalars['ID']['output']>;
  accountantRepresentation?: Maybe<BusinessAccountantRepresentationType>;
  advanceTaxRate?: Maybe<Scalars['Float']['output']>;
  approvalStatus?: Maybe<BusinessApprovalStatus>;
  approvedAt?: Maybe<Scalars['String']['output']>;
  bankDetails?: Maybe<Scalars['String']['output']>;
  billings?: Maybe<Array<BusinessBilling>>;
  bituahLeumiPayment: Scalars['Float']['output'];
  businessIndustryId?: Maybe<Scalars['ID']['output']>;
  businessName: Scalars['String']['output'];
  businessNameEn?: Maybe<Scalars['String']['output']>;
  businessSecondaryIndustryId?: Maybe<Scalars['ID']['output']>;
  businessStatus: BusinessStatus;
  businessType: BusinessType;
  canBeBlocked: Scalars['Boolean']['output'];
  cancelledAt?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  cityEn?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creditCardBuyerKey?: Maybe<Scalars['String']['output']>;
  creditCardExpiration?: Maybe<Scalars['String']['output']>;
  creditCardMask?: Maybe<Scalars['String']['output']>;
  customers?: Maybe<Array<BusinessCustomer>>;
  exemption?: Maybe<BusinessExemption>;
  expectedMonthlyIncome?: Maybe<Scalars['Float']['output']>;
  expenses?: Maybe<Array<BusinessExpense>>;
  id: Scalars['ID']['output'];
  incomeDocumentComments?: Maybe<Scalars['String']['output']>;
  incomes?: Maybe<Array<BusinessIncome>>;
  industry?: Maybe<BusinessIndustry>;
  isEmployee: Scalars['Boolean']['output'];
  isImportDocuments?: Maybe<Scalars['Boolean']['output']>;
  isNewBusiness?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['Boolean']['output']>;
  missingDocuments?: Maybe<MissingDocument>;
  notifications?: Maybe<BusinessNotificationPage>;
  partnerRegistrationNumber?: Maybe<Scalars['String']['output']>;
  paymentIdNumber: Scalars['String']['output'];
  referralId?: Maybe<Scalars['String']['output']>;
  registrationNumber: Scalars['String']['output'];
  reportType?: Maybe<BusinessReportType>;
  reports?: Maybe<Array<BusinessReport>>;
  representationRequestNumber?: Maybe<Scalars['String']['output']>;
  secondaryIndustry?: Maybe<BusinessIndustry>;
  streetAddress: Scalars['String']['output'];
  taoaAccessTokenExpiresTime?: Maybe<Scalars['String']['output']>;
  taoaLastAuthenticationTime?: Maybe<Scalars['String']['output']>;
  taoaRefreshTokenExpiresTime?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
};


export type BusinessBillingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type BusinessCustomersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type BusinessNotificationsArgs = {
  input?: InputMaybe<GetNotificationsInput>;
};

export enum BusinessAccountantRepresentationType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export type BusinessActivity = {
  __typename: 'BusinessActivity';
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencyRate?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceIncludingVat?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum BusinessApprovalStatus {
  BUSINESS_APPROVED = 'BUSINESS_APPROVED',
  DIN_VE_HESHBON_COMPLETED = 'DIN_VE_HESHBON_COMPLETED',
  DIN_VE_HESHBON_NEEDED = 'DIN_VE_HESHBON_NEEDED',
  MISSING_DOCUMENTS_BUSINESS_NEEDED = 'MISSING_DOCUMENTS_BUSINESS_NEEDED',
  ONBOARDING_COMPLETED = 'ONBOARDING_COMPLETED',
  REPRESENTATION_APPROVED = 'REPRESENTATION_APPROVED',
  TAX_AUTHORITY_AND_BITUAH_LEUMI_DOCUMENTS_ACCOUNTANT_SIGNED = 'TAX_AUTHORITY_AND_BITUAH_LEUMI_DOCUMENTS_ACCOUNTANT_SIGNED',
  TAX_AUTHORITY_AND_BITUAH_LEUMI_DOCUMENTS_BUSINESS_SIGNED = 'TAX_AUTHORITY_AND_BITUAH_LEUMI_DOCUMENTS_BUSINESS_SIGNED',
  TAX_AUTHORITY_AND_BITUAH_LEUMI_DOCUMENTS_UPLOAD_UNSIGNED = 'TAX_AUTHORITY_AND_BITUAH_LEUMI_DOCUMENTS_UPLOAD_UNSIGNED',
  TAX_AUTHORITY_DOCUMENTS_SIGNATURES_APPROVED = 'TAX_AUTHORITY_DOCUMENTS_SIGNATURES_APPROVED',
  VAT_BUSINESS_CREATION_DOCUMENT_ACCOUNTANT_SIGNED = 'VAT_BUSINESS_CREATION_DOCUMENT_ACCOUNTANT_SIGNED',
  VAT_BUSINESS_CREATION_DOCUMENT_BUSINESS_SIGNED = 'VAT_BUSINESS_CREATION_DOCUMENT_BUSINESS_SIGNED',
  VAT_BUSINESS_CREATION_DOCUMENT_SIGNATURES_APPROVED = 'VAT_BUSINESS_CREATION_DOCUMENT_SIGNATURES_APPROVED',
  VAT_BUSINESS_CREATION_DOCUMENT_UPLOAD_UNSIGNED = 'VAT_BUSINESS_CREATION_DOCUMENT_UPLOAD_UNSIGNED'
}

export type BusinessBilling = {
  __typename: 'BusinessBilling';
  billingStatus: BusinessBillingStatus;
  business: Business;
  businessId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  datePaid?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  expenseId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  paymeSaleAuthNumber?: Maybe<Scalars['String']['output']>;
  paymeSaleId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  startDate: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum BusinessBillingStatus {
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  IGNORED = 'IGNORED',
  PAID = 'PAID',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  PENDING_REFUND = 'PENDING_REFUND',
  REFUNDED = 'REFUNDED'
}

export type BusinessBillingsChartDataInput = {
  billingsChartOrder: BillingsChartOrder;
};

export type BusinessBillingsChartDataOutput = {
  __typename: 'BusinessBillingsChartDataOutput';
  countFaild?: Maybe<Array<Scalars['Int']['output']>>;
  date?: Maybe<Array<Scalars['String']['output']>>;
  totalFaild?: Maybe<Array<Scalars['Float']['output']>>;
  totalIncomes?: Maybe<Array<Scalars['Float']['output']>>;
  totalPaid?: Maybe<Array<Scalars['Float']['output']>>;
};

export type BusinessBillingsDataByDateInput = {
  date: Scalars['String']['input'];
};

export type BusinessBillingsDataByDateOutput = {
  __typename: 'BusinessBillingsDataByDateOutput';
  countFaild: Scalars['Int']['output'];
  totalFaild: Scalars['Float']['output'];
  totalIncomes: Scalars['Float']['output'];
  totalPaid: Scalars['Float']['output'];
  totalRefunded: Scalars['Float']['output'];
};

export type BusinessBillingsTable = {
  __typename: 'BusinessBillingsTable';
  businessId: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
};

export type BusinessBillingsTableByDate = {
  __typename: 'BusinessBillingsTableByDate';
  business: BusinessBillingsTable;
  totalOwed: Scalars['Float']['output'];
};

export type BusinessBillingsTableByDateInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessBillingsTableByDateOutput = {
  __typename: 'BusinessBillingsTableByDateOutput';
  items?: Maybe<Array<BusinessBillingsTableByDate>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BusinessBituahLeumi = {
  __typename: 'BusinessBituahLeumi';
  bituahLeumiPayment: Scalars['Float']['output'];
  bituahLeumiType: BusinessBituahLeumiType;
  endDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reportId: Scalars['ID']['output'];
  startDate: Scalars['String']['output'];
};

export enum BusinessBituahLeumiType {
  OTHER = 'OTHER',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
  SELF_EMPLOYED_NON_QUALIFYING = 'SELF_EMPLOYED_NON_QUALIFYING'
}

export type BusinessCustomer = {
  __typename: 'BusinessCustomer';
  address?: Maybe<Scalars['String']['output']>;
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankBranch?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  businessId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  saved: Scalars['Boolean']['output'];
};

export type BusinessDocument = {
  __typename: 'BusinessDocument';
  lastModified: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type BusinessExemption = {
  __typename: 'BusinessExemption';
  bookKeepingAuthorization?: Maybe<Scalars['Boolean']['output']>;
  bookKeepingAuthorizationEndDate?: Maybe<Scalars['String']['output']>;
  bookKeepingAuthorizationProductionDate?: Maybe<Scalars['String']['output']>;
  bookKeepingAuthorizationStartDate?: Maybe<Scalars['String']['output']>;
  businessId: Scalars['ID']['output'];
  certainWageTypesRate?: Maybe<Scalars['Int']['output']>;
  certificateValidityEndDate?: Maybe<Scalars['String']['output']>;
  certificateValidityStartDate?: Maybe<Scalars['String']['output']>;
  constructionAndTransportationWorksRate?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  insuranceCommissionRate?: Maybe<Scalars['Int']['output']>;
  interestAndCapitalMarketRate?: Maybe<Scalars['Int']['output']>;
  rentPaymentRate?: Maybe<Scalars['Int']['output']>;
  servicesOrPropertiesAndMoreRate?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type BusinessExpense = {
  __typename: 'BusinessExpense';
  accountantId: Scalars['ID']['output'];
  business: Business;
  businessId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  currency: Currency;
  currencyRate: Scalars['Float']['output'];
  deductedTax: Scalars['Float']['output'];
  deductedVat: Scalars['Float']['output'];
  disputeStatus?: Maybe<Scalars['String']['output']>;
  expenseDate: Scalars['String']['output'];
  expenseIndex?: Maybe<Scalars['Int']['output']>;
  expenseNumber?: Maybe<Scalars['String']['output']>;
  expenseStatus: BusinessExpenseStatus;
  expenseTotalAmount?: Maybe<Scalars['Float']['output']>;
  expenseType: BusinessExpenseType;
  geminaJson?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<BusinessExpenseItem>>>;
  paymentType?: Maybe<PaymentMethod>;
  price: Scalars['Float']['output'];
  priceIncludingVat: Scalars['Float']['output'];
  provider?: Maybe<BusinessProvider>;
  providerId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  vat: Scalars['Float']['output'];
  vatType?: Maybe<BusinessExpenseVatType>;
};

export enum BusinessExpenseDisputeStatus {
  CANCEL_BUSINESS = 'CANCEL_BUSINESS',
  DUPLICATED_EXPENSE = 'DUPLICATED_EXPENSE',
  INVALID_DOCUMENT_TYPE = 'INVALID_DOCUMENT_TYPE',
  NOT_DEDUCTABLE = 'NOT_DEDUCTABLE',
  UNCLEAR_DOCUMENT_SCAN = 'UNCLEAR_DOCUMENT_SCAN'
}

export type BusinessExpenseItem = {
  __typename: 'BusinessExpenseItem';
  category?: Maybe<TaxCategory>;
  expenseCategory?: Maybe<Scalars['String']['output']>;
  expenseId: Scalars['ID']['output'];
  expenseItemStatus: BusinessExpenseItemStatus;
  id: Scalars['ID']['output'];
  itemTax: Array<BusinessExpenseItemTax>;
  itemVat: Array<Maybe<BusinessExpenseItemVat>>;
  price: Scalars['Float']['output'];
  priceIncludingVat?: Maybe<Scalars['Float']['output']>;
  taxCategoryNumber: Scalars['Int']['output'];
  taxDeductionPercentage: Scalars['Float']['output'];
  vat?: Maybe<Scalars['Float']['output']>;
  vatType: BusinessExpenseVatType;
};

export type BusinessExpenseItemInput = {
  expenseCategory?: InputMaybe<Scalars['String']['input']>;
  expenseItemStatus: BusinessExpenseItemStatus;
  itemTax: Array<BusinessExpenseItemTaxInput>;
  itemVat?: InputMaybe<Array<InputMaybe<BusinessExpenseItemVatInput>>>;
  price: Scalars['Float']['input'];
  priceIncludingVat: Scalars['Float']['input'];
  taxCategoryNumber: Scalars['String']['input'];
  vat: Scalars['Float']['input'];
  vatType: Scalars['String']['input'];
};

export enum BusinessExpenseItemStatus {
  APPROVED = 'APPROVED',
  DISALLOWED = 'DISALLOWED'
}

export type BusinessExpenseItemTax = {
  __typename: 'BusinessExpenseItemTax';
  deductedTax: Scalars['Float']['output'];
  expenseItemId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  report?: Maybe<BusinessReport>;
  reportId: Scalars['ID']['output'];
  taxDeductionPercentage: Scalars['Float']['output'];
};

export type BusinessExpenseItemTaxInput = {
  deductedTax: Scalars['Float']['input'];
  reportId: Scalars['ID']['input'];
  taxDeductionPercentage: Scalars['Float']['input'];
};

export type BusinessExpenseItemVat = {
  __typename: 'BusinessExpenseItemVat';
  deductedVat: Scalars['Float']['output'];
  expenseItemId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  report?: Maybe<BusinessReport>;
  reportId?: Maybe<Scalars['ID']['output']>;
  vat: Scalars['Float']['output'];
  vatDeductionPercentage: Scalars['Float']['output'];
  vatPercentage?: Maybe<Scalars['Float']['output']>;
};

export type BusinessExpenseItemVatInput = {
  deductedVat: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  report?: InputMaybe<BusinessExpenseItemVatReportInput>;
  vat: Scalars['Float']['input'];
  vatDeductionPercentage: Scalars['Float']['input'];
  vatPercentage: Scalars['Float']['input'];
};

export type BusinessExpenseItemVatReportInput = {
  endDate: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  reportStatus: BusinessReportStatus;
  startDate: Scalars['String']['input'];
};

export enum BusinessExpenseStatus {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  GEMINA_PROCESSING_FAILED = 'GEMINA_PROCESSING_FAILED',
  GEMINA_PROCESSING_IN_PROGRESS = 'GEMINA_PROCESSING_IN_PROGRESS',
  IN_DISPUTE = 'IN_DISPUTE',
  PENDING_ACCOUNTANT_APPROVAL = 'PENDING_ACCOUNTANT_APPROVAL',
  SYSTEM_PROCESSING_FAILED = 'SYSTEM_PROCESSING_FAILED'
}

export enum BusinessExpenseType {
  CREDIT_NOTE = 'CREDIT_NOTE',
  DELIVERY_NOTE = 'DELIVERY_NOTE',
  DONATION_RECEIPT = 'DONATION_RECEIPT',
  PAYMENT_CONFIRMATION = 'PAYMENT_CONFIRMATION',
  RECEIPT = 'RECEIPT',
  RECEIPT_TAX_INVOICE = 'RECEIPT_TAX_INVOICE',
  REFUND_INVOICE = 'REFUND_INVOICE',
  REFUND_INVOICE_RECEIPT = 'REFUND_INVOICE_RECEIPT',
  REFUND_RECEIPT = 'REFUND_RECEIPT',
  REGULAR = 'REGULAR',
  TAX_INVOICE = 'TAX_INVOICE',
  UNCLASSIFIED = 'UNCLASSIFIED'
}

export enum BusinessExpenseVatType {
  REGULAR_VAT = 'REGULAR_VAT',
  VAT_FREE = 'VAT_FREE',
  ZERO_VAT = 'ZERO_VAT'
}

export type BusinessExpensesWithStatusInput = {
  businessId: Scalars['ID']['input'];
  expenseStatus?: InputMaybe<Array<BusinessExpenseStatus>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessFile = {
  __typename: 'BusinessFile';
  lastModified: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type BusinessIncome = {
  __typename: 'BusinessIncome';
  accountantId: Scalars['ID']['output'];
  business: Business;
  businessId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  currencyRate: Scalars['Float']['output'];
  customer: BusinessCustomer;
  customerId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<BusinessMailer>>;
  english?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  incomeDate: Scalars['String']['output'];
  incomeProvider?: Maybe<BusinessIncomeProvider>;
  incomeStatus: BusinessIncomeStatus;
  incomeType: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  items?: Maybe<Array<BusinessIncomeItem>>;
  paymentDueDate?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<BusinessIncomePayment>>;
  price: Scalars['Float']['output'];
  priceIncludingVat: Scalars['Float']['output'];
  reportId?: Maybe<Scalars['ID']['output']>;
  taoaConfirmationNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  vat: Scalars['Float']['output'];
  vatPercentage: Scalars['Float']['output'];
};

export type BusinessIncomeCustomerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum BusinessIncomeImportRange {
  CURRENT_AND_LAST_YEAR = 'CURRENT_AND_LAST_YEAR',
  CURRENT_AND_TWO_LAST_YEARS = 'CURRENT_AND_TWO_LAST_YEARS',
  CURRENT_YEAR = 'CURRENT_YEAR'
}

export type BusinessIncomeItem = {
  __typename: 'BusinessIncomeItem';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  incomeId: Scalars['ID']['output'];
  itemTax: Array<BusinessIncomeItemTax>;
  itemVat: Array<Maybe<BusinessIncomeItemVat>>;
  itemsOrder?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  priceIncludingVat: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  units: Scalars['Float']['output'];
  vat: Scalars['Float']['output'];
  vatType: BusinessIncomeVatType;
};

export type BusinessIncomeItemTax = {
  __typename: 'BusinessIncomeItemTax';
  id?: Maybe<Scalars['ID']['output']>;
  incomeItemId?: Maybe<Scalars['ID']['output']>;
  report?: Maybe<BusinessReport>;
  reportId: Scalars['ID']['output'];
};

export type BusinessIncomeItemVat = {
  __typename: 'BusinessIncomeItemVat';
  id?: Maybe<Scalars['ID']['output']>;
  incomeItemId?: Maybe<Scalars['ID']['output']>;
  report?: Maybe<BusinessReport>;
  reportId?: Maybe<Scalars['ID']['output']>;
  vat: Scalars['Float']['output'];
  vatPercentage?: Maybe<Scalars['Float']['output']>;
};

export type BusinessIncomeItemsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  priceIncludingVat: Scalars['Float']['input'];
  unitPrice: Scalars['Float']['input'];
  units: Scalars['Float']['input'];
  vat: Scalars['Float']['input'];
  vatType: BusinessIncomeVatType;
};

export type BusinessIncomePayment = {
  __typename: 'BusinessIncomePayment';
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankBranch?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  chequeNum?: Maybe<Scalars['String']['output']>;
  creditCardLastDigits?: Maybe<Scalars['String']['output']>;
  creditCardNumberOfPayments?: Maybe<Scalars['Float']['output']>;
  creditCardPaymentType?: Maybe<Scalars['String']['output']>;
  creditCardType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incomeId: Scalars['ID']['output'];
  paymentApp?: Maybe<BusinessIncomePaymentApp>;
  paymentAppDealNumber?: Maybe<Scalars['String']['output']>;
  paymentDate: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  taxDeduction: Scalars['Float']['output'];
};

export enum BusinessIncomePaymentApp {
  BIT = 'BIT',
  PAY = 'PAY',
  PAYBOX = 'PAYBOX'
}

export enum BusinessIncomePaymentCreditCardPaymentType {
  PAYMENTS = 'PAYMENTS',
  REGULAR = 'REGULAR'
}

export enum BusinessIncomePaymentCreditCardType {
  AMERICAN_EXPRESS = 'AMERICAN_EXPRESS',
  DINERS = 'DINERS',
  ISRACARD = 'ISRACARD',
  MASTERCARD = 'MASTERCARD',
  UNKNOWN = 'UNKNOWN',
  VISA = 'VISA'
}

export type BusinessIncomePaymentsInput = {
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankBranch?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  chequeNum?: InputMaybe<Scalars['String']['input']>;
  creditCardLastDigits?: InputMaybe<Scalars['String']['input']>;
  creditCardNumberOfPayments?: InputMaybe<Scalars['Int']['input']>;
  creditCardPaymentType?: InputMaybe<BusinessIncomePaymentCreditCardPaymentType>;
  creditCardType?: InputMaybe<BusinessIncomePaymentCreditCardType>;
  date: Scalars['String']['input'];
  paymentApp?: InputMaybe<BusinessIncomePaymentApp>;
  paymentAppDealNumber?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: PaymentMethod;
  price: Scalars['Float']['input'];
  taxDeduction?: InputMaybe<Scalars['Float']['input']>;
};

export enum BusinessIncomeProvider {
  BOOSTAPP = 'BOOSTAPP',
  CARDCOM = 'CARDCOM',
  CASPITLIGHT = 'CASPITLIGHT',
  EASY_COUNT = 'EASY_COUNT',
  GREENINVOICE = 'GREENINVOICE',
  ICOUNT = 'ICOUNT',
  JONNI = 'JONNI',
  MANUAL = 'MANUAL',
  MESHULAM = 'MESHULAM',
  MONITEX = 'MONITEX',
  MYCOUNT = 'MYCOUNT',
  SUMIT = 'SUMIT',
  VERIFONE = 'VERIFONE',
  WOLT = 'WOLT',
  YAAD_PAY = 'YAAD_PAY',
  YPAY = 'YPAY'
}

export enum BusinessIncomeStatus {
  CANCELLED = 'CANCELLED',
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
  PARTIAL_REFUNDED = 'PARTIAL_REFUNDED',
  PARTIAL_REFUNDED_CLOSED = 'PARTIAL_REFUNDED_CLOSED'
}

export enum BusinessIncomeType {
  PAYMENT_REQUEST = 'PAYMENT_REQUEST',
  RECEIPT = 'RECEIPT',
  RECEIPT_TAX_INVOICE = 'RECEIPT_TAX_INVOICE',
  REFUND_INVOICE = 'REFUND_INVOICE',
  REFUND_INVOICE_RECEIPT = 'REFUND_INVOICE_RECEIPT',
  REFUND_RECEIPT = 'REFUND_RECEIPT',
  TAX_INVOICE = 'TAX_INVOICE'
}

export enum BusinessIncomeVatType {
  REGULAR_VAT = 'REGULAR_VAT',
  VAT_FREE = 'VAT_FREE',
  ZERO_VAT = 'ZERO_VAT'
}

export type BusinessIndustry = {
  __typename: 'BusinessIndustry';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  irsCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type BusinessMailer = {
  __typename: 'BusinessMailer';
  attachments: Array<EmailAttachment>;
  businessId: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  emailSentAt?: Maybe<Scalars['String']['output']>;
  emailStatus: EmailStatus;
  id: Scalars['ID']['output'];
  recipient: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type BusinessNotification = {
  __typename: 'BusinessNotification';
  businessId: Scalars['ID']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  read: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  values: Array<NotificationValues>;
};

export type BusinessNotificationPage = {
  __typename: 'BusinessNotificationPage';
  items?: Maybe<Array<Maybe<BusinessNotification>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type BusinessPaymentRefundInput = {
  incomeId: Scalars['String']['input'];
};

export type BusinessPaymentRefundOutput = {
  __typename: 'BusinessPaymentRefundOutput';
  data?: Maybe<Scalars['Boolean']['output']>;
};

export type BusinessPaymentRequestInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  incomeId: Scalars['String']['input'];
  messageText?: InputMaybe<Scalars['String']['input']>;
  pageField: BusinessPaymentRequestPageFieldInput;
  registrationNumber: Scalars['String']['input'];
  sendingMode: Scalars['Int']['input'];
};

export type BusinessPaymentRequestOutput = {
  __typename: 'BusinessPaymentRequestOutput';
  data?: Maybe<Scalars['String']['output']>;
};

export type BusinessPaymentRequestPageFieldInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type BusinessPaymentResponseInput = {
  body: Scalars['String']['input'];
  headers: Scalars['AWSJSON']['input'];
  isBase64Encoded: Scalars['Boolean']['input'];
  rawPath: Scalars['String']['input'];
  rawQueryString: Scalars['String']['input'];
  requestContext: Scalars['AWSJSON']['input'];
  routeKey: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type BusinessPaymentResponseOutput = {
  __typename: 'BusinessPaymentResponseOutput';
  data?: Maybe<Scalars['Boolean']['output']>;
};

export type BusinessProvider = {
  __typename: 'BusinessProvider';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isIsraelProvider: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  source: BusinessProviderSource;
  updatedAt: Scalars['String']['output'];
};

export enum BusinessProviderSource {
  ACCOUNTANT = 'ACCOUNTANT',
  API = 'API',
  GEMINA = 'GEMINA',
  MANUAL = 'MANUAL'
}

export type BusinessRecentIncomeItem = {
  __typename: 'BusinessRecentIncomeItem';
  description: Scalars['String']['output'];
  unitPrice: Scalars['String']['output'];
};

export type BusinessReport = {
  __typename: 'BusinessReport';
  advanceTaxPercentage?: Maybe<Scalars['Float']['output']>;
  advanceTaxRate?: Maybe<Scalars['Float']['output']>;
  advancedPaymentAmount?: Maybe<Scalars['Float']['output']>;
  bituahLeumiPayments?: Maybe<Array<BusinessBituahLeumi>>;
  business: Business;
  businessApprovedAt?: Maybe<Scalars['String']['output']>;
  businessId: Scalars['ID']['output'];
  businessType?: Maybe<BusinessType>;
  calculatedAdvancePayments?: Maybe<Scalars['Float']['output']>;
  chargeableBusinessIncome?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  deductedWithheldTax?: Maybe<Scalars['Float']['output']>;
  endDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isThereVatReportForCurrentYear: Scalars['Boolean']['output'];
  pendingApprovalExpenses: Scalars['Int']['output'];
  remainWithheldTax?: Maybe<Scalars['Float']['output']>;
  reportId: Scalars['ID']['output'];
  reportName: Scalars['String']['output'];
  reportStatus: BusinessReportStatus;
  reportType: BusinessReportType;
  startDate: Scalars['String']['output'];
  sumOfBusinessTurnover?: Maybe<Scalars['Float']['output']>;
  sumOfExpensesAfterVatDeductions?: Maybe<Scalars['Float']['output']>;
  sumOfExpensesIncludingVat?: Maybe<Scalars['Float']['output']>;
  sumOfExpensesWithoutVat?: Maybe<Scalars['Float']['output']>;
  sumOfIncomesExemptOfVat?: Maybe<Scalars['Float']['output']>;
  sumOfIncomesExemptOfVatOrZeroVat?: Maybe<Scalars['Float']['output']>;
  sumOfIncomesIncludingVat?: Maybe<Scalars['Float']['output']>;
  sumOfIncomesLiabledToVat?: Maybe<Scalars['Float']['output']>;
  sumOfIncomesWithZeroVat?: Maybe<Scalars['Float']['output']>;
  sumOfInputsOnFixedEquipment?: Maybe<Scalars['Float']['output']>;
  sumOfInputsOnOtherExpenses?: Maybe<Scalars['Float']['output']>;
  sumOfPermittedExpenseDeductions?: Maybe<Scalars['Float']['output']>;
  sumOfVatAmountOnIncomes?: Maybe<Scalars['Float']['output']>;
  sumOfVatInExpenses?: Maybe<Scalars['Float']['output']>;
  sumOfVatPayment?: Maybe<Scalars['Float']['output']>;
  taoaReference?: Maybe<Scalars['String']['output']>;
  taxYear?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
  vatReportId?: Maybe<Scalars['ID']['output']>;
  withheldTax?: Maybe<Scalars['Float']['output']>;
};

export enum BusinessReportStatus {
  ACTIVE = 'ACTIVE',
  AUTHORITIES_REPORTED = 'AUTHORITIES_REPORTED',
  BUSINESS_APPROVED = 'BUSINESS_APPROVED',
  BUSINESS_DECLINED = 'BUSINESS_DECLINED',
  NO_NEED_TO_REPORT = 'NO_NEED_TO_REPORT',
  PENDING_ACCOUNTANT_REVIEW = 'PENDING_ACCOUNTANT_REVIEW',
  PENDING_BUSINESS_RESPONSE = 'PENDING_BUSINESS_RESPONSE'
}

export enum BusinessReportType {
  BI_MONTHLY = 'BI_MONTHLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}

export type BusinessReportsFilterInput = {
  businessId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportName?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessSetup = {
  __typename: 'BusinessSetup';
  businessType: BusinessSetupBusinessType;
  createdAt?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasAccountant: Scalars['Boolean']['output'];
  hasBusiness: Scalars['Boolean']['output'];
  hasEmployees: Scalars['Boolean']['output'];
  invitationSent: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mobile: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum BusinessSetupBusinessType {
  LTD = 'LTD',
  MURSHE = 'MURSHE',
  PATUR = 'PATUR'
}

export type BusinessSignTaxAuthorityAndBituahLeumiDocumentsInput = {
  base64Image: Scalars['String']['input'];
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
  draftPhase: Scalars['Boolean']['input'];
};

export type BusinessSignTaxAuthorityAndBituahLeumiDocumentsOutput = {
  __typename: 'BusinessSignTaxAuthorityAndBituahLeumiDocumentsOutput';
  data: Scalars['Boolean']['output'];
};

export type BusinessSignVatBusinessCreationDocumentInput = {
  base64Image: Scalars['String']['input'];
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
  draftPhase: Scalars['Boolean']['input'];
};

export type BusinessSignVatBusinessCreationDocumentOutput = {
  __typename: 'BusinessSignVatBusinessCreationDocumentOutput';
  data: Scalars['Boolean']['output'];
};

export type BusinessStatistics = {
  __typename: 'BusinessStatistics';
  totalBilled: Scalars['Float']['output'];
};

export enum BusinessStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  CANCELLED = 'CANCELLED',
  ON_HOLD = 'ON_HOLD',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  REGISTRATION_UNCOMPLETE = 'REGISTRATION_UNCOMPLETE'
}

export type BusinessStatusCounters = {
  __typename: 'BusinessStatusCounters';
  ACTIVE?: Maybe<Scalars['Int']['output']>;
  ALL?: Maybe<Scalars['Int']['output']>;
  BEFORE_PENDING_APPROVAL?: Maybe<Scalars['Int']['output']>;
  BILLING_DETAILS?: Maybe<Scalars['Int']['output']>;
  BLOCKED?: Maybe<Scalars['Int']['output']>;
  CANCELLED?: Maybe<Scalars['Int']['output']>;
  ON_HOLD?: Maybe<Scalars['Int']['output']>;
  PENDING_APPROVAL?: Maybe<Scalars['Int']['output']>;
  REGISTRATION_UNCOMPLETE?: Maybe<Scalars['Int']['output']>;
};

export type BusinessSubscription = {
  __typename: 'BusinessSubscription';
  businessId: Scalars['ID']['output'];
  cancelled: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startDate: Scalars['String']['output'];
  subscriptionPlan?: Maybe<BusinessSubscriptionPlan>;
  subscriptionPlanId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export type BusinessSubscriptionConverterInput = {
  businessId: Scalars['ID']['input'];
  isToCreateBilling: Scalars['Boolean']['input'];
  toPlanType: PlanType;
  toPlanTypeFree?: InputMaybe<PlanType>;
};

export type BusinessSubscriptionConverterOutput = {
  __typename: 'BusinessSubscriptionConverterOutput';
  data: Scalars['Boolean']['output'];
};

export type BusinessSubscriptionPlan = {
  __typename: 'BusinessSubscriptionPlan';
  businessType?: Maybe<BusinessType>;
  discountPercentage: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  planType: PlanType;
  price: Scalars['Float']['output'];
  printName: Scalars['String']['output'];
  termInMonth?: Maybe<Scalars['Int']['output']>;
};

export enum BusinessType {
  MURSHE = 'MURSHE',
  PATUR = 'PATUR'
}

export type BusinessTypeConverterInput = {
  businessId: Scalars['ID']['input'];
  conversionDate: Scalars['String']['input'];
  toBusinessType: BusinessType;
};

export type BusinessTypeConverterOutput = {
  __typename: 'BusinessTypeConverterOutput';
  data: Scalars['Boolean']['output'];
};

export type BusinessUploadMissingDocumentsInput = {
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
};

export type BusinessUploadMissingDocumentsOutput = {
  __typename: 'BusinessUploadMissingDocumentsOutput';
  data: Scalars['Boolean']['output'];
};

export enum CalculationBusinessReportError {
  INVALID_BUSINESS = 'INVALID_BUSINESS',
  INVALID_BUSINESS_STATUS = 'INVALID_BUSINESS_STATUS',
  INVALID_REPORT_STATUS = 'INVALID_REPORT_STATUS'
}

export type CalculationBusinessReportInput = {
  businessId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};

export type CalculationBusinessReportOutput = {
  __typename: 'CalculationBusinessReportOutput';
  error?: Maybe<CalculationBusinessReportError>;
  success: Scalars['Boolean']['output'];
};

export type CanBeBlockedInput = {
  businessId: Scalars['ID']['input'];
};

export type CanBeBlockedOutput = {
  __typename: 'CanBeBlockedOutput';
  data: Scalars['Boolean']['output'];
};

export enum CancelBusinessError {
  EXPENSES_PENDING_APPROVAL = 'EXPENSES_PENDING_APPROVAL',
  INVALID_BUSINESS_STATUS = 'INVALID_BUSINESS_STATUS',
  REPORTS_PENDING_APPROVAL = 'REPORTS_PENDING_APPROVAL'
}

export type CancelBusinessInput = {
  businessId: Scalars['ID']['input'];
};

export type CancelBusinessOutput = {
  __typename: 'CancelBusinessOutput';
  error?: Maybe<CancelBusinessError>;
  success: Scalars['Boolean']['output'];
};

export type ChargeFailedBusinessBillingInput = {
  billingId: Scalars['ID']['input'];
};

export type ChargeFailedBusinessBillingMobileInput = {
  businessId: Scalars['ID']['input'];
};

export type ChargeFailedBusinessBillingMobileOutput = {
  __typename: 'ChargeFailedBusinessBillingMobileOutput';
  data: Scalars['Boolean']['output'];
};

export type CloseBusinessReportInput = {
  reportId: Scalars['ID']['input'];
  toReportStatus: Scalars['String']['input'];
};

export type CloseBusinessReportOutput = {
  __typename: 'CloseBusinessReportOutput';
  businessId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  reportStatus: BusinessReportStatus;
};

export type CompanySubscriptionPlan = {
  __typename: 'CompanySubscriptionPlan';
  cancelled: Scalars['Boolean']['output'];
  companyName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  planType?: Maybe<Scalars['String']['output']>;
  planTypeFree?: Maybe<Scalars['String']['output']>;
  referralId: Scalars['String']['output'];
  subscriptionPlanDiscountMursheId?: Maybe<Scalars['ID']['output']>;
  subscriptionPlanDiscountPaturId?: Maybe<Scalars['ID']['output']>;
  subscriptionPlanFreeId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type CreateBusinessExpenseInput = {
  businessId: Scalars['String']['input'];
  expense: Scalars['String']['input'];
};

export type CreateBusinessExpenseOutput = {
  __typename: 'CreateBusinessExpenseOutput';
  expenseId: Scalars['String']['output'];
};

export type CreateBusinessIncomeInput = {
  base64Pdf?: InputMaybe<Scalars['String']['input']>;
  businessId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  customer?: InputMaybe<BusinessIncomeCustomerInput>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  date: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  growTransactionId?: InputMaybe<Scalars['String']['input']>;
  growTransactionToken?: InputMaybe<Scalars['String']['input']>;
  incomeDocumentComments?: InputMaybe<DocumentComments>;
  incomeProvider: Scalars['String']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  items: Array<InputMaybe<BusinessIncomeItemsInput>>;
  parentIncomeId?: InputMaybe<Scalars['ID']['input']>;
  paymentDueDate?: InputMaybe<Scalars['String']['input']>;
  payments: Array<InputMaybe<BusinessIncomePaymentsInput>>;
  pdfLanguage?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  priceIncludingVat: Scalars['Float']['input'];
  saveCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  taxDeduction?: InputMaybe<Scalars['Float']['input']>;
  type: BusinessIncomeType;
  vat: Scalars['Float']['input'];
};

export type CreateBusinessIncomeOutput = {
  __typename: 'CreateBusinessIncomeOutput';
  businessId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

export type CreateCustomerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankBranch?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  businessId: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerOutput = {
  __typename: 'CreateCustomerOutput';
  data?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateProviderInput = {
  isIsraelProvider: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  nickname?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProviderOutput = {
  __typename: 'CreateProviderOutput';
  id: Scalars['ID']['output'];
  isIsraelProvider: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
};

export type CreateTaxCategoryInput = {
  categoryName: Scalars['String']['input'];
  irsCode: Scalars['Int']['input'];
  profitLossCategory: TaxCategoryProfitLossCategory;
  taxDeductionPercentage: Scalars['Float']['input'];
  vatDeductionPercentage: Scalars['Float']['input'];
  vatType: TaxCategoryVatType;
};

export type CreateTaxCategoryOutput = {
  __typename: 'CreateTaxCategoryOutput';
  categoryName: Scalars['String']['output'];
  irsCode: Scalars['Int']['output'];
  profitLossCategory: TaxCategoryProfitLossCategory;
  taxDeductionPercentage: Scalars['Float']['output'];
  vatDeductionPercentage: Scalars['Float']['output'];
  vatType: TaxCategoryVatType;
};

export type CreateUserNoteInput = {
  completed: Scalars['Boolean']['input'];
  createdBy: Scalars['ID']['input'];
  handledBy?: InputMaybe<Scalars['String']['input']>;
  note: Scalars['String']['input'];
  noteType: NotesTypes;
  userId: Scalars['ID']['input'];
};

export type CreateUserNoteOutput = {
  __typename: 'CreateUserNoteOutput';
  data: Scalars['Boolean']['output'];
};

export type Credit = {
  __typename: 'Credit';
  creditType: CreditTypeEnum;
  credits: Scalars['Float']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  startDate: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type CreditType = {
  __typename: 'CreditType';
  creditType?: Maybe<CreditTypeEnum>;
  credits?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum CreditTypeEnum {
  AGE_BETWEEN_16_AND_18 = 'AGE_BETWEEN_16_AND_18',
  CHILD_1_TO_5 = 'CHILD_1_TO_5',
  CHILD_6_TO_17 = 'CHILD_6_TO_17',
  CHILD_ABOVE_18 = 'CHILD_ABOVE_18',
  CHILD_NEWBORN = 'CHILD_NEWBORN',
  CHILD_NO_POSSESSION_1_TO_5 = 'CHILD_NO_POSSESSION_1_TO_5',
  CHILD_NO_POSSESSION_NEWBORN = 'CHILD_NO_POSSESSION_NEWBORN',
  CITIZEN = 'CITIZEN',
  FEMALE = 'FEMALE',
  MARRIED = 'MARRIED',
  MARRIED_SECOND_TIME_AND_PAYS_ALIMONI_FOR_PREVIOUS_SPOUSE = 'MARRIED_SECOND_TIME_AND_PAYS_ALIMONI_FOR_PREVIOUS_SPOUSE',
  MARRIED_TO_WIDOWER_WITH_KIDS_BELOW_18 = 'MARRIED_TO_WIDOWER_WITH_KIDS_BELOW_18',
  PARENT_LIVES_ALONE_WITH_CHILD_AND_NO_SHARED_HOUSEHOLD = 'PARENT_LIVES_ALONE_WITH_CHILD_AND_NO_SHARED_HOUSEHOLD',
  PARENT_LIVES_ALONE_WITH_CHILD_AND_SHARED_HOUSEHOLD = 'PARENT_LIVES_ALONE_WITH_CHILD_AND_SHARED_HOUSEHOLD',
  PARENT_THAT_PAYS_ALIMONI_FOR_CHILD_NO_POSSESS = 'PARENT_THAT_PAYS_ALIMONI_FOR_CHILD_NO_POSSESS',
  SINGLE_PARENT = 'SINGLE_PARENT'
}

export enum Currency {
  AUD = 'AUD',
  CAD = 'CAD',
  CHF = 'CHF',
  DKK = 'DKK',
  EGP = 'EGP',
  EUR = 'EUR',
  GBP = 'GBP',
  ILS = 'ILS',
  JOD = 'JOD',
  JPY = 'JPY',
  LBP = 'LBP',
  NOK = 'NOK',
  SEK = 'SEK',
  USD = 'USD',
  ZAR = 'ZAR'
}

export type CurrencyRate = {
  __typename: 'CurrencyRate';
  currency: Currency;
  rate: Scalars['Float']['output'];
};

export type CustomerImportedIncomes = {
  __typename: 'CustomerImportedIncomes';
  customerIdNumber?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
};

export type DeclineBusinessExpenseDisputeInput = {
  businessId: Scalars['String']['input'];
  expenseId: Scalars['String']['input'];
};

export type DeleteBusinessExpenseInput = {
  expenseId: Scalars['ID']['input'];
};

export type DeleteBusinessFileInput = {
  businessId: Scalars['ID']['input'];
  file?: InputMaybe<Scalars['String']['input']>;
  folder: Scalars['String']['input'];
};

export type DeleteBusinessFileOutput = {
  __typename: 'DeleteBusinessFileOutput';
  data: Scalars['Boolean']['output'];
};

export type DeleteUserNotificationTokenInput = {
  fcmToken: Scalars['String']['input'];
};

export type DiscountPhoneNumber = {
  __typename: 'DiscountPhoneNumber';
  createdAt?: Maybe<Scalars['String']['output']>;
  mobile: Scalars['String']['output'];
  planType: PlanType;
  planTypeFree?: Maybe<PlanType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type DisputeBusinessExpenseInput = {
  disputeStatus: BusinessExpenseDisputeStatus;
  expenseId: Scalars['ID']['input'];
};

export type DisputeBusinessExpenseOutput = {
  __typename: 'DisputeBusinessExpenseOutput';
  disputeStatus: BusinessExpenseDisputeStatus;
  expenseStatus: BusinessExpenseStatus;
  id: Scalars['ID']['output'];
};

export type DocumentComments = {
  footer?: InputMaybe<Scalars['String']['input']>;
  header?: InputMaybe<Scalars['String']['input']>;
  main?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentTree = {
  __typename: 'DocumentTree';
  data?: Maybe<DocumentTreeData>;
  depth?: Maybe<Scalars['Int']['output']>;
};

export type DocumentTreeChildrenAllowedData = {
  __typename: 'DocumentTreeChildrenAllowedData';
  currency: Scalars['String']['output'];
  customer: DocumentTreeCustomer;
  customerId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  incomeType: Scalars['String']['output'];
  items: Array<Maybe<DocumentTreeItem>>;
  payments: Array<Maybe<DocumentTreePayment>>;
  price: Scalars['Float']['output'];
  priceIncludingVat: Scalars['Float']['output'];
  vat: Scalars['Float']['output'];
};

export type DocumentTreeCustomer = {
  __typename: 'DocumentTreeCustomer';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
};

export type DocumentTreeData = {
  __typename: 'DocumentTreeData';
  accountId?: Maybe<Scalars['String']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  costumerId?: Maybe<Scalars['String']['output']>;
  createAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencyRate?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  destId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  incomeDate?: Maybe<Scalars['String']['output']>;
  incomeProvider?: Maybe<Scalars['String']['output']>;
  incomeType?: Maybe<Scalars['String']['output']>;
  incomesStatus?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['Int']['output']>;
  paymentDueDate?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  priceIncludingVat?: Maybe<Scalars['String']['output']>;
  reportEndDate?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['String']['output']>;
  reportStartDate?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  srcId?: Maybe<Scalars['String']['output']>;
  totalDeductedTax?: Maybe<Scalars['String']['output']>;
  totalDeductedVat?: Maybe<Scalars['String']['output']>;
  treeId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
  vatPercentage?: Maybe<Scalars['String']['output']>;
  vatType?: Maybe<Scalars['String']['output']>;
};

export type DocumentTreeInput = {
  srcId: Scalars['String']['input'];
};

export type DocumentTreeItem = {
  __typename: 'DocumentTreeItem';
  description: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceIncludingVat: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  units: Scalars['Int']['output'];
  vat: Scalars['Float']['output'];
  vatType: Scalars['String']['output'];
};

export type DocumentTreeOutput = {
  __typename: 'DocumentTreeOutput';
  childrenAllowedData?: Maybe<Array<Maybe<DocumentTreeChildrenAllowedData>>>;
  items?: Maybe<Array<Maybe<DocumentTree>>>;
};

export type DocumentTreePayment = {
  __typename: 'DocumentTreePayment';
  bankAccount?: Maybe<Scalars['String']['output']>;
  bankBranch?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  chequeNum?: Maybe<Scalars['String']['output']>;
  creditCardLastDigits?: Maybe<Scalars['String']['output']>;
  creditCardNumberOfPayments?: Maybe<Scalars['Float']['output']>;
  creditCardPaymentType?: Maybe<Scalars['String']['output']>;
  creditCardType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  incomeId?: Maybe<Scalars['String']['output']>;
  paymentApp?: Maybe<Scalars['String']['output']>;
  paymentAppDealNumber?: Maybe<Scalars['String']['output']>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  taxDeduction?: Maybe<Scalars['Float']['output']>;
};

export type DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsInput = {
  base64Image: Scalars['String']['input'];
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
  draftPhase: Scalars['Boolean']['input'];
};

export type DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsOutput = {
  __typename: 'DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsOutput';
  data: Array<PdfDataOutput>;
};

export type DraftBusinessSignVatBusinessCreationDocumentInput = {
  base64Image: Scalars['String']['input'];
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
  draftPhase: Scalars['Boolean']['input'];
};

export type DraftBusinessSignVatBusinessCreationDocumentOutput = {
  __typename: 'DraftBusinessSignVatBusinessCreationDocumentOutput';
  data: Array<PdfDataOutput>;
};

export type EditCustomerInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bankAccount?: InputMaybe<Scalars['String']['input']>;
  bankBranch?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  businessId: Scalars['String']['input'];
  customerName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type EditCustomerOutput = {
  __typename: 'EditCustomerOutput';
  data?: Maybe<Scalars['Boolean']['output']>;
};

export type EditDinVeHeshbonToDbInput = {
  addressEnterance?: InputMaybe<Scalars['String']['input']>;
  addressNumber: Scalars['Int']['input'];
  addresseeAddressEnterance?: InputMaybe<Scalars['String']['input']>;
  addresseeAddressNumber?: InputMaybe<Scalars['Int']['input']>;
  addresseeApartmentNumber?: InputMaybe<Scalars['Int']['input']>;
  addresseeCity?: InputMaybe<Scalars['String']['input']>;
  addresseeName?: InputMaybe<Scalars['String']['input']>;
  addresseeStreet?: InputMaybe<Scalars['String']['input']>;
  addresseeZipcode?: InputMaybe<Scalars['String']['input']>;
  agentApartmentNumber?: InputMaybe<Scalars['Int']['input']>;
  agentCity?: InputMaybe<Scalars['String']['input']>;
  agentName?: InputMaybe<Scalars['String']['input']>;
  agentPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  agentStreetAddress?: InputMaybe<Scalars['String']['input']>;
  agentStreetNumber?: InputMaybe<Scalars['Int']['input']>;
  agentZipcode?: InputMaybe<Scalars['Int']['input']>;
  apartmentNumber: Scalars['Int']['input'];
  bankAccountNumber: Scalars['Int']['input'];
  bankBranchName?: InputMaybe<Scalars['String']['input']>;
  bankBranchNumber: Scalars['Int']['input'];
  bankName: Scalars['String']['input'];
  businessApartmentNumber?: InputMaybe<Scalars['Int']['input']>;
  businessCity: Scalars['String']['input'];
  businessId: Scalars['ID']['input'];
  businessPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  businessStreetAddress: Scalars['String']['input'];
  businessStreetNumber?: InputMaybe<Scalars['Int']['input']>;
  businessZipcode?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyStatus: FamilyStatusOptions;
  familyStatusSinceDate?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  homePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  idNumber: Scalars['String']['input'];
  isApproveMessages: Scalars['Boolean']['input'];
  isApproveMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  isMailDifferent?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  mobilePhoneNumber: Scalars['String']['input'];
  occupationsLastTwoYears: Array<InputMaybe<SingleOccupationOptions>>;
  partnerFirstName?: InputMaybe<Scalars['String']['input']>;
  partnerIdNumber?: InputMaybe<Scalars['String']['input']>;
  partnerLastName?: InputMaybe<Scalars['String']['input']>;
  selfEmployedStart?: InputMaybe<SelfEmployedStartObject>;
  sourceOfIncomes: Array<InputMaybe<SourceOfIncomes>>;
  streetAddress: Scalars['String']['input'];
  zipcode?: InputMaybe<Scalars['Int']['input']>;
};

export type EditDinVeHeshbonToDbOutput = {
  __typename: 'EditDinVeHeshbonToDbOutput';
  message: Scalars['String']['output'];
};

export type EditProviderInput = {
  id: Scalars['ID']['input'];
  isIsraelProvider: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  nickname?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};

export type EditProviderOutput = {
  __typename: 'EditProviderOutput';
  id: Scalars['ID']['output'];
  isIsraelProvider: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
};

export type EditTaxCategoryInput = {
  categoryName: Scalars['String']['input'];
  irsCode: Scalars['Int']['input'];
  profitLossCategory: TaxCategoryProfitLossCategory;
  taxDeductionPercentage: Scalars['Float']['input'];
  vatDeductionPercentage: Scalars['Float']['input'];
  vatType: TaxCategoryVatType;
};

export type EditTaxCategoryOutput = {
  __typename: 'EditTaxCategoryOutput';
  categoryName: Scalars['String']['output'];
  irsCode: Scalars['Int']['output'];
  profitLossCategory: TaxCategoryProfitLossCategory;
  taxDeductionPercentage: Scalars['Float']['output'];
  vatDeductionPercentage: Scalars['Float']['output'];
  vatType: TaxCategoryVatType;
};

export type EmailAttachment = {
  __typename: 'EmailAttachment';
  cid: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type EmailAttachmentInput = {
  cid: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

export enum EmailStatus {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS'
}

export enum FamilyStatusOptions {
  DIVORCEE = 'DIVORCEE',
  KNOWN_IN_PUBLIC = 'KNOWN_IN_PUBLIC',
  MARRIED = 'MARRIED',
  SINGLE = 'SINGLE',
  WIDOWER = 'WIDOWER'
}

export type FetchExpensesInApprovalProcessInput = {
  businessId: Scalars['ID']['input'];
};

export type File = {
  __typename: 'File';
  url?: Maybe<Scalars['String']['output']>;
};

export type FillDinVeHeshbonOutput = {
  __typename: 'FillDinVeHeshbonOutput';
  data: Scalars['Boolean']['output'];
};

export type GeminaAmount = {
  __typename: 'GeminaAmount';
  confidence: Scalars['String']['output'];
  coordinates?: Maybe<GeminaCoordinates>;
  value: Scalars['Float']['output'];
};

export type GeminaCoordinates = {
  __typename: 'GeminaCoordinates';
  normalized?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  original?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  relative?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
};

export type GeminaField = {
  __typename: 'GeminaField';
  confidence: Scalars['String']['output'];
  coordinates?: Maybe<GeminaCoordinates>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GeminaJson = {
  __typename: 'GeminaJson';
  assignment_number?: Maybe<GeminaField>;
  business_number?: Maybe<GeminaField>;
  client_id?: Maybe<GeminaField>;
  created?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<GeminaField>;
  document_number?: Maybe<GeminaField>;
  document_type?: Maybe<GeminaField>;
  expense_type?: Maybe<GeminaField>;
  external_id?: Maybe<Scalars['String']['output']>;
  issue_date?: Maybe<GeminaField>;
  net_amount?: Maybe<GeminaAmount>;
  payment_method?: Maybe<GeminaField>;
  primary_document_type?: Maybe<GeminaField>;
  supplier_name?: Maybe<GeminaField>;
  timestamp?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<GeminaAmount>;
  vat_amount?: Maybe<GeminaAmount>;
};

export type GenerateCardIndexInput = {
  businessId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  language: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GenerateCardIndexOutput = {
  __typename: 'GenerateCardIndexOutput';
  base64Pdf: Scalars['String']['output'];
};

export type GenerateCashBookInput = {
  businessId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  language: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GenerateCashBookOutput = {
  __typename: 'GenerateCashBookOutput';
  base64Pdf: Scalars['String']['output'];
};

export type GenerateJonniIncomeReportInput = {
  businessId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GenerateOpenfrmtFileDocument = {
  __typename: 'GenerateOpenfrmtFileDocument';
  amount: Scalars['Float']['output'];
  counter: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GenerateOpenfrmtFileEntry = {
  __typename: 'GenerateOpenfrmtFileEntry';
  entry: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type GenerateOpenfrmtFileInput = {
  businessId: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GenerateOpenfrmtFileOutput = {
  __typename: 'GenerateOpenfrmtFileOutput';
  businessName: Scalars['String']['output'];
  documents: Array<GenerateOpenfrmtFileDocument>;
  endDate: Scalars['String']['output'];
  entries: Array<GenerateOpenfrmtFileEntry>;
  registrationNumber: Scalars['String']['output'];
  route: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

export type GenerateProfitLossDocumentInput = {
  businessId: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GenerateProfitLossDocumentOutput = {
  __typename: 'GenerateProfitLossDocumentOutput';
  base64Pdf: Scalars['String']['output'];
};

export type GetAccountantInput = {
  id: Scalars['ID']['input'];
};

export type GetAccountantSignatureInput = {
  accountantId: Scalars['ID']['input'];
};

export type GetAccountantSignatureUploadUrlInput = {
  accountantId: Scalars['ID']['input'];
};

export type GetBusinessExpenseInput = {
  id: Scalars['ID']['input'];
};

export type GetBusinessFileInput = {
  businessId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
};

export type GetBusinessFileUploadUrlInput = {
  businessId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
};

export type GetBusinessIncomeInput = {
  id: Scalars['ID']['input'];
};

export type GetBusinessIncomePaymentGrowDataInput = {
  incomeId: Scalars['ID']['input'];
};

export type GetBusinessIncomePaymentGrowDataOutput = {
  __typename: 'GetBusinessIncomePaymentGrowDataOutput';
  growTransactionId?: Maybe<Scalars['String']['output']>;
  growTransactionToken?: Maybe<Scalars['String']['output']>;
};

export type GetBusinessIncomesCeilingForBusinessInput = {
  businessId: Scalars['ID']['input'];
};

export type GetBusinessIncomesCeilingForBusinessOutput = {
  __typename: 'GetBusinessIncomesCeilingForBusinessOutput';
  limit?: Maybe<Scalars['Float']['output']>;
  totalIncomes?: Maybe<Scalars['Float']['output']>;
  totalIncomesUnused?: Maybe<Scalars['Float']['output']>;
  unUsedPercentage?: Maybe<Scalars['Float']['output']>;
  usedPercentage?: Maybe<Scalars['Float']['output']>;
};

export type GetBusinessInput = {
  id: Scalars['ID']['input'];
};

export type GetBusinessNotificationInput = {
  id: Scalars['ID']['input'];
};

export type GetBusinessNotificationsInput = {
  businessId: Scalars['ID']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type GetBusinessPendingPaymentsDataInput = {
  businessId: Scalars['ID']['input'];
};

export type GetBusinessPendingPaymentsDataOutput = {
  __typename: 'GetBusinessPendingPaymentsDataOutput';
  businessStatus: BusinessStatus;
  numberOfPendingPayments: Scalars['Int']['output'];
};

export type GetBusinessProviderInput = {
  id: Scalars['ID']['input'];
};

export type GetBusinessReportInput = {
  id: Scalars['ID']['input'];
};

export type GetBusinessSetupInput = {
  mobile?: InputMaybe<Scalars['String']['input']>;
};

export type GetCountBusinessFailedBillingsInput = {
  businessId: Scalars['ID']['input'];
};

export type GetCountBusinessFailedBillingsResponse = {
  __typename: 'GetCountBusinessFailedBillingsResponse';
  total: Scalars['Int']['output'];
};

export type GetCountOpenfrmtFiles = {
  __typename: 'GetCountOpenfrmtFiles';
  amount: Scalars['String']['output'];
  counter: Scalars['Int']['output'];
  incomeType: BusinessIncomeType;
  title: Scalars['String']['output'];
  totalA100: Scalars['Int']['output'];
  totalB100: Scalars['Int']['output'];
  totalB110: Scalars['Int']['output'];
  totalC100: Scalars['Int']['output'];
  totalD110: Scalars['Int']['output'];
  totalD120: Scalars['Int']['output'];
  totalM100: Scalars['Int']['output'];
  totalZ900: Scalars['Int']['output'];
};

export type GetCountOpenfrmtFilesInput = {
  businessId: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GetCurrencyRateInput = {
  currency: Currency;
  date: Scalars['String']['input'];
};

export type GetDataFromPdfInput = {
  base64PdfArray: Array<Scalars['String']['input']>;
  businessId: Scalars['String']['input'];
};

export type GetDataFromPdfOutput = {
  __typename: 'GetDataFromPdfOutput';
  base64Pdf: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  currencyRate: Scalars['Float']['output'];
  customerName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  fullPriceDeviation: Scalars['Float']['output'];
  incomeDate: Scalars['String']['output'];
  incomeProvider: Scalars['String']['output'];
  incomeType: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  items: Array<ImportBusinessIncomeItemsOutput>;
  payments: Array<ImportBusinessIncomePaymentsOutput>;
  price: Scalars['Float']['output'];
  priceIncludingVat: Scalars['Float']['output'];
  pricePaid: Scalars['Float']['output'];
  registrationNumber: Scalars['String']['output'];
  taxDeduction: Scalars['Float']['output'];
  totalDeductedTax: Scalars['Float']['output'];
  totalDeductedVat: Scalars['Float']['output'];
  vat: Scalars['Float']['output'];
};

export type GetDinVeHeshbonData = {
  __typename: 'GetDinVeHeshbonData';
  addressEnterance?: Maybe<Scalars['String']['output']>;
  addressNumber?: Maybe<Scalars['Int']['output']>;
  addresseeAddressEnterance?: Maybe<Scalars['String']['output']>;
  addresseeAddressNumber?: Maybe<Scalars['Int']['output']>;
  addresseeApartmentNumber?: Maybe<Scalars['Int']['output']>;
  addresseeCity?: Maybe<Scalars['String']['output']>;
  addresseeName?: Maybe<Scalars['String']['output']>;
  addresseeStreet?: Maybe<Scalars['String']['output']>;
  addresseeZipcode?: Maybe<Scalars['Int']['output']>;
  agentApartmentNumber?: Maybe<Scalars['Int']['output']>;
  agentCity?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  agentPhoneNumber?: Maybe<Scalars['String']['output']>;
  agentStreetAddress?: Maybe<Scalars['String']['output']>;
  agentStreetNumber?: Maybe<Scalars['Int']['output']>;
  agentZipcode?: Maybe<Scalars['Int']['output']>;
  apartmentNumber?: Maybe<Scalars['Int']['output']>;
  bankAccountNumber?: Maybe<Scalars['Int']['output']>;
  bankBranchName?: Maybe<Scalars['String']['output']>;
  bankBranchNumber?: Maybe<Scalars['Int']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  businessApartmentNumber?: Maybe<Scalars['Int']['output']>;
  businessCity?: Maybe<Scalars['String']['output']>;
  businessId?: Maybe<Scalars['ID']['output']>;
  businessPhoneNumber?: Maybe<Scalars['String']['output']>;
  businessStreetAddress?: Maybe<Scalars['String']['output']>;
  businessStreetNumber?: Maybe<Scalars['Int']['output']>;
  businessZipcode?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyStatus?: Maybe<FamilyStatusOptions>;
  familyStatusSinceDate?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  homePhoneNumber?: Maybe<Scalars['String']['output']>;
  idNumber?: Maybe<Scalars['String']['output']>;
  isApproveMessages?: Maybe<Scalars['Boolean']['output']>;
  isApproveMessaging?: Maybe<Scalars['Boolean']['output']>;
  isMailDifferent?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobilePhoneNumber?: Maybe<Scalars['String']['output']>;
  occupationsLastTwoYears?: Maybe<Array<Maybe<SingleOccupationOptionsX>>>;
  partnerFirstName?: Maybe<Scalars['String']['output']>;
  partnerIdNumber?: Maybe<Scalars['String']['output']>;
  partnerLastName?: Maybe<Scalars['String']['output']>;
  selfEmployedStart?: Maybe<SelfEmployedStartObjectX>;
  sourceOfIncomes?: Maybe<Array<Maybe<SourceOfIncomesX>>>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['Int']['output']>;
};

export type GetDinVeHeshbonDataInput = {
  businessId: Scalars['ID']['input'];
};

export type GetDinVeHeshbonDataOutput = {
  __typename: 'GetDinVeHeshbonDataOutput';
  data?: Maybe<GetDinVeHeshbonData>;
};

export type GetListYearsForBusinessInput = {
  businessId: Scalars['ID']['input'];
};

export type GetListYearsForBusinessOutput = {
  __typename: 'GetListYearsForBusinessOutput';
  years: Array<Scalars['Int']['output']>;
};

export type GetNextBusinessSubscriptionPaymentInput = {
  businessId: Scalars['ID']['input'];
};

export type GetNextBusinessSubscriptionPaymentResponse = {
  __typename: 'GetNextBusinessSubscriptionPaymentResponse';
  date: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export type GetNextIncomeInvoiceNumberInput = {
  businessId: Scalars['ID']['input'];
  incomeType: BusinessIncomeType;
};

export type GetNotificationsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type GetPreviousIncomeInput = {
  businessId: Scalars['String']['input'];
  incomeType: Scalars['String']['input'];
};

export type GetPreviousIncomeOutput = {
  __typename: 'GetPreviousIncomeOutput';
  previousIncomeDate?: Maybe<Scalars['String']['output']>;
};

export type GetSpreadsheetIncomesInput = {
  beginningDateOfIncomesAllowed: Scalars['String']['input'];
  businessId: Scalars['String']['input'];
  importProvider?: InputMaybe<Scalars['String']['input']>;
  imports: Array<ImportIncomesFiles>;
  isOverwriteImports: Scalars['Boolean']['input'];
};

export type GetSpreadsheetIncomesOutput = {
  __typename: 'GetSpreadsheetIncomesOutput';
  data: Scalars['Boolean']['output'];
};

export type GetStatisticsForBusinessInput = {
  businessId: Scalars['ID']['input'];
};

export type GetTaxCategoryInput = {
  irsCode: Scalars['Int']['input'];
};

export enum HoldBusinessError {
  INVALID_BUSINESS_STATUS = 'INVALID_BUSINESS_STATUS'
}

export type HoldBusinessInput = {
  businessId: Scalars['ID']['input'];
};

export type HoldBusinessOutput = {
  __typename: 'HoldBusinessOutput';
  error?: Maybe<HoldBusinessError>;
  success: Scalars['Boolean']['output'];
};

export enum HomeTabsCounters {
  BUSINESSES_PENDING_APPROVAL = 'BUSINESSES_PENDING_APPROVAL',
  BUSINESS_PENDING_DOCUMENTS_TO_UPLOAD = 'BUSINESS_PENDING_DOCUMENTS_TO_UPLOAD',
  EXPENSE_PENDING_APPROVAL = 'EXPENSE_PENDING_APPROVAL'
}

export type HomeTabsCountersData = {
  __typename: 'HomeTabsCountersData';
  BUSINESSES_PENDING_APPROVAL: Scalars['Int']['output'];
  BUSINESS_PENDING_DOCUMENTS_TO_UPLOAD: Scalars['Int']['output'];
  EXPENSE_PENDING_APPROVAL: Scalars['Int']['output'];
};

export enum IdentificationType {
  DRIVING_LICENSE = 'DRIVING_LICENSE',
  PARENT_ID_NUMBER = 'PARENT_ID_NUMBER',
  PASSPORT = 'PASSPORT'
}

export type ImportBusinessIncomeInput = {
  base64Pdf?: InputMaybe<Scalars['String']['input']>;
  businessId: Scalars['ID']['input'];
  currency: Scalars['String']['input'];
  currencyRate: Scalars['Float']['input'];
  customerName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  incomeDate: Scalars['String']['input'];
  incomeProvider: BusinessIncomeProvider;
  incomeType: BusinessIncomeType;
  invoiceNumber: Scalars['Int']['input'];
  items: Array<ImportBusinessIncomeItemsInput>;
  payments?: InputMaybe<Array<InputMaybe<ImportBusinessIncomePaymentsInput>>>;
  price: Scalars['Float']['input'];
  priceIncludingVat: Scalars['Float']['input'];
  taxDeduction: Scalars['Float']['input'];
  vat: Scalars['Float']['input'];
  vatReportId?: InputMaybe<Scalars['String']['input']>;
};

export type ImportBusinessIncomeItemsInput = {
  description: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  priceIncludingVat: Scalars['Float']['input'];
  unitPrice: Scalars['Float']['input'];
  units: Scalars['Float']['input'];
  vat: Scalars['Float']['input'];
  vatType: BusinessIncomeVatType;
};

export type ImportBusinessIncomeItemsOutput = {
  __typename: 'ImportBusinessIncomeItemsOutput';
  description: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceIncludingVat: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
  units: Scalars['Float']['output'];
  vat: Scalars['Float']['output'];
  vatType: Scalars['String']['output'];
};

export type ImportBusinessIncomeOutput = {
  __typename: 'ImportBusinessIncomeOutput';
  id: Scalars['ID']['output'];
};

export type ImportBusinessIncomePaymentsInput = {
  paymentDate: Scalars['String']['input'];
  paymentMethod: PaymentMethod;
  price: Scalars['Float']['input'];
  taxDeduction?: InputMaybe<Scalars['Float']['input']>;
};

export type ImportBusinessIncomePaymentsOutput = {
  __typename: 'ImportBusinessIncomePaymentsOutput';
  paymentDate: Scalars['String']['output'];
  paymentMethod: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  taxDeduction?: Maybe<Scalars['Float']['output']>;
};

export type ImportDataFromCsvOrExeclInput = {
  base64Files: Array<Scalars['String']['input']>;
  businessId: Scalars['ID']['input'];
  fileNames: Array<Scalars['String']['input']>;
  importRange: BusinessIncomeImportRange;
  isOverwriteIncomesEnabled: Scalars['Boolean']['input'];
  overrideIncomeProvider?: InputMaybe<BusinessIncomeProvider>;
};

export type ImportDataFromCsvOrExeclOutput = {
  __typename: 'ImportDataFromCsvOrExeclOutput';
  failed?: Maybe<Array<Maybe<ImportedIncomes>>>;
  succeeded?: Maybe<Array<Maybe<ImportedIncomes>>>;
};

export type ImportedIncomes = {
  __typename: 'ImportedIncomes';
  currency: Scalars['String']['output'];
  currencyRate: Scalars['Float']['output'];
  customer?: Maybe<CustomerImportedIncomes>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  incomeDate: Scalars['String']['output'];
  incomeProvider: Scalars['String']['output'];
  incomeType: Scalars['String']['output'];
  invoiceNumber: Scalars['Float']['output'];
  items?: Maybe<Array<Maybe<ItemImportedIncomes>>>;
  payments?: Maybe<Array<Maybe<PaymentImportedIncomes>>>;
  price: Scalars['Float']['output'];
  priceIncludingVat: Scalars['Float']['output'];
  pricePaid: Scalars['Float']['output'];
  reason?: Maybe<ReasonImportedIncomes>;
  taxDeduction?: Maybe<Scalars['Float']['output']>;
  totalDeductedTax?: Maybe<Scalars['Float']['output']>;
  totalDeductedVat?: Maybe<Scalars['Float']['output']>;
  vat: Scalars['Float']['output'];
  vatType: Scalars['String']['output'];
};

export type InsertDinVeHeshbonToDbInput = {
  addressEnterance?: InputMaybe<Scalars['String']['input']>;
  addressNumber: Scalars['Int']['input'];
  addresseeAddressEnterance?: InputMaybe<Scalars['String']['input']>;
  addresseeAddressNumber?: InputMaybe<Scalars['Int']['input']>;
  addresseeApartmentNumber?: InputMaybe<Scalars['Int']['input']>;
  addresseeCity?: InputMaybe<Scalars['String']['input']>;
  addresseeName?: InputMaybe<Scalars['String']['input']>;
  addresseeStreet?: InputMaybe<Scalars['String']['input']>;
  addresseeZipcode?: InputMaybe<Scalars['String']['input']>;
  agentApartmentNumber?: InputMaybe<Scalars['Int']['input']>;
  agentCity?: InputMaybe<Scalars['String']['input']>;
  agentName?: InputMaybe<Scalars['String']['input']>;
  agentPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  agentStreetAddress?: InputMaybe<Scalars['String']['input']>;
  agentStreetNumber?: InputMaybe<Scalars['Int']['input']>;
  agentZipcode?: InputMaybe<Scalars['Int']['input']>;
  apartmentNumber: Scalars['Int']['input'];
  bankAccountNumber: Scalars['Int']['input'];
  bankBranchName?: InputMaybe<Scalars['String']['input']>;
  bankBranchNumber: Scalars['Int']['input'];
  bankName: Scalars['String']['input'];
  businessApartmentNumber?: InputMaybe<Scalars['Int']['input']>;
  businessApprovalStatus?: InputMaybe<Scalars['String']['input']>;
  businessCity: Scalars['String']['input'];
  businessId: Scalars['ID']['input'];
  businessPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  businessStreetAddress: Scalars['String']['input'];
  businessStreetNumber?: InputMaybe<Scalars['Int']['input']>;
  businessZipcode?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyStatus: FamilyStatusOptions;
  familyStatusSinceDate?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  homePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  idNumber: Scalars['String']['input'];
  isApproveMessages: Scalars['Boolean']['input'];
  isApproveMessaging?: InputMaybe<Scalars['Boolean']['input']>;
  isMailDifferent?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  mobilePhoneNumber: Scalars['String']['input'];
  occupationsLastTwoYears: Array<InputMaybe<SingleOccupationOptions>>;
  partnerFirstName?: InputMaybe<Scalars['String']['input']>;
  partnerIdNumber?: InputMaybe<Scalars['String']['input']>;
  partnerLastName?: InputMaybe<Scalars['String']['input']>;
  selfEmployedStart?: InputMaybe<SelfEmployedStartObject>;
  sourceOfIncomes: Array<InputMaybe<SourceOfIncomes>>;
  streetAddress: Scalars['String']['input'];
  zipcode?: InputMaybe<Scalars['Int']['input']>;
};

export type InsertDinVeHeshbonToDbOutput = {
  __typename: 'InsertDinVeHeshbonToDbOutput';
  message: Scalars['String']['output'];
};

export type IsBusinessNeedToFillDinVeHeshbonInput = {
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
  isDinVeHeshbonNeeded: Scalars['Boolean']['input'];
};

export type IsBusinessNeedToFillDinVeHeshbonOutput = {
  __typename: 'IsBusinessNeedToFillDinVeHeshbonOutput';
  data: Scalars['Boolean']['output'];
};

export type ItemImportedIncomes = {
  __typename: 'ItemImportedIncomes';
  description?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  priceIncludingVat?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

export type ListActivitiesForBusinessInput = {
  businessId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  type: ActivitiesTabs;
};

export type ListActivitiesForBusinessResponse = {
  __typename: 'ListActivitiesForBusinessResponse';
  items?: Maybe<Array<BusinessActivity>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListBusinessBillingsInput = {
  billingStatus?: InputMaybe<BusinessBillingStatus>;
  businessId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListBusinessBillingsOutput = {
  __typename: 'ListBusinessBillingsOutput';
  items?: Maybe<Array<BusinessBilling>>;
  total: Scalars['Int']['output'];
};

export type ListBusinessDocumentsInput = {
  businessId: Scalars['ID']['input'];
};

export type ListBusinessExpensesInput = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  expenseId?: InputMaybe<Scalars['ID']['input']>;
  expenseStatus?: InputMaybe<Array<InputMaybe<BusinessExpenseStatus>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListBusinessExpensesResponse = {
  __typename: 'ListBusinessExpensesResponse';
  items?: Maybe<Array<BusinessExpense>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListBusinessFilesInput = {
  businessId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
};

export type ListBusinessIncomesDocumentsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListBusinessIncomesInput = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  incomeStatus?: InputMaybe<Array<InputMaybe<BusinessIncomeStatus>>>;
  incomeType?: InputMaybe<Array<InputMaybe<BusinessIncomeType>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListBusinessIncomesResponse = {
  __typename: 'ListBusinessIncomesResponse';
  items?: Maybe<Array<BusinessIncome>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListBusinessIncomesStatisticsInput = {
  businessType: BusinessType;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListBusinessIndustriesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListBusinessIndustriesResponse = {
  __typename: 'ListBusinessIndustriesResponse';
  items?: Maybe<Array<BusinessIndustry>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListBusinessPendingDocumentsToUpload = {
  __typename: 'ListBusinessPendingDocumentsToUpload';
  advanceTaxRate: Scalars['Boolean']['output'];
  approvedAt: Scalars['String']['output'];
  bituahLeumiPayment: Scalars['Boolean']['output'];
  businessCertificate: Scalars['Boolean']['output'];
  businessExemption: Scalars['Boolean']['output'];
  businessIndustry: Scalars['Boolean']['output'];
  businessName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  registrationNumber: Scalars['String']['output'];
};

export type ListBusinessPendingDocumentsToUploadInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListBusinessPendingDocumentsToUploadResponse = {
  __typename: 'ListBusinessPendingDocumentsToUploadResponse';
  items?: Maybe<Array<ListBusinessPendingDocumentsToUpload>>;
  total: Scalars['Int']['output'];
};

export type ListBusinessRecentIncomeItemsInput = {
  businessId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListBusinessRecentIncomeItemsResponse = {
  __typename: 'ListBusinessRecentIncomeItemsResponse';
  items?: Maybe<Array<Maybe<BusinessRecentIncomeItem>>>;
  total: Scalars['Int']['output'];
};

export type ListBusinessReportsInput = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
  reportName?: InputMaybe<Scalars['String']['input']>;
  reportStatus?: InputMaybe<BusinessReportStatus>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type ListBusinessReportsMonthlyInput = {
  businessId: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
};

export type ListBusinessReportsMonthlyResponse = {
  __typename: 'ListBusinessReportsMonthlyResponse';
  items?: Maybe<Array<BusinessReport>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListBusinessReportsResponse = {
  __typename: 'ListBusinessReportsResponse';
  items?: Maybe<Array<BusinessReport>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListBusinessSubscriptionsResponse = {
  __typename: 'ListBusinessSubscriptionsResponse';
  items?: Maybe<Array<BusinessSubscription>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListBusinessesBaseInput = {
  businessStatus?: InputMaybe<BusinessStatus>;
  businessType?: InputMaybe<BusinessType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListBusinessesCrmInput = {
  businessStatus?: InputMaybe<BusinessStatus>;
  businessType?: InputMaybe<BusinessType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onboardingStatus?: InputMaybe<Array<InputMaybe<OnboardingStatus>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListBusinessesResponse = {
  __typename: 'ListBusinessesResponse';
  items?: Maybe<Array<Business>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListCompanySubscriptionPlanInput = {
  cancelled: Scalars['Boolean']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type ListCompanySubscriptionPlanOutput = {
  __typename: 'ListCompanySubscriptionPlanOutput';
  items?: Maybe<Array<CompanySubscriptionPlan>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListDiscountPhoneNumbersInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mobile: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListDiscountPhoneNumbersResponse = {
  __typename: 'ListDiscountPhoneNumbersResponse';
  items?: Maybe<Array<DiscountPhoneNumber>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListOpenfrmtFilesInput = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  generateFileDate: Scalars['String']['input'];
  registrationNumber: Scalars['String']['input'];
};

export type ListPopularProvidersInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListProvidersInput = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListProvidersResponse = {
  __typename: 'ListProvidersResponse';
  items?: Maybe<Array<BusinessProvider>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListStaffs = {
  __typename: 'ListStaffs';
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  idNumber?: Maybe<Scalars['String']['output']>;
  isNotified?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<StaffPriority>;
  signatureName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<StaffTypes>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ListStaffsByParentIdByParentId = {
  __typename: 'ListStaffsByParentIdByParentId';
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  idNumber?: Maybe<Scalars['String']['output']>;
  isNotified?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  priority?: Maybe<StaffPriority>;
  signatureName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<StaffTypes>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ListStaffsByParentIdByParentIdResponse = {
  __typename: 'ListStaffsByParentIdByParentIdResponse';
  items: Array<Maybe<ListStaffsByParentIdByParentId>>;
  total: Scalars['Int']['output'];
};

export type ListStaffsByParentIdInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parentId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListStaffsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  type: Array<StaffTypes>;
};

export type ListStaffsResponse = {
  __typename: 'ListStaffsResponse';
  items?: Maybe<Array<Maybe<ListStaffs>>>;
  total: Scalars['Int']['output'];
};

export type ListTaxCategoriesInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type ListTaxCategoriesResponse = {
  __typename: 'ListTaxCategoriesResponse';
  items?: Maybe<Array<TaxCategory>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListUserNotesInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  noteType: NotesTypes;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type ListUserNotesOutput = {
  __typename: 'ListUserNotesOutput';
  completed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  handledBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  note: Scalars['String']['output'];
  noteType?: Maybe<NotesTypes>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type ListUserNotesResponse = {
  __typename: 'ListUserNotesResponse';
  items?: Maybe<Array<ListUserNotesOutput>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum MissingDocument {
  BANK_DOCUMENT = 'BANK_DOCUMENT',
  ID_AND_BANK_DOCUMENT = 'ID_AND_BANK_DOCUMENT',
  ID_DOCUMENT = 'ID_DOCUMENT',
  NONE = 'NONE'
}

export enum MobilePlatformType {
  ANDROID = 'ANDROID',
  IOS = 'IOS'
}

export enum ModelAttributeTypes {
  _NULL = '_null',
  BINARY = 'binary',
  BINARYSET = 'binarySet',
  BOOL = 'bool',
  LIST = 'list',
  MAP = 'map',
  NUMBER = 'number',
  NUMBERSET = 'numberSet',
  STRING = 'string',
  STRINGSET = 'stringSet'
}

export type ModelBooleanInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModelCreditTypeConnection = {
  __typename: 'ModelCreditTypeConnection';
  items: Array<Maybe<CreditType>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelFloatInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
};

export type ModelIdInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<ModelSizeInput>;
};

export type ModelIntInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelSizeInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export enum ModelSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type ModelStringInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<ModelSizeInput>;
};

export type ModelStringKeyConditionInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
};

export type MoveBusinessExpenseVatInput = {
  businessId: Scalars['ID']['input'];
  expenseIds: Array<Scalars['ID']['input']>;
  newVatReportId: Scalars['ID']['input'];
};

export type Mutation = {
  __typename: 'Mutation';
  accountantSignTaxAuthorityAndBituahLeumiDocuments: AccountantSignTaxAuthorityAndBituahLeumiDocumentsOutput;
  accountantSignVatBusinessCreationDocument: AccountantSignVatBusinessCreationDocumentOutput;
  addDiscountPhoneNumber: AddDiscountPhoneNumberOutput;
  addNewStaff: AddNewStaffOutput;
  annualReportRemoveFieldFileBo: AnnualReportSuccessBooleanOutput;
  annualReportRemoveFieldFileMobile: AnnualReportSuccessBooleanOutput;
  annualReportReviewAnnualReportBo: AnnualReportSuccessBooleanOutput;
  annualReportUploadFieldFileBo: AnnualReportUploadFieldFileOutput;
  annualReportUploadFieldFileMobile: AnnualReportUploadFieldFileOutput;
  annualReportValidateAndSubmitFormBo: AnnualReportSuccessBooleanOutput;
  annualReportValidateAndSubmitFormMobile: AnnualReportSuccessBooleanOutput;
  annualReportValidateAndSubmitStepsBo: AnnualReportSuccessBooleanOutput;
  annualReportValidateAndSubmitStepsMobile: AnnualReportSuccessBooleanOutput;
  approveBusiness: ApproveBusinessOutput;
  approveBusinessExpense: ApproveBusinessExpenseOutput;
  approveRepresentation: ApproveRepresentationOutput;
  approveSignaturesOnTaxAuthorityAndBituahLeumiDocuments: ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsOutput;
  approveSignaturesOnVatBusinessCreationDocument: ApproveSignaturesOnVatBusinessCreationDocumentOutput;
  autoSignBO: AutoSignOutput;
  autoSignMobile: AutoSignOutput;
  bankToPdf: BankToPdfOutput;
  businessPaymentRefund: BusinessPaymentRefundOutput;
  businessPaymentRequest: BusinessPaymentRequestOutput;
  businessPaymentResponse: BusinessPaymentResponseOutput;
  businessSignTaxAuthorityAndBituahLeumiDocuments: BusinessSignTaxAuthorityAndBituahLeumiDocumentsOutput;
  businessSignVatBusinessCreationDocument: BusinessSignVatBusinessCreationDocumentOutput;
  businessSubscriptionConverter: BusinessSubscriptionConverterOutput;
  businessTypeConverter: BusinessTypeConverterOutput;
  businessUploadMissingDocuments: BusinessUploadMissingDocumentsOutput;
  calculationBusinessReport: CalculationBusinessReportOutput;
  canBeBlocked: CanBeBlockedOutput;
  cancelBusiness: CancelBusinessOutput;
  chargeFailedBusinessBilling: Scalars['Boolean']['output'];
  chargeFailedBusinessBillingMobile: ChargeFailedBusinessBillingMobileOutput;
  closeBusinessReport: CloseBusinessReportOutput;
  createBusinessExpense: CreateBusinessExpenseOutput;
  createBusinessIncome: CreateBusinessIncomeOutput;
  createCustomer: CreateCustomerOutput;
  createProvider: CreateProviderOutput;
  createTaxCategory: CreateTaxCategoryOutput;
  createUserNote: CreateUserNoteOutput;
  declineBusinessExpenseDispute: Scalars['Boolean']['output'];
  deleteBusinessExpense: Scalars['Boolean']['output'];
  deleteBusinessFile: DeleteBusinessFileOutput;
  deleteUserNotificationToken: Scalars['Boolean']['output'];
  disputeBusinessExpense: DisputeBusinessExpenseOutput;
  documentTree: DocumentTreeOutput;
  draftBusinessSignTaxAuthorityAndBituahLeumiDocuments: DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsOutput;
  draftBusinessSignVatBusinessCreationDocument: DraftBusinessSignVatBusinessCreationDocumentOutput;
  editCustomer: EditCustomerOutput;
  editDinVeHeshbonToDbBO: EditDinVeHeshbonToDbOutput;
  editDinVeHeshbonToDbMobile: EditDinVeHeshbonToDbOutput;
  editProvider: EditProviderOutput;
  editTaxCategory: EditTaxCategoryOutput;
  fillDinVeHeshbon: FillDinVeHeshbonOutput;
  generateCardIndex: GenerateCardIndexOutput;
  generateCashBook: GenerateCashBookOutput;
  generateJonniIncomeReport: File;
  generateOpenfrmtFiles: GenerateOpenfrmtFileOutput;
  generateProfitLossDocument: GenerateProfitLossDocumentOutput;
  getDataFromPdfBO: GetDataFromPdfOutput;
  getDataFromPdfMobile: GetDataFromPdfOutput;
  holdBusiness: HoldBusinessOutput;
  idToPdf: IdToPdfOutput;
  importBusinessIncome: ImportBusinessIncomeOutput;
  importDataFromCsvOrExecl: ImportDataFromCsvOrExeclOutput;
  insertDinVeHeshbonToDbBO: InsertDinVeHeshbonToDbOutput;
  insertDinVeHeshbonToDbMobile: InsertDinVeHeshbonToDbOutput;
  isBusinessNeedToFillDinVeHeshbon: IsBusinessNeedToFillDinVeHeshbonOutput;
  moveBusinessExpenseVat: Scalars['Boolean']['output'];
  refundBusinessBilling: Scalars['Boolean']['output'];
  reopenApprovedBusinessExpense: Scalars['Boolean']['output'];
  reopenBusinessReport: ReopenBusinessReportOutput;
  responseBusinessApproved: ResponseBusinessApprovedOutput;
  responseBusinessDeclined: ResponseBusinessDeclinedOutput;
  restoreBusiness: RestoreBusinessOutput;
  sendBusinessIncomeToEmail: SendBusinessIncomeToEmailOutput;
  setUserNotificationToken: Scalars['Boolean']['output'];
  setWasUserContacted: SetWasUserContactedOutput;
  signUp: SignUpOutput;
  submitAuthoritiesIdentification: SubmitAuthoritiesIdentificationOutput;
  submitBankDetails: SubmitBankDetailsOutput;
  submitBillingDetails: SubmitBillingDetailsOutput;
  submitBusinessApprovalStepFive: Scalars['Boolean']['output'];
  submitBusinessApprovalStepFour: Scalars['Boolean']['output'];
  submitBusinessApprovalStepOne: Scalars['Boolean']['output'];
  submitBusinessApprovalStepThree: Scalars['Boolean']['output'];
  submitBusinessApprovalStepTwo: Scalars['Boolean']['output'];
  submitBusinessDetails: SubmitBusinessDetailsOutput;
  submitBusinessEnglishDetails: SubmitBusinessEnglishDetailsOutput;
  submitBusinessLogo: SubmitBusinessLogoOutput;
  submitBusinessSetup: SubmitBusinessSetupOutput;
  submitCompanySubscriptionPlan: Scalars['Boolean']['output'];
  submitFriendReferral: SubmitFriendReferralOutput;
  submitGiftDetails: SubmitGiftDetailsOutput;
  submitIdentificationUpload: SubmitIdentificationUploadOutput;
  submitIncomeDocumentComments: SubmitIncomeDocumentCommentsOutput;
  submitNewBusinessDetails: SubmitNewBusinessDetailsOutput;
  submitReportForBusinessApproval: SubmitReportForBusinessApprovalOutput;
  taxAuthorityOpenApi: TaxAuthorityOpenApiOutput;
  updateBusinessAddress: Scalars['Boolean']['output'];
  updateBusinessAdvanceTaxRateForReport: UpdateBusinessAdvanceTaxRateForReportOutput;
  updateBusinessAdvances: Scalars['Boolean']['output'];
  updateBusinessApprovalStatus: UpdateBusinessApprovalStatusOutput;
  updateBusinessBilling: UpdateBusinessBillingDetailsOutput;
  updateBusinessBituahLeumiPayment: Scalars['Boolean']['output'];
  updateBusinessBituahLeumiPaymentForReport: UpdateBusinessBituahLeumiPaymentForReportOutput;
  updateBusinessCertificate: UpdateBusinessCertificateOutput;
  updateBusinessDetails: Scalars['Boolean']['output'];
  updateCompletedInUserNote: UpdateCompletedInUserNoteOutput;
  updatePaymentsForReports: UpdatePaymentsForReportsOutput;
  uploadUnsignedTaxAuthorityAndBituahLeumiDocuments: UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsOutput;
  uploadUnsignedVatBusinessCreationDocument: UploadUnsignedVatBusinessCreationDocumentOutput;
};


export type MutationAccountantSignTaxAuthorityAndBituahLeumiDocumentsArgs = {
  input: AccountantSignTaxAuthorityAndBituahLeumiDocumentsInput;
};


export type MutationAccountantSignVatBusinessCreationDocumentArgs = {
  input: AccountantSignVatBusinessCreationDocumentInput;
};


export type MutationAddDiscountPhoneNumberArgs = {
  input: AddDiscountPhoneNumberInput;
};


export type MutationAddNewStaffArgs = {
  input: AddNewStaffInput;
};


export type MutationAnnualReportRemoveFieldFileBoArgs = {
  input: AnnualReportRemoveFieldFileBoInput;
};


export type MutationAnnualReportRemoveFieldFileMobileArgs = {
  input: AnnualReportRemoveFieldFileMobileInput;
};


export type MutationAnnualReportReviewAnnualReportBoArgs = {
  input: AnnualReportReviewAnnualReportBoInput;
};


export type MutationAnnualReportUploadFieldFileBoArgs = {
  input: AnnualReportUploadFieldFileBoInput;
};


export type MutationAnnualReportUploadFieldFileMobileArgs = {
  input: AnnualReportUploadFieldFileMobileInput;
};


export type MutationAnnualReportValidateAndSubmitFormBoArgs = {
  input: AnnualReportValidateAndSubmitFormBoInput;
};


export type MutationAnnualReportValidateAndSubmitFormMobileArgs = {
  input: AnnualReportValidateAndSubmitFormMobileInput;
};


export type MutationAnnualReportValidateAndSubmitStepsBoArgs = {
  input: AnnualReportValidateAndSubmitStepsBoInput;
};


export type MutationAnnualReportValidateAndSubmitStepsMobileArgs = {
  input: AnnualReportValidateAndSubmitStepsMobileInput;
};


export type MutationApproveBusinessArgs = {
  input: ApproveBusinessInput;
};


export type MutationApproveBusinessExpenseArgs = {
  input: ApproveBusinessExpenseInput;
};


export type MutationApproveRepresentationArgs = {
  input: ApproveRepresentationInput;
};


export type MutationApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsArgs = {
  input: ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsInput;
};


export type MutationApproveSignaturesOnVatBusinessCreationDocumentArgs = {
  input: ApproveSignaturesOnVatBusinessCreationDocumentInput;
};


export type MutationAutoSignBoArgs = {
  input: AutoSignInput;
};


export type MutationAutoSignMobileArgs = {
  input: AutoSignInput;
};


export type MutationBankToPdfArgs = {
  input: BankToPdfInput;
};


export type MutationBusinessPaymentRefundArgs = {
  input: BusinessPaymentRefundInput;
};


export type MutationBusinessPaymentRequestArgs = {
  input: BusinessPaymentRequestInput;
};


export type MutationBusinessPaymentResponseArgs = {
  input: BusinessPaymentResponseInput;
};


export type MutationBusinessSignTaxAuthorityAndBituahLeumiDocumentsArgs = {
  input: BusinessSignTaxAuthorityAndBituahLeumiDocumentsInput;
};


export type MutationBusinessSignVatBusinessCreationDocumentArgs = {
  input: BusinessSignVatBusinessCreationDocumentInput;
};


export type MutationBusinessSubscriptionConverterArgs = {
  input: BusinessSubscriptionConverterInput;
};


export type MutationBusinessTypeConverterArgs = {
  input: BusinessTypeConverterInput;
};


export type MutationBusinessUploadMissingDocumentsArgs = {
  input: BusinessUploadMissingDocumentsInput;
};


export type MutationCalculationBusinessReportArgs = {
  input: CalculationBusinessReportInput;
};


export type MutationCanBeBlockedArgs = {
  input: CanBeBlockedInput;
};


export type MutationCancelBusinessArgs = {
  input: CancelBusinessInput;
};


export type MutationChargeFailedBusinessBillingArgs = {
  input: ChargeFailedBusinessBillingInput;
};


export type MutationChargeFailedBusinessBillingMobileArgs = {
  input: ChargeFailedBusinessBillingMobileInput;
};


export type MutationCloseBusinessReportArgs = {
  input: CloseBusinessReportInput;
};


export type MutationCreateBusinessExpenseArgs = {
  input: CreateBusinessExpenseInput;
};


export type MutationCreateBusinessIncomeArgs = {
  input: CreateBusinessIncomeInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateProviderArgs = {
  input: CreateProviderInput;
};


export type MutationCreateTaxCategoryArgs = {
  input: CreateTaxCategoryInput;
};


export type MutationCreateUserNoteArgs = {
  input: CreateUserNoteInput;
};


export type MutationDeclineBusinessExpenseDisputeArgs = {
  input: DeclineBusinessExpenseDisputeInput;
};


export type MutationDeleteBusinessExpenseArgs = {
  input: DeleteBusinessExpenseInput;
};


export type MutationDeleteBusinessFileArgs = {
  input: DeleteBusinessFileInput;
};


export type MutationDeleteUserNotificationTokenArgs = {
  input: DeleteUserNotificationTokenInput;
};


export type MutationDisputeBusinessExpenseArgs = {
  input: DisputeBusinessExpenseInput;
};


export type MutationDocumentTreeArgs = {
  input: DocumentTreeInput;
};


export type MutationDraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsArgs = {
  input: DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsInput;
};


export type MutationDraftBusinessSignVatBusinessCreationDocumentArgs = {
  input: DraftBusinessSignVatBusinessCreationDocumentInput;
};


export type MutationEditCustomerArgs = {
  input: EditCustomerInput;
};


export type MutationEditDinVeHeshbonToDbBoArgs = {
  input: EditDinVeHeshbonToDbInput;
};


export type MutationEditDinVeHeshbonToDbMobileArgs = {
  input: EditDinVeHeshbonToDbInput;
};


export type MutationEditProviderArgs = {
  input: EditProviderInput;
};


export type MutationEditTaxCategoryArgs = {
  input: EditTaxCategoryInput;
};


export type MutationFillDinVeHeshbonArgs = {
  input: InsertDinVeHeshbonToDbInput;
};


export type MutationGenerateCardIndexArgs = {
  input: GenerateCardIndexInput;
};


export type MutationGenerateCashBookArgs = {
  input: GenerateCashBookInput;
};


export type MutationGenerateJonniIncomeReportArgs = {
  input: GenerateJonniIncomeReportInput;
};


export type MutationGenerateOpenfrmtFilesArgs = {
  input: GenerateOpenfrmtFileInput;
};


export type MutationGenerateProfitLossDocumentArgs = {
  input: GenerateProfitLossDocumentInput;
};


export type MutationGetDataFromPdfBoArgs = {
  input: GetDataFromPdfInput;
};


export type MutationGetDataFromPdfMobileArgs = {
  input: GetDataFromPdfInput;
};


export type MutationHoldBusinessArgs = {
  input: HoldBusinessInput;
};


export type MutationIdToPdfArgs = {
  input: IdToPdfInput;
};


export type MutationImportBusinessIncomeArgs = {
  input: ImportBusinessIncomeInput;
};


export type MutationImportDataFromCsvOrExeclArgs = {
  input: ImportDataFromCsvOrExeclInput;
};


export type MutationInsertDinVeHeshbonToDbBoArgs = {
  input: InsertDinVeHeshbonToDbInput;
};


export type MutationInsertDinVeHeshbonToDbMobileArgs = {
  input: InsertDinVeHeshbonToDbInput;
};


export type MutationIsBusinessNeedToFillDinVeHeshbonArgs = {
  input: IsBusinessNeedToFillDinVeHeshbonInput;
};


export type MutationMoveBusinessExpenseVatArgs = {
  input: MoveBusinessExpenseVatInput;
};


export type MutationRefundBusinessBillingArgs = {
  input: RefundBusinessBillingInput;
};


export type MutationReopenApprovedBusinessExpenseArgs = {
  input: ReopenApprovedBusinessExpenseInput;
};


export type MutationReopenBusinessReportArgs = {
  input: ReopenBusinessReportInput;
};


export type MutationResponseBusinessApprovedArgs = {
  input: ResponseBusinessApprovedInput;
};


export type MutationResponseBusinessDeclinedArgs = {
  input: ResponseBusinessDeclinedInput;
};


export type MutationRestoreBusinessArgs = {
  input: RestoreBusinessInput;
};


export type MutationSendBusinessIncomeToEmailArgs = {
  input: SendBusinessIncomeToEmailInput;
};


export type MutationSetUserNotificationTokenArgs = {
  input: SetUserNotificationTokenInput;
};


export type MutationSetWasUserContactedArgs = {
  input: SetWasUserContactedInput;
};


export type MutationSignUpArgs = {
  input: SignUpInput;
};


export type MutationSubmitAuthoritiesIdentificationArgs = {
  input: SubmitAuthoritiesIdentificationInput;
};


export type MutationSubmitBankDetailsArgs = {
  input: SubmitBankDetailsInput;
};


export type MutationSubmitBillingDetailsArgs = {
  input: SubmitBillingDetailsInput;
};


export type MutationSubmitBusinessApprovalStepFiveArgs = {
  input: SubmitBusinessApprovalStepFiveInput;
};


export type MutationSubmitBusinessApprovalStepFourArgs = {
  input: SubmitBusinessApprovalStepFourInput;
};


export type MutationSubmitBusinessApprovalStepOneArgs = {
  input: SubmitBusinessApprovalStepOneInput;
};


export type MutationSubmitBusinessApprovalStepThreeArgs = {
  input: SubmitBusinessApprovalStepThreeInput;
};


export type MutationSubmitBusinessApprovalStepTwoArgs = {
  input: SubmitBusinessApprovalStepTwoInput;
};


export type MutationSubmitBusinessDetailsArgs = {
  input: SubmitBusinessDetailsInput;
};


export type MutationSubmitBusinessEnglishDetailsArgs = {
  input: SubmitBusinessEnglishDetailsInput;
};


export type MutationSubmitBusinessLogoArgs = {
  input: SubmitBusinessLogoInput;
};


export type MutationSubmitBusinessSetupArgs = {
  input: SubmitBusinessSetupInput;
};


export type MutationSubmitCompanySubscriptionPlanArgs = {
  input: SubmitCompanySubscriptionPlanInput;
};


export type MutationSubmitFriendReferralArgs = {
  input: SubmitFriendReferralInput;
};


export type MutationSubmitGiftDetailsArgs = {
  input: SubmitGiftDetailsInput;
};


export type MutationSubmitIdentificationUploadArgs = {
  input: SubmitIdentificationUploadInput;
};


export type MutationSubmitIncomeDocumentCommentsArgs = {
  input: SubmitIncomeDocumentCommentsInput;
};


export type MutationSubmitNewBusinessDetailsArgs = {
  input: SubmitNewBusinessDetailsInput;
};


export type MutationSubmitReportForBusinessApprovalArgs = {
  input: SubmitReportForBusinessApprovalInput;
};


export type MutationTaxAuthorityOpenApiArgs = {
  input: TaxAuthorityOpenApiInput;
};


export type MutationUpdateBusinessAddressArgs = {
  input: UpdateBusinessAddressInput;
};


export type MutationUpdateBusinessAdvanceTaxRateForReportArgs = {
  input: UpdateBusinessAdvanceTaxRateForReportInput;
};


export type MutationUpdateBusinessAdvancesArgs = {
  input: UpdateBusinessAdvancesInput;
};


export type MutationUpdateBusinessApprovalStatusArgs = {
  input: UpdateBusinessApprovalStatusInput;
};


export type MutationUpdateBusinessBillingArgs = {
  input: UpdateBusinessBillingDetailsInput;
};


export type MutationUpdateBusinessBituahLeumiPaymentArgs = {
  input: UpdateBusinessBituahLeumiPaymentInput;
};


export type MutationUpdateBusinessBituahLeumiPaymentForReportArgs = {
  input: UpdateBusinessBituahLeumiPaymentForReportInput;
};


export type MutationUpdateBusinessCertificateArgs = {
  input: UpdateBusinessCertificateInput;
};


export type MutationUpdateBusinessDetailsArgs = {
  input: UpdateBusinessDetailsInput;
};


export type MutationUpdateCompletedInUserNoteArgs = {
  input: UpdateCompletedInUserNoteInput;
};


export type MutationUpdatePaymentsForReportsArgs = {
  input: UpdatePaymentsForReportsInput;
};


export type MutationUploadUnsignedTaxAuthorityAndBituahLeumiDocumentsArgs = {
  input: UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsInput;
};


export type MutationUploadUnsignedVatBusinessCreationDocumentArgs = {
  input: UploadUnsignedVatBusinessCreationDocumentInput;
};

export type NextIncomeInvoiceNumber = {
  __typename: 'NextIncomeInvoiceNumber';
  invoiceNumber: Scalars['Int']['output'];
};

export enum NotesTypes {
  BUSINESS = 'BUSINESS',
  CRM = 'CRM'
}

export type NotificationValues = {
  __typename: 'NotificationValues';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type NotificationValuesInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum OccupationOptions {
  EMPLOYEE = 'EMPLOYEE',
  HIGH_SCHOOL_STUDENT = 'HIGH_SCHOOL_STUDENT',
  HOUSE_KEEPING = 'HOUSE_KEEPING',
  INCOME_NOT_FROM_WORK = 'INCOME_NOT_FROM_WORK',
  KIBBUTZ_MEMBER = 'KIBBUTZ_MEMBER',
  OTHER = 'OTHER',
  OVERSEAS = 'OVERSEAS',
  PENSION = 'PENSION',
  PRISONER = 'PRISONER',
  PROFESSIONAL_TRAINING = 'PROFESSIONAL_TRAINING',
  SHEROT_LEUMI = 'SHEROT_LEUMI',
  SOLDIER_DUTY = 'SOLDIER_DUTY',
  SOLDIER_PERMANENT = 'SOLDIER_PERMANENT',
  STUDENT = 'STUDENT',
  UNEMPLOYED = 'UNEMPLOYED',
  UNPAYED_VACATION = 'UNPAYED_VACATION',
  YESHIVA_STUDENT = 'YESHIVA_STUDENT'
}

export enum OnboardingStatus {
  AUTHORITIES_IDENTIFICATION = 'AUTHORITIES_IDENTIFICATION',
  BILLING_DETAILS = 'BILLING_DETAILS',
  BUSINESS_DETAILS = 'BUSINESS_DETAILS',
  BUSINESS_SETUP = 'BUSINESS_SETUP',
  DONE = 'DONE',
  GIFT_DETAILS = 'GIFT_DETAILS',
  IDENTIFICATION_UPLOAD = 'IDENTIFICATION_UPLOAD',
  NEW_BUSINESS_DETAILS = 'NEW_BUSINESS_DETAILS'
}

export type OperationStatus = {
  __typename: 'OperationStatus';
  err: Scalars['AWSJSON']['output'];
  operationName: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  warn: Array<Maybe<Scalars['AWSJSON']['output']>>;
};

export enum Operations {
  AUTHORIZATION = 'AUTHORIZATION',
  INVOICE_APPROVAL = 'INVOICE_APPROVAL',
  SEND_ADVANCE_PAYMENT = 'SEND_ADVANCE_PAYMENT',
  SEND_VAT_REPORT = 'SEND_VAT_REPORT'
}

export type PaginatedListInput = {
  businessId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortField?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentImportedIncomes = {
  __typename: 'PaymentImportedIncomes';
  paymentDate?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export enum PaymentMethod {
  BANK_TRANSFER = 'BANK_TRANSFER',
  CHEQUE = 'CHEQUE',
  CREDIT_CARD = 'CREDIT_CARD',
  OTHER = 'OTHER',
  PAYMENT_APP = 'PAYMENT_APP',
  TAX_DEDUCTION = 'TAX_DEDUCTION'
}

export type PdfDataOutput = {
  __typename: 'PdfDataOutput';
  base64Pdf: Scalars['String']['output'];
  pdfType: Scalars['String']['output'];
};

export enum PlanType {
  FAMILY = 'FAMILY',
  INDEPENDENCE_DAY = 'INDEPENDENCE_DAY',
  ONEMONTHS33 = 'ONEMONTHS33',
  ONEMONTHS50 = 'ONEMONTHS50',
  ONEMONTHS100 = 'ONEMONTHS100',
  ONEYEAR10 = 'ONEYEAR10',
  ONEYEAR20 = 'ONEYEAR20',
  ONEYEAR30 = 'ONEYEAR30',
  PILOT = 'PILOT',
  REGULAR = 'REGULAR',
  THREEMONTHS33 = 'THREEMONTHS33',
  THREEMONTHS50 = 'THREEMONTHS50',
  THREEMONTHS100 = 'THREEMONTHS100',
  TWOMONTHS33 = 'TWOMONTHS33',
  TWOMONTHS50 = 'TWOMONTHS50',
  TWOMONTHS100 = 'TWOMONTHS100'
}

export type Query = {
  __typename: 'Query';
  annualReportGetAnnualReportBo: AnnualReportWithFilesBoOutput;
  annualReportGetAnnualReportMobile: AnnualReportWithFilesMobileOutput;
  annualReportGetFieldFileContentsBo: AnnualReportFieldFileBase64ContentsOutput;
  annualReportGetFieldFileContentsMobile: AnnualReportFieldFileBase64ContentsOutput;
  annualReportListAnnualReportsBo: AnnualReportListOutput;
  annualReportListAnnualReportsMobile: AnnualReportListOutput;
  businessBillingsChartData: BusinessBillingsChartDataOutput;
  businessBillingsDataByDate: BusinessBillingsDataByDateOutput;
  businessBillingsTableByDate: BusinessBillingsTableByDateOutput;
  getAccountantSignature: File;
  getAccountantSignatureUploadUrl: File;
  getBusiness: Business;
  getBusinessExpense: BusinessExpense;
  getBusinessFile: File;
  getBusinessFileUploadUrl: File;
  getBusinessIncome: BusinessIncome;
  getBusinessIncomePaymentGrowData: GetBusinessIncomePaymentGrowDataOutput;
  getBusinessIncomesCeilingForBusiness: GetBusinessIncomesCeilingForBusinessOutput;
  getBusinessNotification: BusinessNotification;
  getBusinessPendingPaymentsData: GetBusinessPendingPaymentsDataOutput;
  getBusinessProvider: BusinessProvider;
  getBusinessReport: BusinessReport;
  getBusinessSetup?: Maybe<BusinessSetup>;
  getBusinessStatusCounters: BusinessStatusCounters;
  getCountBusinessFailedBillings: GetCountBusinessFailedBillingsResponse;
  getCountOpenfrmtFiles: GetCountOpenfrmtFiles;
  getCurrencyRate: CurrencyRate;
  getDinVeHeshbonDataBO: GetDinVeHeshbonDataOutput;
  getDinVeHeshbonDataMobile: GetDinVeHeshbonDataOutput;
  getHomeTabsCounters: HomeTabsCountersData;
  getListYearsForBusinessBo: GetListYearsForBusinessOutput;
  getListYearsForBusinessMobile: GetListYearsForBusinessOutput;
  getNextBusinessSubscriptionPayment: GetNextBusinessSubscriptionPaymentResponse;
  getNextIncomeInvoiceNumber: NextIncomeInvoiceNumber;
  getPreviousIncomeDate: GetPreviousIncomeOutput;
  getSpreadsheetIncomes: GetSpreadsheetIncomesOutput;
  getStaff: Staff;
  getStatisticsForBusiness: BusinessStatistics;
  getSubscriptionPlans: Array<BusinessSubscriptionPlan>;
  getTaxCategory: TaxCategory;
  getUser?: Maybe<User>;
  listActivitiesForBusiness: ListActivitiesForBusinessResponse;
  listBusinessBillings: ListBusinessBillingsOutput;
  listBusinessDocuments: Array<BusinessDocument>;
  listBusinessExpenses: ListBusinessExpensesResponse;
  listBusinessExpensesInApprovalProcess: ListBusinessExpensesResponse;
  listBusinessExpenses_report: ListBusinessExpensesResponse;
  listBusinessFiles: Array<BusinessFile>;
  listBusinessIncomes: ListBusinessIncomesResponse;
  listBusinessIncomesDocuments: ListBusinessIncomesResponse;
  listBusinessIncomesStatistics: ListBusinessIncomesResponse;
  listBusinessIndustries: ListBusinessIndustriesResponse;
  listBusinessPendingDocumentsToUpload: ListBusinessPendingDocumentsToUploadResponse;
  listBusinessRecentIncomeItems: ListBusinessRecentIncomeItemsResponse;
  listBusinessReports: ListBusinessReportsResponse;
  listBusinessReportsMonthly: ListBusinessReportsMonthlyResponse;
  listBusinessSubscriptions: ListBusinessSubscriptionsResponse;
  listBusinessesBase: ListBusinessesResponse;
  listBusinessesCrm: ListBusinessesResponse;
  listCompanySubscriptionPlan: ListCompanySubscriptionPlanOutput;
  listDiscountPhoneNumbers: ListDiscountPhoneNumbersResponse;
  listOpenfrmtFiles: Array<BusinessFile>;
  listPopularProviders: ListPopularProvidersResponse;
  listProviders: ListProvidersResponse;
  listStaffs: ListStaffsResponse;
  listStaffsByParentId: ListStaffsByParentIdByParentIdResponse;
  listTaxCategories: ListTaxCategoriesResponse;
  listUserNotes: ListUserNotesResponse;
};


export type QueryAnnualReportGetAnnualReportBoArgs = {
  input: AnnualReportGetOneInput;
};


export type QueryAnnualReportGetAnnualReportMobileArgs = {
  input: AnnualReportGetOneInput;
};


export type QueryAnnualReportGetFieldFileContentsBoArgs = {
  input: AnnualReportSpecificFieldFileMobileInput;
};


export type QueryAnnualReportGetFieldFileContentsMobileArgs = {
  input: AnnualReportSpecificFieldFileMobileInput;
};


export type QueryAnnualReportListAnnualReportsBoArgs = {
  input: AnnualReportListBoInput;
};


export type QueryAnnualReportListAnnualReportsMobileArgs = {
  input: AnnualReportListMobileInput;
};


export type QueryBusinessBillingsChartDataArgs = {
  input: BusinessBillingsChartDataInput;
};


export type QueryBusinessBillingsDataByDateArgs = {
  input: BusinessBillingsDataByDateInput;
};


export type QueryBusinessBillingsTableByDateArgs = {
  input: BusinessBillingsTableByDateInput;
};


export type QueryGetAccountantSignatureArgs = {
  input: GetAccountantSignatureInput;
};


export type QueryGetAccountantSignatureUploadUrlArgs = {
  input: GetAccountantSignatureUploadUrlInput;
};


export type QueryGetBusinessArgs = {
  input: GetBusinessInput;
};


export type QueryGetBusinessExpenseArgs = {
  input: GetBusinessExpenseInput;
};


export type QueryGetBusinessFileArgs = {
  input: GetBusinessFileInput;
};


export type QueryGetBusinessFileUploadUrlArgs = {
  input: GetBusinessFileUploadUrlInput;
};


export type QueryGetBusinessIncomeArgs = {
  input: GetBusinessIncomeInput;
};


export type QueryGetBusinessIncomePaymentGrowDataArgs = {
  input: GetBusinessIncomePaymentGrowDataInput;
};


export type QueryGetBusinessIncomesCeilingForBusinessArgs = {
  input: GetBusinessIncomesCeilingForBusinessInput;
};


export type QueryGetBusinessNotificationArgs = {
  input: GetBusinessNotificationInput;
};


export type QueryGetBusinessPendingPaymentsDataArgs = {
  input: GetBusinessPendingPaymentsDataInput;
};


export type QueryGetBusinessProviderArgs = {
  input: GetBusinessProviderInput;
};


export type QueryGetBusinessReportArgs = {
  input: GetBusinessReportInput;
};


export type QueryGetBusinessSetupArgs = {
  input: GetBusinessSetupInput;
};


export type QueryGetCountBusinessFailedBillingsArgs = {
  input: GetCountBusinessFailedBillingsInput;
};


export type QueryGetCountOpenfrmtFilesArgs = {
  input: GetCountOpenfrmtFilesInput;
};


export type QueryGetCurrencyRateArgs = {
  input: GetCurrencyRateInput;
};


export type QueryGetDinVeHeshbonDataBoArgs = {
  input: GetDinVeHeshbonDataInput;
};


export type QueryGetDinVeHeshbonDataMobileArgs = {
  input: GetDinVeHeshbonDataInput;
};


export type QueryGetListYearsForBusinessBoArgs = {
  input: GetListYearsForBusinessInput;
};


export type QueryGetListYearsForBusinessMobileArgs = {
  input: GetListYearsForBusinessInput;
};


export type QueryGetNextBusinessSubscriptionPaymentArgs = {
  input: GetNextBusinessSubscriptionPaymentInput;
};


export type QueryGetNextIncomeInvoiceNumberArgs = {
  input: GetNextIncomeInvoiceNumberInput;
};


export type QueryGetPreviousIncomeDateArgs = {
  input: GetPreviousIncomeInput;
};


export type QueryGetSpreadsheetIncomesArgs = {
  input: GetSpreadsheetIncomesInput;
};


export type QueryGetStatisticsForBusinessArgs = {
  input: GetStatisticsForBusinessInput;
};


export type QueryGetTaxCategoryArgs = {
  input: GetTaxCategoryInput;
};


export type QueryListActivitiesForBusinessArgs = {
  input: ListActivitiesForBusinessInput;
};


export type QueryListBusinessBillingsArgs = {
  input: ListBusinessBillingsInput;
};


export type QueryListBusinessDocumentsArgs = {
  input: ListBusinessDocumentsInput;
};


export type QueryListBusinessExpensesArgs = {
  input: ListBusinessExpensesInput;
};


export type QueryListBusinessExpensesInApprovalProcessArgs = {
  businessId: Scalars['ID']['input'];
  expenseStatus: Array<BusinessExpenseStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryListBusinessExpenses_reportArgs = {
  input: ListBusinessExpensesInput;
};


export type QueryListBusinessFilesArgs = {
  input: ListBusinessFilesInput;
};


export type QueryListBusinessIncomesArgs = {
  input: ListBusinessIncomesInput;
};


export type QueryListBusinessIncomesDocumentsArgs = {
  input: ListBusinessIncomesDocumentsInput;
};


export type QueryListBusinessIncomesStatisticsArgs = {
  input: ListBusinessIncomesStatisticsInput;
};


export type QueryListBusinessIndustriesArgs = {
  input: ListBusinessIndustriesInput;
};


export type QueryListBusinessPendingDocumentsToUploadArgs = {
  input: ListBusinessPendingDocumentsToUploadInput;
};


export type QueryListBusinessRecentIncomeItemsArgs = {
  input: ListBusinessRecentIncomeItemsInput;
};


export type QueryListBusinessReportsArgs = {
  input: ListBusinessReportsInput;
};


export type QueryListBusinessReportsMonthlyArgs = {
  input: ListBusinessReportsMonthlyInput;
};


export type QueryListBusinessSubscriptionsArgs = {
  input: PaginatedListInput;
};


export type QueryListBusinessesBaseArgs = {
  input: ListBusinessesBaseInput;
};


export type QueryListBusinessesCrmArgs = {
  input: ListBusinessesCrmInput;
};


export type QueryListCompanySubscriptionPlanArgs = {
  input: ListCompanySubscriptionPlanInput;
};


export type QueryListDiscountPhoneNumbersArgs = {
  input: ListDiscountPhoneNumbersInput;
};


export type QueryListOpenfrmtFilesArgs = {
  input: ListOpenfrmtFilesInput;
};


export type QueryListPopularProvidersArgs = {
  input: ListPopularProvidersInput;
};


export type QueryListProvidersArgs = {
  input: ListProvidersInput;
};


export type QueryListStaffsArgs = {
  input: ListStaffsInput;
};


export type QueryListStaffsByParentIdArgs = {
  input: ListStaffsByParentIdInput;
};


export type QueryListTaxCategoriesArgs = {
  input: ListTaxCategoriesInput;
};


export type QueryListUserNotesArgs = {
  input: ListUserNotesInput;
};

export type ReasonImportedIncomes = {
  __typename: 'ReasonImportedIncomes';
  message?: Maybe<Scalars['String']['output']>;
};

export type RefundBusinessBillingInput = {
  billingId: Scalars['ID']['input'];
};

export type RefundExpenseInput = {
  expenseId: Scalars['ID']['input'];
};

export type RemoveCreditsInput = {
  creditsId: Scalars['ID']['input'];
};

export type RemoveCreditsOutput = {
  __typename: 'RemoveCreditsOutput';
  endDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ReopenApprovedBusinessExpenseInput = {
  businessId: Scalars['ID']['input'];
  expenseId: Scalars['ID']['input'];
};

export type ReopenBusinessReportInput = {
  reportId: Scalars['ID']['input'];
};

export type ReopenBusinessReportOutput = {
  __typename: 'ReopenBusinessReportOutput';
  businessId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  reportStatus: BusinessReportStatus;
};

export type ResponseBusinessApprovedInput = {
  reportId: Scalars['ID']['input'];
};

export type ResponseBusinessApprovedOutput = {
  __typename: 'ResponseBusinessApprovedOutput';
  businessId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  reportStatus: BusinessReportStatus;
};

export type ResponseBusinessDeclinedInput = {
  reportId: Scalars['ID']['input'];
};

export type ResponseBusinessDeclinedOutput = {
  __typename: 'ResponseBusinessDeclinedOutput';
  businessId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  reportStatus: BusinessReportStatus;
};

export enum RestoreBusinessError {
  INVALID_BUSINESS_STATUS = 'INVALID_BUSINESS_STATUS'
}

export type RestoreBusinessInput = {
  businessId: Scalars['ID']['input'];
};

export type RestoreBusinessOutput = {
  __typename: 'RestoreBusinessOutput';
  error?: Maybe<CancelBusinessError>;
  success: Scalars['Boolean']['output'];
};

export type SelfEmployedStartObject = {
  averageIncomeNis?: InputMaybe<Scalars['Int']['input']>;
  averageWorkingHours?: InputMaybe<AverageWorkingHoursOptions>;
  dateOfStarting?: InputMaybe<Scalars['String']['input']>;
};

export type SelfEmployedStartObjectX = {
  __typename: 'SelfEmployedStartObjectX';
  averageIncomeNis?: Maybe<Scalars['Int']['output']>;
  averageWorkingHours?: Maybe<AverageWorkingHoursOptions>;
  dateOfStarting?: Maybe<Scalars['String']['output']>;
};

export type SendBusinessIncomeToEmailInput = {
  email: Scalars['String']['input'];
  incomeId: Scalars['String']['input'];
  isEnglish: Scalars['Boolean']['input'];
};

export type SendBusinessIncomeToEmailOutput = {
  __typename: 'SendBusinessIncomeToEmailOutput';
  attachments: Scalars['String']['output'];
  businessId: Scalars['ID']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  emailStatus: EmailStatus;
  id: Scalars['ID']['output'];
  recipient: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
};

export type SetUserNotificationTokenInput = {
  fcmToken: Scalars['String']['input'];
  mobilePlatform: MobilePlatformType;
};

export type SetWasUserContactedInput = {
  userId: Scalars['ID']['input'];
};

export type SetWasUserContactedOutput = {
  __typename: 'SetWasUserContactedOutput';
  data: Scalars['Boolean']['output'];
};

export type SignUpInput = {
  identityId: Scalars['String']['input'];
};

export type SignUpOutput = {
  __typename: 'SignUpOutput';
  id: Scalars['ID']['output'];
  mobile: Scalars['String']['output'];
  onboardingStatus: OnboardingStatus;
};

export type SingleOccupationOptions = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  isCurrentlyWorkingInThisJob?: InputMaybe<Scalars['Boolean']['input']>;
  occupation?: InputMaybe<OccupationOptions>;
  upToDate?: InputMaybe<Scalars['String']['input']>;
};

export type SingleOccupationOptionsX = {
  __typename: 'SingleOccupationOptionsX';
  fromDate?: Maybe<Scalars['String']['output']>;
  isCurrentlyWorkingInThisJob?: Maybe<Scalars['Boolean']['output']>;
  occupation?: Maybe<OccupationOptions>;
  upToDate?: Maybe<Scalars['String']['output']>;
};

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type SourceOfIncomes = {
  incomeNis?: InputMaybe<Scalars['Int']['input']>;
  incomeSource?: InputMaybe<Scalars['String']['input']>;
};

export type SourceOfIncomesX = {
  __typename: 'SourceOfIncomesX';
  incomeNis?: Maybe<Scalars['Int']['output']>;
  incomeSource?: Maybe<Scalars['String']['output']>;
};

export type Staff = {
  __typename: 'Staff';
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idNumber: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
  signatureName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum StaffPriority {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export enum StaffTypes {
  ACCOUNTANT = 'ACCOUNTANT',
  ADMINISTRATOR = 'ADMINISTRATOR',
  SUB_ACCOUNTANT = 'SUB_ACCOUNTANT',
  SUB_ADMINISTRATOR = 'SUB_ADMINISTRATOR'
}

export type SubmitAuthoritiesIdentificationInput = {
  birthDate: Scalars['String']['input'];
  businessId: Scalars['ID']['input'];
  type: IdentificationType;
  value: Scalars['String']['input'];
};

export type SubmitAuthoritiesIdentificationOutput = {
  __typename: 'SubmitAuthoritiesIdentificationOutput';
  businessId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  onboardingStatus: OnboardingStatus;
};

export type SubmitBankDetailsInput = {
  bankAccount: Scalars['Int']['input'];
  bankBranch: Scalars['Int']['input'];
  bankName: Scalars['Int']['input'];
  businessId: Scalars['ID']['input'];
  name: Translations;
};

export type SubmitBankDetailsOutput = {
  __typename: 'SubmitBankDetailsOutput';
  data: Scalars['Boolean']['output'];
};

export type SubmitBillingDetailsInput = {
  businessId: Scalars['String']['input'];
  buyerCardExpiration: Scalars['String']['input'];
  buyerCardMask: Scalars['String']['input'];
  buyerKey: Scalars['String']['input'];
};

export type SubmitBillingDetailsOutput = {
  __typename: 'SubmitBillingDetailsOutput';
  businessId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  onboardingStatus: OnboardingStatus;
  status: BusinessStatus;
};

export type SubmitBusinessApprovalStepFiveInput = {
  businessId: Scalars['ID']['input'];
};

export type SubmitBusinessApprovalStepFourInput = {
  businessId: Scalars['ID']['input'];
};

export type SubmitBusinessApprovalStepOneInput = {
  accountantRepresentation: BusinessAccountantRepresentationType;
  businessId: Scalars['ID']['input'];
  businessIndustryId: Scalars['String']['input'];
  isNewBusiness: Scalars['Boolean']['input'];
  representationRequestNumber: Scalars['String']['input'];
};

export type SubmitBusinessApprovalStepThreeInput = {
  businessId: Scalars['ID']['input'];
  signature: Scalars['String']['input'];
};

export type SubmitBusinessApprovalStepTwoInput = {
  businessId: Scalars['ID']['input'];
  signature: Scalars['String']['input'];
};

export type SubmitBusinessDetailsInput = {
  businessName: Scalars['String']['input'];
  city: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  idNumber: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type SubmitBusinessDetailsOutput = {
  __typename: 'SubmitBusinessDetailsOutput';
  businessId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  onboardingStatus: OnboardingStatus;
};

export type SubmitBusinessEnglishDetailsInput = {
  businessId: Scalars['ID']['input'];
  businessNameEn: Scalars['String']['input'];
};

export type SubmitBusinessEnglishDetailsOutput = {
  __typename: 'SubmitBusinessEnglishDetailsOutput';
  data: Scalars['Boolean']['output'];
};

export type SubmitBusinessLogoInput = {
  base64BusinessLogo?: InputMaybe<Scalars['String']['input']>;
  businessId: Scalars['ID']['input'];
};

export type SubmitBusinessLogoOutput = {
  __typename: 'SubmitBusinessLogoOutput';
  data: Scalars['Boolean']['output'];
};

export type SubmitBusinessSetupInput = {
  businessType: BusinessSetupBusinessType;
  hasAccountant: Scalars['Boolean']['input'];
  hasBusiness: Scalars['Boolean']['input'];
  hasEmployees: Scalars['Boolean']['input'];
};

export type SubmitBusinessSetupOutput = {
  __typename: 'SubmitBusinessSetupOutput';
  id: Scalars['ID']['output'];
  mobile: Scalars['String']['output'];
  onboardingStatus: OnboardingStatus;
};

export type SubmitCompanySubscriptionPlanInput = {
  companyName: Scalars['String']['input'];
  subscriptionPlanTypeDiscount?: InputMaybe<Scalars['String']['input']>;
  subscriptionPlanTypeFree?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitContactUsFormInput = {
  mail: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitFriendReferralInput = {
  mobile: Scalars['String']['input'];
  referralId: Scalars['String']['input'];
};

export type SubmitFriendReferralOutput = {
  __typename: 'SubmitFriendReferralOutput';
  mobile: Scalars['String']['output'];
  planType: PlanType;
  planTypeFree?: Maybe<PlanType>;
};

export type SubmitGiftDetailsInput = {
  businessId: Scalars['ID']['input'];
};

export type SubmitGiftDetailsOutput = {
  __typename: 'SubmitGiftDetailsOutput';
  businessId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  onboardingStatus: OnboardingStatus;
};

export type SubmitIdentificationUploadInput = {
  bankDocumentType: Scalars['String']['input'];
  businessId: Scalars['ID']['input'];
};

export type SubmitIdentificationUploadOutput = {
  __typename: 'SubmitIdentificationUploadOutput';
  businessId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  onboardingStatus: OnboardingStatus;
};

export type SubmitIncomeDocumentCommentsInput = {
  businessId: Scalars['ID']['input'];
  footer?: InputMaybe<Translations>;
  main?: InputMaybe<Translations>;
};

export type SubmitIncomeDocumentCommentsOutput = {
  __typename: 'SubmitIncomeDocumentCommentsOutput';
  data: Scalars['Boolean']['output'];
};

export type SubmitNewBusinessDetailsInput = {
  businessId: Scalars['ID']['input'];
  businessIndustryId: Scalars['String']['input'];
  businessSecondaryIndustryId?: InputMaybe<Scalars['String']['input']>;
  expectedMonthlyIncome: Scalars['Float']['input'];
};

export type SubmitNewBusinessDetailsOutput = {
  __typename: 'SubmitNewBusinessDetailsOutput';
  businessId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  onboardingStatus: OnboardingStatus;
};

export type SubmitReportForBusinessApprovalInput = {
  businessId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};

export type SubmitReportForBusinessApprovalOutput = {
  __typename: 'SubmitReportForBusinessApprovalOutput';
  businessId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  reportStatus: BusinessReportStatus;
};

export type SyncContactsContact = {
  emailAddresses: Array<SyncContactsEmailAddresses>;
  names: Array<SyncContactsNames>;
  organizations: Array<SyncContactsOrganizations>;
  phoneNumbers: Array<SyncContactsPhoneNumbers>;
};

export type SyncContactsContactGroup = {
  name: Scalars['String']['input'];
};

export type SyncContactsDevelop = {
  contactGroupName?: InputMaybe<Scalars['String']['input']>;
  subjectIn: Scalars['String']['input'];
  subjectOut?: InputMaybe<Scalars['String']['input']>;
};

export type SyncContactsEmailAddresses = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type SyncContactsInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Array<SyncContactsPeopleContact>>;
  develop?: InputMaybe<SyncContactsDevelop>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SyncContactsNames = {
  displayName: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
};

export type SyncContactsOrganizations = {
  name: Scalars['String']['input'];
};

export type SyncContactsPeopleContact = {
  contact: SyncContactsContact;
  contactGroups?: InputMaybe<Array<SyncContactsContactGroup>>;
};

export type SyncContactsPhoneNumbers = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TaxAuthorityOpenApiInput = {
  businessId: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  incomeId?: InputMaybe<Scalars['String']['input']>;
  operation: Operations;
  reportId?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type TaxAuthorityOpenApiOutput = {
  __typename: 'TaxAuthorityOpenApiOutput';
  data: Scalars['AWSJSON']['output'];
  status: OperationStatus;
};

export type TaxCategory = {
  __typename: 'TaxCategory';
  categoryName: Scalars['String']['output'];
  expenseCategory: TaxCategoryVatType;
  taxCategoryNumber: Scalars['Int']['output'];
  taxDeductionPercentage: Scalars['Float']['output'];
  vatDeductionPercentage: Scalars['Float']['output'];
};

export enum TaxCategoryProfitLossCategory {
  ADMINISTRATIVE_AND_GENERAL_EXPENSES = 'ADMINISTRATIVE_AND_GENERAL_EXPENSES',
  OTHER = 'OTHER',
  SELLING_COSTS = 'SELLING_COSTS'
}

export enum TaxCategoryVatType {
  ASSETS = 'ASSETS',
  OTHER = 'OTHER'
}

export type Translations = {
  ENGLISH?: InputMaybe<Scalars['String']['input']>;
  HEBREW?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBusinessAddressInput = {
  businessId: Scalars['ID']['input'];
  city: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type UpdateBusinessAdvanceTaxRateForReportInput = {
  advanceTaxRate: Scalars['Float']['input'];
  businessId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};

export type UpdateBusinessAdvanceTaxRateForReportOutput = {
  __typename: 'UpdateBusinessAdvanceTaxRateForReportOutput';
  data: Scalars['Boolean']['output'];
};

export type UpdateBusinessAdvancesInput = {
  businessId: Scalars['ID']['input'];
  updatedAdvances: Scalars['Float']['input'];
};

export type UpdateBusinessApprovalStatusInput = {
  approvalStatus: BusinessApprovalStatus;
  businessId: Scalars['ID']['input'];
};

export type UpdateBusinessApprovalStatusOutput = {
  __typename: 'UpdateBusinessApprovalStatusOutput';
  data: Scalars['Boolean']['output'];
};

export type UpdateBusinessBillingDetailsInput = {
  businessId: Scalars['String']['input'];
  buyerCardExpiration: Scalars['String']['input'];
  buyerCardMask: Scalars['String']['input'];
  buyerKey: Scalars['String']['input'];
};

export type UpdateBusinessBillingDetailsOutput = {
  __typename: 'UpdateBusinessBillingDetailsOutput';
  data: Scalars['Boolean']['output'];
};

export type UpdateBusinessBituahLeumiPaymentForReportInput = {
  bituahLeumiPaymentFirstPayment: Scalars['Float']['input'];
  bituahLeumiPaymentSecondPayment: Scalars['Float']['input'];
  businessId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};

export type UpdateBusinessBituahLeumiPaymentForReportOutput = {
  __typename: 'UpdateBusinessBituahLeumiPaymentForReportOutput';
  data: Scalars['Boolean']['output'];
};

export type UpdateBusinessBituahLeumiPaymentInput = {
  bituahLeumiPayment: Scalars['Float']['input'];
  businessId: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};

export type UpdateBusinessCertificateInput = {
  businessId: Scalars['ID']['input'];
};

export type UpdateBusinessCertificateOutput = {
  __typename: 'UpdateBusinessCertificateOutput';
  data: Scalars['Boolean']['output'];
};

export type UpdateBusinessDetailsInput = {
  businessId: Scalars['ID']['input'];
  businessIndustryId?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessSecondaryIndustryId?: InputMaybe<Scalars['String']['input']>;
  isEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  isImportDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  partnerRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  paymentIdNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompletedInUserNoteInput = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateCompletedInUserNoteOutput = {
  __typename: 'UpdateCompletedInUserNoteOutput';
  data: Scalars['Boolean']['output'];
};

export type UpdatePaymentsForReportsBituahLeumiInput = {
  bituahLeumiPayment: Scalars['Float']['input'];
  bituahLeumiType: BusinessBituahLeumiType;
  id: Scalars['ID']['input'];
  startDate: Scalars['String']['input'];
};

export type UpdatePaymentsForReportsInput = {
  advanceTaxRate?: InputMaybe<Scalars['Float']['input']>;
  bituahLeumi: Array<InputMaybe<UpdatePaymentsForReportsBituahLeumiInput>>;
  businessId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};

export type UpdatePaymentsForReportsOutput = {
  __typename: 'UpdatePaymentsForReportsOutput';
  data: Scalars['Boolean']['output'];
};

export type UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsInput = {
  accountantRepresentation: Scalars['String']['input'];
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
  businessIndustryId: Scalars['String']['input'];
  isNewBusiness: Scalars['Boolean']['input'];
  missingDocuments: Scalars['String']['input'];
  representationRequestNumber: Scalars['String']['input'];
};

export type UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsOutput = {
  __typename: 'UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsOutput';
  data: Scalars['Boolean']['output'];
};

export type UploadUnsignedVatBusinessCreationDocumentInput = {
  businessApprovalStatus: BusinessApprovalStatus;
  businessId: Scalars['String']['input'];
};

export type UploadUnsignedVatBusinessCreationDocumentOutput = {
  __typename: 'UploadUnsignedVatBusinessCreationDocumentOutput';
  data: Scalars['Boolean']['output'];
};

export type User = {
  __typename: 'User';
  bankDocumentType?: Maybe<BankDocumentType>;
  birthDate?: Maybe<Scalars['String']['output']>;
  businesses?: Maybe<Array<Business>>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Array<Credit>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idNumber?: Maybe<Scalars['String']['output']>;
  identificationType?: Maybe<IdentificationType>;
  identificationValue?: Maybe<Scalars['String']['output']>;
  identityId: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mobile: Scalars['String']['output'];
  onboardingStatus: OnboardingStatus;
  streetAddress?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  wasContacted?: Maybe<Scalars['Boolean']['output']>;
};

export type BankToPdfInput = {
  businessId: Scalars['ID']['input'];
};

export type BankToPdfOutput = {
  __typename: 'bankToPdfOutput';
  document: Scalars['String']['output'];
};

export type IdToPdfInput = {
  businessId: Scalars['ID']['input'];
};

export type IdToPdfOutput = {
  __typename: 'idToPdfOutput';
  document: Scalars['String']['output'];
};

export type ImportIncomesFiles = {
  files: Array<ImportIncomesFilesData>;
};

export type ImportIncomesFilesData = {
  base64File: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type ListPopularProvidersResponse = {
  __typename: 'listPopularProvidersResponse';
  items?: Maybe<Array<BusinessProvider>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type UpdateTaxDeductionDataInput = {
  calledFrom?: InputMaybe<Scalars['String']['input']>;
};

export type AccountantSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables = Exact<{
  input: AccountantSignTaxAuthorityAndBituahLeumiDocumentsInput;
}>;


export type AccountantSignTaxAuthorityAndBituahLeumiDocumentsMutation = { __typename: 'Mutation', accountantSignTaxAuthorityAndBituahLeumiDocuments: { __typename: 'AccountantSignTaxAuthorityAndBituahLeumiDocumentsOutput', data: boolean } };

export type AccountantSignVatBusinessCreationDocumentMutationVariables = Exact<{
  input: AccountantSignVatBusinessCreationDocumentInput;
}>;


export type AccountantSignVatBusinessCreationDocumentMutation = { __typename: 'Mutation', accountantSignVatBusinessCreationDocument: { __typename: 'AccountantSignVatBusinessCreationDocumentOutput', data: boolean } };

export type AddDiscountPhoneNumberMutationVariables = Exact<{
  input: AddDiscountPhoneNumberInput;
}>;


export type AddDiscountPhoneNumberMutation = { __typename: 'Mutation', addDiscountPhoneNumber: { __typename: 'AddDiscountPhoneNumberOutput', mobile: string } };

export type AddNewStaffMutationVariables = Exact<{
  input: AddNewStaffInput;
}>;


export type AddNewStaffMutation = { __typename: 'Mutation', addNewStaff: { __typename: 'AddNewStaffOutput', data: boolean } };

export type AnnualReportRemoveFieldFileBoMutationVariables = Exact<{
  input: AnnualReportRemoveFieldFileBoInput;
}>;


export type AnnualReportRemoveFieldFileBoMutation = { __typename: 'Mutation', annualReportRemoveFieldFileBo: { __typename: 'AnnualReportSuccessBooleanOutput', success: boolean } };

export type AnnualReportRemoveFieldFileMobileMutationVariables = Exact<{
  input: AnnualReportRemoveFieldFileMobileInput;
}>;


export type AnnualReportRemoveFieldFileMobileMutation = { __typename: 'Mutation', annualReportRemoveFieldFileMobile: { __typename: 'AnnualReportSuccessBooleanOutput', success: boolean } };

export type AnnualReportReviewAnnualReportBoMutationVariables = Exact<{
  input: AnnualReportReviewAnnualReportBoInput;
}>;


export type AnnualReportReviewAnnualReportBoMutation = { __typename: 'Mutation', annualReportReviewAnnualReportBo: { __typename: 'AnnualReportSuccessBooleanOutput', success: boolean } };

export type AnnualReportUploadFieldFileBoMutationVariables = Exact<{
  input: AnnualReportUploadFieldFileBoInput;
}>;


export type AnnualReportUploadFieldFileBoMutation = { __typename: 'Mutation', annualReportUploadFieldFileBo: { __typename: 'AnnualReportUploadFieldFileOutput', newFileName: string } };

export type AnnualReportUploadFieldFileMobileMutationVariables = Exact<{
  input: AnnualReportUploadFieldFileMobileInput;
}>;


export type AnnualReportUploadFieldFileMobileMutation = { __typename: 'Mutation', annualReportUploadFieldFileMobile: { __typename: 'AnnualReportUploadFieldFileOutput', newFileName: string } };

export type AnnualReportValidateAndSubmitFormBoMutationVariables = Exact<{
  input: AnnualReportValidateAndSubmitFormBoInput;
}>;


export type AnnualReportValidateAndSubmitFormBoMutation = { __typename: 'Mutation', annualReportValidateAndSubmitFormBo: { __typename: 'AnnualReportSuccessBooleanOutput', success: boolean } };

export type AnnualReportValidateAndSubmitFormMobileMutationVariables = Exact<{
  input: AnnualReportValidateAndSubmitFormMobileInput;
}>;


export type AnnualReportValidateAndSubmitFormMobileMutation = { __typename: 'Mutation', annualReportValidateAndSubmitFormMobile: { __typename: 'AnnualReportSuccessBooleanOutput', success: boolean } };

export type AnnualReportValidateAndSubmitStepsBoMutationVariables = Exact<{
  input: AnnualReportValidateAndSubmitStepsBoInput;
}>;


export type AnnualReportValidateAndSubmitStepsBoMutation = { __typename: 'Mutation', annualReportValidateAndSubmitStepsBo: { __typename: 'AnnualReportSuccessBooleanOutput', success: boolean } };

export type AnnualReportValidateAndSubmitStepsMobileMutationVariables = Exact<{
  input: AnnualReportValidateAndSubmitStepsMobileInput;
}>;


export type AnnualReportValidateAndSubmitStepsMobileMutation = { __typename: 'Mutation', annualReportValidateAndSubmitStepsMobile: { __typename: 'AnnualReportSuccessBooleanOutput', success: boolean } };

export type ApproveBusinessMutationVariables = Exact<{
  input: ApproveBusinessInput;
}>;


export type ApproveBusinessMutation = { __typename: 'Mutation', approveBusiness: { __typename: 'ApproveBusinessOutput', data: boolean } };

export type ApproveBusinessExpenseMutationVariables = Exact<{
  input: ApproveBusinessExpenseInput;
}>;


export type ApproveBusinessExpenseMutation = { __typename: 'Mutation', approveBusinessExpense: { __typename: 'ApproveBusinessExpenseOutput', status: { __typename: 'OperationStatus', operationName: string, success: boolean, err: string, warn: Array<string | null | undefined> }, data: { __typename: 'ApproveBusinessExpenseData', id: string, isDuplicate: boolean } } };

export type ApproveRepresentationMutationVariables = Exact<{
  input: ApproveRepresentationInput;
}>;


export type ApproveRepresentationMutation = { __typename: 'Mutation', approveRepresentation: { __typename: 'ApproveRepresentationOutput', data: boolean } };

export type ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsMutationVariables = Exact<{
  input: ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsInput;
}>;


export type ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsMutation = { __typename: 'Mutation', approveSignaturesOnTaxAuthorityAndBituahLeumiDocuments: { __typename: 'ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsOutput', data: boolean } };

export type ApproveSignaturesOnVatBusinessCreationDocumentMutationVariables = Exact<{
  input: ApproveSignaturesOnVatBusinessCreationDocumentInput;
}>;


export type ApproveSignaturesOnVatBusinessCreationDocumentMutation = { __typename: 'Mutation', approveSignaturesOnVatBusinessCreationDocument: { __typename: 'ApproveSignaturesOnVatBusinessCreationDocumentOutput', data: boolean } };

export type BankToPdfMutationVariables = Exact<{
  input: BankToPdfInput;
}>;


export type BankToPdfMutation = { __typename: 'Mutation', bankToPdf: { __typename: 'bankToPdfOutput', document: string } };

export type BusinessPaymentRequestMutationVariables = Exact<{
  input: BusinessPaymentRequestInput;
}>;


export type BusinessPaymentRequestMutation = { __typename: 'Mutation', businessPaymentRequest: { __typename: 'BusinessPaymentRequestOutput', data?: string | null | undefined } };

export type BusinessSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables = Exact<{
  input: BusinessSignTaxAuthorityAndBituahLeumiDocumentsInput;
}>;


export type BusinessSignTaxAuthorityAndBituahLeumiDocumentsMutation = { __typename: 'Mutation', businessSignTaxAuthorityAndBituahLeumiDocuments: { __typename: 'BusinessSignTaxAuthorityAndBituahLeumiDocumentsOutput', data: boolean } };

export type BusinessSignVatBusinessCreationDocumentMutationVariables = Exact<{
  input: BusinessSignVatBusinessCreationDocumentInput;
}>;


export type BusinessSignVatBusinessCreationDocumentMutation = { __typename: 'Mutation', businessSignVatBusinessCreationDocument: { __typename: 'BusinessSignVatBusinessCreationDocumentOutput', data: boolean } };

export type BusinessSubscriptionConverterMutationVariables = Exact<{
  input: BusinessSubscriptionConverterInput;
}>;


export type BusinessSubscriptionConverterMutation = { __typename: 'Mutation', businessSubscriptionConverter: { __typename: 'BusinessSubscriptionConverterOutput', data: boolean } };

export type BusinessTypeConverterMutationVariables = Exact<{
  input: BusinessTypeConverterInput;
}>;


export type BusinessTypeConverterMutation = { __typename: 'Mutation', businessTypeConverter: { __typename: 'BusinessTypeConverterOutput', data: boolean } };

export type BusinessUploadMissingDocumentsMutationVariables = Exact<{
  input: BusinessUploadMissingDocumentsInput;
}>;


export type BusinessUploadMissingDocumentsMutation = { __typename: 'Mutation', businessUploadMissingDocuments: { __typename: 'BusinessUploadMissingDocumentsOutput', data: boolean } };

export type CalculationBusinessReportMutationVariables = Exact<{
  input: CalculationBusinessReportInput;
}>;


export type CalculationBusinessReportMutation = { __typename: 'Mutation', calculationBusinessReport: { __typename: 'CalculationBusinessReportOutput', success: boolean, error?: CalculationBusinessReportError | null | undefined } };

export type CanBeBlockedMutationVariables = Exact<{
  input: CanBeBlockedInput;
}>;


export type CanBeBlockedMutation = { __typename: 'Mutation', canBeBlocked: { __typename: 'CanBeBlockedOutput', data: boolean } };

export type CancelBusinessMutationVariables = Exact<{
  input: CancelBusinessInput;
}>;


export type CancelBusinessMutation = { __typename: 'Mutation', cancelBusiness: { __typename: 'CancelBusinessOutput', success: boolean, error?: CancelBusinessError | null | undefined } };

export type ChargeFailedBusinessBillingMutationVariables = Exact<{
  input: ChargeFailedBusinessBillingInput;
}>;


export type ChargeFailedBusinessBillingMutation = { __typename: 'Mutation', chargeFailedBusinessBilling: boolean };

export type ChargeFailedBusinessBillingMobileMutationVariables = Exact<{
  input: ChargeFailedBusinessBillingMobileInput;
}>;


export type ChargeFailedBusinessBillingMobileMutation = { __typename: 'Mutation', chargeFailedBusinessBillingMobile: { __typename: 'ChargeFailedBusinessBillingMobileOutput', data: boolean } };

export type CloseBusinessReportMutationVariables = Exact<{
  input: CloseBusinessReportInput;
}>;


export type CloseBusinessReportMutation = { __typename: 'Mutation', closeBusinessReport: { __typename: 'CloseBusinessReportOutput', id: string } };

export type CreateBusinessIncomeMutationVariables = Exact<{
  input: CreateBusinessIncomeInput;
}>;


export type CreateBusinessIncomeMutation = { __typename: 'Mutation', createBusinessIncome: { __typename: 'CreateBusinessIncomeOutput', id: string, invoiceNumber: number } };

export type CreateCustomerMutationVariables = Exact<{
  input: CreateCustomerInput;
}>;


export type CreateCustomerMutation = { __typename: 'Mutation', createCustomer: { __typename: 'CreateCustomerOutput', data?: boolean | null | undefined } };

export type CreateExpenseMutationVariables = Exact<{
  input: CreateBusinessExpenseInput;
}>;


export type CreateExpenseMutation = { __typename: 'Mutation', createBusinessExpense: { __typename: 'CreateBusinessExpenseOutput', expenseId: string } };

export type CreateProviderMutationVariables = Exact<{
  input: CreateProviderInput;
}>;


export type CreateProviderMutation = { __typename: 'Mutation', createProvider: { __typename: 'CreateProviderOutput', id: string } };

export type CreateTaxCategoryMutationVariables = Exact<{
  input: CreateTaxCategoryInput;
}>;


export type CreateTaxCategoryMutation = { __typename: 'Mutation', createTaxCategory: { __typename: 'CreateTaxCategoryOutput', irsCode: number } };

export type CreateUserNoteMutationVariables = Exact<{
  input: CreateUserNoteInput;
}>;


export type CreateUserNoteMutation = { __typename: 'Mutation', createUserNote: { __typename: 'CreateUserNoteOutput', data: boolean } };

export type DeclineBusinessExpenseDisputeMutationVariables = Exact<{
  input: DeclineBusinessExpenseDisputeInput;
}>;


export type DeclineBusinessExpenseDisputeMutation = { __typename: 'Mutation', declineBusinessExpenseDispute: boolean };

export type DeleteBusinessExpenseMutationVariables = Exact<{
  input: DeleteBusinessExpenseInput;
}>;


export type DeleteBusinessExpenseMutation = { __typename: 'Mutation', deleteBusinessExpense: boolean };

export type DeleteBusinessFileMutationVariables = Exact<{
  input: DeleteBusinessFileInput;
}>;


export type DeleteBusinessFileMutation = { __typename: 'Mutation', deleteBusinessFile: { __typename: 'DeleteBusinessFileOutput', data: boolean } };

export type DeleteUserNotificationTokenMutationVariables = Exact<{
  input: DeleteUserNotificationTokenInput;
}>;


export type DeleteUserNotificationTokenMutation = { __typename: 'Mutation', deleteUserNotificationToken: boolean };

export type DisputeBusinessExpenseMutationVariables = Exact<{
  input: DisputeBusinessExpenseInput;
}>;


export type DisputeBusinessExpenseMutation = { __typename: 'Mutation', disputeBusinessExpense: { __typename: 'DisputeBusinessExpenseOutput', id: string } };

export type DocumentTreeMutationVariables = Exact<{
  input: DocumentTreeInput;
}>;


export type DocumentTreeMutation = { __typename: 'Mutation', documentTree: { __typename: 'DocumentTreeOutput', items?: Array<{ __typename: 'DocumentTree', data?: { __typename: 'DocumentTreeData', id?: string | null | undefined, reportType?: string | null | undefined, incomeType?: string | null | undefined, priceIncludingVat?: string | null | undefined, price?: string | null | undefined, description?: string | null | undefined, incomeDate?: string | null | undefined, currency?: string | null | undefined, currencyRate?: string | null | undefined, reportId?: string | null | undefined, reportStartDate?: string | null | undefined, reportEndDate?: string | null | undefined } | null | undefined } | null | undefined> | null | undefined } };

export type DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables = Exact<{
  input: DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsInput;
}>;


export type DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsMutation = { __typename: 'Mutation', draftBusinessSignTaxAuthorityAndBituahLeumiDocuments: { __typename: 'DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsOutput', data: Array<{ __typename: 'PdfDataOutput', pdfType: string, base64Pdf: string }> } };

export type DraftBusinessSignVatBusinessCreationDocumentMutationVariables = Exact<{
  input: DraftBusinessSignVatBusinessCreationDocumentInput;
}>;


export type DraftBusinessSignVatBusinessCreationDocumentMutation = { __typename: 'Mutation', draftBusinessSignVatBusinessCreationDocument: { __typename: 'DraftBusinessSignVatBusinessCreationDocumentOutput', data: Array<{ __typename: 'PdfDataOutput', pdfType: string, base64Pdf: string }> } };

export type EditCustomerMutationVariables = Exact<{
  input: EditCustomerInput;
}>;


export type EditCustomerMutation = { __typename: 'Mutation', editCustomer: { __typename: 'EditCustomerOutput', data?: boolean | null | undefined } };

export type EditDinVeHeshbonToDbBoMutationVariables = Exact<{
  input: EditDinVeHeshbonToDbInput;
}>;


export type EditDinVeHeshbonToDbBoMutation = { __typename: 'Mutation', editDinVeHeshbonToDbBO: { __typename: 'EditDinVeHeshbonToDbOutput', message: string } };

export type EditProviderMutationVariables = Exact<{
  input: EditProviderInput;
}>;


export type EditProviderMutation = { __typename: 'Mutation', editProvider: { __typename: 'EditProviderOutput', id: string } };

export type EditTaxCategoryMutationVariables = Exact<{
  input: EditTaxCategoryInput;
}>;


export type EditTaxCategoryMutation = { __typename: 'Mutation', editTaxCategory: { __typename: 'EditTaxCategoryOutput', irsCode: number } };

export type FillDinVeHeshbonMutationVariables = Exact<{
  input: InsertDinVeHeshbonToDbInput;
}>;


export type FillDinVeHeshbonMutation = { __typename: 'Mutation', fillDinVeHeshbon: { __typename: 'FillDinVeHeshbonOutput', data: boolean } };

export type GenerateCardIndexMutationVariables = Exact<{
  input: GenerateCardIndexInput;
}>;


export type GenerateCardIndexMutation = { __typename: 'Mutation', generateCardIndex: { __typename: 'GenerateCardIndexOutput', base64Pdf: string } };

export type GenerateCashBookMutationVariables = Exact<{
  input: GenerateCashBookInput;
}>;


export type GenerateCashBookMutation = { __typename: 'Mutation', generateCashBook: { __typename: 'GenerateCashBookOutput', base64Pdf: string } };

export type GenerateJonniIncomeReportMutationVariables = Exact<{
  input: GenerateJonniIncomeReportInput;
}>;


export type GenerateJonniIncomeReportMutation = { __typename: 'Mutation', generateJonniIncomeReport: { __typename: 'File', url?: string | null | undefined } };

export type GenerateOpenfrmtFilesMutationVariables = Exact<{
  input: GenerateOpenfrmtFileInput;
}>;


export type GenerateOpenfrmtFilesMutation = { __typename: 'Mutation', generateOpenfrmtFiles: { __typename: 'GenerateOpenfrmtFileOutput', startDate: string, endDate: string, businessName: string, registrationNumber: string, route: string, entries: Array<{ __typename: 'GenerateOpenfrmtFileEntry', entry: string, total: number, title: string }>, documents: Array<{ __typename: 'GenerateOpenfrmtFileDocument', type: string, counter: number, amount: number, title: string }> } };

export type GenerateProfitLossDocumentMutationVariables = Exact<{
  input: GenerateProfitLossDocumentInput;
}>;


export type GenerateProfitLossDocumentMutation = { __typename: 'Mutation', generateProfitLossDocument: { __typename: 'GenerateProfitLossDocumentOutput', base64Pdf: string } };

export type GetDataFromPdfBoMutationVariables = Exact<{
  input: GetDataFromPdfInput;
}>;


export type GetDataFromPdfBoMutation = { __typename: 'Mutation', getDataFromPdfBO: { __typename: 'GetDataFromPdfOutput', incomeProvider: string, description: string, price: number, priceIncludingVat: number, totalDeductedVat: number, vat: number, currency: string } };

export type GetDataFromPdfMobileMutationVariables = Exact<{
  input: GetDataFromPdfInput;
}>;


export type GetDataFromPdfMobileMutation = { __typename: 'Mutation', getDataFromPdfMobile: { __typename: 'GetDataFromPdfOutput', description: string, currency: string, price: number, vat: number, priceIncludingVat: number, taxDeduction: number, incomeProvider: string, invoiceNumber: string, customerName: string, registrationNumber: string, fullPriceDeviation: number, base64Pdf: string, type: string, date: string, items: Array<{ __typename: 'ImportBusinessIncomeItemsOutput', description: string, vatType: string, units: number, unitPrice: number, price: number, vat: number, priceIncludingVat: number }>, payments: Array<{ __typename: 'ImportBusinessIncomePaymentsOutput', paymentMethod: string, price: number, taxDeduction?: number | null | undefined, date: string }> } };

export type HoldBusinessMutationVariables = Exact<{
  input: HoldBusinessInput;
}>;


export type HoldBusinessMutation = { __typename: 'Mutation', holdBusiness: { __typename: 'HoldBusinessOutput', success: boolean, error?: HoldBusinessError | null | undefined } };

export type IdToPdfMutationVariables = Exact<{
  input: IdToPdfInput;
}>;


export type IdToPdfMutation = { __typename: 'Mutation', idToPdf: { __typename: 'idToPdfOutput', document: string } };

export type ImportBusinessIncomeMutationVariables = Exact<{
  input: ImportBusinessIncomeInput;
}>;


export type ImportBusinessIncomeMutation = { __typename: 'Mutation', importBusinessIncome: { __typename: 'ImportBusinessIncomeOutput', id: string } };

export type InsertDinVeHeshbonToDbBoMutationVariables = Exact<{
  input: InsertDinVeHeshbonToDbInput;
}>;


export type InsertDinVeHeshbonToDbBoMutation = { __typename: 'Mutation', insertDinVeHeshbonToDbBO: { __typename: 'InsertDinVeHeshbonToDbOutput', message: string } };

export type InsertDinVeHeshbonToDbMobileMutationVariables = Exact<{
  input: InsertDinVeHeshbonToDbInput;
}>;


export type InsertDinVeHeshbonToDbMobileMutation = { __typename: 'Mutation', insertDinVeHeshbonToDbMobile: { __typename: 'InsertDinVeHeshbonToDbOutput', message: string } };

export type IsBusinessNeedToFillDinVeHeshbonMutationVariables = Exact<{
  input: IsBusinessNeedToFillDinVeHeshbonInput;
}>;


export type IsBusinessNeedToFillDinVeHeshbonMutation = { __typename: 'Mutation', isBusinessNeedToFillDinVeHeshbon: { __typename: 'IsBusinessNeedToFillDinVeHeshbonOutput', data: boolean } };

export type MoveBusinessExpenseVatMutationVariables = Exact<{
  input: MoveBusinessExpenseVatInput;
}>;


export type MoveBusinessExpenseVatMutation = { __typename: 'Mutation', moveBusinessExpenseVat: boolean };

export type RefundBusinessBillingMutationVariables = Exact<{
  input: RefundBusinessBillingInput;
}>;


export type RefundBusinessBillingMutation = { __typename: 'Mutation', refundBusinessBilling: boolean };

export type ReopenApprovedBusinessExpenseMutationVariables = Exact<{
  input: ReopenApprovedBusinessExpenseInput;
}>;


export type ReopenApprovedBusinessExpenseMutation = { __typename: 'Mutation', reopenApprovedBusinessExpense: boolean };

export type ReopenBusinessReportMutationVariables = Exact<{
  input: ReopenBusinessReportInput;
}>;


export type ReopenBusinessReportMutation = { __typename: 'Mutation', reopenBusinessReport: { __typename: 'ReopenBusinessReportOutput', id: string } };

export type ResponseBusinessApprovedMutationVariables = Exact<{
  input: ResponseBusinessApprovedInput;
}>;


export type ResponseBusinessApprovedMutation = { __typename: 'Mutation', responseBusinessApproved: { __typename: 'ResponseBusinessApprovedOutput', id: string } };

export type ResponseBusinessDeclinedMutationVariables = Exact<{
  input: ResponseBusinessDeclinedInput;
}>;


export type ResponseBusinessDeclinedMutation = { __typename: 'Mutation', responseBusinessDeclined: { __typename: 'ResponseBusinessDeclinedOutput', id: string } };

export type RestoreBusinessMutationVariables = Exact<{
  input: RestoreBusinessInput;
}>;


export type RestoreBusinessMutation = { __typename: 'Mutation', restoreBusiness: { __typename: 'RestoreBusinessOutput', success: boolean, error?: CancelBusinessError | null | undefined } };

export type SendEmailMutationVariables = Exact<{
  input: SendBusinessIncomeToEmailInput;
}>;


export type SendEmailMutation = { __typename: 'Mutation', sendBusinessIncomeToEmail: { __typename: 'SendBusinessIncomeToEmailOutput', subject?: string | null | undefined } };

export type SetUserNotificationTokenMutationVariables = Exact<{
  input: SetUserNotificationTokenInput;
}>;


export type SetUserNotificationTokenMutation = { __typename: 'Mutation', setUserNotificationToken: boolean };

export type SetWasUserContactedMutationVariables = Exact<{
  input: SetWasUserContactedInput;
}>;


export type SetWasUserContactedMutation = { __typename: 'Mutation', setWasUserContacted: { __typename: 'SetWasUserContactedOutput', data: boolean } };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename: 'Mutation', signUp: { __typename: 'SignUpOutput', id: string, onboardingStatus: OnboardingStatus } };

export type SubmitAuthoritiesIdentificationMutationVariables = Exact<{
  input: SubmitAuthoritiesIdentificationInput;
}>;


export type SubmitAuthoritiesIdentificationMutation = { __typename: 'Mutation', submitAuthoritiesIdentification: { __typename: 'SubmitAuthoritiesIdentificationOutput', onboardingStatus: OnboardingStatus, id: string } };

export type SubmitIdentificationUploadMutationVariables = Exact<{
  input: SubmitIdentificationUploadInput;
}>;


export type SubmitIdentificationUploadMutation = { __typename: 'Mutation', submitIdentificationUpload: { __typename: 'SubmitIdentificationUploadOutput', id: string, onboardingStatus: OnboardingStatus } };

export type SubmitBankDetailsMutationVariables = Exact<{
  input: SubmitBankDetailsInput;
}>;


export type SubmitBankDetailsMutation = { __typename: 'Mutation', submitBankDetails: { __typename: 'SubmitBankDetailsOutput', data: boolean } };

export type SubmitBillingDetailsMutationVariables = Exact<{
  input: SubmitBillingDetailsInput;
}>;


export type SubmitBillingDetailsMutation = { __typename: 'Mutation', submitBillingDetails: { __typename: 'SubmitBillingDetailsOutput', id: string } };

export type SubmitBusinessDetailsMutationVariables = Exact<{
  input: SubmitBusinessDetailsInput;
}>;


export type SubmitBusinessDetailsMutation = { __typename: 'Mutation', submitBusinessDetails: { __typename: 'SubmitBusinessDetailsOutput', businessId: string, onboardingStatus: OnboardingStatus } };

export type SubmitBusinessEnglishDetailsMutationVariables = Exact<{
  input: SubmitBusinessEnglishDetailsInput;
}>;


export type SubmitBusinessEnglishDetailsMutation = { __typename: 'Mutation', submitBusinessEnglishDetails: { __typename: 'SubmitBusinessEnglishDetailsOutput', data: boolean } };

export type SubmitBusinessLogoMutationVariables = Exact<{
  input: SubmitBusinessLogoInput;
}>;


export type SubmitBusinessLogoMutation = { __typename: 'Mutation', submitBusinessLogo: { __typename: 'SubmitBusinessLogoOutput', data: boolean } };

export type SubmitBusinessSetupMutationVariables = Exact<{
  input: SubmitBusinessSetupInput;
}>;


export type SubmitBusinessSetupMutation = { __typename: 'Mutation', submitBusinessSetup: { __typename: 'SubmitBusinessSetupOutput', id: string, onboardingStatus: OnboardingStatus } };

export type SubmitCompanySubscriptionPlanMutationVariables = Exact<{
  input: SubmitCompanySubscriptionPlanInput;
}>;


export type SubmitCompanySubscriptionPlanMutation = { __typename: 'Mutation', submitCompanySubscriptionPlan: boolean };

export type SubmitFriendReferralMutationVariables = Exact<{
  input: SubmitFriendReferralInput;
}>;


export type SubmitFriendReferralMutation = { __typename: 'Mutation', submitFriendReferral: { __typename: 'SubmitFriendReferralOutput', mobile: string, planType: PlanType, planTypeFree?: PlanType | null | undefined } };

export type SubmitGiftDetailsMutationVariables = Exact<{
  input: SubmitGiftDetailsInput;
}>;


export type SubmitGiftDetailsMutation = { __typename: 'Mutation', submitGiftDetails: { __typename: 'SubmitGiftDetailsOutput', id: string, onboardingStatus: OnboardingStatus } };

export type SubmitIncomeDocumentCommentsMutationVariables = Exact<{
  input: SubmitIncomeDocumentCommentsInput;
}>;


export type SubmitIncomeDocumentCommentsMutation = { __typename: 'Mutation', submitIncomeDocumentComments: { __typename: 'SubmitIncomeDocumentCommentsOutput', data: boolean } };

export type SubmitNewBusinessDetailsMutationVariables = Exact<{
  input: SubmitNewBusinessDetailsInput;
}>;


export type SubmitNewBusinessDetailsMutation = { __typename: 'Mutation', submitNewBusinessDetails: { __typename: 'SubmitNewBusinessDetailsOutput', onboardingStatus: OnboardingStatus } };

export type SubmitReportForBusinessApprovalMutationVariables = Exact<{
  input: SubmitReportForBusinessApprovalInput;
}>;


export type SubmitReportForBusinessApprovalMutation = { __typename: 'Mutation', submitReportForBusinessApproval: { __typename: 'SubmitReportForBusinessApprovalOutput', id: string } };

export type TaxAuthorityOpenApiMutationVariables = Exact<{
  input: TaxAuthorityOpenApiInput;
}>;


export type TaxAuthorityOpenApiMutation = { __typename: 'Mutation', taxAuthorityOpenApi: { __typename: 'TaxAuthorityOpenApiOutput', data: string, status: { __typename: 'OperationStatus', operationName: string, success: boolean, err: string, warn: Array<string | null | undefined> } } };

export type UpdateBusinessAddressMutationVariables = Exact<{
  input: UpdateBusinessAddressInput;
}>;


export type UpdateBusinessAddressMutation = { __typename: 'Mutation', updateBusinessAddress: boolean };

export type UpdateBusinessAdvanceTaxRateForReportMutationVariables = Exact<{
  input: UpdateBusinessAdvanceTaxRateForReportInput;
}>;


export type UpdateBusinessAdvanceTaxRateForReportMutation = { __typename: 'Mutation', updateBusinessAdvanceTaxRateForReport: { __typename: 'UpdateBusinessAdvanceTaxRateForReportOutput', data: boolean } };

export type UpdateBusinessAdvancesMutationVariables = Exact<{
  input: UpdateBusinessAdvancesInput;
}>;


export type UpdateBusinessAdvancesMutation = { __typename: 'Mutation', updateBusinessAdvances: boolean };

export type UpdateBusinessApprovalStatusMutationVariables = Exact<{
  input: UpdateBusinessApprovalStatusInput;
}>;


export type UpdateBusinessApprovalStatusMutation = { __typename: 'Mutation', updateBusinessApprovalStatus: { __typename: 'UpdateBusinessApprovalStatusOutput', data: boolean } };

export type UpdateBusinessBillingMutationVariables = Exact<{
  input: UpdateBusinessBillingDetailsInput;
}>;


export type UpdateBusinessBillingMutation = { __typename: 'Mutation', updateBusinessBilling: { __typename: 'UpdateBusinessBillingDetailsOutput', data: boolean } };

export type UpdateBusinessBituahLeumiPaymentMutationVariables = Exact<{
  input: UpdateBusinessBituahLeumiPaymentInput;
}>;


export type UpdateBusinessBituahLeumiPaymentMutation = { __typename: 'Mutation', updateBusinessBituahLeumiPayment: boolean };

export type UpdateBusinessBituahLeumiPaymentForReportMutationVariables = Exact<{
  input: UpdateBusinessBituahLeumiPaymentForReportInput;
}>;


export type UpdateBusinessBituahLeumiPaymentForReportMutation = { __typename: 'Mutation', updateBusinessBituahLeumiPaymentForReport: { __typename: 'UpdateBusinessBituahLeumiPaymentForReportOutput', data: boolean } };

export type UpdateBusinessCertificateMutationVariables = Exact<{
  input: UpdateBusinessCertificateInput;
}>;


export type UpdateBusinessCertificateMutation = { __typename: 'Mutation', updateBusinessCertificate: { __typename: 'UpdateBusinessCertificateOutput', data: boolean } };

export type UpdateBusinessDetailsMutationVariables = Exact<{
  input: UpdateBusinessDetailsInput;
}>;


export type UpdateBusinessDetailsMutation = { __typename: 'Mutation', updateBusinessDetails: boolean };

export type UpdateCompletedInUserNoteMutationVariables = Exact<{
  input: UpdateCompletedInUserNoteInput;
}>;


export type UpdateCompletedInUserNoteMutation = { __typename: 'Mutation', updateCompletedInUserNote: { __typename: 'UpdateCompletedInUserNoteOutput', data: boolean } };

export type UpdatePaymentsForReportsMutationVariables = Exact<{
  input: UpdatePaymentsForReportsInput;
}>;


export type UpdatePaymentsForReportsMutation = { __typename: 'Mutation', updatePaymentsForReports: { __typename: 'UpdatePaymentsForReportsOutput', data: boolean } };

export type UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsMutationVariables = Exact<{
  input: UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsInput;
}>;


export type UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsMutation = { __typename: 'Mutation', uploadUnsignedTaxAuthorityAndBituahLeumiDocuments: { __typename: 'UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsOutput', data: boolean } };

export type UploadUnsignedVatBusinessCreationDocumentMutationVariables = Exact<{
  input: UploadUnsignedVatBusinessCreationDocumentInput;
}>;


export type UploadUnsignedVatBusinessCreationDocumentMutation = { __typename: 'Mutation', uploadUnsignedVatBusinessCreationDocument: { __typename: 'UploadUnsignedVatBusinessCreationDocumentOutput', data: boolean } };

export type BusinessBillingsChartDataQueryVariables = Exact<{
  input: BusinessBillingsChartDataInput;
}>;


export type BusinessBillingsChartDataQuery = { __typename: 'Query', businessBillingsChartData: { __typename: 'BusinessBillingsChartDataOutput', totalIncomes?: Array<number> | null | undefined, totalPaid?: Array<number> | null | undefined, totalFaild?: Array<number> | null | undefined, countFaild?: Array<number> | null | undefined, date?: Array<string> | null | undefined } };

export type BusinessBillingsDataByDateQueryVariables = Exact<{
  input: BusinessBillingsDataByDateInput;
}>;


export type BusinessBillingsDataByDateQuery = { __typename: 'Query', businessBillingsDataByDate: { __typename: 'BusinessBillingsDataByDateOutput', totalIncomes: number, totalPaid: number, totalRefunded: number, totalFaild: number, countFaild: number } };

export type BusinessBillingsTableByDateQueryVariables = Exact<{
  input: BusinessBillingsTableByDateInput;
}>;


export type BusinessBillingsTableByDateQuery = { __typename: 'Query', businessBillingsTableByDate: { __typename: 'BusinessBillingsTableByDateOutput', items?: Array<{ __typename: 'BusinessBillingsTableByDate', totalOwed: number, business: { __typename: 'BusinessBillingsTable', businessId: string, mobile: string, businessName: string, firstName: string, lastName: string } }> | null | undefined } };

export type BusinessPaymentRefundMutationVariables = Exact<{
  input: BusinessPaymentRefundInput;
}>;


export type BusinessPaymentRefundMutation = { __typename: 'Mutation', businessPaymentRefund: { __typename: 'BusinessPaymentRefundOutput', data?: boolean | null | undefined } };

export type GetAccountantSignatureQueryVariables = Exact<{
  input: GetAccountantSignatureInput;
}>;


export type GetAccountantSignatureQuery = { __typename: 'Query', getAccountantSignature: { __typename: 'File', url?: string | null | undefined } };

export type GetAccountantSignatureUploadUrlQueryVariables = Exact<{
  input: GetAccountantSignatureUploadUrlInput;
}>;


export type GetAccountantSignatureUploadUrlQuery = { __typename: 'Query', getAccountantSignatureUploadUrl: { __typename: 'File', url?: string | null | undefined } };

export type GetBusinessBasicQueryVariables = Exact<{
  input: GetBusinessInput;
}>;


export type GetBusinessBasicQuery = { __typename: 'Query', getBusiness: { __typename: 'Business', id: string, businessName: string } };

export type GetBusinessBasicInfoQueryVariables = Exact<{
  input: GetBusinessInput;
}>;


export type GetBusinessBasicInfoQuery = { __typename: 'Query', getBusiness: { __typename: 'Business', id: string, userId: string, businessType: BusinessType, businessStatus: BusinessStatus, city: string, streetAddress: string, user: { __typename: 'User', mobile: string, idNumber?: string | null | undefined, email?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined } } };

export type GetBusinessBillingDetailsQueryVariables = Exact<{
  input: GetBusinessInput;
}>;


export type GetBusinessBillingDetailsQuery = { __typename: 'Query', getBusiness: { __typename: 'Business', businessType: BusinessType, paymentIdNumber: string, user: { __typename: 'User', mobile: string, email?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined } } };

export type GetCountBusinessFailedBillingsQueryVariables = Exact<{
  input: GetCountBusinessFailedBillingsInput;
}>;


export type GetCountBusinessFailedBillingsQuery = { __typename: 'Query', getCountBusinessFailedBillings: { __typename: 'GetCountBusinessFailedBillingsResponse', total: number } };

export type GetBusinessDocumentSettingsQueryVariables = Exact<{
  input: GetBusinessInput;
}>;


export type GetBusinessDocumentSettingsQuery = { __typename: 'Query', getBusiness: { __typename: 'Business', incomeDocumentComments?: string | null | undefined, bankDetails?: string | null | undefined, businessNameEn?: string | null | undefined, logo?: boolean | null | undefined } };

export type GetBusinessFileQueryVariables = Exact<{
  input: GetBusinessFileInput;
}>;


export type GetBusinessFileQuery = { __typename: 'Query', getBusinessFile: { __typename: 'File', url?: string | null | undefined } };

export type GetFileQueryVariables = Exact<{
  input: GetBusinessFileInput;
}>;


export type GetFileQuery = { __typename: 'Query', getBusinessFile: { __typename: 'File', url?: string | null | undefined } };

export type GetBusinessFileUploadUrlQueryVariables = Exact<{
  input: GetBusinessFileUploadUrlInput;
}>;


export type GetBusinessFileUploadUrlQuery = { __typename: 'Query', getBusinessFileUploadUrl: { __typename: 'File', url?: string | null | undefined } };

export type GetBusinessQueryVariables = Exact<{
  input: GetBusinessInput;
}>;


export type GetBusinessQuery = { __typename: 'Query', getBusiness: { __typename: 'Business', id: string, registrationNumber: string, businessName: string, businessStatus: BusinessStatus, isNewBusiness?: boolean | null | undefined, approvalStatus?: BusinessApprovalStatus | null | undefined, approvedAt?: string | null | undefined, cancelledAt?: string | null | undefined, businessType: BusinessType, advanceTaxRate?: number | null | undefined, creditCardMask?: string | null | undefined, bituahLeumiPayment: number, createdAt?: string | null | undefined, city: string, streetAddress: string, partnerRegistrationNumber?: string | null | undefined, isEmployee: boolean, canBeBlocked: boolean, paymentIdNumber: string, isImportDocuments?: boolean | null | undefined, exemption?: { __typename: 'BusinessExemption', createdAt: string, updatedAt: string, businessId: string, servicesOrPropertiesAndMoreRate?: number | null | undefined, constructionAndTransportationWorksRate?: number | null | undefined, insuranceCommissionRate?: number | null | undefined, certainWageTypesRate?: number | null | undefined, interestAndCapitalMarketRate?: number | null | undefined, bookKeepingAuthorization?: boolean | null | undefined, certificateValidityStartDate?: string | null | undefined, certificateValidityEndDate?: string | null | undefined } | null | undefined, industry?: { __typename: 'BusinessIndustry', id: string, name: string, irsCode: string } | null | undefined, secondaryIndustry?: { __typename: 'BusinessIndustry', id: string, name: string, irsCode: string } | null | undefined, user: { __typename: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, birthDate?: string | null | undefined, mobile: string, email?: string | null | undefined, identificationType?: IdentificationType | null | undefined, identificationValue?: string | null | undefined } } };

export type GetBusinessFullQueryVariables = Exact<{
  input1: GetBusinessInput;
  input2: GetListYearsForBusinessInput;
}>;


export type GetBusinessFullQuery = { __typename: 'Query', getBusiness: { __typename: 'Business', id: string, registrationNumber: string, businessName: string, businessStatus: BusinessStatus, isNewBusiness?: boolean | null | undefined, approvalStatus?: BusinessApprovalStatus | null | undefined, approvedAt?: string | null | undefined, cancelledAt?: string | null | undefined, businessType: BusinessType, advanceTaxRate?: number | null | undefined, creditCardMask?: string | null | undefined, bituahLeumiPayment: number, createdAt?: string | null | undefined, city: string, streetAddress: string, partnerRegistrationNumber?: string | null | undefined, isEmployee: boolean, canBeBlocked: boolean, paymentIdNumber: string, isImportDocuments?: boolean | null | undefined, exemption?: { __typename: 'BusinessExemption', createdAt: string, updatedAt: string, businessId: string, servicesOrPropertiesAndMoreRate?: number | null | undefined, constructionAndTransportationWorksRate?: number | null | undefined, insuranceCommissionRate?: number | null | undefined, certainWageTypesRate?: number | null | undefined, interestAndCapitalMarketRate?: number | null | undefined, bookKeepingAuthorization?: boolean | null | undefined, certificateValidityStartDate?: string | null | undefined, certificateValidityEndDate?: string | null | undefined } | null | undefined, industry?: { __typename: 'BusinessIndustry', id: string, name: string, irsCode: string } | null | undefined, secondaryIndustry?: { __typename: 'BusinessIndustry', id: string, name: string, irsCode: string } | null | undefined, user: { __typename: 'User', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, birthDate?: string | null | undefined, mobile: string, email?: string | null | undefined, identificationType?: IdentificationType | null | undefined, identificationValue?: string | null | undefined } }, getListYearsForBusinessBo: { __typename: 'GetListYearsForBusinessOutput', years: Array<number> } };

export type GetBusinessNotificationQueryVariables = Exact<{
  input: GetBusinessNotificationInput;
}>;


export type GetBusinessNotificationQuery = { __typename: 'Query', getBusinessNotification: { __typename: 'BusinessNotification', businessId: string, id: string, type: string, values: Array<{ __typename: 'NotificationValues', name: string, value: string }> } };

export type GetNotificationsQueryVariables = Exact<{
  input1: GetBusinessInput;
  input2?: InputMaybe<GetNotificationsInput>;
}>;


export type GetNotificationsQuery = { __typename: 'Query', getBusiness: { __typename: 'Business', notifications?: { __typename: 'BusinessNotificationPage', nextToken?: string | null | undefined, items?: Array<{ __typename: 'BusinessNotification', id: string, content?: string | null | undefined, date: string, type: string, values: Array<{ __typename: 'NotificationValues', name: string, value: string }> } | null | undefined> | null | undefined } | null | undefined } };

export type GetBusinessPendingApprovalQueryVariables = Exact<{
  input: GetBusinessInput;
}>;


export type GetBusinessPendingApprovalQuery = { __typename: 'Query', getBusiness: { __typename: 'Business', id: string, approvalStatus?: BusinessApprovalStatus | null | undefined, isNewBusiness?: boolean | null | undefined, representationRequestNumber?: string | null | undefined, missingDocuments?: MissingDocument | null | undefined } };

export type GetBusinessPendingPaymentsDataQueryVariables = Exact<{
  input: GetBusinessPendingPaymentsDataInput;
}>;


export type GetBusinessPendingPaymentsDataQuery = { __typename: 'Query', getBusinessPendingPaymentsData: { __typename: 'GetBusinessPendingPaymentsDataOutput', numberOfPendingPayments: number, businessStatus: BusinessStatus } };

export type GetBusinessSetupQueryVariables = Exact<{
  input: GetBusinessSetupInput;
}>;


export type GetBusinessSetupQuery = { __typename: 'Query', getBusinessSetup?: { __typename: 'BusinessSetup', businessType: BusinessSetupBusinessType, hasAccountant: boolean, hasBusiness: boolean } | null | undefined };

export type GetStatisticsForBusinessQueryVariables = Exact<{
  input: GetStatisticsForBusinessInput;
}>;


export type GetStatisticsForBusinessQuery = { __typename: 'Query', getStatisticsForBusiness: { __typename: 'BusinessStatistics', totalBilled: number } };

export type GetBusinessStatusCountersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessStatusCountersQuery = { __typename: 'Query', getBusinessStatusCounters: { __typename: 'BusinessStatusCounters', REGISTRATION_UNCOMPLETE?: number | null | undefined, BILLING_DETAILS?: number | null | undefined, BEFORE_PENDING_APPROVAL?: number | null | undefined, PENDING_APPROVAL?: number | null | undefined, ACTIVE?: number | null | undefined, CANCELLED?: number | null | undefined, BLOCKED?: number | null | undefined, ALL?: number | null | undefined, ON_HOLD?: number | null | undefined } };

export type GetBusinessTaoaLastAuthenticationTimeQueryVariables = Exact<{
  input: GetBusinessInput;
}>;


export type GetBusinessTaoaLastAuthenticationTimeQuery = { __typename: 'Query', getBusiness: { __typename: 'Business', taoaLastAuthenticationTime?: string | null | undefined } };

export type GetExpenseQueryVariables = Exact<{
  input: GetBusinessExpenseInput;
}>;


export type GetExpenseQuery = { __typename: 'Query', getBusinessExpense: { __typename: 'BusinessExpense', id: string, expenseDate: string, expenseStatus: BusinessExpenseStatus, disputeStatus?: string | null | undefined, currency: Currency, currencyRate: number, price: number, vat: number, expenseType: BusinessExpenseType, expenseNumber?: string | null | undefined, vatType?: BusinessExpenseVatType | null | undefined, priceIncludingVat: number, deductedVat: number, deductedTax: number, provider?: { __typename: 'BusinessProvider', name: string } | null | undefined, items?: Array<{ __typename: 'BusinessExpenseItem', taxCategoryNumber: number, price: number, itemTax: Array<{ __typename: 'BusinessExpenseItemTax', deductedTax: number }>, itemVat: Array<{ __typename: 'BusinessExpenseItemVat', deductedVat: number } | null | undefined>, category?: { __typename: 'TaxCategory', categoryName: string } | null | undefined } | null | undefined> | null | undefined } };

export type GetBusinessExpenseCompleteQueryVariables = Exact<{
  input: ListBusinessExpensesInput;
}>;


export type GetBusinessExpenseCompleteQuery = { __typename: 'Query', listBusinessExpenses: { __typename: 'ListBusinessExpensesResponse', items?: Array<{ __typename: 'BusinessExpense', id: string, businessId: string, createdAt: string, updatedAt: string, expenseStatus: BusinessExpenseStatus, disputeStatus?: string | null | undefined, expenseDate: string, expenseNumber?: string | null | undefined, currency: Currency, currencyRate: number, price: number, priceIncludingVat: number, vat: number, vatType?: BusinessExpenseVatType | null | undefined, deductedVat: number, deductedTax: number, expenseType: BusinessExpenseType, geminaJson?: string | null | undefined, expenseTotalAmount?: number | null | undefined, business: { __typename: 'Business', id: string, businessType: BusinessType, registrationNumber: string, businessName: string, industry?: { __typename: 'BusinessIndustry', name: string } | null | undefined, user: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined }, exemption?: { __typename: 'BusinessExemption', servicesOrPropertiesAndMoreRate?: number | null | undefined, constructionAndTransportationWorksRate?: number | null | undefined, insuranceCommissionRate?: number | null | undefined, certainWageTypesRate?: number | null | undefined, interestAndCapitalMarketRate?: number | null | undefined } | null | undefined }, provider?: { __typename: 'BusinessProvider', name: string, registrationNumber?: string | null | undefined, isIsraelProvider: boolean, id: string, createdAt: string, updatedAt: string, nickname?: string | null | undefined, source: BusinessProviderSource } | null | undefined, items?: Array<{ __typename: 'BusinessExpenseItem', expenseItemStatus: BusinessExpenseItemStatus, taxCategoryNumber: number, price: number, priceIncludingVat?: number | null | undefined, vat?: number | null | undefined, vatType: BusinessExpenseVatType, expenseCategory?: string | null | undefined, itemTax: Array<{ __typename: 'BusinessExpenseItemTax', reportId: string, deductedTax: number, taxDeductionPercentage: number, report?: { __typename: 'BusinessReport', startDate: string, endDate: string, reportStatus: BusinessReportStatus } | null | undefined }>, itemVat: Array<{ __typename: 'BusinessExpenseItemVat', id?: string | null | undefined, reportId?: string | null | undefined, deductedVat: number, vatDeductionPercentage: number, vat: number, report?: { __typename: 'BusinessReport', startDate: string, endDate: string, reportStatus: BusinessReportStatus, businessType?: BusinessType | null | undefined } | null | undefined } | null | undefined>, category?: { __typename: 'TaxCategory', categoryName: string } | null | undefined } | null | undefined> | null | undefined }> | null | undefined } };

export type GetBusinessExpense_expenseIndexQueryVariables = Exact<{
  input: ListBusinessExpensesInput;
}>;


export type GetBusinessExpense_expenseIndexQuery = { __typename: 'Query', listBusinessExpenses: { __typename: 'ListBusinessExpensesResponse', items?: Array<{ __typename: 'BusinessExpense', expenseIndex?: number | null | undefined }> | null | undefined } };

export type GetBusinessExpenseSummaryQueryVariables = Exact<{
  input: GetBusinessExpenseInput;
}>;


export type GetBusinessExpenseSummaryQuery = { __typename: 'Query', getBusinessExpense: { __typename: 'BusinessExpense', businessId: string, priceIncludingVat: number, expenseStatus: BusinessExpenseStatus, business: { __typename: 'Business', businessName: string } } };

export type GetBusinessIncomesCeilingForBusinessQueryVariables = Exact<{
  input: GetBusinessIncomesCeilingForBusinessInput;
}>;


export type GetBusinessIncomesCeilingForBusinessQuery = { __typename: 'Query', getBusinessIncomesCeilingForBusiness: { __typename: 'GetBusinessIncomesCeilingForBusinessOutput', totalIncomesUnused?: number | null | undefined, unUsedPercentage?: number | null | undefined, usedPercentage?: number | null | undefined, totalIncomes?: number | null | undefined, limit?: number | null | undefined } };

export type GetIncomeQueryVariables = Exact<{
  input: GetBusinessIncomeInput;
}>;


export type GetIncomeQuery = { __typename: 'Query', getBusinessIncome: { __typename: 'BusinessIncome', incomeProvider?: BusinessIncomeProvider | null | undefined, id: string, incomeDate: string, invoiceNumber: string, description?: string | null | undefined, taoaConfirmationNumber?: string | null | undefined, incomeStatus: BusinessIncomeStatus, incomeType: string, price: number, currency: string, currencyRate: number, vat: number, priceIncludingVat: number, english?: boolean | null | undefined, businessId: string, customer: { __typename: 'BusinessCustomer', id: string, customerName: string, phone?: string | null | undefined, registrationNumber?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined }, items?: Array<{ __typename: 'BusinessIncomeItem', description: string, unitPrice: number, units: number, priceIncludingVat: number, price: number, vat: number, itemTax: Array<{ __typename: 'BusinessIncomeItemTax', id?: string | null | undefined, reportId: string, incomeItemId?: string | null | undefined, report?: { __typename: 'BusinessReport', startDate: string, endDate: string, reportStatus: BusinessReportStatus } | null | undefined }>, itemVat: Array<{ __typename: 'BusinessIncomeItemVat', id?: string | null | undefined, reportId?: string | null | undefined, incomeItemId?: string | null | undefined, report?: { __typename: 'BusinessReport', startDate: string, endDate: string, reportStatus: BusinessReportStatus, businessType?: BusinessType | null | undefined } | null | undefined } | null | undefined> }> | null | undefined, payments?: Array<{ __typename: 'BusinessIncomePayment', paymentMethod: string, price: number, taxDeduction: number, bankName?: string | null | undefined, bankBranch?: string | null | undefined, bankAccount?: string | null | undefined, chequeNum?: string | null | undefined, creditCardType?: string | null | undefined, creditCardPaymentType?: string | null | undefined, creditCardNumberOfPayments?: number | null | undefined, creditCardLastDigits?: string | null | undefined, paymentApp?: BusinessIncomePaymentApp | null | undefined, paymentAppDealNumber?: string | null | undefined, date: string }> | null | undefined, business: { __typename: 'Business', businessType: BusinessType } } };

export type GetIncomeEmailsQueryVariables = Exact<{
  input: GetBusinessIncomeInput;
}>;


export type GetIncomeEmailsQuery = { __typename: 'Query', getBusinessIncome: { __typename: 'BusinessIncome', emails?: Array<{ __typename: 'BusinessMailer', recipient: string, emailSentAt?: string | null | undefined, emailStatus: EmailStatus }> | null | undefined } };

export type GetBusinessIncomeQueryVariables = Exact<{
  input: GetBusinessIncomeInput;
}>;


export type GetBusinessIncomeQuery = { __typename: 'Query', getBusinessIncome: { __typename: 'BusinessIncome', incomeProvider?: BusinessIncomeProvider | null | undefined, id: string, businessId: string, incomeType: string, currency: string, currencyRate: number, incomeDate: string, vat: number, price: number, priceIncludingVat: number, invoiceNumber: string, reportId?: string | null | undefined, business: { __typename: 'Business', businessName: string, registrationNumber: string, businessType: BusinessType, industry?: { __typename: 'BusinessIndustry', name: string } | null | undefined, user: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined } }, customer: { __typename: 'BusinessCustomer', customerName: string, registrationNumber?: string | null | undefined }, items?: Array<{ __typename: 'BusinessIncomeItem', description: string, unitPrice: number, units: number, priceIncludingVat: number, price: number, vat: number, itemTax: Array<{ __typename: 'BusinessIncomeItemTax', id?: string | null | undefined, reportId: string, incomeItemId?: string | null | undefined, report?: { __typename: 'BusinessReport', startDate: string, endDate: string, reportStatus: BusinessReportStatus } | null | undefined }>, itemVat: Array<{ __typename: 'BusinessIncomeItemVat', id?: string | null | undefined, reportId?: string | null | undefined, incomeItemId?: string | null | undefined, report?: { __typename: 'BusinessReport', startDate: string, endDate: string, reportStatus: BusinessReportStatus, businessType?: BusinessType | null | undefined } | null | undefined } | null | undefined> }> | null | undefined, payments?: Array<{ __typename: 'BusinessIncomePayment', paymentMethod: string, taxDeduction: number }> | null | undefined } };

export type GetBusinessIncomePaymentGrowDataQueryVariables = Exact<{
  input: GetBusinessIncomePaymentGrowDataInput;
}>;


export type GetBusinessIncomePaymentGrowDataQuery = { __typename: 'Query', getBusinessIncomePaymentGrowData: { __typename: 'GetBusinessIncomePaymentGrowDataOutput', growTransactionId?: string | null | undefined, growTransactionToken?: string | null | undefined } };

export type GetBusinessProviderQueryVariables = Exact<{
  input: GetBusinessProviderInput;
}>;


export type GetBusinessProviderQuery = { __typename: 'Query', getBusinessProvider: { __typename: 'BusinessProvider', id: string, name: string, isIsraelProvider: boolean, nickname?: string | null | undefined, registrationNumber?: string | null | undefined } };

export type GetBusinessReportDatesQueryVariables = Exact<{
  input: GetBusinessReportInput;
}>;


export type GetBusinessReportDatesQuery = { __typename: 'Query', getBusinessReport: { __typename: 'BusinessReport', startDate: string, endDate: string } };

export type GetBusinessReportQueryVariables = Exact<{
  input: ListBusinessReportsInput;
}>;


export type GetBusinessReportQuery = { __typename: 'Query', listBusinessReports: { __typename: 'ListBusinessReportsResponse', items?: Array<{ __typename: 'BusinessReport', id: string, businessType?: BusinessType | null | undefined, reportType: BusinessReportType, reportStatus: BusinessReportStatus, startDate: string, endDate: string, advancedPaymentAmount?: number | null | undefined, sumOfVatPayment?: number | null | undefined, sumOfInputsOnFixedEquipment?: number | null | undefined, sumOfInputsOnOtherExpenses?: number | null | undefined, sumOfExpensesIncludingVat?: number | null | undefined, sumOfExpensesWithoutVat?: number | null | undefined, sumOfIncomesIncludingVat?: number | null | undefined, calculatedAdvancePayments?: number | null | undefined, sumOfIncomesExemptOfVatOrZeroVat?: number | null | undefined, sumOfBusinessTurnover?: number | null | undefined, sumOfIncomesLiabledToVat?: number | null | undefined, sumOfVatAmountOnIncomes?: number | null | undefined, withheldTax?: number | null | undefined, advanceTaxPercentage?: number | null | undefined, pendingApprovalExpenses: number, businessId: string, reportName: string, taoaReference?: string | null | undefined, bituahLeumiPayments?: Array<{ __typename: 'BusinessBituahLeumi', id: string, reportId: string, bituahLeumiPayment: number, startDate: string, endDate: string }> | null | undefined }> | null | undefined } };

export type GetCountOpenfrmtFilesQueryVariables = Exact<{
  input: GetCountOpenfrmtFilesInput;
}>;


export type GetCountOpenfrmtFilesQuery = { __typename: 'Query', getCountOpenfrmtFiles: { __typename: 'GetCountOpenfrmtFiles', amount: string, counter: number, incomeType: BusinessIncomeType, title: string, totalA100: number, totalB100: number, totalB110: number, totalC100: number, totalD110: number, totalD120: number, totalM100: number, totalZ900: number } };

export type GetCurrencyRateQueryVariables = Exact<{
  input: GetCurrencyRateInput;
}>;


export type GetCurrencyRateQuery = { __typename: 'Query', getCurrencyRate: { __typename: 'CurrencyRate', currency: Currency, rate: number } };

export type GetDocumentTreeChildrenAllowedDataMutationVariables = Exact<{
  input: DocumentTreeInput;
}>;


export type GetDocumentTreeChildrenAllowedDataMutation = { __typename: 'Mutation', documentTree: { __typename: 'DocumentTreeOutput', childrenAllowedData?: Array<{ __typename: 'DocumentTreeChildrenAllowedData', incomeType: string, currency: string, customerId: string, description: string, price: number, priceIncludingVat: number, vat: number, customer: { __typename: 'DocumentTreeCustomer', name: string, phone?: string | null | undefined, email?: string | null | undefined, registrationNumber?: string | null | undefined }, items: Array<{ __typename: 'DocumentTreeItem', description: string, units: number, unitPrice: number, price: number, vat: number, vatType: string, priceIncludingVat: number } | null | undefined>, payments: Array<{ __typename: 'DocumentTreePayment', price: number, paymentMethod?: string | null | undefined, paymentApp?: string | null | undefined, bankName?: string | null | undefined, bankBranch?: string | null | undefined, bankAccount?: string | null | undefined, taxDeduction?: number | null | undefined, creditCardPaymentType?: string | null | undefined, creditCardNumberOfPayments?: number | null | undefined, creditCardType?: string | null | undefined } | null | undefined> } | null | undefined> | null | undefined } };

export type GetHomeTabsCountersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHomeTabsCountersQuery = { __typename: 'Query', getHomeTabsCounters: { __typename: 'HomeTabsCountersData', BUSINESSES_PENDING_APPROVAL: number, EXPENSE_PENDING_APPROVAL: number, BUSINESS_PENDING_DOCUMENTS_TO_UPLOAD: number } };

export type GetNextBusinessSubscriptionPaymentQueryVariables = Exact<{
  input: GetNextBusinessSubscriptionPaymentInput;
}>;


export type GetNextBusinessSubscriptionPaymentQuery = { __typename: 'Query', getNextBusinessSubscriptionPayment: { __typename: 'GetNextBusinessSubscriptionPaymentResponse', date: string, price: number } };

export type GetNextIncomeInvoiceNumberQueryVariables = Exact<{
  input: GetNextIncomeInvoiceNumberInput;
}>;


export type GetNextIncomeInvoiceNumberQuery = { __typename: 'Query', getNextIncomeInvoiceNumber: { __typename: 'NextIncomeInvoiceNumber', invoiceNumber: number } };

export type GetPreviousIncomeDateQueryVariables = Exact<{
  input: GetPreviousIncomeInput;
}>;


export type GetPreviousIncomeDateQuery = { __typename: 'Query', getPreviousIncomeDate: { __typename: 'GetPreviousIncomeOutput', previousIncomeDate?: string | null | undefined } };

export type GetSpreadsheetIncomesQueryVariables = Exact<{
  input: GetSpreadsheetIncomesInput;
}>;


export type GetSpreadsheetIncomesQuery = { __typename: 'Query', getSpreadsheetIncomes: { __typename: 'GetSpreadsheetIncomesOutput', data: boolean } };

export type GetStaffQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStaffQuery = { __typename: 'Query', getStaff: { __typename: 'Staff', id: string, mobile: string, firstName: string, lastName: string, idNumber: string } };

export type GetSubscriptionPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionPlansQuery = { __typename: 'Query', getSubscriptionPlans: Array<{ __typename: 'BusinessSubscriptionPlan', businessType?: BusinessType | null | undefined, discountPercentage: number, price: number, termInMonth?: number | null | undefined, planType: PlanType }> };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename: 'Query', getUser?: { __typename: 'User', id: string, mobile: string, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, idNumber?: string | null | undefined, onboardingStatus: OnboardingStatus, businesses?: Array<{ __typename: 'Business', id: string, businessType: BusinessType }> | null | undefined } | null | undefined };

export type GetUserBusinessIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserBusinessIdQuery = { __typename: 'Query', getUser?: { __typename: 'User', businesses?: Array<{ __typename: 'Business', id: string }> | null | undefined } | null | undefined };

export type GetUserOnboardingStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserOnboardingStatusQuery = { __typename: 'Query', getUser?: { __typename: 'User', onboardingStatus: OnboardingStatus } | null | undefined };

export type GetUserWithBusinessesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserWithBusinessesQuery = { __typename: 'Query', getUser?: { __typename: 'User', id: string, onboardingStatus: OnboardingStatus, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, mobile: string, identificationType?: IdentificationType | null | undefined, idNumber?: string | null | undefined, businesses?: Array<{ __typename: 'Business', id: string, businessStatus: BusinessStatus }> | null | undefined } | null | undefined };

export type GetActivityQueryVariables = Exact<{
  input: ListActivitiesForBusinessInput;
}>;


export type GetActivityQuery = { __typename: 'Query', listActivitiesForBusiness: { __typename: 'ListActivitiesForBusinessResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessActivity', id?: string | null | undefined, createdAt?: string | null | undefined, priceIncludingVat?: number | null | undefined, price?: number | null | undefined, description?: string | null | undefined, date?: string | null | undefined, currency?: string | null | undefined, currencyRate?: string | null | undefined, type?: string | null | undefined, documentType?: string | null | undefined }> | null | undefined } };

export type ListBusinessBillingsQueryVariables = Exact<{
  input: ListBusinessBillingsInput;
}>;


export type ListBusinessBillingsQuery = { __typename: 'Query', listBusinessBillings: { __typename: 'ListBusinessBillingsOutput', total: number, items?: Array<{ __typename: 'BusinessBilling', id: string, datePaid?: string | null | undefined, billingStatus: BusinessBillingStatus, price: number, startDate: string, endDate: string, description: string, expenseId?: string | null | undefined }> | null | undefined } };

export type ListBusinessDocumentsQueryVariables = Exact<{
  input: ListBusinessDocumentsInput;
}>;


export type ListBusinessDocumentsQuery = { __typename: 'Query', listBusinessDocuments: Array<{ __typename: 'BusinessDocument', name: string, type: string, lastModified: string }> };

export type ListBusinessExpensesQueryVariables = Exact<{
  input: ListBusinessExpensesInput;
}>;


export type ListBusinessExpensesQuery = { __typename: 'Query', listBusinessExpenses: { __typename: 'ListBusinessExpensesResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessExpense', id: string, businessId: string, expenseIndex?: number | null | undefined, price: number, vat: number, expenseType: BusinessExpenseType, priceIncludingVat: number, createdAt: string, expenseDate: string, currency: Currency, currencyRate: number, provider?: { __typename: 'BusinessProvider', id: string, name: string } | null | undefined, business: { __typename: 'Business', id: string, registrationNumber: string, businessName: string, user: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined } } }> | null | undefined } };

export type ListBusinessExpenses_reportQueryVariables = Exact<{
  input: ListBusinessExpensesInput;
}>;


export type ListBusinessExpenses_reportQuery = { __typename: 'Query', listBusinessExpenses: { __typename: 'ListBusinessExpensesResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessExpense', disputeStatus?: string | null | undefined, id: string, expenseNumber?: string | null | undefined, priceIncludingVat: number, currencyRate: number, currency: Currency, price: number, expenseType: BusinessExpenseType, createdAt: string, expenseDate: string, deductedVat: number, provider?: { __typename: 'BusinessProvider', name: string } | null | undefined, business: { __typename: 'Business', id: string, businessName: string }, items?: Array<{ __typename: 'BusinessExpenseItem', itemVat: Array<{ __typename: 'BusinessExpenseItemVat', report?: { __typename: 'BusinessReport', startDate: string, endDate: string } | null | undefined } | null | undefined>, itemTax: Array<{ __typename: 'BusinessExpenseItemTax', report?: { __typename: 'BusinessReport', startDate: string, endDate: string } | null | undefined }> } | null | undefined> | null | undefined }> | null | undefined } };

export type ListBusinessExpensesSkipQueryVariables = Exact<{
  input: ListBusinessExpensesInput;
}>;


export type ListBusinessExpensesSkipQuery = { __typename: 'Query', listBusinessExpenses: { __typename: 'ListBusinessExpensesResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessExpense', id: string, expenseIndex?: number | null | undefined }> | null | undefined } };

export type ListBusinessExpensesInProcessQueryVariables = Exact<{
  input1: ListBusinessExpensesInput;
  input2: ListBusinessExpensesInput;
}>;


export type ListBusinessExpensesInProcessQuery = { __typename: 'Query', pendingApproval: { __typename: 'ListBusinessExpensesResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessExpense', id: string, priceIncludingVat: number, currency: Currency, expenseDate: string, createdAt: string, expenseStatus: BusinessExpenseStatus, provider?: { __typename: 'BusinessProvider', name: string } | null | undefined }> | null | undefined }, inDispute: { __typename: 'ListBusinessExpensesResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessExpense', id: string, priceIncludingVat: number, currency: Currency, expenseDate: string, createdAt: string, expenseStatus: BusinessExpenseStatus, provider?: { __typename: 'BusinessProvider', name: string } | null | undefined }> | null | undefined } };

export type ListBusinessFilesQueryVariables = Exact<{
  input: ListBusinessFilesInput;
}>;


export type ListBusinessFilesQuery = { __typename: 'Query', listBusinessFiles: Array<{ __typename: 'BusinessFile', name: string, size: number }> };

export type ListBusinessIncomesQueryVariables = Exact<{
  input: ListBusinessIncomesInput;
}>;


export type ListBusinessIncomesQuery = { __typename: 'Query', listBusinessIncomes: { __typename: 'ListBusinessIncomesResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessIncome', id: string, businessId: string, incomeType: string, description?: string | null | undefined, reportId?: string | null | undefined, currency: string, currencyRate: number, priceIncludingVat: number, price: number, vat: number, incomeDate: string, invoiceNumber: string, incomeProvider?: BusinessIncomeProvider | null | undefined }> | null | undefined } };

export type ListBusinessIncomesStatisticsQueryVariables = Exact<{
  input: ListBusinessIncomesStatisticsInput;
}>;


export type ListBusinessIncomesStatisticsQuery = { __typename: 'Query', listBusinessIncomesStatistics: { __typename: 'ListBusinessIncomesResponse', items?: Array<{ __typename: 'BusinessIncome', incomeType: string, currencyRate: number, priceIncludingVat: number, price: number, vat: number }> | null | undefined } };

export type ListBusinessIncomesDocumentsQueryVariables = Exact<{
  input: ListBusinessIncomesDocumentsInput;
}>;


export type ListBusinessIncomesDocumentsQuery = { __typename: 'Query', listBusinessIncomesDocuments: { __typename: 'ListBusinessIncomesResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessIncome', id: string, businessId: string, reportId?: string | null | undefined, createdAt?: string | null | undefined }> | null | undefined } };

export type ListBusinessIncomesDocumentsDetailedQueryVariables = Exact<{
  input: ListBusinessIncomesDocumentsInput;
}>;


export type ListBusinessIncomesDocumentsDetailedQuery = { __typename: 'Query', listBusinessIncomesDocuments: { __typename: 'ListBusinessIncomesResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessIncome', id: string, businessId: string, incomeType: string, description?: string | null | undefined, reportId?: string | null | undefined, currency: string, currencyRate: number, priceIncludingVat: number, price: number, vat: number, incomeDate: string, invoiceNumber: string, incomeProvider?: BusinessIncomeProvider | null | undefined }> | null | undefined } };

export type ListBusinessIndustriesQueryVariables = Exact<{
  input: ListBusinessIndustriesInput;
}>;


export type ListBusinessIndustriesQuery = { __typename: 'Query', listBusinessIndustries: { __typename: 'ListBusinessIndustriesResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessIndustry', id: string, name: string, irsCode: string }> | null | undefined } };

export type ListBusinessPendingDocumentsToUploadQueryVariables = Exact<{
  input: ListBusinessPendingDocumentsToUploadInput;
}>;


export type ListBusinessPendingDocumentsToUploadQuery = { __typename: 'Query', listBusinessPendingDocumentsToUpload: { __typename: 'ListBusinessPendingDocumentsToUploadResponse', total: number, items?: Array<{ __typename: 'ListBusinessPendingDocumentsToUpload', id: string, businessName: string, firstName: string, lastName: string, registrationNumber: string, advanceTaxRate: boolean, bituahLeumiPayment: boolean, businessExemption: boolean, businessCertificate: boolean, approvedAt: string, businessIndustry: boolean }> | null | undefined } };

export type ListBusinessRecentIncomeItemsQueryVariables = Exact<{
  input: ListBusinessRecentIncomeItemsInput;
}>;


export type ListBusinessRecentIncomeItemsQuery = { __typename: 'Query', listBusinessRecentIncomeItems: { __typename: 'ListBusinessRecentIncomeItemsResponse', items?: Array<{ __typename: 'BusinessRecentIncomeItem', description: string, unitPrice: string } | null | undefined> | null | undefined } };

export type ListBusinessReportsQueryVariables = Exact<{
  input: ListBusinessReportsInput;
}>;


export type ListBusinessReportsQuery = { __typename: 'Query', listBusinessReports: { __typename: 'ListBusinessReportsResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessReport', id: string, reportName: string, reportStatus: BusinessReportStatus, startDate: string, endDate: string, pendingApprovalExpenses: number, isThereVatReportForCurrentYear: boolean, advanceTaxRate?: number | null | undefined, sumOfIncomesIncludingVat?: number | null | undefined, advancedPaymentAmount?: number | null | undefined, sumOfVatPayment?: number | null | undefined, business: { __typename: 'Business', id: string, businessName: string, businessType: BusinessType, registrationNumber: string, isImportDocuments?: boolean | null | undefined, user: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined } }, bituahLeumiPayments?: Array<{ __typename: 'BusinessBituahLeumi', id: string, reportId: string, bituahLeumiPayment: number, startDate: string, endDate: string, bituahLeumiType: BusinessBituahLeumiType }> | null | undefined }> | null | undefined } };

export type ListBusinessReportsCompleteQueryVariables = Exact<{
  input: ListBusinessReportsInput;
}>;


export type ListBusinessReportsCompleteQuery = { __typename: 'Query', listBusinessReports: { __typename: 'ListBusinessReportsResponse', items?: Array<{ __typename: 'BusinessReport', id: string, reportName: string, reportStatus: BusinessReportStatus, startDate: string, endDate: string, pendingApprovalExpenses: number, business: { __typename: 'Business', id: string } }> | null | undefined } };

export type ListBusinessReportsMonthlyQueryVariables = Exact<{
  input: ListBusinessReportsMonthlyInput;
}>;


export type ListBusinessReportsMonthlyQuery = { __typename: 'Query', listBusinessReportsMonthly: { __typename: 'ListBusinessReportsMonthlyResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessReport', businessId: string, vatReportId?: string | null | undefined, startDate: string, sumOfBusinessTurnover?: number | null | undefined, calculatedAdvancePayments?: number | null | undefined, advancedPaymentAmount?: number | null | undefined, sumOfPermittedExpenseDeductions?: number | null | undefined, chargeableBusinessIncome?: number | null | undefined, withheldTax?: number | null | undefined, sumOfVatInExpenses?: number | null | undefined, sumOfIncomesExemptOfVat?: number | null | undefined, sumOfIncomesWithZeroVat?: number | null | undefined, sumOfExpensesIncludingVat?: number | null | undefined, sumOfIncomesExemptOfVatOrZeroVat?: number | null | undefined, sumOfIncomesIncludingVat?: number | null | undefined, sumOfIncomesLiabledToVat?: number | null | undefined, sumOfVatAmountOnIncomes?: number | null | undefined, sumOfExpensesWithoutVat?: number | null | undefined, sumOfExpensesAfterVatDeductions?: number | null | undefined, sumOfInputsOnFixedEquipment?: number | null | undefined, sumOfInputsOnOtherExpenses?: number | null | undefined, sumOfVatPayment?: number | null | undefined, advanceTaxPercentage?: number | null | undefined, advanceTaxRate?: number | null | undefined, bituahLeumiPayments?: Array<{ __typename: 'BusinessBituahLeumi', id: string, reportId: string, bituahLeumiPayment: number, startDate: string, endDate: string, bituahLeumiType: BusinessBituahLeumiType }> | null | undefined }> | null | undefined } };

export type ListBusinessSubscriptionsQueryVariables = Exact<{
  input: PaginatedListInput;
}>;


export type ListBusinessSubscriptionsQuery = { __typename: 'Query', listBusinessSubscriptions: { __typename: 'ListBusinessSubscriptionsResponse', items?: Array<{ __typename: 'BusinessSubscription', id: string, startDate: string, endDate?: string | null | undefined, cancelled: boolean, subscriptionPlan?: { __typename: 'BusinessSubscriptionPlan', price: number, discountPercentage: number, printName: string } | null | undefined }> | null | undefined } };

export type ListBusinessesBaseQueryVariables = Exact<{
  input: ListBusinessesBaseInput;
}>;


export type ListBusinessesBaseQuery = { __typename: 'Query', listBusinessesBase: { __typename: 'ListBusinessesResponse', total?: number | null | undefined, items?: Array<{ __typename: 'Business', id: string, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, userId: string, businessType: BusinessType, registrationNumber: string, city: string, streetAddress: string, businessName: string, businessStatus: BusinessStatus, approvalStatus?: BusinessApprovalStatus | null | undefined, user: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, mobile: string } }> | null | undefined } };

export type ListBusinessesCrmQueryVariables = Exact<{
  input: ListBusinessesCrmInput;
}>;


export type ListBusinessesCrmQuery = { __typename: 'Query', listBusinessesCrm: { __typename: 'ListBusinessesResponse', total?: number | null | undefined, items?: Array<{ __typename: 'Business', id: string, businessName: string, businessStatus: BusinessStatus, businessType: BusinessType, registrationNumber: string, createdAt?: string | null | undefined, user: { __typename: 'User', firstName?: string | null | undefined, lastName?: string | null | undefined, mobile: string, email?: string | null | undefined } }> | null | undefined } };

export type ListCompanySubscriptionPlanQueryVariables = Exact<{
  input: ListCompanySubscriptionPlanInput;
}>;


export type ListCompanySubscriptionPlanQuery = { __typename: 'Query', listCompanySubscriptionPlan: { __typename: 'ListCompanySubscriptionPlanOutput', items?: Array<{ __typename: 'CompanySubscriptionPlan', id: string, companyName: string, referralId: string, planType?: string | null | undefined, planTypeFree?: string | null | undefined, createdAt: string }> | null | undefined } };

export type ListDiscountPhoneNumbersQueryVariables = Exact<{
  input: ListDiscountPhoneNumbersInput;
}>;


export type ListDiscountPhoneNumbersQuery = { __typename: 'Query', listDiscountPhoneNumbers: { __typename: 'ListDiscountPhoneNumbersResponse', total?: number | null | undefined, items?: Array<{ __typename: 'DiscountPhoneNumber', mobile: string, planType: PlanType, planTypeFree?: PlanType | null | undefined, createdAt?: string | null | undefined }> | null | undefined } };

export type ListOpenfrmtFilesQueryVariables = Exact<{
  input: ListOpenfrmtFilesInput;
}>;


export type ListOpenfrmtFilesQuery = { __typename: 'Query', listOpenfrmtFiles: Array<{ __typename: 'BusinessFile', name: string }> };

export type ListPopularProvidersQueryVariables = Exact<{
  input: ListPopularProvidersInput;
}>;


export type ListPopularProvidersQuery = { __typename: 'Query', listPopularProviders: { __typename: 'listPopularProvidersResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessProvider', id: string, createdAt: string, updatedAt: string, name: string, isIsraelProvider: boolean, nickname?: string | null | undefined, registrationNumber?: string | null | undefined, source: BusinessProviderSource }> | null | undefined } };

export type ListProvidersQueryVariables = Exact<{
  input: ListProvidersInput;
}>;


export type ListProvidersQuery = { __typename: 'Query', listProviders: { __typename: 'ListProvidersResponse', total?: number | null | undefined, items?: Array<{ __typename: 'BusinessProvider', id: string, name: string, isIsraelProvider: boolean, nickname?: string | null | undefined, registrationNumber?: string | null | undefined }> | null | undefined } };

export type ListStaffsQueryVariables = Exact<{
  input: ListStaffsInput;
}>;


export type ListStaffsQuery = { __typename: 'Query', listStaffs: { __typename: 'ListStaffsResponse', total: number, items?: Array<{ __typename: 'ListStaffs', id?: string | null | undefined, updatedAt?: string | null | undefined, createdAt?: string | null | undefined, type?: StaffTypes | null | undefined, email?: string | null | undefined, mobile?: string | null | undefined, lastName?: string | null | undefined, firstName?: string | null | undefined, idNumber?: string | null | undefined } | null | undefined> | null | undefined } };

export type ListStaffsBasicQueryVariables = Exact<{
  input: ListStaffsInput;
}>;


export type ListStaffsBasicQuery = { __typename: 'Query', listStaffs: { __typename: 'ListStaffsResponse', total: number, items?: Array<{ __typename: 'ListStaffs', id?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined } | null | undefined> | null | undefined } };

export type ListStaffsByParentIdQueryVariables = Exact<{
  input: ListStaffsByParentIdInput;
}>;


export type ListStaffsByParentIdQuery = { __typename: 'Query', listStaffsByParentId: { __typename: 'ListStaffsByParentIdByParentIdResponse', total: number, items: Array<{ __typename: 'ListStaffsByParentIdByParentId', id?: string | null | undefined, updatedAt?: string | null | undefined, createdAt?: string | null | undefined, type?: StaffTypes | null | undefined, email?: string | null | undefined, mobile?: string | null | undefined, lastName?: string | null | undefined, firstName?: string | null | undefined, idNumber?: string | null | undefined } | null | undefined> } };

export type ListTaxCategoriesQueryVariables = Exact<{
  input: ListTaxCategoriesInput;
}>;


export type ListTaxCategoriesQuery = { __typename: 'Query', listTaxCategories: { __typename: 'ListTaxCategoriesResponse', total?: number | null | undefined, items?: Array<{ __typename: 'TaxCategory', taxCategoryNumber: number, categoryName: string, taxDeductionPercentage: number, vatDeductionPercentage: number, expenseCategory: TaxCategoryVatType }> | null | undefined } };

export type ListUserNotesQueryVariables = Exact<{
  input: ListUserNotesInput;
}>;


export type ListUserNotesQuery = { __typename: 'Query', listUserNotes: { __typename: 'ListUserNotesResponse', total?: number | null | undefined, items?: Array<{ __typename: 'ListUserNotesOutput', id: string, userId: string, note: string, createdBy?: string | null | undefined, completed?: boolean | null | undefined, noteType?: NotesTypes | null | undefined, createdAt?: string | null | undefined, updatedAt?: string | null | undefined, handledBy?: string | null | undefined }> | null | undefined } };

export type SearchCustomersQueryVariables = Exact<{
  input: GetBusinessInput;
}>;


export type SearchCustomersQuery = { __typename: 'Query', getBusiness: { __typename: 'Business', customers?: Array<{ __typename: 'BusinessCustomer', id: string, customerName: string, phone?: string | null | undefined, registrationNumber?: string | null | undefined, address?: string | null | undefined, email?: string | null | undefined, bankName?: string | null | undefined, bankBranch?: string | null | undefined, bankAccount?: string | null | undefined }> | null | undefined } };

export type AnnualReportGetAnnualReportBoQueryVariables = Exact<{
  input: AnnualReportGetOneInput;
}>;


export type AnnualReportGetAnnualReportBoQuery = { __typename: 'Query', annualReportGetAnnualReportBo: { __typename: 'AnnualReportWithFilesBoOutput', id: string, businessId: string, year: number, formMobile?: string | null | undefined, formBo?: string | null | undefined, status: AnnualReportStatus, comment?: string | null | undefined, lockedBy?: string | null | undefined, lockedAt?: string | null | undefined, lastBusinessInteractionAt?: string | null | undefined, fieldsFilesMap: Array<{ __typename: 'AnnualReportFieldsFilesMap', formFieldPath: string, fileNames: Array<string> }> } };

export type AnnualReportGetFieldFileContentsBoQueryVariables = Exact<{
  input: AnnualReportSpecificFieldFileMobileInput;
}>;


export type AnnualReportGetFieldFileContentsBoQuery = { __typename: 'Query', annualReportGetFieldFileContentsBo: { __typename: 'AnnualReportFieldFileBase64ContentsOutput', base64FileContents: string } };

export type AnnualReportListAnnualReportsBoQueryVariables = Exact<{
  input: AnnualReportListBoInput;
}>;


export type AnnualReportListAnnualReportsBoQuery = { __typename: 'Query', annualReportListAnnualReportsBo: { __typename: 'AnnualReportListOutput', nextToken?: string | null | undefined, items: Array<{ __typename: 'AnnualReportForList', id: string, businessId: string, year: number, status: AnnualReportStatus, lastBusinessInteractionAt?: string | null | undefined }> } };

export type GetDinVeHeshbonDataBoQueryVariables = Exact<{
  input: GetDinVeHeshbonDataInput;
}>;


export type GetDinVeHeshbonDataBoQuery = { __typename: 'Query', getDinVeHeshbonDataBO: { __typename: 'GetDinVeHeshbonDataOutput', data?: { __typename: 'GetDinVeHeshbonData', firstName?: string | null | undefined, lastName?: string | null | undefined, idNumber?: string | null | undefined, mobilePhoneNumber?: string | null | undefined, businessCity?: string | null | undefined, businessStreetAddress?: string | null | undefined, familyStatus?: FamilyStatusOptions | null | undefined, familyStatusSinceDate?: string | null | undefined, partnerFirstName?: string | null | undefined, partnerLastName?: string | null | undefined, partnerIdNumber?: string | null | undefined, city?: string | null | undefined, streetAddress?: string | null | undefined, addressNumber?: number | null | undefined, apartmentNumber?: number | null | undefined, bankName?: string | null | undefined, bankBranchName?: string | null | undefined, bankBranchNumber?: number | null | undefined, bankAccountNumber?: number | null | undefined, isApproveMessages?: boolean | null | undefined, occupationsLastTwoYears?: Array<{ __typename: 'SingleOccupationOptionsX', occupation?: OccupationOptions | null | undefined, fromDate?: string | null | undefined, isCurrentlyWorkingInThisJob?: boolean | null | undefined, upToDate?: string | null | undefined } | null | undefined> | null | undefined, sourceOfIncomes?: Array<{ __typename: 'SourceOfIncomesX', incomeSource?: string | null | undefined, incomeNis?: number | null | undefined } | null | undefined> | null | undefined, selfEmployedStart?: { __typename: 'SelfEmployedStartObjectX', dateOfStarting?: string | null | undefined, averageWorkingHours?: AverageWorkingHoursOptions | null | undefined, averageIncomeNis?: number | null | undefined } | null | undefined } | null | undefined } };

export type GetListYearsForBusinessBoQueryVariables = Exact<{
  input: GetListYearsForBusinessInput;
}>;


export type GetListYearsForBusinessBoQuery = { __typename: 'Query', getListYearsForBusinessBo: { __typename: 'GetListYearsForBusinessOutput', years: Array<number> } };

export type AnnualReportGetAnnualReportMobileQueryVariables = Exact<{
  input: AnnualReportGetOneInput;
}>;


export type AnnualReportGetAnnualReportMobileQuery = { __typename: 'Query', annualReportGetAnnualReportMobile: { __typename: 'AnnualReportWithFilesMobileOutput', id: string, businessId: string, year: number, formMobile?: string | null | undefined, status: AnnualReportStatus, comment?: string | null | undefined, lockedBy?: string | null | undefined, lockedAt?: string | null | undefined, lastBusinessInteractionAt?: string | null | undefined, fieldsFilesMap: Array<{ __typename: 'AnnualReportFieldsFilesMap', formFieldPath: string, fileNames: Array<string> }> } };

export type AnnualReportGetFieldFileContentsMobileQueryVariables = Exact<{
  input: AnnualReportSpecificFieldFileMobileInput;
}>;


export type AnnualReportGetFieldFileContentsMobileQuery = { __typename: 'Query', annualReportGetFieldFileContentsMobile: { __typename: 'AnnualReportFieldFileBase64ContentsOutput', base64FileContents: string } };

export type AnnualReportListAnnualReportsMobileQueryVariables = Exact<{
  input: AnnualReportListMobileInput;
}>;


export type AnnualReportListAnnualReportsMobileQuery = { __typename: 'Query', annualReportListAnnualReportsMobile: { __typename: 'AnnualReportListOutput', items: Array<{ __typename: 'AnnualReportForList', id: string, businessId: string, year: number, status: AnnualReportStatus, lastBusinessInteractionAt?: string | null | undefined }> } };

export type GetCurrentBusinessMobileQueryVariables = Exact<{
  input1: GetBusinessInput;
  input2: GetListYearsForBusinessInput;
}>;


export type GetCurrentBusinessMobileQuery = { __typename: 'Query', getBusiness: { __typename: 'Business', businessName: string, businessType: BusinessType, reportType?: BusinessReportType | null | undefined, businessStatus: BusinessStatus, approvalStatus?: BusinessApprovalStatus | null | undefined, representationRequestNumber?: string | null | undefined, referralId?: string | null | undefined, registrationNumber: string }, getListYearsForBusinessMobile: { __typename: 'GetListYearsForBusinessOutput', years: Array<number> } };

export type GetDinVeHeshbonDataMobileQueryVariables = Exact<{
  input: GetDinVeHeshbonDataInput;
}>;


export type GetDinVeHeshbonDataMobileQuery = { __typename: 'Query', getDinVeHeshbonDataMobile: { __typename: 'GetDinVeHeshbonDataOutput', data?: { __typename: 'GetDinVeHeshbonData', firstName?: string | null | undefined, lastName?: string | null | undefined, idNumber?: string | null | undefined, mobilePhoneNumber?: string | null | undefined, businessCity?: string | null | undefined, businessStreetAddress?: string | null | undefined, familyStatus?: FamilyStatusOptions | null | undefined, familyStatusSinceDate?: string | null | undefined, partnerFirstName?: string | null | undefined, partnerLastName?: string | null | undefined, partnerIdNumber?: string | null | undefined, city?: string | null | undefined, streetAddress?: string | null | undefined, addressNumber?: number | null | undefined, apartmentNumber?: number | null | undefined, bankName?: string | null | undefined, bankBranchName?: string | null | undefined, bankBranchNumber?: number | null | undefined, bankAccountNumber?: number | null | undefined, isApproveMessages?: boolean | null | undefined, occupationsLastTwoYears?: Array<{ __typename: 'SingleOccupationOptionsX', occupation?: OccupationOptions | null | undefined, fromDate?: string | null | undefined, isCurrentlyWorkingInThisJob?: boolean | null | undefined, upToDate?: string | null | undefined } | null | undefined> | null | undefined, sourceOfIncomes?: Array<{ __typename: 'SourceOfIncomesX', incomeSource?: string | null | undefined, incomeNis?: number | null | undefined } | null | undefined> | null | undefined, selfEmployedStart?: { __typename: 'SelfEmployedStartObjectX', dateOfStarting?: string | null | undefined, averageWorkingHours?: AverageWorkingHoursOptions | null | undefined, averageIncomeNis?: number | null | undefined } | null | undefined } | null | undefined } };

export type GetListYearsForBusinessMobileQueryVariables = Exact<{
  input: GetListYearsForBusinessInput;
}>;


export type GetListYearsForBusinessMobileQuery = { __typename: 'Query', getListYearsForBusinessMobile: { __typename: 'GetListYearsForBusinessOutput', years: Array<number> } };



export const AccountantSignTaxAuthorityAndBituahLeumiDocumentsDocument = `
    mutation AccountantSignTaxAuthorityAndBituahLeumiDocuments($input: AccountantSignTaxAuthorityAndBituahLeumiDocumentsInput!) {
  accountantSignTaxAuthorityAndBituahLeumiDocuments(input: $input) {
    data
  }
}
    `;

export const useAccountantSignTaxAuthorityAndBituahLeumiDocumentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AccountantSignTaxAuthorityAndBituahLeumiDocumentsMutation, TError, AccountantSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables, TContext>) => {
    
    return useMutation<AccountantSignTaxAuthorityAndBituahLeumiDocumentsMutation, TError, AccountantSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables, TContext>(
      {
    mutationKey: ['AccountantSignTaxAuthorityAndBituahLeumiDocuments'],
    mutationFn: (variables?: AccountantSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables) => amplifyFetcher<AccountantSignTaxAuthorityAndBituahLeumiDocumentsMutation, AccountantSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables>(AccountantSignTaxAuthorityAndBituahLeumiDocumentsDocument, variables)(),
    ...options
  }
    )};

useAccountantSignTaxAuthorityAndBituahLeumiDocumentsMutation.getKey = () => ['AccountantSignTaxAuthorityAndBituahLeumiDocuments'];

export const AccountantSignVatBusinessCreationDocumentDocument = `
    mutation AccountantSignVatBusinessCreationDocument($input: AccountantSignVatBusinessCreationDocumentInput!) {
  accountantSignVatBusinessCreationDocument(input: $input) {
    data
  }
}
    `;

export const useAccountantSignVatBusinessCreationDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AccountantSignVatBusinessCreationDocumentMutation, TError, AccountantSignVatBusinessCreationDocumentMutationVariables, TContext>) => {
    
    return useMutation<AccountantSignVatBusinessCreationDocumentMutation, TError, AccountantSignVatBusinessCreationDocumentMutationVariables, TContext>(
      {
    mutationKey: ['AccountantSignVatBusinessCreationDocument'],
    mutationFn: (variables?: AccountantSignVatBusinessCreationDocumentMutationVariables) => amplifyFetcher<AccountantSignVatBusinessCreationDocumentMutation, AccountantSignVatBusinessCreationDocumentMutationVariables>(AccountantSignVatBusinessCreationDocumentDocument, variables)(),
    ...options
  }
    )};

useAccountantSignVatBusinessCreationDocumentMutation.getKey = () => ['AccountantSignVatBusinessCreationDocument'];

export const AddDiscountPhoneNumberDocument = `
    mutation AddDiscountPhoneNumber($input: AddDiscountPhoneNumberInput!) {
  addDiscountPhoneNumber(input: $input) {
    mobile
  }
}
    `;

export const useAddDiscountPhoneNumberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddDiscountPhoneNumberMutation, TError, AddDiscountPhoneNumberMutationVariables, TContext>) => {
    
    return useMutation<AddDiscountPhoneNumberMutation, TError, AddDiscountPhoneNumberMutationVariables, TContext>(
      {
    mutationKey: ['AddDiscountPhoneNumber'],
    mutationFn: (variables?: AddDiscountPhoneNumberMutationVariables) => amplifyFetcher<AddDiscountPhoneNumberMutation, AddDiscountPhoneNumberMutationVariables>(AddDiscountPhoneNumberDocument, variables)(),
    ...options
  }
    )};

useAddDiscountPhoneNumberMutation.getKey = () => ['AddDiscountPhoneNumber'];

export const AddNewStaffDocument = `
    mutation AddNewStaff($input: AddNewStaffInput!) {
  addNewStaff(input: $input) {
    data
  }
}
    `;

export const useAddNewStaffMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddNewStaffMutation, TError, AddNewStaffMutationVariables, TContext>) => {
    
    return useMutation<AddNewStaffMutation, TError, AddNewStaffMutationVariables, TContext>(
      {
    mutationKey: ['AddNewStaff'],
    mutationFn: (variables?: AddNewStaffMutationVariables) => amplifyFetcher<AddNewStaffMutation, AddNewStaffMutationVariables>(AddNewStaffDocument, variables)(),
    ...options
  }
    )};

useAddNewStaffMutation.getKey = () => ['AddNewStaff'];

export const AnnualReportRemoveFieldFileBoDocument = `
    mutation AnnualReportRemoveFieldFileBo($input: AnnualReportRemoveFieldFileBoInput!) {
  annualReportRemoveFieldFileBo(input: $input) {
    success
  }
}
    `;

export const useAnnualReportRemoveFieldFileBoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AnnualReportRemoveFieldFileBoMutation, TError, AnnualReportRemoveFieldFileBoMutationVariables, TContext>) => {
    
    return useMutation<AnnualReportRemoveFieldFileBoMutation, TError, AnnualReportRemoveFieldFileBoMutationVariables, TContext>(
      {
    mutationKey: ['AnnualReportRemoveFieldFileBo'],
    mutationFn: (variables?: AnnualReportRemoveFieldFileBoMutationVariables) => amplifyFetcher<AnnualReportRemoveFieldFileBoMutation, AnnualReportRemoveFieldFileBoMutationVariables>(AnnualReportRemoveFieldFileBoDocument, variables)(),
    ...options
  }
    )};

useAnnualReportRemoveFieldFileBoMutation.getKey = () => ['AnnualReportRemoveFieldFileBo'];

export const AnnualReportRemoveFieldFileMobileDocument = `
    mutation AnnualReportRemoveFieldFileMobile($input: AnnualReportRemoveFieldFileMobileInput!) {
  annualReportRemoveFieldFileMobile(input: $input) {
    success
  }
}
    `;

export const useAnnualReportRemoveFieldFileMobileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AnnualReportRemoveFieldFileMobileMutation, TError, AnnualReportRemoveFieldFileMobileMutationVariables, TContext>) => {
    
    return useMutation<AnnualReportRemoveFieldFileMobileMutation, TError, AnnualReportRemoveFieldFileMobileMutationVariables, TContext>(
      {
    mutationKey: ['AnnualReportRemoveFieldFileMobile'],
    mutationFn: (variables?: AnnualReportRemoveFieldFileMobileMutationVariables) => amplifyFetcher<AnnualReportRemoveFieldFileMobileMutation, AnnualReportRemoveFieldFileMobileMutationVariables>(AnnualReportRemoveFieldFileMobileDocument, variables)(),
    ...options
  }
    )};

useAnnualReportRemoveFieldFileMobileMutation.getKey = () => ['AnnualReportRemoveFieldFileMobile'];

export const AnnualReportReviewAnnualReportBoDocument = `
    mutation AnnualReportReviewAnnualReportBo($input: AnnualReportReviewAnnualReportBoInput!) {
  annualReportReviewAnnualReportBo(input: $input) {
    success
  }
}
    `;

export const useAnnualReportReviewAnnualReportBoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AnnualReportReviewAnnualReportBoMutation, TError, AnnualReportReviewAnnualReportBoMutationVariables, TContext>) => {
    
    return useMutation<AnnualReportReviewAnnualReportBoMutation, TError, AnnualReportReviewAnnualReportBoMutationVariables, TContext>(
      {
    mutationKey: ['AnnualReportReviewAnnualReportBo'],
    mutationFn: (variables?: AnnualReportReviewAnnualReportBoMutationVariables) => amplifyFetcher<AnnualReportReviewAnnualReportBoMutation, AnnualReportReviewAnnualReportBoMutationVariables>(AnnualReportReviewAnnualReportBoDocument, variables)(),
    ...options
  }
    )};

useAnnualReportReviewAnnualReportBoMutation.getKey = () => ['AnnualReportReviewAnnualReportBo'];

export const AnnualReportUploadFieldFileBoDocument = `
    mutation AnnualReportUploadFieldFileBo($input: AnnualReportUploadFieldFileBoInput!) {
  annualReportUploadFieldFileBo(input: $input) {
    newFileName
  }
}
    `;

export const useAnnualReportUploadFieldFileBoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AnnualReportUploadFieldFileBoMutation, TError, AnnualReportUploadFieldFileBoMutationVariables, TContext>) => {
    
    return useMutation<AnnualReportUploadFieldFileBoMutation, TError, AnnualReportUploadFieldFileBoMutationVariables, TContext>(
      {
    mutationKey: ['AnnualReportUploadFieldFileBo'],
    mutationFn: (variables?: AnnualReportUploadFieldFileBoMutationVariables) => amplifyFetcher<AnnualReportUploadFieldFileBoMutation, AnnualReportUploadFieldFileBoMutationVariables>(AnnualReportUploadFieldFileBoDocument, variables)(),
    ...options
  }
    )};

useAnnualReportUploadFieldFileBoMutation.getKey = () => ['AnnualReportUploadFieldFileBo'];

export const AnnualReportUploadFieldFileMobileDocument = `
    mutation AnnualReportUploadFieldFileMobile($input: AnnualReportUploadFieldFileMobileInput!) {
  annualReportUploadFieldFileMobile(input: $input) {
    newFileName
  }
}
    `;

export const useAnnualReportUploadFieldFileMobileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AnnualReportUploadFieldFileMobileMutation, TError, AnnualReportUploadFieldFileMobileMutationVariables, TContext>) => {
    
    return useMutation<AnnualReportUploadFieldFileMobileMutation, TError, AnnualReportUploadFieldFileMobileMutationVariables, TContext>(
      {
    mutationKey: ['AnnualReportUploadFieldFileMobile'],
    mutationFn: (variables?: AnnualReportUploadFieldFileMobileMutationVariables) => amplifyFetcher<AnnualReportUploadFieldFileMobileMutation, AnnualReportUploadFieldFileMobileMutationVariables>(AnnualReportUploadFieldFileMobileDocument, variables)(),
    ...options
  }
    )};

useAnnualReportUploadFieldFileMobileMutation.getKey = () => ['AnnualReportUploadFieldFileMobile'];

export const AnnualReportValidateAndSubmitFormBoDocument = `
    mutation AnnualReportValidateAndSubmitFormBo($input: AnnualReportValidateAndSubmitFormBoInput!) {
  annualReportValidateAndSubmitFormBo(input: $input) {
    success
  }
}
    `;

export const useAnnualReportValidateAndSubmitFormBoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AnnualReportValidateAndSubmitFormBoMutation, TError, AnnualReportValidateAndSubmitFormBoMutationVariables, TContext>) => {
    
    return useMutation<AnnualReportValidateAndSubmitFormBoMutation, TError, AnnualReportValidateAndSubmitFormBoMutationVariables, TContext>(
      {
    mutationKey: ['AnnualReportValidateAndSubmitFormBo'],
    mutationFn: (variables?: AnnualReportValidateAndSubmitFormBoMutationVariables) => amplifyFetcher<AnnualReportValidateAndSubmitFormBoMutation, AnnualReportValidateAndSubmitFormBoMutationVariables>(AnnualReportValidateAndSubmitFormBoDocument, variables)(),
    ...options
  }
    )};

useAnnualReportValidateAndSubmitFormBoMutation.getKey = () => ['AnnualReportValidateAndSubmitFormBo'];

export const AnnualReportValidateAndSubmitFormMobileDocument = `
    mutation AnnualReportValidateAndSubmitFormMobile($input: AnnualReportValidateAndSubmitFormMobileInput!) {
  annualReportValidateAndSubmitFormMobile(input: $input) {
    success
  }
}
    `;

export const useAnnualReportValidateAndSubmitFormMobileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AnnualReportValidateAndSubmitFormMobileMutation, TError, AnnualReportValidateAndSubmitFormMobileMutationVariables, TContext>) => {
    
    return useMutation<AnnualReportValidateAndSubmitFormMobileMutation, TError, AnnualReportValidateAndSubmitFormMobileMutationVariables, TContext>(
      {
    mutationKey: ['AnnualReportValidateAndSubmitFormMobile'],
    mutationFn: (variables?: AnnualReportValidateAndSubmitFormMobileMutationVariables) => amplifyFetcher<AnnualReportValidateAndSubmitFormMobileMutation, AnnualReportValidateAndSubmitFormMobileMutationVariables>(AnnualReportValidateAndSubmitFormMobileDocument, variables)(),
    ...options
  }
    )};

useAnnualReportValidateAndSubmitFormMobileMutation.getKey = () => ['AnnualReportValidateAndSubmitFormMobile'];

export const AnnualReportValidateAndSubmitStepsBoDocument = `
    mutation AnnualReportValidateAndSubmitStepsBo($input: AnnualReportValidateAndSubmitStepsBoInput!) {
  annualReportValidateAndSubmitStepsBo(input: $input) {
    success
  }
}
    `;

export const useAnnualReportValidateAndSubmitStepsBoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AnnualReportValidateAndSubmitStepsBoMutation, TError, AnnualReportValidateAndSubmitStepsBoMutationVariables, TContext>) => {
    
    return useMutation<AnnualReportValidateAndSubmitStepsBoMutation, TError, AnnualReportValidateAndSubmitStepsBoMutationVariables, TContext>(
      {
    mutationKey: ['AnnualReportValidateAndSubmitStepsBo'],
    mutationFn: (variables?: AnnualReportValidateAndSubmitStepsBoMutationVariables) => amplifyFetcher<AnnualReportValidateAndSubmitStepsBoMutation, AnnualReportValidateAndSubmitStepsBoMutationVariables>(AnnualReportValidateAndSubmitStepsBoDocument, variables)(),
    ...options
  }
    )};

useAnnualReportValidateAndSubmitStepsBoMutation.getKey = () => ['AnnualReportValidateAndSubmitStepsBo'];

export const AnnualReportValidateAndSubmitStepsMobileDocument = `
    mutation AnnualReportValidateAndSubmitStepsMobile($input: AnnualReportValidateAndSubmitStepsMobileInput!) {
  annualReportValidateAndSubmitStepsMobile(input: $input) {
    success
  }
}
    `;

export const useAnnualReportValidateAndSubmitStepsMobileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AnnualReportValidateAndSubmitStepsMobileMutation, TError, AnnualReportValidateAndSubmitStepsMobileMutationVariables, TContext>) => {
    
    return useMutation<AnnualReportValidateAndSubmitStepsMobileMutation, TError, AnnualReportValidateAndSubmitStepsMobileMutationVariables, TContext>(
      {
    mutationKey: ['AnnualReportValidateAndSubmitStepsMobile'],
    mutationFn: (variables?: AnnualReportValidateAndSubmitStepsMobileMutationVariables) => amplifyFetcher<AnnualReportValidateAndSubmitStepsMobileMutation, AnnualReportValidateAndSubmitStepsMobileMutationVariables>(AnnualReportValidateAndSubmitStepsMobileDocument, variables)(),
    ...options
  }
    )};

useAnnualReportValidateAndSubmitStepsMobileMutation.getKey = () => ['AnnualReportValidateAndSubmitStepsMobile'];

export const ApproveBusinessDocument = `
    mutation ApproveBusiness($input: ApproveBusinessInput!) {
  approveBusiness(input: $input) {
    data
  }
}
    `;

export const useApproveBusinessMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApproveBusinessMutation, TError, ApproveBusinessMutationVariables, TContext>) => {
    
    return useMutation<ApproveBusinessMutation, TError, ApproveBusinessMutationVariables, TContext>(
      {
    mutationKey: ['ApproveBusiness'],
    mutationFn: (variables?: ApproveBusinessMutationVariables) => amplifyFetcher<ApproveBusinessMutation, ApproveBusinessMutationVariables>(ApproveBusinessDocument, variables)(),
    ...options
  }
    )};

useApproveBusinessMutation.getKey = () => ['ApproveBusiness'];

export const ApproveBusinessExpenseDocument = `
    mutation ApproveBusinessExpense($input: ApproveBusinessExpenseInput!) {
  approveBusinessExpense(input: $input) {
    status {
      operationName
      success
      err
      warn
    }
    data {
      id
      isDuplicate
    }
  }
}
    `;

export const useApproveBusinessExpenseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApproveBusinessExpenseMutation, TError, ApproveBusinessExpenseMutationVariables, TContext>) => {
    
    return useMutation<ApproveBusinessExpenseMutation, TError, ApproveBusinessExpenseMutationVariables, TContext>(
      {
    mutationKey: ['ApproveBusinessExpense'],
    mutationFn: (variables?: ApproveBusinessExpenseMutationVariables) => amplifyFetcher<ApproveBusinessExpenseMutation, ApproveBusinessExpenseMutationVariables>(ApproveBusinessExpenseDocument, variables)(),
    ...options
  }
    )};

useApproveBusinessExpenseMutation.getKey = () => ['ApproveBusinessExpense'];

export const ApproveRepresentationDocument = `
    mutation ApproveRepresentation($input: ApproveRepresentationInput!) {
  approveRepresentation(input: $input) {
    data
  }
}
    `;

export const useApproveRepresentationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApproveRepresentationMutation, TError, ApproveRepresentationMutationVariables, TContext>) => {
    
    return useMutation<ApproveRepresentationMutation, TError, ApproveRepresentationMutationVariables, TContext>(
      {
    mutationKey: ['ApproveRepresentation'],
    mutationFn: (variables?: ApproveRepresentationMutationVariables) => amplifyFetcher<ApproveRepresentationMutation, ApproveRepresentationMutationVariables>(ApproveRepresentationDocument, variables)(),
    ...options
  }
    )};

useApproveRepresentationMutation.getKey = () => ['ApproveRepresentation'];

export const ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsDocument = `
    mutation ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocuments($input: ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsInput!) {
  approveSignaturesOnTaxAuthorityAndBituahLeumiDocuments(input: $input) {
    data
  }
}
    `;

export const useApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsMutation, TError, ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsMutationVariables, TContext>) => {
    
    return useMutation<ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsMutation, TError, ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsMutationVariables, TContext>(
      {
    mutationKey: ['ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocuments'],
    mutationFn: (variables?: ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsMutationVariables) => amplifyFetcher<ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsMutation, ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsMutationVariables>(ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsDocument, variables)(),
    ...options
  }
    )};

useApproveSignaturesOnTaxAuthorityAndBituahLeumiDocumentsMutation.getKey = () => ['ApproveSignaturesOnTaxAuthorityAndBituahLeumiDocuments'];

export const ApproveSignaturesOnVatBusinessCreationDocumentDocument = `
    mutation ApproveSignaturesOnVatBusinessCreationDocument($input: ApproveSignaturesOnVatBusinessCreationDocumentInput!) {
  approveSignaturesOnVatBusinessCreationDocument(input: $input) {
    data
  }
}
    `;

export const useApproveSignaturesOnVatBusinessCreationDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ApproveSignaturesOnVatBusinessCreationDocumentMutation, TError, ApproveSignaturesOnVatBusinessCreationDocumentMutationVariables, TContext>) => {
    
    return useMutation<ApproveSignaturesOnVatBusinessCreationDocumentMutation, TError, ApproveSignaturesOnVatBusinessCreationDocumentMutationVariables, TContext>(
      {
    mutationKey: ['ApproveSignaturesOnVatBusinessCreationDocument'],
    mutationFn: (variables?: ApproveSignaturesOnVatBusinessCreationDocumentMutationVariables) => amplifyFetcher<ApproveSignaturesOnVatBusinessCreationDocumentMutation, ApproveSignaturesOnVatBusinessCreationDocumentMutationVariables>(ApproveSignaturesOnVatBusinessCreationDocumentDocument, variables)(),
    ...options
  }
    )};

useApproveSignaturesOnVatBusinessCreationDocumentMutation.getKey = () => ['ApproveSignaturesOnVatBusinessCreationDocument'];

export const BankToPdfDocument = `
    mutation BankToPdf($input: bankToPdfInput!) {
  bankToPdf(input: $input) {
    document
  }
}
    `;

export const useBankToPdfMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BankToPdfMutation, TError, BankToPdfMutationVariables, TContext>) => {
    
    return useMutation<BankToPdfMutation, TError, BankToPdfMutationVariables, TContext>(
      {
    mutationKey: ['BankToPdf'],
    mutationFn: (variables?: BankToPdfMutationVariables) => amplifyFetcher<BankToPdfMutation, BankToPdfMutationVariables>(BankToPdfDocument, variables)(),
    ...options
  }
    )};

useBankToPdfMutation.getKey = () => ['BankToPdf'];

export const BusinessPaymentRequestDocument = `
    mutation BusinessPaymentRequest($input: BusinessPaymentRequestInput!) {
  businessPaymentRequest(input: $input) {
    data
  }
}
    `;

export const useBusinessPaymentRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BusinessPaymentRequestMutation, TError, BusinessPaymentRequestMutationVariables, TContext>) => {
    
    return useMutation<BusinessPaymentRequestMutation, TError, BusinessPaymentRequestMutationVariables, TContext>(
      {
    mutationKey: ['BusinessPaymentRequest'],
    mutationFn: (variables?: BusinessPaymentRequestMutationVariables) => amplifyFetcher<BusinessPaymentRequestMutation, BusinessPaymentRequestMutationVariables>(BusinessPaymentRequestDocument, variables)(),
    ...options
  }
    )};

useBusinessPaymentRequestMutation.getKey = () => ['BusinessPaymentRequest'];

export const BusinessSignTaxAuthorityAndBituahLeumiDocumentsDocument = `
    mutation BusinessSignTaxAuthorityAndBituahLeumiDocuments($input: BusinessSignTaxAuthorityAndBituahLeumiDocumentsInput!) {
  businessSignTaxAuthorityAndBituahLeumiDocuments(input: $input) {
    data
  }
}
    `;

export const useBusinessSignTaxAuthorityAndBituahLeumiDocumentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BusinessSignTaxAuthorityAndBituahLeumiDocumentsMutation, TError, BusinessSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables, TContext>) => {
    
    return useMutation<BusinessSignTaxAuthorityAndBituahLeumiDocumentsMutation, TError, BusinessSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables, TContext>(
      {
    mutationKey: ['BusinessSignTaxAuthorityAndBituahLeumiDocuments'],
    mutationFn: (variables?: BusinessSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables) => amplifyFetcher<BusinessSignTaxAuthorityAndBituahLeumiDocumentsMutation, BusinessSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables>(BusinessSignTaxAuthorityAndBituahLeumiDocumentsDocument, variables)(),
    ...options
  }
    )};

useBusinessSignTaxAuthorityAndBituahLeumiDocumentsMutation.getKey = () => ['BusinessSignTaxAuthorityAndBituahLeumiDocuments'];

export const BusinessSignVatBusinessCreationDocumentDocument = `
    mutation BusinessSignVatBusinessCreationDocument($input: BusinessSignVatBusinessCreationDocumentInput!) {
  businessSignVatBusinessCreationDocument(input: $input) {
    data
  }
}
    `;

export const useBusinessSignVatBusinessCreationDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BusinessSignVatBusinessCreationDocumentMutation, TError, BusinessSignVatBusinessCreationDocumentMutationVariables, TContext>) => {
    
    return useMutation<BusinessSignVatBusinessCreationDocumentMutation, TError, BusinessSignVatBusinessCreationDocumentMutationVariables, TContext>(
      {
    mutationKey: ['BusinessSignVatBusinessCreationDocument'],
    mutationFn: (variables?: BusinessSignVatBusinessCreationDocumentMutationVariables) => amplifyFetcher<BusinessSignVatBusinessCreationDocumentMutation, BusinessSignVatBusinessCreationDocumentMutationVariables>(BusinessSignVatBusinessCreationDocumentDocument, variables)(),
    ...options
  }
    )};

useBusinessSignVatBusinessCreationDocumentMutation.getKey = () => ['BusinessSignVatBusinessCreationDocument'];

export const BusinessSubscriptionConverterDocument = `
    mutation BusinessSubscriptionConverter($input: BusinessSubscriptionConverterInput!) {
  businessSubscriptionConverter(input: $input) {
    data
  }
}
    `;

export const useBusinessSubscriptionConverterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BusinessSubscriptionConverterMutation, TError, BusinessSubscriptionConverterMutationVariables, TContext>) => {
    
    return useMutation<BusinessSubscriptionConverterMutation, TError, BusinessSubscriptionConverterMutationVariables, TContext>(
      {
    mutationKey: ['BusinessSubscriptionConverter'],
    mutationFn: (variables?: BusinessSubscriptionConverterMutationVariables) => amplifyFetcher<BusinessSubscriptionConverterMutation, BusinessSubscriptionConverterMutationVariables>(BusinessSubscriptionConverterDocument, variables)(),
    ...options
  }
    )};

useBusinessSubscriptionConverterMutation.getKey = () => ['BusinessSubscriptionConverter'];

export const BusinessTypeConverterDocument = `
    mutation BusinessTypeConverter($input: BusinessTypeConverterInput!) {
  businessTypeConverter(input: $input) {
    data
  }
}
    `;

export const useBusinessTypeConverterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BusinessTypeConverterMutation, TError, BusinessTypeConverterMutationVariables, TContext>) => {
    
    return useMutation<BusinessTypeConverterMutation, TError, BusinessTypeConverterMutationVariables, TContext>(
      {
    mutationKey: ['BusinessTypeConverter'],
    mutationFn: (variables?: BusinessTypeConverterMutationVariables) => amplifyFetcher<BusinessTypeConverterMutation, BusinessTypeConverterMutationVariables>(BusinessTypeConverterDocument, variables)(),
    ...options
  }
    )};

useBusinessTypeConverterMutation.getKey = () => ['BusinessTypeConverter'];

export const BusinessUploadMissingDocumentsDocument = `
    mutation BusinessUploadMissingDocuments($input: BusinessUploadMissingDocumentsInput!) {
  businessUploadMissingDocuments(input: $input) {
    data
  }
}
    `;

export const useBusinessUploadMissingDocumentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BusinessUploadMissingDocumentsMutation, TError, BusinessUploadMissingDocumentsMutationVariables, TContext>) => {
    
    return useMutation<BusinessUploadMissingDocumentsMutation, TError, BusinessUploadMissingDocumentsMutationVariables, TContext>(
      {
    mutationKey: ['BusinessUploadMissingDocuments'],
    mutationFn: (variables?: BusinessUploadMissingDocumentsMutationVariables) => amplifyFetcher<BusinessUploadMissingDocumentsMutation, BusinessUploadMissingDocumentsMutationVariables>(BusinessUploadMissingDocumentsDocument, variables)(),
    ...options
  }
    )};

useBusinessUploadMissingDocumentsMutation.getKey = () => ['BusinessUploadMissingDocuments'];

export const CalculationBusinessReportDocument = `
    mutation CalculationBusinessReport($input: CalculationBusinessReportInput!) {
  calculationBusinessReport(input: $input) {
    success
    error
  }
}
    `;

export const useCalculationBusinessReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CalculationBusinessReportMutation, TError, CalculationBusinessReportMutationVariables, TContext>) => {
    
    return useMutation<CalculationBusinessReportMutation, TError, CalculationBusinessReportMutationVariables, TContext>(
      {
    mutationKey: ['CalculationBusinessReport'],
    mutationFn: (variables?: CalculationBusinessReportMutationVariables) => amplifyFetcher<CalculationBusinessReportMutation, CalculationBusinessReportMutationVariables>(CalculationBusinessReportDocument, variables)(),
    ...options
  }
    )};

useCalculationBusinessReportMutation.getKey = () => ['CalculationBusinessReport'];

export const CanBeBlockedDocument = `
    mutation CanBeBlocked($input: CanBeBlockedInput!) {
  canBeBlocked(input: $input) {
    data
  }
}
    `;

export const useCanBeBlockedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CanBeBlockedMutation, TError, CanBeBlockedMutationVariables, TContext>) => {
    
    return useMutation<CanBeBlockedMutation, TError, CanBeBlockedMutationVariables, TContext>(
      {
    mutationKey: ['CanBeBlocked'],
    mutationFn: (variables?: CanBeBlockedMutationVariables) => amplifyFetcher<CanBeBlockedMutation, CanBeBlockedMutationVariables>(CanBeBlockedDocument, variables)(),
    ...options
  }
    )};

useCanBeBlockedMutation.getKey = () => ['CanBeBlocked'];

export const CancelBusinessDocument = `
    mutation CancelBusiness($input: CancelBusinessInput!) {
  cancelBusiness(input: $input) {
    success
    error
  }
}
    `;

export const useCancelBusinessMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CancelBusinessMutation, TError, CancelBusinessMutationVariables, TContext>) => {
    
    return useMutation<CancelBusinessMutation, TError, CancelBusinessMutationVariables, TContext>(
      {
    mutationKey: ['CancelBusiness'],
    mutationFn: (variables?: CancelBusinessMutationVariables) => amplifyFetcher<CancelBusinessMutation, CancelBusinessMutationVariables>(CancelBusinessDocument, variables)(),
    ...options
  }
    )};

useCancelBusinessMutation.getKey = () => ['CancelBusiness'];

export const ChargeFailedBusinessBillingDocument = `
    mutation ChargeFailedBusinessBilling($input: ChargeFailedBusinessBillingInput!) {
  chargeFailedBusinessBilling(input: $input)
}
    `;

export const useChargeFailedBusinessBillingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChargeFailedBusinessBillingMutation, TError, ChargeFailedBusinessBillingMutationVariables, TContext>) => {
    
    return useMutation<ChargeFailedBusinessBillingMutation, TError, ChargeFailedBusinessBillingMutationVariables, TContext>(
      {
    mutationKey: ['ChargeFailedBusinessBilling'],
    mutationFn: (variables?: ChargeFailedBusinessBillingMutationVariables) => amplifyFetcher<ChargeFailedBusinessBillingMutation, ChargeFailedBusinessBillingMutationVariables>(ChargeFailedBusinessBillingDocument, variables)(),
    ...options
  }
    )};

useChargeFailedBusinessBillingMutation.getKey = () => ['ChargeFailedBusinessBilling'];

export const ChargeFailedBusinessBillingMobileDocument = `
    mutation ChargeFailedBusinessBillingMobile($input: ChargeFailedBusinessBillingMobileInput!) {
  chargeFailedBusinessBillingMobile(input: $input) {
    data
  }
}
    `;

export const useChargeFailedBusinessBillingMobileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChargeFailedBusinessBillingMobileMutation, TError, ChargeFailedBusinessBillingMobileMutationVariables, TContext>) => {
    
    return useMutation<ChargeFailedBusinessBillingMobileMutation, TError, ChargeFailedBusinessBillingMobileMutationVariables, TContext>(
      {
    mutationKey: ['ChargeFailedBusinessBillingMobile'],
    mutationFn: (variables?: ChargeFailedBusinessBillingMobileMutationVariables) => amplifyFetcher<ChargeFailedBusinessBillingMobileMutation, ChargeFailedBusinessBillingMobileMutationVariables>(ChargeFailedBusinessBillingMobileDocument, variables)(),
    ...options
  }
    )};

useChargeFailedBusinessBillingMobileMutation.getKey = () => ['ChargeFailedBusinessBillingMobile'];

export const CloseBusinessReportDocument = `
    mutation CloseBusinessReport($input: CloseBusinessReportInput!) {
  closeBusinessReport(input: $input) {
    id
  }
}
    `;

export const useCloseBusinessReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CloseBusinessReportMutation, TError, CloseBusinessReportMutationVariables, TContext>) => {
    
    return useMutation<CloseBusinessReportMutation, TError, CloseBusinessReportMutationVariables, TContext>(
      {
    mutationKey: ['CloseBusinessReport'],
    mutationFn: (variables?: CloseBusinessReportMutationVariables) => amplifyFetcher<CloseBusinessReportMutation, CloseBusinessReportMutationVariables>(CloseBusinessReportDocument, variables)(),
    ...options
  }
    )};

useCloseBusinessReportMutation.getKey = () => ['CloseBusinessReport'];

export const CreateBusinessIncomeDocument = `
    mutation CreateBusinessIncome($input: CreateBusinessIncomeInput!) {
  createBusinessIncome(input: $input) {
    id
    invoiceNumber
  }
}
    `;

export const useCreateBusinessIncomeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateBusinessIncomeMutation, TError, CreateBusinessIncomeMutationVariables, TContext>) => {
    
    return useMutation<CreateBusinessIncomeMutation, TError, CreateBusinessIncomeMutationVariables, TContext>(
      {
    mutationKey: ['CreateBusinessIncome'],
    mutationFn: (variables?: CreateBusinessIncomeMutationVariables) => amplifyFetcher<CreateBusinessIncomeMutation, CreateBusinessIncomeMutationVariables>(CreateBusinessIncomeDocument, variables)(),
    ...options
  }
    )};

useCreateBusinessIncomeMutation.getKey = () => ['CreateBusinessIncome'];

export const CreateCustomerDocument = `
    mutation CreateCustomer($input: CreateCustomerInput!) {
  createCustomer(input: $input) {
    data
  }
}
    `;

export const useCreateCustomerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCustomerMutation, TError, CreateCustomerMutationVariables, TContext>) => {
    
    return useMutation<CreateCustomerMutation, TError, CreateCustomerMutationVariables, TContext>(
      {
    mutationKey: ['CreateCustomer'],
    mutationFn: (variables?: CreateCustomerMutationVariables) => amplifyFetcher<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, variables)(),
    ...options
  }
    )};

useCreateCustomerMutation.getKey = () => ['CreateCustomer'];

export const CreateExpenseDocument = `
    mutation CreateExpense($input: CreateBusinessExpenseInput!) {
  createBusinessExpense(input: $input) {
    expenseId
  }
}
    `;

export const useCreateExpenseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateExpenseMutation, TError, CreateExpenseMutationVariables, TContext>) => {
    
    return useMutation<CreateExpenseMutation, TError, CreateExpenseMutationVariables, TContext>(
      {
    mutationKey: ['CreateExpense'],
    mutationFn: (variables?: CreateExpenseMutationVariables) => amplifyFetcher<CreateExpenseMutation, CreateExpenseMutationVariables>(CreateExpenseDocument, variables)(),
    ...options
  }
    )};

useCreateExpenseMutation.getKey = () => ['CreateExpense'];

export const CreateProviderDocument = `
    mutation CreateProvider($input: CreateProviderInput!) {
  createProvider(input: $input) {
    id
  }
}
    `;

export const useCreateProviderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProviderMutation, TError, CreateProviderMutationVariables, TContext>) => {
    
    return useMutation<CreateProviderMutation, TError, CreateProviderMutationVariables, TContext>(
      {
    mutationKey: ['CreateProvider'],
    mutationFn: (variables?: CreateProviderMutationVariables) => amplifyFetcher<CreateProviderMutation, CreateProviderMutationVariables>(CreateProviderDocument, variables)(),
    ...options
  }
    )};

useCreateProviderMutation.getKey = () => ['CreateProvider'];

export const CreateTaxCategoryDocument = `
    mutation CreateTaxCategory($input: CreateTaxCategoryInput!) {
  createTaxCategory(input: $input) {
    irsCode
  }
}
    `;

export const useCreateTaxCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateTaxCategoryMutation, TError, CreateTaxCategoryMutationVariables, TContext>) => {
    
    return useMutation<CreateTaxCategoryMutation, TError, CreateTaxCategoryMutationVariables, TContext>(
      {
    mutationKey: ['CreateTaxCategory'],
    mutationFn: (variables?: CreateTaxCategoryMutationVariables) => amplifyFetcher<CreateTaxCategoryMutation, CreateTaxCategoryMutationVariables>(CreateTaxCategoryDocument, variables)(),
    ...options
  }
    )};

useCreateTaxCategoryMutation.getKey = () => ['CreateTaxCategory'];

export const CreateUserNoteDocument = `
    mutation CreateUserNote($input: CreateUserNoteInput!) {
  createUserNote(input: $input) {
    data
  }
}
    `;

export const useCreateUserNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateUserNoteMutation, TError, CreateUserNoteMutationVariables, TContext>) => {
    
    return useMutation<CreateUserNoteMutation, TError, CreateUserNoteMutationVariables, TContext>(
      {
    mutationKey: ['CreateUserNote'],
    mutationFn: (variables?: CreateUserNoteMutationVariables) => amplifyFetcher<CreateUserNoteMutation, CreateUserNoteMutationVariables>(CreateUserNoteDocument, variables)(),
    ...options
  }
    )};

useCreateUserNoteMutation.getKey = () => ['CreateUserNote'];

export const DeclineBusinessExpenseDisputeDocument = `
    mutation DeclineBusinessExpenseDispute($input: DeclineBusinessExpenseDisputeInput!) {
  declineBusinessExpenseDispute(input: $input)
}
    `;

export const useDeclineBusinessExpenseDisputeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeclineBusinessExpenseDisputeMutation, TError, DeclineBusinessExpenseDisputeMutationVariables, TContext>) => {
    
    return useMutation<DeclineBusinessExpenseDisputeMutation, TError, DeclineBusinessExpenseDisputeMutationVariables, TContext>(
      {
    mutationKey: ['DeclineBusinessExpenseDispute'],
    mutationFn: (variables?: DeclineBusinessExpenseDisputeMutationVariables) => amplifyFetcher<DeclineBusinessExpenseDisputeMutation, DeclineBusinessExpenseDisputeMutationVariables>(DeclineBusinessExpenseDisputeDocument, variables)(),
    ...options
  }
    )};

useDeclineBusinessExpenseDisputeMutation.getKey = () => ['DeclineBusinessExpenseDispute'];

export const DeleteBusinessExpenseDocument = `
    mutation DeleteBusinessExpense($input: DeleteBusinessExpenseInput!) {
  deleteBusinessExpense(input: $input)
}
    `;

export const useDeleteBusinessExpenseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteBusinessExpenseMutation, TError, DeleteBusinessExpenseMutationVariables, TContext>) => {
    
    return useMutation<DeleteBusinessExpenseMutation, TError, DeleteBusinessExpenseMutationVariables, TContext>(
      {
    mutationKey: ['DeleteBusinessExpense'],
    mutationFn: (variables?: DeleteBusinessExpenseMutationVariables) => amplifyFetcher<DeleteBusinessExpenseMutation, DeleteBusinessExpenseMutationVariables>(DeleteBusinessExpenseDocument, variables)(),
    ...options
  }
    )};

useDeleteBusinessExpenseMutation.getKey = () => ['DeleteBusinessExpense'];

export const DeleteBusinessFileDocument = `
    mutation DeleteBusinessFile($input: DeleteBusinessFileInput!) {
  deleteBusinessFile(input: $input) {
    data
  }
}
    `;

export const useDeleteBusinessFileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteBusinessFileMutation, TError, DeleteBusinessFileMutationVariables, TContext>) => {
    
    return useMutation<DeleteBusinessFileMutation, TError, DeleteBusinessFileMutationVariables, TContext>(
      {
    mutationKey: ['DeleteBusinessFile'],
    mutationFn: (variables?: DeleteBusinessFileMutationVariables) => amplifyFetcher<DeleteBusinessFileMutation, DeleteBusinessFileMutationVariables>(DeleteBusinessFileDocument, variables)(),
    ...options
  }
    )};

useDeleteBusinessFileMutation.getKey = () => ['DeleteBusinessFile'];

export const DeleteUserNotificationTokenDocument = `
    mutation DeleteUserNotificationToken($input: DeleteUserNotificationTokenInput!) {
  deleteUserNotificationToken(input: $input)
}
    `;

export const useDeleteUserNotificationTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteUserNotificationTokenMutation, TError, DeleteUserNotificationTokenMutationVariables, TContext>) => {
    
    return useMutation<DeleteUserNotificationTokenMutation, TError, DeleteUserNotificationTokenMutationVariables, TContext>(
      {
    mutationKey: ['DeleteUserNotificationToken'],
    mutationFn: (variables?: DeleteUserNotificationTokenMutationVariables) => amplifyFetcher<DeleteUserNotificationTokenMutation, DeleteUserNotificationTokenMutationVariables>(DeleteUserNotificationTokenDocument, variables)(),
    ...options
  }
    )};

useDeleteUserNotificationTokenMutation.getKey = () => ['DeleteUserNotificationToken'];

export const DisputeBusinessExpenseDocument = `
    mutation DisputeBusinessExpense($input: DisputeBusinessExpenseInput!) {
  disputeBusinessExpense(input: $input) {
    id
  }
}
    `;

export const useDisputeBusinessExpenseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DisputeBusinessExpenseMutation, TError, DisputeBusinessExpenseMutationVariables, TContext>) => {
    
    return useMutation<DisputeBusinessExpenseMutation, TError, DisputeBusinessExpenseMutationVariables, TContext>(
      {
    mutationKey: ['DisputeBusinessExpense'],
    mutationFn: (variables?: DisputeBusinessExpenseMutationVariables) => amplifyFetcher<DisputeBusinessExpenseMutation, DisputeBusinessExpenseMutationVariables>(DisputeBusinessExpenseDocument, variables)(),
    ...options
  }
    )};

useDisputeBusinessExpenseMutation.getKey = () => ['DisputeBusinessExpense'];

export const DocumentTreeDocument = `
    mutation DocumentTree($input: DocumentTreeInput!) {
  documentTree(input: $input) {
    items {
      data {
        id
        reportType
        incomeType
        priceIncludingVat
        price
        description
        incomeDate
        currency
        currencyRate
        reportId
        reportStartDate
        reportEndDate
      }
    }
  }
}
    `;

export const useDocumentTreeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DocumentTreeMutation, TError, DocumentTreeMutationVariables, TContext>) => {
    
    return useMutation<DocumentTreeMutation, TError, DocumentTreeMutationVariables, TContext>(
      {
    mutationKey: ['DocumentTree'],
    mutationFn: (variables?: DocumentTreeMutationVariables) => amplifyFetcher<DocumentTreeMutation, DocumentTreeMutationVariables>(DocumentTreeDocument, variables)(),
    ...options
  }
    )};

useDocumentTreeMutation.getKey = () => ['DocumentTree'];

export const DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsDocument = `
    mutation DraftBusinessSignTaxAuthorityAndBituahLeumiDocuments($input: DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsInput!) {
  draftBusinessSignTaxAuthorityAndBituahLeumiDocuments(input: $input) {
    data {
      pdfType
      base64Pdf
    }
  }
}
    `;

export const useDraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsMutation, TError, DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables, TContext>) => {
    
    return useMutation<DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsMutation, TError, DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables, TContext>(
      {
    mutationKey: ['DraftBusinessSignTaxAuthorityAndBituahLeumiDocuments'],
    mutationFn: (variables?: DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables) => amplifyFetcher<DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsMutation, DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsMutationVariables>(DraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsDocument, variables)(),
    ...options
  }
    )};

useDraftBusinessSignTaxAuthorityAndBituahLeumiDocumentsMutation.getKey = () => ['DraftBusinessSignTaxAuthorityAndBituahLeumiDocuments'];

export const DraftBusinessSignVatBusinessCreationDocumentDocument = `
    mutation DraftBusinessSignVatBusinessCreationDocument($input: DraftBusinessSignVatBusinessCreationDocumentInput!) {
  draftBusinessSignVatBusinessCreationDocument(input: $input) {
    data {
      pdfType
      base64Pdf
    }
  }
}
    `;

export const useDraftBusinessSignVatBusinessCreationDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DraftBusinessSignVatBusinessCreationDocumentMutation, TError, DraftBusinessSignVatBusinessCreationDocumentMutationVariables, TContext>) => {
    
    return useMutation<DraftBusinessSignVatBusinessCreationDocumentMutation, TError, DraftBusinessSignVatBusinessCreationDocumentMutationVariables, TContext>(
      {
    mutationKey: ['DraftBusinessSignVatBusinessCreationDocument'],
    mutationFn: (variables?: DraftBusinessSignVatBusinessCreationDocumentMutationVariables) => amplifyFetcher<DraftBusinessSignVatBusinessCreationDocumentMutation, DraftBusinessSignVatBusinessCreationDocumentMutationVariables>(DraftBusinessSignVatBusinessCreationDocumentDocument, variables)(),
    ...options
  }
    )};

useDraftBusinessSignVatBusinessCreationDocumentMutation.getKey = () => ['DraftBusinessSignVatBusinessCreationDocument'];

export const EditCustomerDocument = `
    mutation EditCustomer($input: EditCustomerInput!) {
  editCustomer(input: $input) {
    data
  }
}
    `;

export const useEditCustomerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditCustomerMutation, TError, EditCustomerMutationVariables, TContext>) => {
    
    return useMutation<EditCustomerMutation, TError, EditCustomerMutationVariables, TContext>(
      {
    mutationKey: ['EditCustomer'],
    mutationFn: (variables?: EditCustomerMutationVariables) => amplifyFetcher<EditCustomerMutation, EditCustomerMutationVariables>(EditCustomerDocument, variables)(),
    ...options
  }
    )};

useEditCustomerMutation.getKey = () => ['EditCustomer'];

export const EditDinVeHeshbonToDbBoDocument = `
    mutation EditDinVeHeshbonToDbBO($input: EditDinVeHeshbonToDbInput!) {
  editDinVeHeshbonToDbBO(input: $input) {
    message
  }
}
    `;

export const useEditDinVeHeshbonToDbBoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditDinVeHeshbonToDbBoMutation, TError, EditDinVeHeshbonToDbBoMutationVariables, TContext>) => {
    
    return useMutation<EditDinVeHeshbonToDbBoMutation, TError, EditDinVeHeshbonToDbBoMutationVariables, TContext>(
      {
    mutationKey: ['EditDinVeHeshbonToDbBO'],
    mutationFn: (variables?: EditDinVeHeshbonToDbBoMutationVariables) => amplifyFetcher<EditDinVeHeshbonToDbBoMutation, EditDinVeHeshbonToDbBoMutationVariables>(EditDinVeHeshbonToDbBoDocument, variables)(),
    ...options
  }
    )};

useEditDinVeHeshbonToDbBoMutation.getKey = () => ['EditDinVeHeshbonToDbBO'];

export const EditProviderDocument = `
    mutation EditProvider($input: EditProviderInput!) {
  editProvider(input: $input) {
    id
  }
}
    `;

export const useEditProviderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditProviderMutation, TError, EditProviderMutationVariables, TContext>) => {
    
    return useMutation<EditProviderMutation, TError, EditProviderMutationVariables, TContext>(
      {
    mutationKey: ['EditProvider'],
    mutationFn: (variables?: EditProviderMutationVariables) => amplifyFetcher<EditProviderMutation, EditProviderMutationVariables>(EditProviderDocument, variables)(),
    ...options
  }
    )};

useEditProviderMutation.getKey = () => ['EditProvider'];

export const EditTaxCategoryDocument = `
    mutation EditTaxCategory($input: EditTaxCategoryInput!) {
  editTaxCategory(input: $input) {
    irsCode
  }
}
    `;

export const useEditTaxCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditTaxCategoryMutation, TError, EditTaxCategoryMutationVariables, TContext>) => {
    
    return useMutation<EditTaxCategoryMutation, TError, EditTaxCategoryMutationVariables, TContext>(
      {
    mutationKey: ['EditTaxCategory'],
    mutationFn: (variables?: EditTaxCategoryMutationVariables) => amplifyFetcher<EditTaxCategoryMutation, EditTaxCategoryMutationVariables>(EditTaxCategoryDocument, variables)(),
    ...options
  }
    )};

useEditTaxCategoryMutation.getKey = () => ['EditTaxCategory'];

export const FillDinVeHeshbonDocument = `
    mutation FillDinVeHeshbon($input: InsertDinVeHeshbonToDbInput!) {
  fillDinVeHeshbon(input: $input) {
    data
  }
}
    `;

export const useFillDinVeHeshbonMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<FillDinVeHeshbonMutation, TError, FillDinVeHeshbonMutationVariables, TContext>) => {
    
    return useMutation<FillDinVeHeshbonMutation, TError, FillDinVeHeshbonMutationVariables, TContext>(
      {
    mutationKey: ['FillDinVeHeshbon'],
    mutationFn: (variables?: FillDinVeHeshbonMutationVariables) => amplifyFetcher<FillDinVeHeshbonMutation, FillDinVeHeshbonMutationVariables>(FillDinVeHeshbonDocument, variables)(),
    ...options
  }
    )};

useFillDinVeHeshbonMutation.getKey = () => ['FillDinVeHeshbon'];

export const GenerateCardIndexDocument = `
    mutation GenerateCardIndex($input: GenerateCardIndexInput!) {
  generateCardIndex(input: $input) {
    base64Pdf
  }
}
    `;

export const useGenerateCardIndexMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateCardIndexMutation, TError, GenerateCardIndexMutationVariables, TContext>) => {
    
    return useMutation<GenerateCardIndexMutation, TError, GenerateCardIndexMutationVariables, TContext>(
      {
    mutationKey: ['GenerateCardIndex'],
    mutationFn: (variables?: GenerateCardIndexMutationVariables) => amplifyFetcher<GenerateCardIndexMutation, GenerateCardIndexMutationVariables>(GenerateCardIndexDocument, variables)(),
    ...options
  }
    )};

useGenerateCardIndexMutation.getKey = () => ['GenerateCardIndex'];

export const GenerateCashBookDocument = `
    mutation GenerateCashBook($input: GenerateCashBookInput!) {
  generateCashBook(input: $input) {
    base64Pdf
  }
}
    `;

export const useGenerateCashBookMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateCashBookMutation, TError, GenerateCashBookMutationVariables, TContext>) => {
    
    return useMutation<GenerateCashBookMutation, TError, GenerateCashBookMutationVariables, TContext>(
      {
    mutationKey: ['GenerateCashBook'],
    mutationFn: (variables?: GenerateCashBookMutationVariables) => amplifyFetcher<GenerateCashBookMutation, GenerateCashBookMutationVariables>(GenerateCashBookDocument, variables)(),
    ...options
  }
    )};

useGenerateCashBookMutation.getKey = () => ['GenerateCashBook'];

export const GenerateJonniIncomeReportDocument = `
    mutation GenerateJonniIncomeReport($input: GenerateJonniIncomeReportInput!) {
  generateJonniIncomeReport(input: $input) {
    url
  }
}
    `;

export const useGenerateJonniIncomeReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateJonniIncomeReportMutation, TError, GenerateJonniIncomeReportMutationVariables, TContext>) => {
    
    return useMutation<GenerateJonniIncomeReportMutation, TError, GenerateJonniIncomeReportMutationVariables, TContext>(
      {
    mutationKey: ['GenerateJonniIncomeReport'],
    mutationFn: (variables?: GenerateJonniIncomeReportMutationVariables) => amplifyFetcher<GenerateJonniIncomeReportMutation, GenerateJonniIncomeReportMutationVariables>(GenerateJonniIncomeReportDocument, variables)(),
    ...options
  }
    )};

useGenerateJonniIncomeReportMutation.getKey = () => ['GenerateJonniIncomeReport'];

export const GenerateOpenfrmtFilesDocument = `
    mutation GenerateOpenfrmtFiles($input: GenerateOpenfrmtFileInput!) {
  generateOpenfrmtFiles(input: $input) {
    startDate
    endDate
    businessName
    registrationNumber
    route
    entries {
      entry
      total
      title
    }
    documents {
      type
      counter
      amount
      title
    }
  }
}
    `;

export const useGenerateOpenfrmtFilesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateOpenfrmtFilesMutation, TError, GenerateOpenfrmtFilesMutationVariables, TContext>) => {
    
    return useMutation<GenerateOpenfrmtFilesMutation, TError, GenerateOpenfrmtFilesMutationVariables, TContext>(
      {
    mutationKey: ['GenerateOpenfrmtFiles'],
    mutationFn: (variables?: GenerateOpenfrmtFilesMutationVariables) => amplifyFetcher<GenerateOpenfrmtFilesMutation, GenerateOpenfrmtFilesMutationVariables>(GenerateOpenfrmtFilesDocument, variables)(),
    ...options
  }
    )};

useGenerateOpenfrmtFilesMutation.getKey = () => ['GenerateOpenfrmtFiles'];

export const GenerateProfitLossDocumentDocument = `
    mutation GenerateProfitLossDocument($input: GenerateProfitLossDocumentInput!) {
  generateProfitLossDocument(input: $input) {
    base64Pdf
  }
}
    `;

export const useGenerateProfitLossDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateProfitLossDocumentMutation, TError, GenerateProfitLossDocumentMutationVariables, TContext>) => {
    
    return useMutation<GenerateProfitLossDocumentMutation, TError, GenerateProfitLossDocumentMutationVariables, TContext>(
      {
    mutationKey: ['GenerateProfitLossDocument'],
    mutationFn: (variables?: GenerateProfitLossDocumentMutationVariables) => amplifyFetcher<GenerateProfitLossDocumentMutation, GenerateProfitLossDocumentMutationVariables>(GenerateProfitLossDocumentDocument, variables)(),
    ...options
  }
    )};

useGenerateProfitLossDocumentMutation.getKey = () => ['GenerateProfitLossDocument'];

export const GetDataFromPdfBoDocument = `
    mutation GetDataFromPdfBO($input: GetDataFromPdfInput!) {
  getDataFromPdfBO(input: $input) {
    incomeProvider
    description
    price
    priceIncludingVat
    totalDeductedVat
    vat
    currency
  }
}
    `;

export const useGetDataFromPdfBoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetDataFromPdfBoMutation, TError, GetDataFromPdfBoMutationVariables, TContext>) => {
    
    return useMutation<GetDataFromPdfBoMutation, TError, GetDataFromPdfBoMutationVariables, TContext>(
      {
    mutationKey: ['GetDataFromPdfBO'],
    mutationFn: (variables?: GetDataFromPdfBoMutationVariables) => amplifyFetcher<GetDataFromPdfBoMutation, GetDataFromPdfBoMutationVariables>(GetDataFromPdfBoDocument, variables)(),
    ...options
  }
    )};

useGetDataFromPdfBoMutation.getKey = () => ['GetDataFromPdfBO'];

export const GetDataFromPdfMobileDocument = `
    mutation GetDataFromPdfMobile($input: GetDataFromPdfInput!) {
  getDataFromPdfMobile(input: $input) {
    description
    type: incomeType
    date: incomeDate
    currency
    price
    vat
    priceIncludingVat
    items {
      description
      vatType
      units
      unitPrice
      price
      vat
      priceIncludingVat
    }
    payments {
      paymentMethod
      date: paymentDate
      price
      taxDeduction
    }
    taxDeduction
    incomeProvider
    invoiceNumber
    customerName
    registrationNumber
    fullPriceDeviation
    base64Pdf
  }
}
    `;

export const useGetDataFromPdfMobileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetDataFromPdfMobileMutation, TError, GetDataFromPdfMobileMutationVariables, TContext>) => {
    
    return useMutation<GetDataFromPdfMobileMutation, TError, GetDataFromPdfMobileMutationVariables, TContext>(
      {
    mutationKey: ['GetDataFromPdfMobile'],
    mutationFn: (variables?: GetDataFromPdfMobileMutationVariables) => amplifyFetcher<GetDataFromPdfMobileMutation, GetDataFromPdfMobileMutationVariables>(GetDataFromPdfMobileDocument, variables)(),
    ...options
  }
    )};

useGetDataFromPdfMobileMutation.getKey = () => ['GetDataFromPdfMobile'];

export const HoldBusinessDocument = `
    mutation HoldBusiness($input: HoldBusinessInput!) {
  holdBusiness(input: $input) {
    success
    error
  }
}
    `;

export const useHoldBusinessMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<HoldBusinessMutation, TError, HoldBusinessMutationVariables, TContext>) => {
    
    return useMutation<HoldBusinessMutation, TError, HoldBusinessMutationVariables, TContext>(
      {
    mutationKey: ['HoldBusiness'],
    mutationFn: (variables?: HoldBusinessMutationVariables) => amplifyFetcher<HoldBusinessMutation, HoldBusinessMutationVariables>(HoldBusinessDocument, variables)(),
    ...options
  }
    )};

useHoldBusinessMutation.getKey = () => ['HoldBusiness'];

export const IdToPdfDocument = `
    mutation IdToPdf($input: idToPdfInput!) {
  idToPdf(input: $input) {
    document
  }
}
    `;

export const useIdToPdfMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<IdToPdfMutation, TError, IdToPdfMutationVariables, TContext>) => {
    
    return useMutation<IdToPdfMutation, TError, IdToPdfMutationVariables, TContext>(
      {
    mutationKey: ['IdToPdf'],
    mutationFn: (variables?: IdToPdfMutationVariables) => amplifyFetcher<IdToPdfMutation, IdToPdfMutationVariables>(IdToPdfDocument, variables)(),
    ...options
  }
    )};

useIdToPdfMutation.getKey = () => ['IdToPdf'];

export const ImportBusinessIncomeDocument = `
    mutation ImportBusinessIncome($input: ImportBusinessIncomeInput!) {
  importBusinessIncome(input: $input) {
    id
  }
}
    `;

export const useImportBusinessIncomeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportBusinessIncomeMutation, TError, ImportBusinessIncomeMutationVariables, TContext>) => {
    
    return useMutation<ImportBusinessIncomeMutation, TError, ImportBusinessIncomeMutationVariables, TContext>(
      {
    mutationKey: ['ImportBusinessIncome'],
    mutationFn: (variables?: ImportBusinessIncomeMutationVariables) => amplifyFetcher<ImportBusinessIncomeMutation, ImportBusinessIncomeMutationVariables>(ImportBusinessIncomeDocument, variables)(),
    ...options
  }
    )};

useImportBusinessIncomeMutation.getKey = () => ['ImportBusinessIncome'];

export const InsertDinVeHeshbonToDbBoDocument = `
    mutation InsertDinVeHeshbonToDbBO($input: InsertDinVeHeshbonToDbInput!) {
  insertDinVeHeshbonToDbBO(input: $input) {
    message
  }
}
    `;

export const useInsertDinVeHeshbonToDbBoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InsertDinVeHeshbonToDbBoMutation, TError, InsertDinVeHeshbonToDbBoMutationVariables, TContext>) => {
    
    return useMutation<InsertDinVeHeshbonToDbBoMutation, TError, InsertDinVeHeshbonToDbBoMutationVariables, TContext>(
      {
    mutationKey: ['InsertDinVeHeshbonToDbBO'],
    mutationFn: (variables?: InsertDinVeHeshbonToDbBoMutationVariables) => amplifyFetcher<InsertDinVeHeshbonToDbBoMutation, InsertDinVeHeshbonToDbBoMutationVariables>(InsertDinVeHeshbonToDbBoDocument, variables)(),
    ...options
  }
    )};

useInsertDinVeHeshbonToDbBoMutation.getKey = () => ['InsertDinVeHeshbonToDbBO'];

export const InsertDinVeHeshbonToDbMobileDocument = `
    mutation InsertDinVeHeshbonToDbMobile($input: InsertDinVeHeshbonToDbInput!) {
  insertDinVeHeshbonToDbMobile(input: $input) {
    message
  }
}
    `;

export const useInsertDinVeHeshbonToDbMobileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InsertDinVeHeshbonToDbMobileMutation, TError, InsertDinVeHeshbonToDbMobileMutationVariables, TContext>) => {
    
    return useMutation<InsertDinVeHeshbonToDbMobileMutation, TError, InsertDinVeHeshbonToDbMobileMutationVariables, TContext>(
      {
    mutationKey: ['InsertDinVeHeshbonToDbMobile'],
    mutationFn: (variables?: InsertDinVeHeshbonToDbMobileMutationVariables) => amplifyFetcher<InsertDinVeHeshbonToDbMobileMutation, InsertDinVeHeshbonToDbMobileMutationVariables>(InsertDinVeHeshbonToDbMobileDocument, variables)(),
    ...options
  }
    )};

useInsertDinVeHeshbonToDbMobileMutation.getKey = () => ['InsertDinVeHeshbonToDbMobile'];

export const IsBusinessNeedToFillDinVeHeshbonDocument = `
    mutation IsBusinessNeedToFillDinVeHeshbon($input: IsBusinessNeedToFillDinVeHeshbonInput!) {
  isBusinessNeedToFillDinVeHeshbon(input: $input) {
    data
  }
}
    `;

export const useIsBusinessNeedToFillDinVeHeshbonMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<IsBusinessNeedToFillDinVeHeshbonMutation, TError, IsBusinessNeedToFillDinVeHeshbonMutationVariables, TContext>) => {
    
    return useMutation<IsBusinessNeedToFillDinVeHeshbonMutation, TError, IsBusinessNeedToFillDinVeHeshbonMutationVariables, TContext>(
      {
    mutationKey: ['IsBusinessNeedToFillDinVeHeshbon'],
    mutationFn: (variables?: IsBusinessNeedToFillDinVeHeshbonMutationVariables) => amplifyFetcher<IsBusinessNeedToFillDinVeHeshbonMutation, IsBusinessNeedToFillDinVeHeshbonMutationVariables>(IsBusinessNeedToFillDinVeHeshbonDocument, variables)(),
    ...options
  }
    )};

useIsBusinessNeedToFillDinVeHeshbonMutation.getKey = () => ['IsBusinessNeedToFillDinVeHeshbon'];

export const MoveBusinessExpenseVatDocument = `
    mutation MoveBusinessExpenseVat($input: MoveBusinessExpenseVatInput!) {
  moveBusinessExpenseVat(input: $input)
}
    `;

export const useMoveBusinessExpenseVatMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MoveBusinessExpenseVatMutation, TError, MoveBusinessExpenseVatMutationVariables, TContext>) => {
    
    return useMutation<MoveBusinessExpenseVatMutation, TError, MoveBusinessExpenseVatMutationVariables, TContext>(
      {
    mutationKey: ['MoveBusinessExpenseVat'],
    mutationFn: (variables?: MoveBusinessExpenseVatMutationVariables) => amplifyFetcher<MoveBusinessExpenseVatMutation, MoveBusinessExpenseVatMutationVariables>(MoveBusinessExpenseVatDocument, variables)(),
    ...options
  }
    )};

useMoveBusinessExpenseVatMutation.getKey = () => ['MoveBusinessExpenseVat'];

export const RefundBusinessBillingDocument = `
    mutation RefundBusinessBilling($input: RefundBusinessBillingInput!) {
  refundBusinessBilling(input: $input)
}
    `;

export const useRefundBusinessBillingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RefundBusinessBillingMutation, TError, RefundBusinessBillingMutationVariables, TContext>) => {
    
    return useMutation<RefundBusinessBillingMutation, TError, RefundBusinessBillingMutationVariables, TContext>(
      {
    mutationKey: ['RefundBusinessBilling'],
    mutationFn: (variables?: RefundBusinessBillingMutationVariables) => amplifyFetcher<RefundBusinessBillingMutation, RefundBusinessBillingMutationVariables>(RefundBusinessBillingDocument, variables)(),
    ...options
  }
    )};

useRefundBusinessBillingMutation.getKey = () => ['RefundBusinessBilling'];

export const ReopenApprovedBusinessExpenseDocument = `
    mutation ReopenApprovedBusinessExpense($input: ReopenApprovedBusinessExpenseInput!) {
  reopenApprovedBusinessExpense(input: $input)
}
    `;

export const useReopenApprovedBusinessExpenseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReopenApprovedBusinessExpenseMutation, TError, ReopenApprovedBusinessExpenseMutationVariables, TContext>) => {
    
    return useMutation<ReopenApprovedBusinessExpenseMutation, TError, ReopenApprovedBusinessExpenseMutationVariables, TContext>(
      {
    mutationKey: ['ReopenApprovedBusinessExpense'],
    mutationFn: (variables?: ReopenApprovedBusinessExpenseMutationVariables) => amplifyFetcher<ReopenApprovedBusinessExpenseMutation, ReopenApprovedBusinessExpenseMutationVariables>(ReopenApprovedBusinessExpenseDocument, variables)(),
    ...options
  }
    )};

useReopenApprovedBusinessExpenseMutation.getKey = () => ['ReopenApprovedBusinessExpense'];

export const ReopenBusinessReportDocument = `
    mutation ReopenBusinessReport($input: ReopenBusinessReportInput!) {
  reopenBusinessReport(input: $input) {
    id
  }
}
    `;

export const useReopenBusinessReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReopenBusinessReportMutation, TError, ReopenBusinessReportMutationVariables, TContext>) => {
    
    return useMutation<ReopenBusinessReportMutation, TError, ReopenBusinessReportMutationVariables, TContext>(
      {
    mutationKey: ['ReopenBusinessReport'],
    mutationFn: (variables?: ReopenBusinessReportMutationVariables) => amplifyFetcher<ReopenBusinessReportMutation, ReopenBusinessReportMutationVariables>(ReopenBusinessReportDocument, variables)(),
    ...options
  }
    )};

useReopenBusinessReportMutation.getKey = () => ['ReopenBusinessReport'];

export const ResponseBusinessApprovedDocument = `
    mutation ResponseBusinessApproved($input: ResponseBusinessApprovedInput!) {
  responseBusinessApproved(input: $input) {
    id
  }
}
    `;

export const useResponseBusinessApprovedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResponseBusinessApprovedMutation, TError, ResponseBusinessApprovedMutationVariables, TContext>) => {
    
    return useMutation<ResponseBusinessApprovedMutation, TError, ResponseBusinessApprovedMutationVariables, TContext>(
      {
    mutationKey: ['ResponseBusinessApproved'],
    mutationFn: (variables?: ResponseBusinessApprovedMutationVariables) => amplifyFetcher<ResponseBusinessApprovedMutation, ResponseBusinessApprovedMutationVariables>(ResponseBusinessApprovedDocument, variables)(),
    ...options
  }
    )};

useResponseBusinessApprovedMutation.getKey = () => ['ResponseBusinessApproved'];

export const ResponseBusinessDeclinedDocument = `
    mutation ResponseBusinessDeclined($input: ResponseBusinessDeclinedInput!) {
  responseBusinessDeclined(input: $input) {
    id
  }
}
    `;

export const useResponseBusinessDeclinedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResponseBusinessDeclinedMutation, TError, ResponseBusinessDeclinedMutationVariables, TContext>) => {
    
    return useMutation<ResponseBusinessDeclinedMutation, TError, ResponseBusinessDeclinedMutationVariables, TContext>(
      {
    mutationKey: ['ResponseBusinessDeclined'],
    mutationFn: (variables?: ResponseBusinessDeclinedMutationVariables) => amplifyFetcher<ResponseBusinessDeclinedMutation, ResponseBusinessDeclinedMutationVariables>(ResponseBusinessDeclinedDocument, variables)(),
    ...options
  }
    )};

useResponseBusinessDeclinedMutation.getKey = () => ['ResponseBusinessDeclined'];

export const RestoreBusinessDocument = `
    mutation RestoreBusiness($input: RestoreBusinessInput!) {
  restoreBusiness(input: $input) {
    success
    error
  }
}
    `;

export const useRestoreBusinessMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RestoreBusinessMutation, TError, RestoreBusinessMutationVariables, TContext>) => {
    
    return useMutation<RestoreBusinessMutation, TError, RestoreBusinessMutationVariables, TContext>(
      {
    mutationKey: ['RestoreBusiness'],
    mutationFn: (variables?: RestoreBusinessMutationVariables) => amplifyFetcher<RestoreBusinessMutation, RestoreBusinessMutationVariables>(RestoreBusinessDocument, variables)(),
    ...options
  }
    )};

useRestoreBusinessMutation.getKey = () => ['RestoreBusiness'];

export const SendEmailDocument = `
    mutation SendEmail($input: SendBusinessIncomeToEmailInput!) {
  sendBusinessIncomeToEmail(input: $input) {
    subject
  }
}
    `;

export const useSendEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendEmailMutation, TError, SendEmailMutationVariables, TContext>) => {
    
    return useMutation<SendEmailMutation, TError, SendEmailMutationVariables, TContext>(
      {
    mutationKey: ['SendEmail'],
    mutationFn: (variables?: SendEmailMutationVariables) => amplifyFetcher<SendEmailMutation, SendEmailMutationVariables>(SendEmailDocument, variables)(),
    ...options
  }
    )};

useSendEmailMutation.getKey = () => ['SendEmail'];

export const SetUserNotificationTokenDocument = `
    mutation SetUserNotificationToken($input: SetUserNotificationTokenInput!) {
  setUserNotificationToken(input: $input)
}
    `;

export const useSetUserNotificationTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetUserNotificationTokenMutation, TError, SetUserNotificationTokenMutationVariables, TContext>) => {
    
    return useMutation<SetUserNotificationTokenMutation, TError, SetUserNotificationTokenMutationVariables, TContext>(
      {
    mutationKey: ['SetUserNotificationToken'],
    mutationFn: (variables?: SetUserNotificationTokenMutationVariables) => amplifyFetcher<SetUserNotificationTokenMutation, SetUserNotificationTokenMutationVariables>(SetUserNotificationTokenDocument, variables)(),
    ...options
  }
    )};

useSetUserNotificationTokenMutation.getKey = () => ['SetUserNotificationToken'];

export const SetWasUserContactedDocument = `
    mutation SetWasUserContacted($input: SetWasUserContactedInput!) {
  setWasUserContacted(input: $input) {
    data
  }
}
    `;

export const useSetWasUserContactedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetWasUserContactedMutation, TError, SetWasUserContactedMutationVariables, TContext>) => {
    
    return useMutation<SetWasUserContactedMutation, TError, SetWasUserContactedMutationVariables, TContext>(
      {
    mutationKey: ['SetWasUserContacted'],
    mutationFn: (variables?: SetWasUserContactedMutationVariables) => amplifyFetcher<SetWasUserContactedMutation, SetWasUserContactedMutationVariables>(SetWasUserContactedDocument, variables)(),
    ...options
  }
    )};

useSetWasUserContactedMutation.getKey = () => ['SetWasUserContacted'];

export const SignUpDocument = `
    mutation SignUp($input: SignUpInput!) {
  signUp(input: $input) {
    id
    onboardingStatus
  }
}
    `;

export const useSignUpMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SignUpMutation, TError, SignUpMutationVariables, TContext>) => {
    
    return useMutation<SignUpMutation, TError, SignUpMutationVariables, TContext>(
      {
    mutationKey: ['SignUp'],
    mutationFn: (variables?: SignUpMutationVariables) => amplifyFetcher<SignUpMutation, SignUpMutationVariables>(SignUpDocument, variables)(),
    ...options
  }
    )};

useSignUpMutation.getKey = () => ['SignUp'];

export const SubmitAuthoritiesIdentificationDocument = `
    mutation SubmitAuthoritiesIdentification($input: SubmitAuthoritiesIdentificationInput!) {
  submitAuthoritiesIdentification(input: $input) {
    onboardingStatus
    id
  }
}
    `;

export const useSubmitAuthoritiesIdentificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitAuthoritiesIdentificationMutation, TError, SubmitAuthoritiesIdentificationMutationVariables, TContext>) => {
    
    return useMutation<SubmitAuthoritiesIdentificationMutation, TError, SubmitAuthoritiesIdentificationMutationVariables, TContext>(
      {
    mutationKey: ['SubmitAuthoritiesIdentification'],
    mutationFn: (variables?: SubmitAuthoritiesIdentificationMutationVariables) => amplifyFetcher<SubmitAuthoritiesIdentificationMutation, SubmitAuthoritiesIdentificationMutationVariables>(SubmitAuthoritiesIdentificationDocument, variables)(),
    ...options
  }
    )};

useSubmitAuthoritiesIdentificationMutation.getKey = () => ['SubmitAuthoritiesIdentification'];

export const SubmitIdentificationUploadDocument = `
    mutation SubmitIdentificationUpload($input: SubmitIdentificationUploadInput!) {
  submitIdentificationUpload(input: $input) {
    id
    onboardingStatus
  }
}
    `;

export const useSubmitIdentificationUploadMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitIdentificationUploadMutation, TError, SubmitIdentificationUploadMutationVariables, TContext>) => {
    
    return useMutation<SubmitIdentificationUploadMutation, TError, SubmitIdentificationUploadMutationVariables, TContext>(
      {
    mutationKey: ['SubmitIdentificationUpload'],
    mutationFn: (variables?: SubmitIdentificationUploadMutationVariables) => amplifyFetcher<SubmitIdentificationUploadMutation, SubmitIdentificationUploadMutationVariables>(SubmitIdentificationUploadDocument, variables)(),
    ...options
  }
    )};

useSubmitIdentificationUploadMutation.getKey = () => ['SubmitIdentificationUpload'];

export const SubmitBankDetailsDocument = `
    mutation SubmitBankDetails($input: SubmitBankDetailsInput!) {
  submitBankDetails(input: $input) {
    data
  }
}
    `;

export const useSubmitBankDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitBankDetailsMutation, TError, SubmitBankDetailsMutationVariables, TContext>) => {
    
    return useMutation<SubmitBankDetailsMutation, TError, SubmitBankDetailsMutationVariables, TContext>(
      {
    mutationKey: ['SubmitBankDetails'],
    mutationFn: (variables?: SubmitBankDetailsMutationVariables) => amplifyFetcher<SubmitBankDetailsMutation, SubmitBankDetailsMutationVariables>(SubmitBankDetailsDocument, variables)(),
    ...options
  }
    )};

useSubmitBankDetailsMutation.getKey = () => ['SubmitBankDetails'];

export const SubmitBillingDetailsDocument = `
    mutation SubmitBillingDetails($input: SubmitBillingDetailsInput!) {
  submitBillingDetails(input: $input) {
    id
  }
}
    `;

export const useSubmitBillingDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitBillingDetailsMutation, TError, SubmitBillingDetailsMutationVariables, TContext>) => {
    
    return useMutation<SubmitBillingDetailsMutation, TError, SubmitBillingDetailsMutationVariables, TContext>(
      {
    mutationKey: ['SubmitBillingDetails'],
    mutationFn: (variables?: SubmitBillingDetailsMutationVariables) => amplifyFetcher<SubmitBillingDetailsMutation, SubmitBillingDetailsMutationVariables>(SubmitBillingDetailsDocument, variables)(),
    ...options
  }
    )};

useSubmitBillingDetailsMutation.getKey = () => ['SubmitBillingDetails'];

export const SubmitBusinessDetailsDocument = `
    mutation SubmitBusinessDetails($input: SubmitBusinessDetailsInput!) {
  submitBusinessDetails(input: $input) {
    businessId
    onboardingStatus
  }
}
    `;

export const useSubmitBusinessDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitBusinessDetailsMutation, TError, SubmitBusinessDetailsMutationVariables, TContext>) => {
    
    return useMutation<SubmitBusinessDetailsMutation, TError, SubmitBusinessDetailsMutationVariables, TContext>(
      {
    mutationKey: ['SubmitBusinessDetails'],
    mutationFn: (variables?: SubmitBusinessDetailsMutationVariables) => amplifyFetcher<SubmitBusinessDetailsMutation, SubmitBusinessDetailsMutationVariables>(SubmitBusinessDetailsDocument, variables)(),
    ...options
  }
    )};

useSubmitBusinessDetailsMutation.getKey = () => ['SubmitBusinessDetails'];

export const SubmitBusinessEnglishDetailsDocument = `
    mutation SubmitBusinessEnglishDetails($input: SubmitBusinessEnglishDetailsInput!) {
  submitBusinessEnglishDetails(input: $input) {
    data
  }
}
    `;

export const useSubmitBusinessEnglishDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitBusinessEnglishDetailsMutation, TError, SubmitBusinessEnglishDetailsMutationVariables, TContext>) => {
    
    return useMutation<SubmitBusinessEnglishDetailsMutation, TError, SubmitBusinessEnglishDetailsMutationVariables, TContext>(
      {
    mutationKey: ['SubmitBusinessEnglishDetails'],
    mutationFn: (variables?: SubmitBusinessEnglishDetailsMutationVariables) => amplifyFetcher<SubmitBusinessEnglishDetailsMutation, SubmitBusinessEnglishDetailsMutationVariables>(SubmitBusinessEnglishDetailsDocument, variables)(),
    ...options
  }
    )};

useSubmitBusinessEnglishDetailsMutation.getKey = () => ['SubmitBusinessEnglishDetails'];

export const SubmitBusinessLogoDocument = `
    mutation SubmitBusinessLogo($input: SubmitBusinessLogoInput!) {
  submitBusinessLogo(input: $input) {
    data
  }
}
    `;

export const useSubmitBusinessLogoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitBusinessLogoMutation, TError, SubmitBusinessLogoMutationVariables, TContext>) => {
    
    return useMutation<SubmitBusinessLogoMutation, TError, SubmitBusinessLogoMutationVariables, TContext>(
      {
    mutationKey: ['SubmitBusinessLogo'],
    mutationFn: (variables?: SubmitBusinessLogoMutationVariables) => amplifyFetcher<SubmitBusinessLogoMutation, SubmitBusinessLogoMutationVariables>(SubmitBusinessLogoDocument, variables)(),
    ...options
  }
    )};

useSubmitBusinessLogoMutation.getKey = () => ['SubmitBusinessLogo'];

export const SubmitBusinessSetupDocument = `
    mutation SubmitBusinessSetup($input: SubmitBusinessSetupInput!) {
  submitBusinessSetup(input: $input) {
    id
    onboardingStatus
  }
}
    `;

export const useSubmitBusinessSetupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitBusinessSetupMutation, TError, SubmitBusinessSetupMutationVariables, TContext>) => {
    
    return useMutation<SubmitBusinessSetupMutation, TError, SubmitBusinessSetupMutationVariables, TContext>(
      {
    mutationKey: ['SubmitBusinessSetup'],
    mutationFn: (variables?: SubmitBusinessSetupMutationVariables) => amplifyFetcher<SubmitBusinessSetupMutation, SubmitBusinessSetupMutationVariables>(SubmitBusinessSetupDocument, variables)(),
    ...options
  }
    )};

useSubmitBusinessSetupMutation.getKey = () => ['SubmitBusinessSetup'];

export const SubmitCompanySubscriptionPlanDocument = `
    mutation SubmitCompanySubscriptionPlan($input: SubmitCompanySubscriptionPlanInput!) {
  submitCompanySubscriptionPlan(input: $input)
}
    `;

export const useSubmitCompanySubscriptionPlanMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitCompanySubscriptionPlanMutation, TError, SubmitCompanySubscriptionPlanMutationVariables, TContext>) => {
    
    return useMutation<SubmitCompanySubscriptionPlanMutation, TError, SubmitCompanySubscriptionPlanMutationVariables, TContext>(
      {
    mutationKey: ['SubmitCompanySubscriptionPlan'],
    mutationFn: (variables?: SubmitCompanySubscriptionPlanMutationVariables) => amplifyFetcher<SubmitCompanySubscriptionPlanMutation, SubmitCompanySubscriptionPlanMutationVariables>(SubmitCompanySubscriptionPlanDocument, variables)(),
    ...options
  }
    )};

useSubmitCompanySubscriptionPlanMutation.getKey = () => ['SubmitCompanySubscriptionPlan'];

export const SubmitFriendReferralDocument = `
    mutation SubmitFriendReferral($input: SubmitFriendReferralInput!) {
  submitFriendReferral(input: $input) {
    mobile
    planType
    planTypeFree
  }
}
    `;

export const useSubmitFriendReferralMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitFriendReferralMutation, TError, SubmitFriendReferralMutationVariables, TContext>) => {
    
    return useMutation<SubmitFriendReferralMutation, TError, SubmitFriendReferralMutationVariables, TContext>(
      {
    mutationKey: ['SubmitFriendReferral'],
    mutationFn: (variables?: SubmitFriendReferralMutationVariables) => amplifyFetcher<SubmitFriendReferralMutation, SubmitFriendReferralMutationVariables>(SubmitFriendReferralDocument, variables)(),
    ...options
  }
    )};

useSubmitFriendReferralMutation.getKey = () => ['SubmitFriendReferral'];

export const SubmitGiftDetailsDocument = `
    mutation SubmitGiftDetails($input: SubmitGiftDetailsInput!) {
  submitGiftDetails(input: $input) {
    id
    onboardingStatus
  }
}
    `;

export const useSubmitGiftDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitGiftDetailsMutation, TError, SubmitGiftDetailsMutationVariables, TContext>) => {
    
    return useMutation<SubmitGiftDetailsMutation, TError, SubmitGiftDetailsMutationVariables, TContext>(
      {
    mutationKey: ['SubmitGiftDetails'],
    mutationFn: (variables?: SubmitGiftDetailsMutationVariables) => amplifyFetcher<SubmitGiftDetailsMutation, SubmitGiftDetailsMutationVariables>(SubmitGiftDetailsDocument, variables)(),
    ...options
  }
    )};

useSubmitGiftDetailsMutation.getKey = () => ['SubmitGiftDetails'];

export const SubmitIncomeDocumentCommentsDocument = `
    mutation SubmitIncomeDocumentComments($input: SubmitIncomeDocumentCommentsInput!) {
  submitIncomeDocumentComments(input: $input) {
    data
  }
}
    `;

export const useSubmitIncomeDocumentCommentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitIncomeDocumentCommentsMutation, TError, SubmitIncomeDocumentCommentsMutationVariables, TContext>) => {
    
    return useMutation<SubmitIncomeDocumentCommentsMutation, TError, SubmitIncomeDocumentCommentsMutationVariables, TContext>(
      {
    mutationKey: ['SubmitIncomeDocumentComments'],
    mutationFn: (variables?: SubmitIncomeDocumentCommentsMutationVariables) => amplifyFetcher<SubmitIncomeDocumentCommentsMutation, SubmitIncomeDocumentCommentsMutationVariables>(SubmitIncomeDocumentCommentsDocument, variables)(),
    ...options
  }
    )};

useSubmitIncomeDocumentCommentsMutation.getKey = () => ['SubmitIncomeDocumentComments'];

export const SubmitNewBusinessDetailsDocument = `
    mutation submitNewBusinessDetails($input: SubmitNewBusinessDetailsInput!) {
  submitNewBusinessDetails(input: $input) {
    onboardingStatus
  }
}
    `;

export const useSubmitNewBusinessDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitNewBusinessDetailsMutation, TError, SubmitNewBusinessDetailsMutationVariables, TContext>) => {
    
    return useMutation<SubmitNewBusinessDetailsMutation, TError, SubmitNewBusinessDetailsMutationVariables, TContext>(
      {
    mutationKey: ['submitNewBusinessDetails'],
    mutationFn: (variables?: SubmitNewBusinessDetailsMutationVariables) => amplifyFetcher<SubmitNewBusinessDetailsMutation, SubmitNewBusinessDetailsMutationVariables>(SubmitNewBusinessDetailsDocument, variables)(),
    ...options
  }
    )};

useSubmitNewBusinessDetailsMutation.getKey = () => ['submitNewBusinessDetails'];

export const SubmitReportForBusinessApprovalDocument = `
    mutation SubmitReportForBusinessApproval($input: SubmitReportForBusinessApprovalInput!) {
  submitReportForBusinessApproval(input: $input) {
    id
  }
}
    `;

export const useSubmitReportForBusinessApprovalMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitReportForBusinessApprovalMutation, TError, SubmitReportForBusinessApprovalMutationVariables, TContext>) => {
    
    return useMutation<SubmitReportForBusinessApprovalMutation, TError, SubmitReportForBusinessApprovalMutationVariables, TContext>(
      {
    mutationKey: ['SubmitReportForBusinessApproval'],
    mutationFn: (variables?: SubmitReportForBusinessApprovalMutationVariables) => amplifyFetcher<SubmitReportForBusinessApprovalMutation, SubmitReportForBusinessApprovalMutationVariables>(SubmitReportForBusinessApprovalDocument, variables)(),
    ...options
  }
    )};

useSubmitReportForBusinessApprovalMutation.getKey = () => ['SubmitReportForBusinessApproval'];

export const TaxAuthorityOpenApiDocument = `
    mutation TaxAuthorityOpenApi($input: TaxAuthorityOpenApiInput!) {
  taxAuthorityOpenApi(input: $input) {
    status {
      operationName
      success
      err
      warn
    }
    data
  }
}
    `;

export const useTaxAuthorityOpenApiMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TaxAuthorityOpenApiMutation, TError, TaxAuthorityOpenApiMutationVariables, TContext>) => {
    
    return useMutation<TaxAuthorityOpenApiMutation, TError, TaxAuthorityOpenApiMutationVariables, TContext>(
      {
    mutationKey: ['TaxAuthorityOpenApi'],
    mutationFn: (variables?: TaxAuthorityOpenApiMutationVariables) => amplifyFetcher<TaxAuthorityOpenApiMutation, TaxAuthorityOpenApiMutationVariables>(TaxAuthorityOpenApiDocument, variables)(),
    ...options
  }
    )};

useTaxAuthorityOpenApiMutation.getKey = () => ['TaxAuthorityOpenApi'];

export const UpdateBusinessAddressDocument = `
    mutation UpdateBusinessAddress($input: UpdateBusinessAddressInput!) {
  updateBusinessAddress(input: $input)
}
    `;

export const useUpdateBusinessAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBusinessAddressMutation, TError, UpdateBusinessAddressMutationVariables, TContext>) => {
    
    return useMutation<UpdateBusinessAddressMutation, TError, UpdateBusinessAddressMutationVariables, TContext>(
      {
    mutationKey: ['UpdateBusinessAddress'],
    mutationFn: (variables?: UpdateBusinessAddressMutationVariables) => amplifyFetcher<UpdateBusinessAddressMutation, UpdateBusinessAddressMutationVariables>(UpdateBusinessAddressDocument, variables)(),
    ...options
  }
    )};

useUpdateBusinessAddressMutation.getKey = () => ['UpdateBusinessAddress'];

export const UpdateBusinessAdvanceTaxRateForReportDocument = `
    mutation UpdateBusinessAdvanceTaxRateForReport($input: UpdateBusinessAdvanceTaxRateForReportInput!) {
  updateBusinessAdvanceTaxRateForReport(input: $input) {
    data
  }
}
    `;

export const useUpdateBusinessAdvanceTaxRateForReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBusinessAdvanceTaxRateForReportMutation, TError, UpdateBusinessAdvanceTaxRateForReportMutationVariables, TContext>) => {
    
    return useMutation<UpdateBusinessAdvanceTaxRateForReportMutation, TError, UpdateBusinessAdvanceTaxRateForReportMutationVariables, TContext>(
      {
    mutationKey: ['UpdateBusinessAdvanceTaxRateForReport'],
    mutationFn: (variables?: UpdateBusinessAdvanceTaxRateForReportMutationVariables) => amplifyFetcher<UpdateBusinessAdvanceTaxRateForReportMutation, UpdateBusinessAdvanceTaxRateForReportMutationVariables>(UpdateBusinessAdvanceTaxRateForReportDocument, variables)(),
    ...options
  }
    )};

useUpdateBusinessAdvanceTaxRateForReportMutation.getKey = () => ['UpdateBusinessAdvanceTaxRateForReport'];

export const UpdateBusinessAdvancesDocument = `
    mutation UpdateBusinessAdvances($input: UpdateBusinessAdvancesInput!) {
  updateBusinessAdvances(input: $input)
}
    `;

export const useUpdateBusinessAdvancesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBusinessAdvancesMutation, TError, UpdateBusinessAdvancesMutationVariables, TContext>) => {
    
    return useMutation<UpdateBusinessAdvancesMutation, TError, UpdateBusinessAdvancesMutationVariables, TContext>(
      {
    mutationKey: ['UpdateBusinessAdvances'],
    mutationFn: (variables?: UpdateBusinessAdvancesMutationVariables) => amplifyFetcher<UpdateBusinessAdvancesMutation, UpdateBusinessAdvancesMutationVariables>(UpdateBusinessAdvancesDocument, variables)(),
    ...options
  }
    )};

useUpdateBusinessAdvancesMutation.getKey = () => ['UpdateBusinessAdvances'];

export const UpdateBusinessApprovalStatusDocument = `
    mutation UpdateBusinessApprovalStatus($input: UpdateBusinessApprovalStatusInput!) {
  updateBusinessApprovalStatus(input: $input) {
    data
  }
}
    `;

export const useUpdateBusinessApprovalStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBusinessApprovalStatusMutation, TError, UpdateBusinessApprovalStatusMutationVariables, TContext>) => {
    
    return useMutation<UpdateBusinessApprovalStatusMutation, TError, UpdateBusinessApprovalStatusMutationVariables, TContext>(
      {
    mutationKey: ['UpdateBusinessApprovalStatus'],
    mutationFn: (variables?: UpdateBusinessApprovalStatusMutationVariables) => amplifyFetcher<UpdateBusinessApprovalStatusMutation, UpdateBusinessApprovalStatusMutationVariables>(UpdateBusinessApprovalStatusDocument, variables)(),
    ...options
  }
    )};

useUpdateBusinessApprovalStatusMutation.getKey = () => ['UpdateBusinessApprovalStatus'];

export const UpdateBusinessBillingDocument = `
    mutation UpdateBusinessBilling($input: UpdateBusinessBillingDetailsInput!) {
  updateBusinessBilling(input: $input) {
    data
  }
}
    `;

export const useUpdateBusinessBillingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBusinessBillingMutation, TError, UpdateBusinessBillingMutationVariables, TContext>) => {
    
    return useMutation<UpdateBusinessBillingMutation, TError, UpdateBusinessBillingMutationVariables, TContext>(
      {
    mutationKey: ['UpdateBusinessBilling'],
    mutationFn: (variables?: UpdateBusinessBillingMutationVariables) => amplifyFetcher<UpdateBusinessBillingMutation, UpdateBusinessBillingMutationVariables>(UpdateBusinessBillingDocument, variables)(),
    ...options
  }
    )};

useUpdateBusinessBillingMutation.getKey = () => ['UpdateBusinessBilling'];

export const UpdateBusinessBituahLeumiPaymentDocument = `
    mutation UpdateBusinessBituahLeumiPayment($input: UpdateBusinessBituahLeumiPaymentInput!) {
  updateBusinessBituahLeumiPayment(input: $input)
}
    `;

export const useUpdateBusinessBituahLeumiPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBusinessBituahLeumiPaymentMutation, TError, UpdateBusinessBituahLeumiPaymentMutationVariables, TContext>) => {
    
    return useMutation<UpdateBusinessBituahLeumiPaymentMutation, TError, UpdateBusinessBituahLeumiPaymentMutationVariables, TContext>(
      {
    mutationKey: ['UpdateBusinessBituahLeumiPayment'],
    mutationFn: (variables?: UpdateBusinessBituahLeumiPaymentMutationVariables) => amplifyFetcher<UpdateBusinessBituahLeumiPaymentMutation, UpdateBusinessBituahLeumiPaymentMutationVariables>(UpdateBusinessBituahLeumiPaymentDocument, variables)(),
    ...options
  }
    )};

useUpdateBusinessBituahLeumiPaymentMutation.getKey = () => ['UpdateBusinessBituahLeumiPayment'];

export const UpdateBusinessBituahLeumiPaymentForReportDocument = `
    mutation UpdateBusinessBituahLeumiPaymentForReport($input: UpdateBusinessBituahLeumiPaymentForReportInput!) {
  updateBusinessBituahLeumiPaymentForReport(input: $input) {
    data
  }
}
    `;

export const useUpdateBusinessBituahLeumiPaymentForReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBusinessBituahLeumiPaymentForReportMutation, TError, UpdateBusinessBituahLeumiPaymentForReportMutationVariables, TContext>) => {
    
    return useMutation<UpdateBusinessBituahLeumiPaymentForReportMutation, TError, UpdateBusinessBituahLeumiPaymentForReportMutationVariables, TContext>(
      {
    mutationKey: ['UpdateBusinessBituahLeumiPaymentForReport'],
    mutationFn: (variables?: UpdateBusinessBituahLeumiPaymentForReportMutationVariables) => amplifyFetcher<UpdateBusinessBituahLeumiPaymentForReportMutation, UpdateBusinessBituahLeumiPaymentForReportMutationVariables>(UpdateBusinessBituahLeumiPaymentForReportDocument, variables)(),
    ...options
  }
    )};

useUpdateBusinessBituahLeumiPaymentForReportMutation.getKey = () => ['UpdateBusinessBituahLeumiPaymentForReport'];

export const UpdateBusinessCertificateDocument = `
    mutation UpdateBusinessCertificate($input: UpdateBusinessCertificateInput!) {
  updateBusinessCertificate(input: $input) {
    data
  }
}
    `;

export const useUpdateBusinessCertificateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBusinessCertificateMutation, TError, UpdateBusinessCertificateMutationVariables, TContext>) => {
    
    return useMutation<UpdateBusinessCertificateMutation, TError, UpdateBusinessCertificateMutationVariables, TContext>(
      {
    mutationKey: ['UpdateBusinessCertificate'],
    mutationFn: (variables?: UpdateBusinessCertificateMutationVariables) => amplifyFetcher<UpdateBusinessCertificateMutation, UpdateBusinessCertificateMutationVariables>(UpdateBusinessCertificateDocument, variables)(),
    ...options
  }
    )};

useUpdateBusinessCertificateMutation.getKey = () => ['UpdateBusinessCertificate'];

export const UpdateBusinessDetailsDocument = `
    mutation UpdateBusinessDetails($input: UpdateBusinessDetailsInput!) {
  updateBusinessDetails(input: $input)
}
    `;

export const useUpdateBusinessDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBusinessDetailsMutation, TError, UpdateBusinessDetailsMutationVariables, TContext>) => {
    
    return useMutation<UpdateBusinessDetailsMutation, TError, UpdateBusinessDetailsMutationVariables, TContext>(
      {
    mutationKey: ['UpdateBusinessDetails'],
    mutationFn: (variables?: UpdateBusinessDetailsMutationVariables) => amplifyFetcher<UpdateBusinessDetailsMutation, UpdateBusinessDetailsMutationVariables>(UpdateBusinessDetailsDocument, variables)(),
    ...options
  }
    )};

useUpdateBusinessDetailsMutation.getKey = () => ['UpdateBusinessDetails'];

export const UpdateCompletedInUserNoteDocument = `
    mutation UpdateCompletedInUserNote($input: UpdateCompletedInUserNoteInput!) {
  updateCompletedInUserNote(input: $input) {
    data
  }
}
    `;

export const useUpdateCompletedInUserNoteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCompletedInUserNoteMutation, TError, UpdateCompletedInUserNoteMutationVariables, TContext>) => {
    
    return useMutation<UpdateCompletedInUserNoteMutation, TError, UpdateCompletedInUserNoteMutationVariables, TContext>(
      {
    mutationKey: ['UpdateCompletedInUserNote'],
    mutationFn: (variables?: UpdateCompletedInUserNoteMutationVariables) => amplifyFetcher<UpdateCompletedInUserNoteMutation, UpdateCompletedInUserNoteMutationVariables>(UpdateCompletedInUserNoteDocument, variables)(),
    ...options
  }
    )};

useUpdateCompletedInUserNoteMutation.getKey = () => ['UpdateCompletedInUserNote'];

export const UpdatePaymentsForReportsDocument = `
    mutation UpdatePaymentsForReports($input: UpdatePaymentsForReportsInput!) {
  updatePaymentsForReports(input: $input) {
    data
  }
}
    `;

export const useUpdatePaymentsForReportsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdatePaymentsForReportsMutation, TError, UpdatePaymentsForReportsMutationVariables, TContext>) => {
    
    return useMutation<UpdatePaymentsForReportsMutation, TError, UpdatePaymentsForReportsMutationVariables, TContext>(
      {
    mutationKey: ['UpdatePaymentsForReports'],
    mutationFn: (variables?: UpdatePaymentsForReportsMutationVariables) => amplifyFetcher<UpdatePaymentsForReportsMutation, UpdatePaymentsForReportsMutationVariables>(UpdatePaymentsForReportsDocument, variables)(),
    ...options
  }
    )};

useUpdatePaymentsForReportsMutation.getKey = () => ['UpdatePaymentsForReports'];

export const UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsDocument = `
    mutation UploadUnsignedTaxAuthorityAndBituahLeumiDocuments($input: UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsInput!) {
  uploadUnsignedTaxAuthorityAndBituahLeumiDocuments(input: $input) {
    data
  }
}
    `;

export const useUploadUnsignedTaxAuthorityAndBituahLeumiDocumentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsMutation, TError, UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsMutationVariables, TContext>) => {
    
    return useMutation<UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsMutation, TError, UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsMutationVariables, TContext>(
      {
    mutationKey: ['UploadUnsignedTaxAuthorityAndBituahLeumiDocuments'],
    mutationFn: (variables?: UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsMutationVariables) => amplifyFetcher<UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsMutation, UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsMutationVariables>(UploadUnsignedTaxAuthorityAndBituahLeumiDocumentsDocument, variables)(),
    ...options
  }
    )};

useUploadUnsignedTaxAuthorityAndBituahLeumiDocumentsMutation.getKey = () => ['UploadUnsignedTaxAuthorityAndBituahLeumiDocuments'];

export const UploadUnsignedVatBusinessCreationDocumentDocument = `
    mutation UploadUnsignedVatBusinessCreationDocument($input: UploadUnsignedVatBusinessCreationDocumentInput!) {
  uploadUnsignedVatBusinessCreationDocument(input: $input) {
    data
  }
}
    `;

export const useUploadUnsignedVatBusinessCreationDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UploadUnsignedVatBusinessCreationDocumentMutation, TError, UploadUnsignedVatBusinessCreationDocumentMutationVariables, TContext>) => {
    
    return useMutation<UploadUnsignedVatBusinessCreationDocumentMutation, TError, UploadUnsignedVatBusinessCreationDocumentMutationVariables, TContext>(
      {
    mutationKey: ['UploadUnsignedVatBusinessCreationDocument'],
    mutationFn: (variables?: UploadUnsignedVatBusinessCreationDocumentMutationVariables) => amplifyFetcher<UploadUnsignedVatBusinessCreationDocumentMutation, UploadUnsignedVatBusinessCreationDocumentMutationVariables>(UploadUnsignedVatBusinessCreationDocumentDocument, variables)(),
    ...options
  }
    )};

useUploadUnsignedVatBusinessCreationDocumentMutation.getKey = () => ['UploadUnsignedVatBusinessCreationDocument'];

export const BusinessBillingsChartDataDocument = `
    query BusinessBillingsChartData($input: BusinessBillingsChartDataInput!) {
  businessBillingsChartData(input: $input) {
    totalIncomes
    totalPaid
    totalFaild
    countFaild
    date
  }
}
    `;

export const useBusinessBillingsChartDataQuery = <
      TData = BusinessBillingsChartDataQuery,
      TError = unknown
    >(
      variables: BusinessBillingsChartDataQueryVariables,
      options?: Omit<UseQueryOptions<BusinessBillingsChartDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BusinessBillingsChartDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BusinessBillingsChartDataQuery, TError, TData>(
      {
    queryKey: ['BusinessBillingsChartData', variables],
    queryFn: amplifyFetcher<BusinessBillingsChartDataQuery, BusinessBillingsChartDataQueryVariables>(BusinessBillingsChartDataDocument, variables),
    ...options
  }
    )};

useBusinessBillingsChartDataQuery.document = BusinessBillingsChartDataDocument;

useBusinessBillingsChartDataQuery.getKey = (variables: BusinessBillingsChartDataQueryVariables) => ['BusinessBillingsChartData', variables];

export const useInfiniteBusinessBillingsChartDataQuery = <
      TData = InfiniteData<BusinessBillingsChartDataQuery>,
      TError = unknown
    >(
      variables: BusinessBillingsChartDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BusinessBillingsChartDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BusinessBillingsChartDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<BusinessBillingsChartDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BusinessBillingsChartData.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<BusinessBillingsChartDataQuery, BusinessBillingsChartDataQueryVariables>(BusinessBillingsChartDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteBusinessBillingsChartDataQuery.getKey = (variables: BusinessBillingsChartDataQueryVariables) => ['BusinessBillingsChartData.infinite', variables];

export const BusinessBillingsDataByDateDocument = `
    query BusinessBillingsDataByDate($input: BusinessBillingsDataByDateInput!) {
  businessBillingsDataByDate(input: $input) {
    totalIncomes
    totalPaid
    totalRefunded
    totalFaild
    countFaild
  }
}
    `;

export const useBusinessBillingsDataByDateQuery = <
      TData = BusinessBillingsDataByDateQuery,
      TError = unknown
    >(
      variables: BusinessBillingsDataByDateQueryVariables,
      options?: Omit<UseQueryOptions<BusinessBillingsDataByDateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BusinessBillingsDataByDateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BusinessBillingsDataByDateQuery, TError, TData>(
      {
    queryKey: ['BusinessBillingsDataByDate', variables],
    queryFn: amplifyFetcher<BusinessBillingsDataByDateQuery, BusinessBillingsDataByDateQueryVariables>(BusinessBillingsDataByDateDocument, variables),
    ...options
  }
    )};

useBusinessBillingsDataByDateQuery.document = BusinessBillingsDataByDateDocument;

useBusinessBillingsDataByDateQuery.getKey = (variables: BusinessBillingsDataByDateQueryVariables) => ['BusinessBillingsDataByDate', variables];

export const useInfiniteBusinessBillingsDataByDateQuery = <
      TData = InfiniteData<BusinessBillingsDataByDateQuery>,
      TError = unknown
    >(
      variables: BusinessBillingsDataByDateQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BusinessBillingsDataByDateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BusinessBillingsDataByDateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<BusinessBillingsDataByDateQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BusinessBillingsDataByDate.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<BusinessBillingsDataByDateQuery, BusinessBillingsDataByDateQueryVariables>(BusinessBillingsDataByDateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteBusinessBillingsDataByDateQuery.getKey = (variables: BusinessBillingsDataByDateQueryVariables) => ['BusinessBillingsDataByDate.infinite', variables];

export const BusinessBillingsTableByDateDocument = `
    query BusinessBillingsTableByDate($input: BusinessBillingsTableByDateInput!) {
  businessBillingsTableByDate(input: $input) {
    items {
      totalOwed
      business {
        businessId
        mobile
        businessName
        firstName
        lastName
      }
    }
  }
}
    `;

export const useBusinessBillingsTableByDateQuery = <
      TData = BusinessBillingsTableByDateQuery,
      TError = unknown
    >(
      variables: BusinessBillingsTableByDateQueryVariables,
      options?: Omit<UseQueryOptions<BusinessBillingsTableByDateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<BusinessBillingsTableByDateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<BusinessBillingsTableByDateQuery, TError, TData>(
      {
    queryKey: ['BusinessBillingsTableByDate', variables],
    queryFn: amplifyFetcher<BusinessBillingsTableByDateQuery, BusinessBillingsTableByDateQueryVariables>(BusinessBillingsTableByDateDocument, variables),
    ...options
  }
    )};

useBusinessBillingsTableByDateQuery.document = BusinessBillingsTableByDateDocument;

useBusinessBillingsTableByDateQuery.getKey = (variables: BusinessBillingsTableByDateQueryVariables) => ['BusinessBillingsTableByDate', variables];

export const useInfiniteBusinessBillingsTableByDateQuery = <
      TData = InfiniteData<BusinessBillingsTableByDateQuery>,
      TError = unknown
    >(
      variables: BusinessBillingsTableByDateQueryVariables,
      options: Omit<UseInfiniteQueryOptions<BusinessBillingsTableByDateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<BusinessBillingsTableByDateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<BusinessBillingsTableByDateQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['BusinessBillingsTableByDate.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<BusinessBillingsTableByDateQuery, BusinessBillingsTableByDateQueryVariables>(BusinessBillingsTableByDateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteBusinessBillingsTableByDateQuery.getKey = (variables: BusinessBillingsTableByDateQueryVariables) => ['BusinessBillingsTableByDate.infinite', variables];

export const BusinessPaymentRefundDocument = `
    mutation BusinessPaymentRefund($input: BusinessPaymentRefundInput!) {
  businessPaymentRefund(input: $input) {
    data
  }
}
    `;

export const useBusinessPaymentRefundMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BusinessPaymentRefundMutation, TError, BusinessPaymentRefundMutationVariables, TContext>) => {
    
    return useMutation<BusinessPaymentRefundMutation, TError, BusinessPaymentRefundMutationVariables, TContext>(
      {
    mutationKey: ['BusinessPaymentRefund'],
    mutationFn: (variables?: BusinessPaymentRefundMutationVariables) => amplifyFetcher<BusinessPaymentRefundMutation, BusinessPaymentRefundMutationVariables>(BusinessPaymentRefundDocument, variables)(),
    ...options
  }
    )};

useBusinessPaymentRefundMutation.getKey = () => ['BusinessPaymentRefund'];

export const GetAccountantSignatureDocument = `
    query GetAccountantSignature($input: GetAccountantSignatureInput!) {
  getAccountantSignature(input: $input) {
    url
  }
}
    `;

export const useGetAccountantSignatureQuery = <
      TData = GetAccountantSignatureQuery,
      TError = unknown
    >(
      variables: GetAccountantSignatureQueryVariables,
      options?: Omit<UseQueryOptions<GetAccountantSignatureQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAccountantSignatureQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAccountantSignatureQuery, TError, TData>(
      {
    queryKey: ['GetAccountantSignature', variables],
    queryFn: amplifyFetcher<GetAccountantSignatureQuery, GetAccountantSignatureQueryVariables>(GetAccountantSignatureDocument, variables),
    ...options
  }
    )};

useGetAccountantSignatureQuery.document = GetAccountantSignatureDocument;

useGetAccountantSignatureQuery.getKey = (variables: GetAccountantSignatureQueryVariables) => ['GetAccountantSignature', variables];

export const useInfiniteGetAccountantSignatureQuery = <
      TData = InfiniteData<GetAccountantSignatureQuery>,
      TError = unknown
    >(
      variables: GetAccountantSignatureQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAccountantSignatureQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAccountantSignatureQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAccountantSignatureQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAccountantSignature.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetAccountantSignatureQuery, GetAccountantSignatureQueryVariables>(GetAccountantSignatureDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAccountantSignatureQuery.getKey = (variables: GetAccountantSignatureQueryVariables) => ['GetAccountantSignature.infinite', variables];

export const GetAccountantSignatureUploadUrlDocument = `
    query GetAccountantSignatureUploadUrl($input: GetAccountantSignatureUploadUrlInput!) {
  getAccountantSignatureUploadUrl(input: $input) {
    url
  }
}
    `;

export const useGetAccountantSignatureUploadUrlQuery = <
      TData = GetAccountantSignatureUploadUrlQuery,
      TError = unknown
    >(
      variables: GetAccountantSignatureUploadUrlQueryVariables,
      options?: Omit<UseQueryOptions<GetAccountantSignatureUploadUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAccountantSignatureUploadUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAccountantSignatureUploadUrlQuery, TError, TData>(
      {
    queryKey: ['GetAccountantSignatureUploadUrl', variables],
    queryFn: amplifyFetcher<GetAccountantSignatureUploadUrlQuery, GetAccountantSignatureUploadUrlQueryVariables>(GetAccountantSignatureUploadUrlDocument, variables),
    ...options
  }
    )};

useGetAccountantSignatureUploadUrlQuery.document = GetAccountantSignatureUploadUrlDocument;

useGetAccountantSignatureUploadUrlQuery.getKey = (variables: GetAccountantSignatureUploadUrlQueryVariables) => ['GetAccountantSignatureUploadUrl', variables];

export const useInfiniteGetAccountantSignatureUploadUrlQuery = <
      TData = InfiniteData<GetAccountantSignatureUploadUrlQuery>,
      TError = unknown
    >(
      variables: GetAccountantSignatureUploadUrlQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAccountantSignatureUploadUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAccountantSignatureUploadUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetAccountantSignatureUploadUrlQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetAccountantSignatureUploadUrl.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetAccountantSignatureUploadUrlQuery, GetAccountantSignatureUploadUrlQueryVariables>(GetAccountantSignatureUploadUrlDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAccountantSignatureUploadUrlQuery.getKey = (variables: GetAccountantSignatureUploadUrlQueryVariables) => ['GetAccountantSignatureUploadUrl.infinite', variables];

export const GetBusinessBasicDocument = `
    query GetBusinessBasic($input: GetBusinessInput!) {
  getBusiness(input: $input) {
    id
    businessName
  }
}
    `;

export const useGetBusinessBasicQuery = <
      TData = GetBusinessBasicQuery,
      TError = unknown
    >(
      variables: GetBusinessBasicQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessBasicQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessBasicQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessBasicQuery, TError, TData>(
      {
    queryKey: ['GetBusinessBasic', variables],
    queryFn: amplifyFetcher<GetBusinessBasicQuery, GetBusinessBasicQueryVariables>(GetBusinessBasicDocument, variables),
    ...options
  }
    )};

useGetBusinessBasicQuery.document = GetBusinessBasicDocument;

useGetBusinessBasicQuery.getKey = (variables: GetBusinessBasicQueryVariables) => ['GetBusinessBasic', variables];

export const useInfiniteGetBusinessBasicQuery = <
      TData = InfiniteData<GetBusinessBasicQuery>,
      TError = unknown
    >(
      variables: GetBusinessBasicQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessBasicQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessBasicQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessBasicQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessBasic.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessBasicQuery, GetBusinessBasicQueryVariables>(GetBusinessBasicDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessBasicQuery.getKey = (variables: GetBusinessBasicQueryVariables) => ['GetBusinessBasic.infinite', variables];

export const GetBusinessBasicInfoDocument = `
    query GetBusinessBasicInfo($input: GetBusinessInput!) {
  getBusiness(input: $input) {
    id
    userId
    businessType
    businessStatus
    city
    streetAddress
    user {
      mobile
      idNumber
      email
      firstName
      lastName
    }
  }
}
    `;

export const useGetBusinessBasicInfoQuery = <
      TData = GetBusinessBasicInfoQuery,
      TError = unknown
    >(
      variables: GetBusinessBasicInfoQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessBasicInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessBasicInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessBasicInfoQuery, TError, TData>(
      {
    queryKey: ['GetBusinessBasicInfo', variables],
    queryFn: amplifyFetcher<GetBusinessBasicInfoQuery, GetBusinessBasicInfoQueryVariables>(GetBusinessBasicInfoDocument, variables),
    ...options
  }
    )};

useGetBusinessBasicInfoQuery.document = GetBusinessBasicInfoDocument;

useGetBusinessBasicInfoQuery.getKey = (variables: GetBusinessBasicInfoQueryVariables) => ['GetBusinessBasicInfo', variables];

export const useInfiniteGetBusinessBasicInfoQuery = <
      TData = InfiniteData<GetBusinessBasicInfoQuery>,
      TError = unknown
    >(
      variables: GetBusinessBasicInfoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessBasicInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessBasicInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessBasicInfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessBasicInfo.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessBasicInfoQuery, GetBusinessBasicInfoQueryVariables>(GetBusinessBasicInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessBasicInfoQuery.getKey = (variables: GetBusinessBasicInfoQueryVariables) => ['GetBusinessBasicInfo.infinite', variables];

export const GetBusinessBillingDetailsDocument = `
    query GetBusinessBillingDetails($input: GetBusinessInput!) {
  getBusiness(input: $input) {
    businessType
    paymentIdNumber
    user {
      mobile
      email
      firstName
      lastName
    }
  }
}
    `;

export const useGetBusinessBillingDetailsQuery = <
      TData = GetBusinessBillingDetailsQuery,
      TError = unknown
    >(
      variables: GetBusinessBillingDetailsQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessBillingDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessBillingDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessBillingDetailsQuery, TError, TData>(
      {
    queryKey: ['GetBusinessBillingDetails', variables],
    queryFn: amplifyFetcher<GetBusinessBillingDetailsQuery, GetBusinessBillingDetailsQueryVariables>(GetBusinessBillingDetailsDocument, variables),
    ...options
  }
    )};

useGetBusinessBillingDetailsQuery.document = GetBusinessBillingDetailsDocument;

useGetBusinessBillingDetailsQuery.getKey = (variables: GetBusinessBillingDetailsQueryVariables) => ['GetBusinessBillingDetails', variables];

export const useInfiniteGetBusinessBillingDetailsQuery = <
      TData = InfiniteData<GetBusinessBillingDetailsQuery>,
      TError = unknown
    >(
      variables: GetBusinessBillingDetailsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessBillingDetailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessBillingDetailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessBillingDetailsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessBillingDetails.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessBillingDetailsQuery, GetBusinessBillingDetailsQueryVariables>(GetBusinessBillingDetailsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessBillingDetailsQuery.getKey = (variables: GetBusinessBillingDetailsQueryVariables) => ['GetBusinessBillingDetails.infinite', variables];

export const GetCountBusinessFailedBillingsDocument = `
    query GetCountBusinessFailedBillings($input: GetCountBusinessFailedBillingsInput!) {
  getCountBusinessFailedBillings(input: $input) {
    total
  }
}
    `;

export const useGetCountBusinessFailedBillingsQuery = <
      TData = GetCountBusinessFailedBillingsQuery,
      TError = unknown
    >(
      variables: GetCountBusinessFailedBillingsQueryVariables,
      options?: Omit<UseQueryOptions<GetCountBusinessFailedBillingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCountBusinessFailedBillingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCountBusinessFailedBillingsQuery, TError, TData>(
      {
    queryKey: ['GetCountBusinessFailedBillings', variables],
    queryFn: amplifyFetcher<GetCountBusinessFailedBillingsQuery, GetCountBusinessFailedBillingsQueryVariables>(GetCountBusinessFailedBillingsDocument, variables),
    ...options
  }
    )};

useGetCountBusinessFailedBillingsQuery.document = GetCountBusinessFailedBillingsDocument;

useGetCountBusinessFailedBillingsQuery.getKey = (variables: GetCountBusinessFailedBillingsQueryVariables) => ['GetCountBusinessFailedBillings', variables];

export const useInfiniteGetCountBusinessFailedBillingsQuery = <
      TData = InfiniteData<GetCountBusinessFailedBillingsQuery>,
      TError = unknown
    >(
      variables: GetCountBusinessFailedBillingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCountBusinessFailedBillingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCountBusinessFailedBillingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetCountBusinessFailedBillingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetCountBusinessFailedBillings.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetCountBusinessFailedBillingsQuery, GetCountBusinessFailedBillingsQueryVariables>(GetCountBusinessFailedBillingsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCountBusinessFailedBillingsQuery.getKey = (variables: GetCountBusinessFailedBillingsQueryVariables) => ['GetCountBusinessFailedBillings.infinite', variables];

export const GetBusinessDocumentSettingsDocument = `
    query GetBusinessDocumentSettings($input: GetBusinessInput!) {
  getBusiness(input: $input) {
    incomeDocumentComments
    bankDetails
    businessNameEn
    logo
  }
}
    `;

export const useGetBusinessDocumentSettingsQuery = <
      TData = GetBusinessDocumentSettingsQuery,
      TError = unknown
    >(
      variables: GetBusinessDocumentSettingsQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessDocumentSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessDocumentSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessDocumentSettingsQuery, TError, TData>(
      {
    queryKey: ['GetBusinessDocumentSettings', variables],
    queryFn: amplifyFetcher<GetBusinessDocumentSettingsQuery, GetBusinessDocumentSettingsQueryVariables>(GetBusinessDocumentSettingsDocument, variables),
    ...options
  }
    )};

useGetBusinessDocumentSettingsQuery.document = GetBusinessDocumentSettingsDocument;

useGetBusinessDocumentSettingsQuery.getKey = (variables: GetBusinessDocumentSettingsQueryVariables) => ['GetBusinessDocumentSettings', variables];

export const useInfiniteGetBusinessDocumentSettingsQuery = <
      TData = InfiniteData<GetBusinessDocumentSettingsQuery>,
      TError = unknown
    >(
      variables: GetBusinessDocumentSettingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessDocumentSettingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessDocumentSettingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessDocumentSettingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessDocumentSettings.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessDocumentSettingsQuery, GetBusinessDocumentSettingsQueryVariables>(GetBusinessDocumentSettingsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessDocumentSettingsQuery.getKey = (variables: GetBusinessDocumentSettingsQueryVariables) => ['GetBusinessDocumentSettings.infinite', variables];

export const GetBusinessFileDocument = `
    query GetBusinessFile($input: GetBusinessFileInput!) {
  getBusinessFile(input: $input) {
    url
  }
}
    `;

export const useGetBusinessFileQuery = <
      TData = GetBusinessFileQuery,
      TError = unknown
    >(
      variables: GetBusinessFileQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessFileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessFileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessFileQuery, TError, TData>(
      {
    queryKey: ['GetBusinessFile', variables],
    queryFn: amplifyFetcher<GetBusinessFileQuery, GetBusinessFileQueryVariables>(GetBusinessFileDocument, variables),
    ...options
  }
    )};

useGetBusinessFileQuery.document = GetBusinessFileDocument;

useGetBusinessFileQuery.getKey = (variables: GetBusinessFileQueryVariables) => ['GetBusinessFile', variables];

export const useInfiniteGetBusinessFileQuery = <
      TData = InfiniteData<GetBusinessFileQuery>,
      TError = unknown
    >(
      variables: GetBusinessFileQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessFileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessFileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessFileQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessFile.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessFileQuery, GetBusinessFileQueryVariables>(GetBusinessFileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessFileQuery.getKey = (variables: GetBusinessFileQueryVariables) => ['GetBusinessFile.infinite', variables];

export const GetFileDocument = `
    query GetFile($input: GetBusinessFileInput!) {
  getBusinessFile(input: $input) {
    url
  }
}
    `;

export const useGetFileQuery = <
      TData = GetFileQuery,
      TError = unknown
    >(
      variables: GetFileQueryVariables,
      options?: Omit<UseQueryOptions<GetFileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileQuery, TError, TData>(
      {
    queryKey: ['GetFile', variables],
    queryFn: amplifyFetcher<GetFileQuery, GetFileQueryVariables>(GetFileDocument, variables),
    ...options
  }
    )};

useGetFileQuery.document = GetFileDocument;

useGetFileQuery.getKey = (variables: GetFileQueryVariables) => ['GetFile', variables];

export const useInfiniteGetFileQuery = <
      TData = InfiniteData<GetFileQuery>,
      TError = unknown
    >(
      variables: GetFileQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetFileQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetFile.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetFileQuery, GetFileQueryVariables>(GetFileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileQuery.getKey = (variables: GetFileQueryVariables) => ['GetFile.infinite', variables];

export const GetBusinessFileUploadUrlDocument = `
    query GetBusinessFileUploadUrl($input: GetBusinessFileUploadUrlInput!) {
  getBusinessFileUploadUrl(input: $input) {
    url
  }
}
    `;

export const useGetBusinessFileUploadUrlQuery = <
      TData = GetBusinessFileUploadUrlQuery,
      TError = unknown
    >(
      variables: GetBusinessFileUploadUrlQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessFileUploadUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessFileUploadUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessFileUploadUrlQuery, TError, TData>(
      {
    queryKey: ['GetBusinessFileUploadUrl', variables],
    queryFn: amplifyFetcher<GetBusinessFileUploadUrlQuery, GetBusinessFileUploadUrlQueryVariables>(GetBusinessFileUploadUrlDocument, variables),
    ...options
  }
    )};

useGetBusinessFileUploadUrlQuery.document = GetBusinessFileUploadUrlDocument;

useGetBusinessFileUploadUrlQuery.getKey = (variables: GetBusinessFileUploadUrlQueryVariables) => ['GetBusinessFileUploadUrl', variables];

export const useInfiniteGetBusinessFileUploadUrlQuery = <
      TData = InfiniteData<GetBusinessFileUploadUrlQuery>,
      TError = unknown
    >(
      variables: GetBusinessFileUploadUrlQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessFileUploadUrlQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessFileUploadUrlQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessFileUploadUrlQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessFileUploadUrl.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessFileUploadUrlQuery, GetBusinessFileUploadUrlQueryVariables>(GetBusinessFileUploadUrlDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessFileUploadUrlQuery.getKey = (variables: GetBusinessFileUploadUrlQueryVariables) => ['GetBusinessFileUploadUrl.infinite', variables];

export const GetBusinessDocument = `
    query GetBusiness($input: GetBusinessInput!) {
  getBusiness(input: $input) {
    id
    registrationNumber
    businessName
    businessStatus
    isNewBusiness
    approvalStatus
    approvedAt
    cancelledAt
    businessType
    advanceTaxRate
    creditCardMask
    exemption {
      createdAt
      updatedAt
      businessId
      servicesOrPropertiesAndMoreRate
      constructionAndTransportationWorksRate
      insuranceCommissionRate
      certainWageTypesRate
      interestAndCapitalMarketRate
      bookKeepingAuthorization
      certificateValidityStartDate
      certificateValidityEndDate
    }
    bituahLeumiPayment
    industry {
      id
      name
      irsCode
    }
    secondaryIndustry {
      id
      name
      irsCode
    }
    createdAt
    city
    streetAddress
    user {
      id
      firstName
      lastName
      birthDate
      mobile
      email
      identificationType
      identificationValue
    }
    partnerRegistrationNumber
    isEmployee
    canBeBlocked
    paymentIdNumber
    isImportDocuments
  }
}
    `;

export const useGetBusinessQuery = <
      TData = GetBusinessQuery,
      TError = unknown
    >(
      variables: GetBusinessQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessQuery, TError, TData>(
      {
    queryKey: ['GetBusiness', variables],
    queryFn: amplifyFetcher<GetBusinessQuery, GetBusinessQueryVariables>(GetBusinessDocument, variables),
    ...options
  }
    )};

useGetBusinessQuery.document = GetBusinessDocument;

useGetBusinessQuery.getKey = (variables: GetBusinessQueryVariables) => ['GetBusiness', variables];

export const useInfiniteGetBusinessQuery = <
      TData = InfiniteData<GetBusinessQuery>,
      TError = unknown
    >(
      variables: GetBusinessQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusiness.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessQuery, GetBusinessQueryVariables>(GetBusinessDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessQuery.getKey = (variables: GetBusinessQueryVariables) => ['GetBusiness.infinite', variables];

export const GetBusinessFullDocument = `
    query GetBusinessFull($input1: GetBusinessInput!, $input2: GetListYearsForBusinessInput!) {
  getBusiness(input: $input1) {
    id
    registrationNumber
    businessName
    businessStatus
    isNewBusiness
    approvalStatus
    approvedAt
    cancelledAt
    businessType
    advanceTaxRate
    creditCardMask
    exemption {
      createdAt
      updatedAt
      businessId
      servicesOrPropertiesAndMoreRate
      constructionAndTransportationWorksRate
      insuranceCommissionRate
      certainWageTypesRate
      interestAndCapitalMarketRate
      bookKeepingAuthorization
      certificateValidityStartDate
      certificateValidityEndDate
    }
    bituahLeumiPayment
    industry {
      id
      name
      irsCode
    }
    secondaryIndustry {
      id
      name
      irsCode
    }
    createdAt
    city
    streetAddress
    user {
      id
      firstName
      lastName
      birthDate
      mobile
      email
      identificationType
      identificationValue
    }
    partnerRegistrationNumber
    isEmployee
    canBeBlocked
    paymentIdNumber
    isImportDocuments
  }
  getListYearsForBusinessBo(input: $input2) {
    years
  }
}
    `;

export const useGetBusinessFullQuery = <
      TData = GetBusinessFullQuery,
      TError = unknown
    >(
      variables: GetBusinessFullQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessFullQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessFullQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessFullQuery, TError, TData>(
      {
    queryKey: ['GetBusinessFull', variables],
    queryFn: amplifyFetcher<GetBusinessFullQuery, GetBusinessFullQueryVariables>(GetBusinessFullDocument, variables),
    ...options
  }
    )};

useGetBusinessFullQuery.document = GetBusinessFullDocument;

useGetBusinessFullQuery.getKey = (variables: GetBusinessFullQueryVariables) => ['GetBusinessFull', variables];

export const useInfiniteGetBusinessFullQuery = <
      TData = InfiniteData<GetBusinessFullQuery>,
      TError = unknown
    >(
      variables: GetBusinessFullQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessFullQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessFullQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessFullQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessFull.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessFullQuery, GetBusinessFullQueryVariables>(GetBusinessFullDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessFullQuery.getKey = (variables: GetBusinessFullQueryVariables) => ['GetBusinessFull.infinite', variables];

export const GetBusinessNotificationDocument = `
    query GetBusinessNotification($input: GetBusinessNotificationInput!) {
  getBusinessNotification(input: $input) {
    businessId
    id
    type
    values {
      name
      value
    }
  }
}
    `;

export const useGetBusinessNotificationQuery = <
      TData = GetBusinessNotificationQuery,
      TError = unknown
    >(
      variables: GetBusinessNotificationQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessNotificationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessNotificationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessNotificationQuery, TError, TData>(
      {
    queryKey: ['GetBusinessNotification', variables],
    queryFn: amplifyFetcher<GetBusinessNotificationQuery, GetBusinessNotificationQueryVariables>(GetBusinessNotificationDocument, variables),
    ...options
  }
    )};

useGetBusinessNotificationQuery.document = GetBusinessNotificationDocument;

useGetBusinessNotificationQuery.getKey = (variables: GetBusinessNotificationQueryVariables) => ['GetBusinessNotification', variables];

export const useInfiniteGetBusinessNotificationQuery = <
      TData = InfiniteData<GetBusinessNotificationQuery>,
      TError = unknown
    >(
      variables: GetBusinessNotificationQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessNotificationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessNotificationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessNotificationQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessNotification.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessNotificationQuery, GetBusinessNotificationQueryVariables>(GetBusinessNotificationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessNotificationQuery.getKey = (variables: GetBusinessNotificationQueryVariables) => ['GetBusinessNotification.infinite', variables];

export const GetNotificationsDocument = `
    query GetNotifications($input1: GetBusinessInput!, $input2: GetNotificationsInput) {
  getBusiness(input: $input1) {
    notifications(input: $input2) {
      items {
        id
        content
        date
        values {
          name
          value
        }
        type
      }
      nextToken
    }
  }
}
    `;

export const useGetNotificationsQuery = <
      TData = GetNotificationsQuery,
      TError = unknown
    >(
      variables: GetNotificationsQueryVariables,
      options?: Omit<UseQueryOptions<GetNotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetNotificationsQuery, TError, TData>(
      {
    queryKey: ['GetNotifications', variables],
    queryFn: amplifyFetcher<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, variables),
    ...options
  }
    )};

useGetNotificationsQuery.document = GetNotificationsDocument;

useGetNotificationsQuery.getKey = (variables: GetNotificationsQueryVariables) => ['GetNotifications', variables];

export const useInfiniteGetNotificationsQuery = <
      TData = InfiniteData<GetNotificationsQuery>,
      TError = unknown
    >(
      variables: GetNotificationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetNotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetNotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetNotificationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetNotifications.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetNotificationsQuery.getKey = (variables: GetNotificationsQueryVariables) => ['GetNotifications.infinite', variables];

export const GetBusinessPendingApprovalDocument = `
    query GetBusinessPendingApproval($input: GetBusinessInput!) {
  getBusiness(input: $input) {
    id
    approvalStatus
    isNewBusiness
    representationRequestNumber
    missingDocuments
  }
}
    `;

export const useGetBusinessPendingApprovalQuery = <
      TData = GetBusinessPendingApprovalQuery,
      TError = unknown
    >(
      variables: GetBusinessPendingApprovalQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessPendingApprovalQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessPendingApprovalQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessPendingApprovalQuery, TError, TData>(
      {
    queryKey: ['GetBusinessPendingApproval', variables],
    queryFn: amplifyFetcher<GetBusinessPendingApprovalQuery, GetBusinessPendingApprovalQueryVariables>(GetBusinessPendingApprovalDocument, variables),
    ...options
  }
    )};

useGetBusinessPendingApprovalQuery.document = GetBusinessPendingApprovalDocument;

useGetBusinessPendingApprovalQuery.getKey = (variables: GetBusinessPendingApprovalQueryVariables) => ['GetBusinessPendingApproval', variables];

export const useInfiniteGetBusinessPendingApprovalQuery = <
      TData = InfiniteData<GetBusinessPendingApprovalQuery>,
      TError = unknown
    >(
      variables: GetBusinessPendingApprovalQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessPendingApprovalQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessPendingApprovalQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessPendingApprovalQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessPendingApproval.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessPendingApprovalQuery, GetBusinessPendingApprovalQueryVariables>(GetBusinessPendingApprovalDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessPendingApprovalQuery.getKey = (variables: GetBusinessPendingApprovalQueryVariables) => ['GetBusinessPendingApproval.infinite', variables];

export const GetBusinessPendingPaymentsDataDocument = `
    query GetBusinessPendingPaymentsData($input: GetBusinessPendingPaymentsDataInput!) {
  getBusinessPendingPaymentsData(input: $input) {
    numberOfPendingPayments
    businessStatus
  }
}
    `;

export const useGetBusinessPendingPaymentsDataQuery = <
      TData = GetBusinessPendingPaymentsDataQuery,
      TError = unknown
    >(
      variables: GetBusinessPendingPaymentsDataQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessPendingPaymentsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessPendingPaymentsDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessPendingPaymentsDataQuery, TError, TData>(
      {
    queryKey: ['GetBusinessPendingPaymentsData', variables],
    queryFn: amplifyFetcher<GetBusinessPendingPaymentsDataQuery, GetBusinessPendingPaymentsDataQueryVariables>(GetBusinessPendingPaymentsDataDocument, variables),
    ...options
  }
    )};

useGetBusinessPendingPaymentsDataQuery.document = GetBusinessPendingPaymentsDataDocument;

useGetBusinessPendingPaymentsDataQuery.getKey = (variables: GetBusinessPendingPaymentsDataQueryVariables) => ['GetBusinessPendingPaymentsData', variables];

export const useInfiniteGetBusinessPendingPaymentsDataQuery = <
      TData = InfiniteData<GetBusinessPendingPaymentsDataQuery>,
      TError = unknown
    >(
      variables: GetBusinessPendingPaymentsDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessPendingPaymentsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessPendingPaymentsDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessPendingPaymentsDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessPendingPaymentsData.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessPendingPaymentsDataQuery, GetBusinessPendingPaymentsDataQueryVariables>(GetBusinessPendingPaymentsDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessPendingPaymentsDataQuery.getKey = (variables: GetBusinessPendingPaymentsDataQueryVariables) => ['GetBusinessPendingPaymentsData.infinite', variables];

export const GetBusinessSetupDocument = `
    query GetBusinessSetup($input: GetBusinessSetupInput!) {
  getBusinessSetup(input: $input) {
    businessType
    hasAccountant
    hasBusiness
  }
}
    `;

export const useGetBusinessSetupQuery = <
      TData = GetBusinessSetupQuery,
      TError = unknown
    >(
      variables: GetBusinessSetupQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessSetupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessSetupQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessSetupQuery, TError, TData>(
      {
    queryKey: ['GetBusinessSetup', variables],
    queryFn: amplifyFetcher<GetBusinessSetupQuery, GetBusinessSetupQueryVariables>(GetBusinessSetupDocument, variables),
    ...options
  }
    )};

useGetBusinessSetupQuery.document = GetBusinessSetupDocument;

useGetBusinessSetupQuery.getKey = (variables: GetBusinessSetupQueryVariables) => ['GetBusinessSetup', variables];

export const useInfiniteGetBusinessSetupQuery = <
      TData = InfiniteData<GetBusinessSetupQuery>,
      TError = unknown
    >(
      variables: GetBusinessSetupQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessSetupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessSetupQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessSetupQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessSetup.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessSetupQuery, GetBusinessSetupQueryVariables>(GetBusinessSetupDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessSetupQuery.getKey = (variables: GetBusinessSetupQueryVariables) => ['GetBusinessSetup.infinite', variables];

export const GetStatisticsForBusinessDocument = `
    query GetStatisticsForBusiness($input: GetStatisticsForBusinessInput!) {
  getStatisticsForBusiness(input: $input) {
    totalBilled
  }
}
    `;

export const useGetStatisticsForBusinessQuery = <
      TData = GetStatisticsForBusinessQuery,
      TError = unknown
    >(
      variables: GetStatisticsForBusinessQueryVariables,
      options?: Omit<UseQueryOptions<GetStatisticsForBusinessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetStatisticsForBusinessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetStatisticsForBusinessQuery, TError, TData>(
      {
    queryKey: ['GetStatisticsForBusiness', variables],
    queryFn: amplifyFetcher<GetStatisticsForBusinessQuery, GetStatisticsForBusinessQueryVariables>(GetStatisticsForBusinessDocument, variables),
    ...options
  }
    )};

useGetStatisticsForBusinessQuery.document = GetStatisticsForBusinessDocument;

useGetStatisticsForBusinessQuery.getKey = (variables: GetStatisticsForBusinessQueryVariables) => ['GetStatisticsForBusiness', variables];

export const useInfiniteGetStatisticsForBusinessQuery = <
      TData = InfiniteData<GetStatisticsForBusinessQuery>,
      TError = unknown
    >(
      variables: GetStatisticsForBusinessQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetStatisticsForBusinessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetStatisticsForBusinessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetStatisticsForBusinessQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetStatisticsForBusiness.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetStatisticsForBusinessQuery, GetStatisticsForBusinessQueryVariables>(GetStatisticsForBusinessDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetStatisticsForBusinessQuery.getKey = (variables: GetStatisticsForBusinessQueryVariables) => ['GetStatisticsForBusiness.infinite', variables];

export const GetBusinessStatusCountersDocument = `
    query GetBusinessStatusCounters {
  getBusinessStatusCounters {
    REGISTRATION_UNCOMPLETE
    BILLING_DETAILS
    BEFORE_PENDING_APPROVAL
    PENDING_APPROVAL
    ACTIVE
    CANCELLED
    BLOCKED
    ALL
    ON_HOLD
  }
}
    `;

export const useGetBusinessStatusCountersQuery = <
      TData = GetBusinessStatusCountersQuery,
      TError = unknown
    >(
      variables?: GetBusinessStatusCountersQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessStatusCountersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessStatusCountersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessStatusCountersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetBusinessStatusCounters'] : ['GetBusinessStatusCounters', variables],
    queryFn: amplifyFetcher<GetBusinessStatusCountersQuery, GetBusinessStatusCountersQueryVariables>(GetBusinessStatusCountersDocument, variables),
    ...options
  }
    )};

useGetBusinessStatusCountersQuery.document = GetBusinessStatusCountersDocument;

useGetBusinessStatusCountersQuery.getKey = (variables?: GetBusinessStatusCountersQueryVariables) => variables === undefined ? ['GetBusinessStatusCounters'] : ['GetBusinessStatusCounters', variables];

export const useInfiniteGetBusinessStatusCountersQuery = <
      TData = InfiniteData<GetBusinessStatusCountersQuery>,
      TError = unknown
    >(
      variables: GetBusinessStatusCountersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessStatusCountersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessStatusCountersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessStatusCountersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetBusinessStatusCounters.infinite'] : ['GetBusinessStatusCounters.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessStatusCountersQuery, GetBusinessStatusCountersQueryVariables>(GetBusinessStatusCountersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessStatusCountersQuery.getKey = (variables?: GetBusinessStatusCountersQueryVariables) => variables === undefined ? ['GetBusinessStatusCounters.infinite'] : ['GetBusinessStatusCounters.infinite', variables];

export const GetBusinessTaoaLastAuthenticationTimeDocument = `
    query GetBusinessTaoaLastAuthenticationTime($input: GetBusinessInput!) {
  getBusiness(input: $input) {
    taoaLastAuthenticationTime
  }
}
    `;

export const useGetBusinessTaoaLastAuthenticationTimeQuery = <
      TData = GetBusinessTaoaLastAuthenticationTimeQuery,
      TError = unknown
    >(
      variables: GetBusinessTaoaLastAuthenticationTimeQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessTaoaLastAuthenticationTimeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessTaoaLastAuthenticationTimeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessTaoaLastAuthenticationTimeQuery, TError, TData>(
      {
    queryKey: ['GetBusinessTaoaLastAuthenticationTime', variables],
    queryFn: amplifyFetcher<GetBusinessTaoaLastAuthenticationTimeQuery, GetBusinessTaoaLastAuthenticationTimeQueryVariables>(GetBusinessTaoaLastAuthenticationTimeDocument, variables),
    ...options
  }
    )};

useGetBusinessTaoaLastAuthenticationTimeQuery.document = GetBusinessTaoaLastAuthenticationTimeDocument;

useGetBusinessTaoaLastAuthenticationTimeQuery.getKey = (variables: GetBusinessTaoaLastAuthenticationTimeQueryVariables) => ['GetBusinessTaoaLastAuthenticationTime', variables];

export const useInfiniteGetBusinessTaoaLastAuthenticationTimeQuery = <
      TData = InfiniteData<GetBusinessTaoaLastAuthenticationTimeQuery>,
      TError = unknown
    >(
      variables: GetBusinessTaoaLastAuthenticationTimeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessTaoaLastAuthenticationTimeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessTaoaLastAuthenticationTimeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessTaoaLastAuthenticationTimeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessTaoaLastAuthenticationTime.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessTaoaLastAuthenticationTimeQuery, GetBusinessTaoaLastAuthenticationTimeQueryVariables>(GetBusinessTaoaLastAuthenticationTimeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessTaoaLastAuthenticationTimeQuery.getKey = (variables: GetBusinessTaoaLastAuthenticationTimeQueryVariables) => ['GetBusinessTaoaLastAuthenticationTime.infinite', variables];

export const GetExpenseDocument = `
    query GetExpense($input: GetBusinessExpenseInput!) {
  getBusinessExpense(input: $input) {
    id
    expenseDate
    provider {
      name
    }
    expenseStatus
    disputeStatus
    currency
    currencyRate
    price
    vat
    expenseType
    expenseNumber
    vatType
    priceIncludingVat
    deductedVat
    deductedTax
    items {
      taxCategoryNumber
      price
      itemTax {
        deductedTax
      }
      itemVat {
        deductedVat
      }
      category {
        categoryName
      }
    }
  }
}
    `;

export const useGetExpenseQuery = <
      TData = GetExpenseQuery,
      TError = unknown
    >(
      variables: GetExpenseQueryVariables,
      options?: Omit<UseQueryOptions<GetExpenseQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetExpenseQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetExpenseQuery, TError, TData>(
      {
    queryKey: ['GetExpense', variables],
    queryFn: amplifyFetcher<GetExpenseQuery, GetExpenseQueryVariables>(GetExpenseDocument, variables),
    ...options
  }
    )};

useGetExpenseQuery.document = GetExpenseDocument;

useGetExpenseQuery.getKey = (variables: GetExpenseQueryVariables) => ['GetExpense', variables];

export const useInfiniteGetExpenseQuery = <
      TData = InfiniteData<GetExpenseQuery>,
      TError = unknown
    >(
      variables: GetExpenseQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetExpenseQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetExpenseQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetExpenseQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetExpense.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetExpenseQuery, GetExpenseQueryVariables>(GetExpenseDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetExpenseQuery.getKey = (variables: GetExpenseQueryVariables) => ['GetExpense.infinite', variables];

export const GetBusinessExpenseCompleteDocument = `
    query GetBusinessExpenseComplete($input: ListBusinessExpensesInput!) {
  listBusinessExpenses(input: $input) {
    items {
      id
      businessId
      business {
        id
        businessType
        registrationNumber
        businessName
        industry {
          name
        }
        user {
          firstName
          lastName
        }
        exemption {
          servicesOrPropertiesAndMoreRate
          constructionAndTransportationWorksRate
          insuranceCommissionRate
          certainWageTypesRate
          interestAndCapitalMarketRate
        }
      }
      createdAt
      updatedAt
      provider {
        name
        registrationNumber
        isIsraelProvider
      }
      expenseStatus
      disputeStatus
      expenseDate
      expenseNumber
      currency
      currencyRate
      price
      priceIncludingVat
      vat
      vatType
      deductedVat
      deductedTax
      expenseType
      geminaJson
      provider {
        id
        createdAt
        updatedAt
        name
        isIsraelProvider
        nickname
        registrationNumber
        source
      }
      items {
        expenseItemStatus
        taxCategoryNumber
        price
        priceIncludingVat
        vat
        itemTax {
          reportId
          deductedTax
          taxDeductionPercentage
          report {
            startDate
            endDate
            reportStatus
          }
        }
        itemVat {
          id
          reportId
          deductedVat
          vatDeductionPercentage
          vat
          report {
            startDate
            endDate
            reportStatus
            businessType
          }
        }
        category {
          categoryName
        }
        vatType
        expenseCategory
      }
      expenseTotalAmount
    }
  }
}
    `;

export const useGetBusinessExpenseCompleteQuery = <
      TData = GetBusinessExpenseCompleteQuery,
      TError = unknown
    >(
      variables: GetBusinessExpenseCompleteQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessExpenseCompleteQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessExpenseCompleteQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessExpenseCompleteQuery, TError, TData>(
      {
    queryKey: ['GetBusinessExpenseComplete', variables],
    queryFn: amplifyFetcher<GetBusinessExpenseCompleteQuery, GetBusinessExpenseCompleteQueryVariables>(GetBusinessExpenseCompleteDocument, variables),
    ...options
  }
    )};

useGetBusinessExpenseCompleteQuery.document = GetBusinessExpenseCompleteDocument;

useGetBusinessExpenseCompleteQuery.getKey = (variables: GetBusinessExpenseCompleteQueryVariables) => ['GetBusinessExpenseComplete', variables];

export const useInfiniteGetBusinessExpenseCompleteQuery = <
      TData = InfiniteData<GetBusinessExpenseCompleteQuery>,
      TError = unknown
    >(
      variables: GetBusinessExpenseCompleteQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessExpenseCompleteQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessExpenseCompleteQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessExpenseCompleteQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessExpenseComplete.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessExpenseCompleteQuery, GetBusinessExpenseCompleteQueryVariables>(GetBusinessExpenseCompleteDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessExpenseCompleteQuery.getKey = (variables: GetBusinessExpenseCompleteQueryVariables) => ['GetBusinessExpenseComplete.infinite', variables];

export const GetBusinessExpense_expenseIndexDocument = `
    query GetBusinessExpense_expenseIndex($input: ListBusinessExpensesInput!) {
  listBusinessExpenses(input: $input) {
    items {
      expenseIndex
    }
  }
}
    `;

export const useGetBusinessExpense_expenseIndexQuery = <
      TData = GetBusinessExpense_expenseIndexQuery,
      TError = unknown
    >(
      variables: GetBusinessExpense_expenseIndexQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessExpense_expenseIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessExpense_expenseIndexQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessExpense_expenseIndexQuery, TError, TData>(
      {
    queryKey: ['GetBusinessExpense_expenseIndex', variables],
    queryFn: amplifyFetcher<GetBusinessExpense_expenseIndexQuery, GetBusinessExpense_expenseIndexQueryVariables>(GetBusinessExpense_expenseIndexDocument, variables),
    ...options
  }
    )};

useGetBusinessExpense_expenseIndexQuery.document = GetBusinessExpense_expenseIndexDocument;

useGetBusinessExpense_expenseIndexQuery.getKey = (variables: GetBusinessExpense_expenseIndexQueryVariables) => ['GetBusinessExpense_expenseIndex', variables];

export const useInfiniteGetBusinessExpense_expenseIndexQuery = <
      TData = InfiniteData<GetBusinessExpense_expenseIndexQuery>,
      TError = unknown
    >(
      variables: GetBusinessExpense_expenseIndexQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessExpense_expenseIndexQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessExpense_expenseIndexQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessExpense_expenseIndexQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessExpense_expenseIndex.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessExpense_expenseIndexQuery, GetBusinessExpense_expenseIndexQueryVariables>(GetBusinessExpense_expenseIndexDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessExpense_expenseIndexQuery.getKey = (variables: GetBusinessExpense_expenseIndexQueryVariables) => ['GetBusinessExpense_expenseIndex.infinite', variables];

export const GetBusinessExpenseSummaryDocument = `
    query GetBusinessExpenseSummary($input: GetBusinessExpenseInput!) {
  getBusinessExpense(input: $input) {
    businessId
    priceIncludingVat
    expenseStatus
    business {
      businessName
    }
  }
}
    `;

export const useGetBusinessExpenseSummaryQuery = <
      TData = GetBusinessExpenseSummaryQuery,
      TError = unknown
    >(
      variables: GetBusinessExpenseSummaryQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessExpenseSummaryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessExpenseSummaryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessExpenseSummaryQuery, TError, TData>(
      {
    queryKey: ['GetBusinessExpenseSummary', variables],
    queryFn: amplifyFetcher<GetBusinessExpenseSummaryQuery, GetBusinessExpenseSummaryQueryVariables>(GetBusinessExpenseSummaryDocument, variables),
    ...options
  }
    )};

useGetBusinessExpenseSummaryQuery.document = GetBusinessExpenseSummaryDocument;

useGetBusinessExpenseSummaryQuery.getKey = (variables: GetBusinessExpenseSummaryQueryVariables) => ['GetBusinessExpenseSummary', variables];

export const useInfiniteGetBusinessExpenseSummaryQuery = <
      TData = InfiniteData<GetBusinessExpenseSummaryQuery>,
      TError = unknown
    >(
      variables: GetBusinessExpenseSummaryQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessExpenseSummaryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessExpenseSummaryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessExpenseSummaryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessExpenseSummary.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessExpenseSummaryQuery, GetBusinessExpenseSummaryQueryVariables>(GetBusinessExpenseSummaryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessExpenseSummaryQuery.getKey = (variables: GetBusinessExpenseSummaryQueryVariables) => ['GetBusinessExpenseSummary.infinite', variables];

export const GetBusinessIncomesCeilingForBusinessDocument = `
    query GetBusinessIncomesCeilingForBusiness($input: GetBusinessIncomesCeilingForBusinessInput!) {
  getBusinessIncomesCeilingForBusiness(input: $input) {
    totalIncomesUnused
    unUsedPercentage
    usedPercentage
    totalIncomes
    limit
  }
}
    `;

export const useGetBusinessIncomesCeilingForBusinessQuery = <
      TData = GetBusinessIncomesCeilingForBusinessQuery,
      TError = unknown
    >(
      variables: GetBusinessIncomesCeilingForBusinessQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessIncomesCeilingForBusinessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessIncomesCeilingForBusinessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessIncomesCeilingForBusinessQuery, TError, TData>(
      {
    queryKey: ['GetBusinessIncomesCeilingForBusiness', variables],
    queryFn: amplifyFetcher<GetBusinessIncomesCeilingForBusinessQuery, GetBusinessIncomesCeilingForBusinessQueryVariables>(GetBusinessIncomesCeilingForBusinessDocument, variables),
    ...options
  }
    )};

useGetBusinessIncomesCeilingForBusinessQuery.document = GetBusinessIncomesCeilingForBusinessDocument;

useGetBusinessIncomesCeilingForBusinessQuery.getKey = (variables: GetBusinessIncomesCeilingForBusinessQueryVariables) => ['GetBusinessIncomesCeilingForBusiness', variables];

export const useInfiniteGetBusinessIncomesCeilingForBusinessQuery = <
      TData = InfiniteData<GetBusinessIncomesCeilingForBusinessQuery>,
      TError = unknown
    >(
      variables: GetBusinessIncomesCeilingForBusinessQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessIncomesCeilingForBusinessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessIncomesCeilingForBusinessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessIncomesCeilingForBusinessQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessIncomesCeilingForBusiness.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessIncomesCeilingForBusinessQuery, GetBusinessIncomesCeilingForBusinessQueryVariables>(GetBusinessIncomesCeilingForBusinessDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessIncomesCeilingForBusinessQuery.getKey = (variables: GetBusinessIncomesCeilingForBusinessQueryVariables) => ['GetBusinessIncomesCeilingForBusiness.infinite', variables];

export const GetIncomeDocument = `
    query GetIncome($input: GetBusinessIncomeInput!) {
  getBusinessIncome(input: $input) {
    incomeProvider
    id
    incomeDate
    invoiceNumber
    description
    taoaConfirmationNumber
    customer {
      id
      customerName
      phone
      registrationNumber
      address
      email
    }
    incomeStatus
    incomeType
    price
    currency
    currencyRate
    vat
    priceIncludingVat
    english
    items {
      description
      unitPrice
      units
      priceIncludingVat
      price
      vat
      itemTax {
        id
        reportId
        incomeItemId
        report {
          startDate
          endDate
          reportStatus
        }
      }
      itemVat {
        id
        reportId
        incomeItemId
        report {
          startDate
          endDate
          reportStatus
          businessType
        }
      }
    }
    payments {
      paymentMethod
      date: paymentDate
      price
      taxDeduction
      bankName
      bankBranch
      bankAccount
      chequeNum
      creditCardType
      creditCardPaymentType
      creditCardNumberOfPayments
      creditCardLastDigits
      paymentApp
      paymentAppDealNumber
    }
    businessId
    business {
      businessType
    }
  }
}
    `;

export const useGetIncomeQuery = <
      TData = GetIncomeQuery,
      TError = unknown
    >(
      variables: GetIncomeQueryVariables,
      options?: Omit<UseQueryOptions<GetIncomeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetIncomeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetIncomeQuery, TError, TData>(
      {
    queryKey: ['GetIncome', variables],
    queryFn: amplifyFetcher<GetIncomeQuery, GetIncomeQueryVariables>(GetIncomeDocument, variables),
    ...options
  }
    )};

useGetIncomeQuery.document = GetIncomeDocument;

useGetIncomeQuery.getKey = (variables: GetIncomeQueryVariables) => ['GetIncome', variables];

export const useInfiniteGetIncomeQuery = <
      TData = InfiniteData<GetIncomeQuery>,
      TError = unknown
    >(
      variables: GetIncomeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetIncomeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetIncomeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetIncomeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetIncome.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetIncomeQuery, GetIncomeQueryVariables>(GetIncomeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetIncomeQuery.getKey = (variables: GetIncomeQueryVariables) => ['GetIncome.infinite', variables];

export const GetIncomeEmailsDocument = `
    query GetIncomeEmails($input: GetBusinessIncomeInput!) {
  getBusinessIncome(input: $input) {
    emails {
      recipient
      emailSentAt
      emailStatus
    }
  }
}
    `;

export const useGetIncomeEmailsQuery = <
      TData = GetIncomeEmailsQuery,
      TError = unknown
    >(
      variables: GetIncomeEmailsQueryVariables,
      options?: Omit<UseQueryOptions<GetIncomeEmailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetIncomeEmailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetIncomeEmailsQuery, TError, TData>(
      {
    queryKey: ['GetIncomeEmails', variables],
    queryFn: amplifyFetcher<GetIncomeEmailsQuery, GetIncomeEmailsQueryVariables>(GetIncomeEmailsDocument, variables),
    ...options
  }
    )};

useGetIncomeEmailsQuery.document = GetIncomeEmailsDocument;

useGetIncomeEmailsQuery.getKey = (variables: GetIncomeEmailsQueryVariables) => ['GetIncomeEmails', variables];

export const useInfiniteGetIncomeEmailsQuery = <
      TData = InfiniteData<GetIncomeEmailsQuery>,
      TError = unknown
    >(
      variables: GetIncomeEmailsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetIncomeEmailsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetIncomeEmailsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetIncomeEmailsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetIncomeEmails.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetIncomeEmailsQuery, GetIncomeEmailsQueryVariables>(GetIncomeEmailsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetIncomeEmailsQuery.getKey = (variables: GetIncomeEmailsQueryVariables) => ['GetIncomeEmails.infinite', variables];

export const GetBusinessIncomeDocument = `
    query GetBusinessIncome($input: GetBusinessIncomeInput!) {
  getBusinessIncome(input: $input) {
    incomeProvider
    id
    businessId
    incomeType
    currency
    currencyRate
    incomeDate
    vat
    price
    priceIncludingVat
    invoiceNumber
    reportId
    business {
      businessName
      registrationNumber
      businessType
      industry {
        name
      }
      user {
        firstName
        lastName
      }
    }
    customer {
      customerName
      registrationNumber
    }
    items {
      description
      unitPrice
      units
      priceIncludingVat
      price
      vat
      itemTax {
        id
        reportId
        incomeItemId
        report {
          startDate
          endDate
          reportStatus
        }
      }
      itemVat {
        id
        reportId
        incomeItemId
        report {
          startDate
          endDate
          reportStatus
          businessType
        }
      }
    }
    payments {
      paymentMethod
      taxDeduction
    }
  }
}
    `;

export const useGetBusinessIncomeQuery = <
      TData = GetBusinessIncomeQuery,
      TError = unknown
    >(
      variables: GetBusinessIncomeQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessIncomeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessIncomeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessIncomeQuery, TError, TData>(
      {
    queryKey: ['GetBusinessIncome', variables],
    queryFn: amplifyFetcher<GetBusinessIncomeQuery, GetBusinessIncomeQueryVariables>(GetBusinessIncomeDocument, variables),
    ...options
  }
    )};

useGetBusinessIncomeQuery.document = GetBusinessIncomeDocument;

useGetBusinessIncomeQuery.getKey = (variables: GetBusinessIncomeQueryVariables) => ['GetBusinessIncome', variables];

export const useInfiniteGetBusinessIncomeQuery = <
      TData = InfiniteData<GetBusinessIncomeQuery>,
      TError = unknown
    >(
      variables: GetBusinessIncomeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessIncomeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessIncomeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessIncomeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessIncome.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessIncomeQuery, GetBusinessIncomeQueryVariables>(GetBusinessIncomeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessIncomeQuery.getKey = (variables: GetBusinessIncomeQueryVariables) => ['GetBusinessIncome.infinite', variables];

export const GetBusinessIncomePaymentGrowDataDocument = `
    query GetBusinessIncomePaymentGrowData($input: GetBusinessIncomePaymentGrowDataInput!) {
  getBusinessIncomePaymentGrowData(input: $input) {
    growTransactionId
    growTransactionToken
  }
}
    `;

export const useGetBusinessIncomePaymentGrowDataQuery = <
      TData = GetBusinessIncomePaymentGrowDataQuery,
      TError = unknown
    >(
      variables: GetBusinessIncomePaymentGrowDataQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessIncomePaymentGrowDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessIncomePaymentGrowDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessIncomePaymentGrowDataQuery, TError, TData>(
      {
    queryKey: ['GetBusinessIncomePaymentGrowData', variables],
    queryFn: amplifyFetcher<GetBusinessIncomePaymentGrowDataQuery, GetBusinessIncomePaymentGrowDataQueryVariables>(GetBusinessIncomePaymentGrowDataDocument, variables),
    ...options
  }
    )};

useGetBusinessIncomePaymentGrowDataQuery.document = GetBusinessIncomePaymentGrowDataDocument;

useGetBusinessIncomePaymentGrowDataQuery.getKey = (variables: GetBusinessIncomePaymentGrowDataQueryVariables) => ['GetBusinessIncomePaymentGrowData', variables];

export const useInfiniteGetBusinessIncomePaymentGrowDataQuery = <
      TData = InfiniteData<GetBusinessIncomePaymentGrowDataQuery>,
      TError = unknown
    >(
      variables: GetBusinessIncomePaymentGrowDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessIncomePaymentGrowDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessIncomePaymentGrowDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessIncomePaymentGrowDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessIncomePaymentGrowData.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessIncomePaymentGrowDataQuery, GetBusinessIncomePaymentGrowDataQueryVariables>(GetBusinessIncomePaymentGrowDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessIncomePaymentGrowDataQuery.getKey = (variables: GetBusinessIncomePaymentGrowDataQueryVariables) => ['GetBusinessIncomePaymentGrowData.infinite', variables];

export const GetBusinessProviderDocument = `
    query GetBusinessProvider($input: GetBusinessProviderInput!) {
  getBusinessProvider(input: $input) {
    id
    name
    isIsraelProvider
    nickname
    registrationNumber
  }
}
    `;

export const useGetBusinessProviderQuery = <
      TData = GetBusinessProviderQuery,
      TError = unknown
    >(
      variables: GetBusinessProviderQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessProviderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessProviderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessProviderQuery, TError, TData>(
      {
    queryKey: ['GetBusinessProvider', variables],
    queryFn: amplifyFetcher<GetBusinessProviderQuery, GetBusinessProviderQueryVariables>(GetBusinessProviderDocument, variables),
    ...options
  }
    )};

useGetBusinessProviderQuery.document = GetBusinessProviderDocument;

useGetBusinessProviderQuery.getKey = (variables: GetBusinessProviderQueryVariables) => ['GetBusinessProvider', variables];

export const useInfiniteGetBusinessProviderQuery = <
      TData = InfiniteData<GetBusinessProviderQuery>,
      TError = unknown
    >(
      variables: GetBusinessProviderQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessProviderQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessProviderQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessProviderQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessProvider.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessProviderQuery, GetBusinessProviderQueryVariables>(GetBusinessProviderDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessProviderQuery.getKey = (variables: GetBusinessProviderQueryVariables) => ['GetBusinessProvider.infinite', variables];

export const GetBusinessReportDatesDocument = `
    query GetBusinessReportDates($input: GetBusinessReportInput!) {
  getBusinessReport(input: $input) {
    startDate
    endDate
  }
}
    `;

export const useGetBusinessReportDatesQuery = <
      TData = GetBusinessReportDatesQuery,
      TError = unknown
    >(
      variables: GetBusinessReportDatesQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessReportDatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessReportDatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessReportDatesQuery, TError, TData>(
      {
    queryKey: ['GetBusinessReportDates', variables],
    queryFn: amplifyFetcher<GetBusinessReportDatesQuery, GetBusinessReportDatesQueryVariables>(GetBusinessReportDatesDocument, variables),
    ...options
  }
    )};

useGetBusinessReportDatesQuery.document = GetBusinessReportDatesDocument;

useGetBusinessReportDatesQuery.getKey = (variables: GetBusinessReportDatesQueryVariables) => ['GetBusinessReportDates', variables];

export const useInfiniteGetBusinessReportDatesQuery = <
      TData = InfiniteData<GetBusinessReportDatesQuery>,
      TError = unknown
    >(
      variables: GetBusinessReportDatesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessReportDatesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessReportDatesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessReportDatesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessReportDates.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessReportDatesQuery, GetBusinessReportDatesQueryVariables>(GetBusinessReportDatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessReportDatesQuery.getKey = (variables: GetBusinessReportDatesQueryVariables) => ['GetBusinessReportDates.infinite', variables];

export const GetBusinessReportDocument = `
    query GetBusinessReport($input: ListBusinessReportsInput!) {
  listBusinessReports(input: $input) {
    items {
      id
      businessType
      reportType
      reportStatus
      startDate
      endDate
      advancedPaymentAmount
      sumOfVatPayment
      sumOfInputsOnFixedEquipment
      sumOfInputsOnOtherExpenses
      sumOfExpensesIncludingVat
      sumOfExpensesWithoutVat
      sumOfIncomesIncludingVat
      calculatedAdvancePayments
      sumOfIncomesExemptOfVatOrZeroVat
      sumOfBusinessTurnover
      sumOfIncomesLiabledToVat
      sumOfVatAmountOnIncomes
      withheldTax
      advanceTaxPercentage
      pendingApprovalExpenses
      businessId
      reportName
      taoaReference
      bituahLeumiPayments {
        id
        reportId
        bituahLeumiPayment
        startDate
        endDate
      }
    }
  }
}
    `;

export const useGetBusinessReportQuery = <
      TData = GetBusinessReportQuery,
      TError = unknown
    >(
      variables: GetBusinessReportQueryVariables,
      options?: Omit<UseQueryOptions<GetBusinessReportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetBusinessReportQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetBusinessReportQuery, TError, TData>(
      {
    queryKey: ['GetBusinessReport', variables],
    queryFn: amplifyFetcher<GetBusinessReportQuery, GetBusinessReportQueryVariables>(GetBusinessReportDocument, variables),
    ...options
  }
    )};

useGetBusinessReportQuery.document = GetBusinessReportDocument;

useGetBusinessReportQuery.getKey = (variables: GetBusinessReportQueryVariables) => ['GetBusinessReport', variables];

export const useInfiniteGetBusinessReportQuery = <
      TData = InfiniteData<GetBusinessReportQuery>,
      TError = unknown
    >(
      variables: GetBusinessReportQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetBusinessReportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetBusinessReportQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetBusinessReportQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetBusinessReport.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetBusinessReportQuery, GetBusinessReportQueryVariables>(GetBusinessReportDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetBusinessReportQuery.getKey = (variables: GetBusinessReportQueryVariables) => ['GetBusinessReport.infinite', variables];

export const GetCountOpenfrmtFilesDocument = `
    query GetCountOpenfrmtFiles($input: GetCountOpenfrmtFilesInput!) {
  getCountOpenfrmtFiles(input: $input) {
    amount
    counter
    incomeType
    title
    totalA100
    totalB100
    totalB110
    totalC100
    totalD110
    totalD120
    totalM100
    totalZ900
  }
}
    `;

export const useGetCountOpenfrmtFilesQuery = <
      TData = GetCountOpenfrmtFilesQuery,
      TError = unknown
    >(
      variables: GetCountOpenfrmtFilesQueryVariables,
      options?: Omit<UseQueryOptions<GetCountOpenfrmtFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCountOpenfrmtFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCountOpenfrmtFilesQuery, TError, TData>(
      {
    queryKey: ['GetCountOpenfrmtFiles', variables],
    queryFn: amplifyFetcher<GetCountOpenfrmtFilesQuery, GetCountOpenfrmtFilesQueryVariables>(GetCountOpenfrmtFilesDocument, variables),
    ...options
  }
    )};

useGetCountOpenfrmtFilesQuery.document = GetCountOpenfrmtFilesDocument;

useGetCountOpenfrmtFilesQuery.getKey = (variables: GetCountOpenfrmtFilesQueryVariables) => ['GetCountOpenfrmtFiles', variables];

export const useInfiniteGetCountOpenfrmtFilesQuery = <
      TData = InfiniteData<GetCountOpenfrmtFilesQuery>,
      TError = unknown
    >(
      variables: GetCountOpenfrmtFilesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCountOpenfrmtFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCountOpenfrmtFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetCountOpenfrmtFilesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetCountOpenfrmtFiles.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetCountOpenfrmtFilesQuery, GetCountOpenfrmtFilesQueryVariables>(GetCountOpenfrmtFilesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCountOpenfrmtFilesQuery.getKey = (variables: GetCountOpenfrmtFilesQueryVariables) => ['GetCountOpenfrmtFiles.infinite', variables];

export const GetCurrencyRateDocument = `
    query GetCurrencyRate($input: GetCurrencyRateInput!) {
  getCurrencyRate(input: $input) {
    currency
    rate
  }
}
    `;

export const useGetCurrencyRateQuery = <
      TData = GetCurrencyRateQuery,
      TError = unknown
    >(
      variables: GetCurrencyRateQueryVariables,
      options?: Omit<UseQueryOptions<GetCurrencyRateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCurrencyRateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCurrencyRateQuery, TError, TData>(
      {
    queryKey: ['GetCurrencyRate', variables],
    queryFn: amplifyFetcher<GetCurrencyRateQuery, GetCurrencyRateQueryVariables>(GetCurrencyRateDocument, variables),
    ...options
  }
    )};

useGetCurrencyRateQuery.document = GetCurrencyRateDocument;

useGetCurrencyRateQuery.getKey = (variables: GetCurrencyRateQueryVariables) => ['GetCurrencyRate', variables];

export const useInfiniteGetCurrencyRateQuery = <
      TData = InfiniteData<GetCurrencyRateQuery>,
      TError = unknown
    >(
      variables: GetCurrencyRateQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCurrencyRateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCurrencyRateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetCurrencyRateQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetCurrencyRate.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetCurrencyRateQuery, GetCurrencyRateQueryVariables>(GetCurrencyRateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCurrencyRateQuery.getKey = (variables: GetCurrencyRateQueryVariables) => ['GetCurrencyRate.infinite', variables];

export const GetDocumentTreeChildrenAllowedDataDocument = `
    mutation GetDocumentTreeChildrenAllowedData($input: DocumentTreeInput!) {
  documentTree(input: $input) {
    childrenAllowedData {
      incomeType
      currency
      customerId
      customer {
        name
        phone
        email
        registrationNumber
      }
      description
      items {
        description
        units
        unitPrice
        price
        vat
        vatType
        priceIncludingVat
      }
      payments {
        price
        paymentMethod
        paymentApp
        bankName
        bankBranch
        bankAccount
        taxDeduction
        creditCardPaymentType
        creditCardNumberOfPayments
        creditCardType
      }
      price
      priceIncludingVat
      vat
    }
  }
}
    `;

export const useGetDocumentTreeChildrenAllowedDataMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetDocumentTreeChildrenAllowedDataMutation, TError, GetDocumentTreeChildrenAllowedDataMutationVariables, TContext>) => {
    
    return useMutation<GetDocumentTreeChildrenAllowedDataMutation, TError, GetDocumentTreeChildrenAllowedDataMutationVariables, TContext>(
      {
    mutationKey: ['GetDocumentTreeChildrenAllowedData'],
    mutationFn: (variables?: GetDocumentTreeChildrenAllowedDataMutationVariables) => amplifyFetcher<GetDocumentTreeChildrenAllowedDataMutation, GetDocumentTreeChildrenAllowedDataMutationVariables>(GetDocumentTreeChildrenAllowedDataDocument, variables)(),
    ...options
  }
    )};

useGetDocumentTreeChildrenAllowedDataMutation.getKey = () => ['GetDocumentTreeChildrenAllowedData'];

export const GetHomeTabsCountersDocument = `
    query GetHomeTabsCounters {
  getHomeTabsCounters {
    BUSINESSES_PENDING_APPROVAL
    EXPENSE_PENDING_APPROVAL
    BUSINESS_PENDING_DOCUMENTS_TO_UPLOAD
  }
}
    `;

export const useGetHomeTabsCountersQuery = <
      TData = GetHomeTabsCountersQuery,
      TError = unknown
    >(
      variables?: GetHomeTabsCountersQueryVariables,
      options?: Omit<UseQueryOptions<GetHomeTabsCountersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetHomeTabsCountersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetHomeTabsCountersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetHomeTabsCounters'] : ['GetHomeTabsCounters', variables],
    queryFn: amplifyFetcher<GetHomeTabsCountersQuery, GetHomeTabsCountersQueryVariables>(GetHomeTabsCountersDocument, variables),
    ...options
  }
    )};

useGetHomeTabsCountersQuery.document = GetHomeTabsCountersDocument;

useGetHomeTabsCountersQuery.getKey = (variables?: GetHomeTabsCountersQueryVariables) => variables === undefined ? ['GetHomeTabsCounters'] : ['GetHomeTabsCounters', variables];

export const useInfiniteGetHomeTabsCountersQuery = <
      TData = InfiniteData<GetHomeTabsCountersQuery>,
      TError = unknown
    >(
      variables: GetHomeTabsCountersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetHomeTabsCountersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetHomeTabsCountersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetHomeTabsCountersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetHomeTabsCounters.infinite'] : ['GetHomeTabsCounters.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetHomeTabsCountersQuery, GetHomeTabsCountersQueryVariables>(GetHomeTabsCountersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetHomeTabsCountersQuery.getKey = (variables?: GetHomeTabsCountersQueryVariables) => variables === undefined ? ['GetHomeTabsCounters.infinite'] : ['GetHomeTabsCounters.infinite', variables];

export const GetNextBusinessSubscriptionPaymentDocument = `
    query GetNextBusinessSubscriptionPayment($input: GetNextBusinessSubscriptionPaymentInput!) {
  getNextBusinessSubscriptionPayment(input: $input) {
    date
    price
  }
}
    `;

export const useGetNextBusinessSubscriptionPaymentQuery = <
      TData = GetNextBusinessSubscriptionPaymentQuery,
      TError = unknown
    >(
      variables: GetNextBusinessSubscriptionPaymentQueryVariables,
      options?: Omit<UseQueryOptions<GetNextBusinessSubscriptionPaymentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNextBusinessSubscriptionPaymentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetNextBusinessSubscriptionPaymentQuery, TError, TData>(
      {
    queryKey: ['GetNextBusinessSubscriptionPayment', variables],
    queryFn: amplifyFetcher<GetNextBusinessSubscriptionPaymentQuery, GetNextBusinessSubscriptionPaymentQueryVariables>(GetNextBusinessSubscriptionPaymentDocument, variables),
    ...options
  }
    )};

useGetNextBusinessSubscriptionPaymentQuery.document = GetNextBusinessSubscriptionPaymentDocument;

useGetNextBusinessSubscriptionPaymentQuery.getKey = (variables: GetNextBusinessSubscriptionPaymentQueryVariables) => ['GetNextBusinessSubscriptionPayment', variables];

export const useInfiniteGetNextBusinessSubscriptionPaymentQuery = <
      TData = InfiniteData<GetNextBusinessSubscriptionPaymentQuery>,
      TError = unknown
    >(
      variables: GetNextBusinessSubscriptionPaymentQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetNextBusinessSubscriptionPaymentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetNextBusinessSubscriptionPaymentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetNextBusinessSubscriptionPaymentQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetNextBusinessSubscriptionPayment.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetNextBusinessSubscriptionPaymentQuery, GetNextBusinessSubscriptionPaymentQueryVariables>(GetNextBusinessSubscriptionPaymentDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetNextBusinessSubscriptionPaymentQuery.getKey = (variables: GetNextBusinessSubscriptionPaymentQueryVariables) => ['GetNextBusinessSubscriptionPayment.infinite', variables];

export const GetNextIncomeInvoiceNumberDocument = `
    query GetNextIncomeInvoiceNumber($input: GetNextIncomeInvoiceNumberInput!) {
  getNextIncomeInvoiceNumber(input: $input) {
    invoiceNumber
  }
}
    `;

export const useGetNextIncomeInvoiceNumberQuery = <
      TData = GetNextIncomeInvoiceNumberQuery,
      TError = unknown
    >(
      variables: GetNextIncomeInvoiceNumberQueryVariables,
      options?: Omit<UseQueryOptions<GetNextIncomeInvoiceNumberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetNextIncomeInvoiceNumberQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetNextIncomeInvoiceNumberQuery, TError, TData>(
      {
    queryKey: ['GetNextIncomeInvoiceNumber', variables],
    queryFn: amplifyFetcher<GetNextIncomeInvoiceNumberQuery, GetNextIncomeInvoiceNumberQueryVariables>(GetNextIncomeInvoiceNumberDocument, variables),
    ...options
  }
    )};

useGetNextIncomeInvoiceNumberQuery.document = GetNextIncomeInvoiceNumberDocument;

useGetNextIncomeInvoiceNumberQuery.getKey = (variables: GetNextIncomeInvoiceNumberQueryVariables) => ['GetNextIncomeInvoiceNumber', variables];

export const useInfiniteGetNextIncomeInvoiceNumberQuery = <
      TData = InfiniteData<GetNextIncomeInvoiceNumberQuery>,
      TError = unknown
    >(
      variables: GetNextIncomeInvoiceNumberQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetNextIncomeInvoiceNumberQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetNextIncomeInvoiceNumberQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetNextIncomeInvoiceNumberQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetNextIncomeInvoiceNumber.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetNextIncomeInvoiceNumberQuery, GetNextIncomeInvoiceNumberQueryVariables>(GetNextIncomeInvoiceNumberDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetNextIncomeInvoiceNumberQuery.getKey = (variables: GetNextIncomeInvoiceNumberQueryVariables) => ['GetNextIncomeInvoiceNumber.infinite', variables];

export const GetPreviousIncomeDateDocument = `
    query GetPreviousIncomeDate($input: GetPreviousIncomeInput!) {
  getPreviousIncomeDate(input: $input) {
    previousIncomeDate
  }
}
    `;

export const useGetPreviousIncomeDateQuery = <
      TData = GetPreviousIncomeDateQuery,
      TError = unknown
    >(
      variables: GetPreviousIncomeDateQueryVariables,
      options?: Omit<UseQueryOptions<GetPreviousIncomeDateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPreviousIncomeDateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPreviousIncomeDateQuery, TError, TData>(
      {
    queryKey: ['GetPreviousIncomeDate', variables],
    queryFn: amplifyFetcher<GetPreviousIncomeDateQuery, GetPreviousIncomeDateQueryVariables>(GetPreviousIncomeDateDocument, variables),
    ...options
  }
    )};

useGetPreviousIncomeDateQuery.document = GetPreviousIncomeDateDocument;

useGetPreviousIncomeDateQuery.getKey = (variables: GetPreviousIncomeDateQueryVariables) => ['GetPreviousIncomeDate', variables];

export const useInfiniteGetPreviousIncomeDateQuery = <
      TData = InfiniteData<GetPreviousIncomeDateQuery>,
      TError = unknown
    >(
      variables: GetPreviousIncomeDateQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetPreviousIncomeDateQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetPreviousIncomeDateQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetPreviousIncomeDateQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetPreviousIncomeDate.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetPreviousIncomeDateQuery, GetPreviousIncomeDateQueryVariables>(GetPreviousIncomeDateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetPreviousIncomeDateQuery.getKey = (variables: GetPreviousIncomeDateQueryVariables) => ['GetPreviousIncomeDate.infinite', variables];

export const GetSpreadsheetIncomesDocument = `
    query GetSpreadsheetIncomes($input: GetSpreadsheetIncomesInput!) {
  getSpreadsheetIncomes(input: $input) {
    data
  }
}
    `;

export const useGetSpreadsheetIncomesQuery = <
      TData = GetSpreadsheetIncomesQuery,
      TError = unknown
    >(
      variables: GetSpreadsheetIncomesQueryVariables,
      options?: Omit<UseQueryOptions<GetSpreadsheetIncomesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSpreadsheetIncomesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSpreadsheetIncomesQuery, TError, TData>(
      {
    queryKey: ['GetSpreadsheetIncomes', variables],
    queryFn: amplifyFetcher<GetSpreadsheetIncomesQuery, GetSpreadsheetIncomesQueryVariables>(GetSpreadsheetIncomesDocument, variables),
    ...options
  }
    )};

useGetSpreadsheetIncomesQuery.document = GetSpreadsheetIncomesDocument;

useGetSpreadsheetIncomesQuery.getKey = (variables: GetSpreadsheetIncomesQueryVariables) => ['GetSpreadsheetIncomes', variables];

export const useInfiniteGetSpreadsheetIncomesQuery = <
      TData = InfiniteData<GetSpreadsheetIncomesQuery>,
      TError = unknown
    >(
      variables: GetSpreadsheetIncomesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSpreadsheetIncomesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSpreadsheetIncomesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetSpreadsheetIncomesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetSpreadsheetIncomes.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetSpreadsheetIncomesQuery, GetSpreadsheetIncomesQueryVariables>(GetSpreadsheetIncomesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSpreadsheetIncomesQuery.getKey = (variables: GetSpreadsheetIncomesQueryVariables) => ['GetSpreadsheetIncomes.infinite', variables];

export const GetStaffDocument = `
    query GetStaff {
  getStaff {
    id
    mobile
    firstName
    lastName
    idNumber
  }
}
    `;

export const useGetStaffQuery = <
      TData = GetStaffQuery,
      TError = unknown
    >(
      variables?: GetStaffQueryVariables,
      options?: Omit<UseQueryOptions<GetStaffQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetStaffQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetStaffQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetStaff'] : ['GetStaff', variables],
    queryFn: amplifyFetcher<GetStaffQuery, GetStaffQueryVariables>(GetStaffDocument, variables),
    ...options
  }
    )};

useGetStaffQuery.document = GetStaffDocument;

useGetStaffQuery.getKey = (variables?: GetStaffQueryVariables) => variables === undefined ? ['GetStaff'] : ['GetStaff', variables];

export const useInfiniteGetStaffQuery = <
      TData = InfiniteData<GetStaffQuery>,
      TError = unknown
    >(
      variables: GetStaffQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetStaffQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetStaffQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetStaffQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetStaff.infinite'] : ['GetStaff.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetStaffQuery, GetStaffQueryVariables>(GetStaffDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetStaffQuery.getKey = (variables?: GetStaffQueryVariables) => variables === undefined ? ['GetStaff.infinite'] : ['GetStaff.infinite', variables];

export const GetSubscriptionPlansDocument = `
    query GetSubscriptionPlans {
  getSubscriptionPlans {
    businessType
    discountPercentage
    price
    termInMonth
    planType
  }
}
    `;

export const useGetSubscriptionPlansQuery = <
      TData = GetSubscriptionPlansQuery,
      TError = unknown
    >(
      variables?: GetSubscriptionPlansQueryVariables,
      options?: Omit<UseQueryOptions<GetSubscriptionPlansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSubscriptionPlansQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSubscriptionPlansQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetSubscriptionPlans'] : ['GetSubscriptionPlans', variables],
    queryFn: amplifyFetcher<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>(GetSubscriptionPlansDocument, variables),
    ...options
  }
    )};

useGetSubscriptionPlansQuery.document = GetSubscriptionPlansDocument;

useGetSubscriptionPlansQuery.getKey = (variables?: GetSubscriptionPlansQueryVariables) => variables === undefined ? ['GetSubscriptionPlans'] : ['GetSubscriptionPlans', variables];

export const useInfiniteGetSubscriptionPlansQuery = <
      TData = InfiniteData<GetSubscriptionPlansQuery>,
      TError = unknown
    >(
      variables: GetSubscriptionPlansQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSubscriptionPlansQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSubscriptionPlansQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetSubscriptionPlansQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetSubscriptionPlans.infinite'] : ['GetSubscriptionPlans.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetSubscriptionPlansQuery, GetSubscriptionPlansQueryVariables>(GetSubscriptionPlansDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSubscriptionPlansQuery.getKey = (variables?: GetSubscriptionPlansQueryVariables) => variables === undefined ? ['GetSubscriptionPlans.infinite'] : ['GetSubscriptionPlans.infinite', variables];

export const GetUserDocument = `
    query GetUser {
  getUser {
    id
    mobile
    firstName
    lastName
    email
    idNumber
    onboardingStatus
    businesses {
      id
      businessType
    }
  }
}
    `;

export const useGetUserQuery = <
      TData = GetUserQuery,
      TError = unknown
    >(
      variables?: GetUserQueryVariables,
      options?: Omit<UseQueryOptions<GetUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetUser'] : ['GetUser', variables],
    queryFn: amplifyFetcher<GetUserQuery, GetUserQueryVariables>(GetUserDocument, variables),
    ...options
  }
    )};

useGetUserQuery.document = GetUserDocument;

useGetUserQuery.getKey = (variables?: GetUserQueryVariables) => variables === undefined ? ['GetUser'] : ['GetUser', variables];

export const useInfiniteGetUserQuery = <
      TData = InfiniteData<GetUserQuery>,
      TError = unknown
    >(
      variables: GetUserQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetUserQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetUser.infinite'] : ['GetUser.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetUserQuery, GetUserQueryVariables>(GetUserDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserQuery.getKey = (variables?: GetUserQueryVariables) => variables === undefined ? ['GetUser.infinite'] : ['GetUser.infinite', variables];

export const GetUserBusinessIdDocument = `
    query GetUserBusinessId {
  getUser {
    businesses {
      id
    }
  }
}
    `;

export const useGetUserBusinessIdQuery = <
      TData = GetUserBusinessIdQuery,
      TError = unknown
    >(
      variables?: GetUserBusinessIdQueryVariables,
      options?: Omit<UseQueryOptions<GetUserBusinessIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserBusinessIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserBusinessIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetUserBusinessId'] : ['GetUserBusinessId', variables],
    queryFn: amplifyFetcher<GetUserBusinessIdQuery, GetUserBusinessIdQueryVariables>(GetUserBusinessIdDocument, variables),
    ...options
  }
    )};

useGetUserBusinessIdQuery.document = GetUserBusinessIdDocument;

useGetUserBusinessIdQuery.getKey = (variables?: GetUserBusinessIdQueryVariables) => variables === undefined ? ['GetUserBusinessId'] : ['GetUserBusinessId', variables];

export const useInfiniteGetUserBusinessIdQuery = <
      TData = InfiniteData<GetUserBusinessIdQuery>,
      TError = unknown
    >(
      variables: GetUserBusinessIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserBusinessIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserBusinessIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetUserBusinessIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetUserBusinessId.infinite'] : ['GetUserBusinessId.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetUserBusinessIdQuery, GetUserBusinessIdQueryVariables>(GetUserBusinessIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserBusinessIdQuery.getKey = (variables?: GetUserBusinessIdQueryVariables) => variables === undefined ? ['GetUserBusinessId.infinite'] : ['GetUserBusinessId.infinite', variables];

export const GetUserOnboardingStatusDocument = `
    query GetUserOnboardingStatus {
  getUser {
    onboardingStatus
  }
}
    `;

export const useGetUserOnboardingStatusQuery = <
      TData = GetUserOnboardingStatusQuery,
      TError = unknown
    >(
      variables?: GetUserOnboardingStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetUserOnboardingStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserOnboardingStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserOnboardingStatusQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetUserOnboardingStatus'] : ['GetUserOnboardingStatus', variables],
    queryFn: amplifyFetcher<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>(GetUserOnboardingStatusDocument, variables),
    ...options
  }
    )};

useGetUserOnboardingStatusQuery.document = GetUserOnboardingStatusDocument;

useGetUserOnboardingStatusQuery.getKey = (variables?: GetUserOnboardingStatusQueryVariables) => variables === undefined ? ['GetUserOnboardingStatus'] : ['GetUserOnboardingStatus', variables];

export const useInfiniteGetUserOnboardingStatusQuery = <
      TData = InfiniteData<GetUserOnboardingStatusQuery>,
      TError = unknown
    >(
      variables: GetUserOnboardingStatusQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserOnboardingStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserOnboardingStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetUserOnboardingStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetUserOnboardingStatus.infinite'] : ['GetUserOnboardingStatus.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetUserOnboardingStatusQuery, GetUserOnboardingStatusQueryVariables>(GetUserOnboardingStatusDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserOnboardingStatusQuery.getKey = (variables?: GetUserOnboardingStatusQueryVariables) => variables === undefined ? ['GetUserOnboardingStatus.infinite'] : ['GetUserOnboardingStatus.infinite', variables];

export const GetUserWithBusinessesDocument = `
    query GetUserWithBusinesses {
  getUser {
    id
    onboardingStatus
    firstName
    lastName
    email
    mobile
    identificationType
    idNumber
    businesses {
      id
      businessStatus
    }
  }
}
    `;

export const useGetUserWithBusinessesQuery = <
      TData = GetUserWithBusinessesQuery,
      TError = unknown
    >(
      variables?: GetUserWithBusinessesQueryVariables,
      options?: Omit<UseQueryOptions<GetUserWithBusinessesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserWithBusinessesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserWithBusinessesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetUserWithBusinesses'] : ['GetUserWithBusinesses', variables],
    queryFn: amplifyFetcher<GetUserWithBusinessesQuery, GetUserWithBusinessesQueryVariables>(GetUserWithBusinessesDocument, variables),
    ...options
  }
    )};

useGetUserWithBusinessesQuery.document = GetUserWithBusinessesDocument;

useGetUserWithBusinessesQuery.getKey = (variables?: GetUserWithBusinessesQueryVariables) => variables === undefined ? ['GetUserWithBusinesses'] : ['GetUserWithBusinesses', variables];

export const useInfiniteGetUserWithBusinessesQuery = <
      TData = InfiniteData<GetUserWithBusinessesQuery>,
      TError = unknown
    >(
      variables: GetUserWithBusinessesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserWithBusinessesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserWithBusinessesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetUserWithBusinessesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetUserWithBusinesses.infinite'] : ['GetUserWithBusinesses.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetUserWithBusinessesQuery, GetUserWithBusinessesQueryVariables>(GetUserWithBusinessesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserWithBusinessesQuery.getKey = (variables?: GetUserWithBusinessesQueryVariables) => variables === undefined ? ['GetUserWithBusinesses.infinite'] : ['GetUserWithBusinesses.infinite', variables];

export const GetActivityDocument = `
    query GetActivity($input: ListActivitiesForBusinessInput!) {
  listActivitiesForBusiness(input: $input) {
    items {
      id
      createdAt
      priceIncludingVat
      price
      description
      date
      currency
      currencyRate
      type
      documentType
    }
    total
  }
}
    `;

export const useGetActivityQuery = <
      TData = GetActivityQuery,
      TError = unknown
    >(
      variables: GetActivityQueryVariables,
      options?: Omit<UseQueryOptions<GetActivityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetActivityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetActivityQuery, TError, TData>(
      {
    queryKey: ['GetActivity', variables],
    queryFn: amplifyFetcher<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, variables),
    ...options
  }
    )};

useGetActivityQuery.document = GetActivityDocument;

useGetActivityQuery.getKey = (variables: GetActivityQueryVariables) => ['GetActivity', variables];

export const useInfiniteGetActivityQuery = <
      TData = InfiniteData<GetActivityQuery>,
      TError = unknown
    >(
      variables: GetActivityQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetActivityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetActivityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetActivityQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetActivity.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetActivityQuery, GetActivityQueryVariables>(GetActivityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetActivityQuery.getKey = (variables: GetActivityQueryVariables) => ['GetActivity.infinite', variables];

export const ListBusinessBillingsDocument = `
    query ListBusinessBillings($input: ListBusinessBillingsInput!) {
  listBusinessBillings(input: $input) {
    items {
      id
      datePaid
      billingStatus
      price
      startDate
      endDate
      description
      expenseId
    }
    total
  }
}
    `;

export const useListBusinessBillingsQuery = <
      TData = ListBusinessBillingsQuery,
      TError = unknown
    >(
      variables: ListBusinessBillingsQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessBillingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessBillingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessBillingsQuery, TError, TData>(
      {
    queryKey: ['ListBusinessBillings', variables],
    queryFn: amplifyFetcher<ListBusinessBillingsQuery, ListBusinessBillingsQueryVariables>(ListBusinessBillingsDocument, variables),
    ...options
  }
    )};

useListBusinessBillingsQuery.document = ListBusinessBillingsDocument;

useListBusinessBillingsQuery.getKey = (variables: ListBusinessBillingsQueryVariables) => ['ListBusinessBillings', variables];

export const useInfiniteListBusinessBillingsQuery = <
      TData = InfiniteData<ListBusinessBillingsQuery>,
      TError = unknown
    >(
      variables: ListBusinessBillingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessBillingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessBillingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessBillingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessBillings.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessBillingsQuery, ListBusinessBillingsQueryVariables>(ListBusinessBillingsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessBillingsQuery.getKey = (variables: ListBusinessBillingsQueryVariables) => ['ListBusinessBillings.infinite', variables];

export const ListBusinessDocumentsDocument = `
    query ListBusinessDocuments($input: ListBusinessDocumentsInput!) {
  listBusinessDocuments(input: $input) {
    name
    type
    lastModified
  }
}
    `;

export const useListBusinessDocumentsQuery = <
      TData = ListBusinessDocumentsQuery,
      TError = unknown
    >(
      variables: ListBusinessDocumentsQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessDocumentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessDocumentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessDocumentsQuery, TError, TData>(
      {
    queryKey: ['ListBusinessDocuments', variables],
    queryFn: amplifyFetcher<ListBusinessDocumentsQuery, ListBusinessDocumentsQueryVariables>(ListBusinessDocumentsDocument, variables),
    ...options
  }
    )};

useListBusinessDocumentsQuery.document = ListBusinessDocumentsDocument;

useListBusinessDocumentsQuery.getKey = (variables: ListBusinessDocumentsQueryVariables) => ['ListBusinessDocuments', variables];

export const useInfiniteListBusinessDocumentsQuery = <
      TData = InfiniteData<ListBusinessDocumentsQuery>,
      TError = unknown
    >(
      variables: ListBusinessDocumentsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessDocumentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessDocumentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessDocumentsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessDocuments.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessDocumentsQuery, ListBusinessDocumentsQueryVariables>(ListBusinessDocumentsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessDocumentsQuery.getKey = (variables: ListBusinessDocumentsQueryVariables) => ['ListBusinessDocuments.infinite', variables];

export const ListBusinessExpensesDocument = `
    query ListBusinessExpenses($input: ListBusinessExpensesInput!) {
  listBusinessExpenses(input: $input) {
    items {
      id
      businessId
      expenseIndex
      price
      vat
      expenseType
      priceIncludingVat
      createdAt
      expenseDate
      currency
      currencyRate
      provider {
        id
        name
      }
      business {
        id
        registrationNumber
        businessName
        user {
          firstName
          lastName
        }
      }
    }
    total
  }
}
    `;

export const useListBusinessExpensesQuery = <
      TData = ListBusinessExpensesQuery,
      TError = unknown
    >(
      variables: ListBusinessExpensesQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessExpensesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessExpensesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessExpensesQuery, TError, TData>(
      {
    queryKey: ['ListBusinessExpenses', variables],
    queryFn: amplifyFetcher<ListBusinessExpensesQuery, ListBusinessExpensesQueryVariables>(ListBusinessExpensesDocument, variables),
    ...options
  }
    )};

useListBusinessExpensesQuery.document = ListBusinessExpensesDocument;

useListBusinessExpensesQuery.getKey = (variables: ListBusinessExpensesQueryVariables) => ['ListBusinessExpenses', variables];

export const useInfiniteListBusinessExpensesQuery = <
      TData = InfiniteData<ListBusinessExpensesQuery>,
      TError = unknown
    >(
      variables: ListBusinessExpensesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessExpensesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessExpensesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessExpensesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessExpenses.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessExpensesQuery, ListBusinessExpensesQueryVariables>(ListBusinessExpensesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessExpensesQuery.getKey = (variables: ListBusinessExpensesQueryVariables) => ['ListBusinessExpenses.infinite', variables];

export const ListBusinessExpenses_reportDocument = `
    query ListBusinessExpenses_report($input: ListBusinessExpensesInput!) {
  listBusinessExpenses(input: $input) {
    items {
      disputeStatus
      id
      expenseNumber
      provider {
        name
      }
      priceIncludingVat
      currencyRate
      currency
      price
      expenseType
      createdAt
      expenseDate
      deductedVat
      disputeStatus
      business {
        id
        businessName
      }
      items {
        itemVat {
          report {
            startDate
            endDate
          }
        }
        itemTax {
          report {
            startDate
            endDate
          }
        }
      }
    }
    total
  }
}
    `;

export const useListBusinessExpenses_reportQuery = <
      TData = ListBusinessExpenses_reportQuery,
      TError = unknown
    >(
      variables: ListBusinessExpenses_reportQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessExpenses_reportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessExpenses_reportQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessExpenses_reportQuery, TError, TData>(
      {
    queryKey: ['ListBusinessExpenses_report', variables],
    queryFn: amplifyFetcher<ListBusinessExpenses_reportQuery, ListBusinessExpenses_reportQueryVariables>(ListBusinessExpenses_reportDocument, variables),
    ...options
  }
    )};

useListBusinessExpenses_reportQuery.document = ListBusinessExpenses_reportDocument;

useListBusinessExpenses_reportQuery.getKey = (variables: ListBusinessExpenses_reportQueryVariables) => ['ListBusinessExpenses_report', variables];

export const useInfiniteListBusinessExpenses_reportQuery = <
      TData = InfiniteData<ListBusinessExpenses_reportQuery>,
      TError = unknown
    >(
      variables: ListBusinessExpenses_reportQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessExpenses_reportQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessExpenses_reportQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessExpenses_reportQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessExpenses_report.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessExpenses_reportQuery, ListBusinessExpenses_reportQueryVariables>(ListBusinessExpenses_reportDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessExpenses_reportQuery.getKey = (variables: ListBusinessExpenses_reportQueryVariables) => ['ListBusinessExpenses_report.infinite', variables];

export const ListBusinessExpensesSkipDocument = `
    query ListBusinessExpensesSkip($input: ListBusinessExpensesInput!) {
  listBusinessExpenses(input: $input) {
    items {
      id
      expenseIndex
    }
    total
  }
}
    `;

export const useListBusinessExpensesSkipQuery = <
      TData = ListBusinessExpensesSkipQuery,
      TError = unknown
    >(
      variables: ListBusinessExpensesSkipQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessExpensesSkipQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessExpensesSkipQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessExpensesSkipQuery, TError, TData>(
      {
    queryKey: ['ListBusinessExpensesSkip', variables],
    queryFn: amplifyFetcher<ListBusinessExpensesSkipQuery, ListBusinessExpensesSkipQueryVariables>(ListBusinessExpensesSkipDocument, variables),
    ...options
  }
    )};

useListBusinessExpensesSkipQuery.document = ListBusinessExpensesSkipDocument;

useListBusinessExpensesSkipQuery.getKey = (variables: ListBusinessExpensesSkipQueryVariables) => ['ListBusinessExpensesSkip', variables];

export const useInfiniteListBusinessExpensesSkipQuery = <
      TData = InfiniteData<ListBusinessExpensesSkipQuery>,
      TError = unknown
    >(
      variables: ListBusinessExpensesSkipQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessExpensesSkipQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessExpensesSkipQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessExpensesSkipQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessExpensesSkip.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessExpensesSkipQuery, ListBusinessExpensesSkipQueryVariables>(ListBusinessExpensesSkipDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessExpensesSkipQuery.getKey = (variables: ListBusinessExpensesSkipQueryVariables) => ['ListBusinessExpensesSkip.infinite', variables];

export const ListBusinessExpensesInProcessDocument = `
    query ListBusinessExpensesInProcess($input1: ListBusinessExpensesInput!, $input2: ListBusinessExpensesInput!) {
  pendingApproval: listBusinessExpenses(input: $input1) {
    total
    items {
      id
      priceIncludingVat
      currency
      expenseDate
      createdAt
      expenseStatus
      provider {
        name
      }
    }
  }
  inDispute: listBusinessExpenses(input: $input2) {
    total
    items {
      id
      priceIncludingVat
      currency
      expenseDate
      createdAt
      expenseStatus
      provider {
        name
      }
    }
  }
}
    `;

export const useListBusinessExpensesInProcessQuery = <
      TData = ListBusinessExpensesInProcessQuery,
      TError = unknown
    >(
      variables: ListBusinessExpensesInProcessQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessExpensesInProcessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessExpensesInProcessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessExpensesInProcessQuery, TError, TData>(
      {
    queryKey: ['ListBusinessExpensesInProcess', variables],
    queryFn: amplifyFetcher<ListBusinessExpensesInProcessQuery, ListBusinessExpensesInProcessQueryVariables>(ListBusinessExpensesInProcessDocument, variables),
    ...options
  }
    )};

useListBusinessExpensesInProcessQuery.document = ListBusinessExpensesInProcessDocument;

useListBusinessExpensesInProcessQuery.getKey = (variables: ListBusinessExpensesInProcessQueryVariables) => ['ListBusinessExpensesInProcess', variables];

export const useInfiniteListBusinessExpensesInProcessQuery = <
      TData = InfiniteData<ListBusinessExpensesInProcessQuery>,
      TError = unknown
    >(
      variables: ListBusinessExpensesInProcessQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessExpensesInProcessQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessExpensesInProcessQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessExpensesInProcessQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessExpensesInProcess.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessExpensesInProcessQuery, ListBusinessExpensesInProcessQueryVariables>(ListBusinessExpensesInProcessDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessExpensesInProcessQuery.getKey = (variables: ListBusinessExpensesInProcessQueryVariables) => ['ListBusinessExpensesInProcess.infinite', variables];

export const ListBusinessFilesDocument = `
    query ListBusinessFiles($input: ListBusinessFilesInput!) {
  listBusinessFiles(input: $input) {
    name
    size
  }
}
    `;

export const useListBusinessFilesQuery = <
      TData = ListBusinessFilesQuery,
      TError = unknown
    >(
      variables: ListBusinessFilesQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessFilesQuery, TError, TData>(
      {
    queryKey: ['ListBusinessFiles', variables],
    queryFn: amplifyFetcher<ListBusinessFilesQuery, ListBusinessFilesQueryVariables>(ListBusinessFilesDocument, variables),
    ...options
  }
    )};

useListBusinessFilesQuery.document = ListBusinessFilesDocument;

useListBusinessFilesQuery.getKey = (variables: ListBusinessFilesQueryVariables) => ['ListBusinessFiles', variables];

export const useInfiniteListBusinessFilesQuery = <
      TData = InfiniteData<ListBusinessFilesQuery>,
      TError = unknown
    >(
      variables: ListBusinessFilesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessFilesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessFiles.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessFilesQuery, ListBusinessFilesQueryVariables>(ListBusinessFilesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessFilesQuery.getKey = (variables: ListBusinessFilesQueryVariables) => ['ListBusinessFiles.infinite', variables];

export const ListBusinessIncomesDocument = `
    query ListBusinessIncomes($input: ListBusinessIncomesInput!) {
  listBusinessIncomes(input: $input) {
    items {
      id
      businessId
      incomeType
      description
      reportId
      currency
      currencyRate
      priceIncludingVat
      price
      vat
      incomeDate
      invoiceNumber
      incomeProvider
    }
    total
  }
}
    `;

export const useListBusinessIncomesQuery = <
      TData = ListBusinessIncomesQuery,
      TError = unknown
    >(
      variables: ListBusinessIncomesQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessIncomesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessIncomesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessIncomesQuery, TError, TData>(
      {
    queryKey: ['ListBusinessIncomes', variables],
    queryFn: amplifyFetcher<ListBusinessIncomesQuery, ListBusinessIncomesQueryVariables>(ListBusinessIncomesDocument, variables),
    ...options
  }
    )};

useListBusinessIncomesQuery.document = ListBusinessIncomesDocument;

useListBusinessIncomesQuery.getKey = (variables: ListBusinessIncomesQueryVariables) => ['ListBusinessIncomes', variables];

export const useInfiniteListBusinessIncomesQuery = <
      TData = InfiniteData<ListBusinessIncomesQuery>,
      TError = unknown
    >(
      variables: ListBusinessIncomesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessIncomesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessIncomesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessIncomesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessIncomes.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessIncomesQuery, ListBusinessIncomesQueryVariables>(ListBusinessIncomesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessIncomesQuery.getKey = (variables: ListBusinessIncomesQueryVariables) => ['ListBusinessIncomes.infinite', variables];

export const ListBusinessIncomesStatisticsDocument = `
    query ListBusinessIncomesStatistics($input: ListBusinessIncomesStatisticsInput!) {
  listBusinessIncomesStatistics(input: $input) {
    items {
      incomeType
      currencyRate
      priceIncludingVat
      price
      vat
    }
  }
}
    `;

export const useListBusinessIncomesStatisticsQuery = <
      TData = ListBusinessIncomesStatisticsQuery,
      TError = unknown
    >(
      variables: ListBusinessIncomesStatisticsQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessIncomesStatisticsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessIncomesStatisticsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessIncomesStatisticsQuery, TError, TData>(
      {
    queryKey: ['ListBusinessIncomesStatistics', variables],
    queryFn: amplifyFetcher<ListBusinessIncomesStatisticsQuery, ListBusinessIncomesStatisticsQueryVariables>(ListBusinessIncomesStatisticsDocument, variables),
    ...options
  }
    )};

useListBusinessIncomesStatisticsQuery.document = ListBusinessIncomesStatisticsDocument;

useListBusinessIncomesStatisticsQuery.getKey = (variables: ListBusinessIncomesStatisticsQueryVariables) => ['ListBusinessIncomesStatistics', variables];

export const useInfiniteListBusinessIncomesStatisticsQuery = <
      TData = InfiniteData<ListBusinessIncomesStatisticsQuery>,
      TError = unknown
    >(
      variables: ListBusinessIncomesStatisticsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessIncomesStatisticsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessIncomesStatisticsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessIncomesStatisticsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessIncomesStatistics.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessIncomesStatisticsQuery, ListBusinessIncomesStatisticsQueryVariables>(ListBusinessIncomesStatisticsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessIncomesStatisticsQuery.getKey = (variables: ListBusinessIncomesStatisticsQueryVariables) => ['ListBusinessIncomesStatistics.infinite', variables];

export const ListBusinessIncomesDocumentsDocument = `
    query ListBusinessIncomesDocuments($input: ListBusinessIncomesDocumentsInput!) {
  listBusinessIncomesDocuments(input: $input) {
    items {
      id
      businessId
      reportId
      createdAt
    }
    total
  }
}
    `;

export const useListBusinessIncomesDocumentsQuery = <
      TData = ListBusinessIncomesDocumentsQuery,
      TError = unknown
    >(
      variables: ListBusinessIncomesDocumentsQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessIncomesDocumentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessIncomesDocumentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessIncomesDocumentsQuery, TError, TData>(
      {
    queryKey: ['ListBusinessIncomesDocuments', variables],
    queryFn: amplifyFetcher<ListBusinessIncomesDocumentsQuery, ListBusinessIncomesDocumentsQueryVariables>(ListBusinessIncomesDocumentsDocument, variables),
    ...options
  }
    )};

useListBusinessIncomesDocumentsQuery.document = ListBusinessIncomesDocumentsDocument;

useListBusinessIncomesDocumentsQuery.getKey = (variables: ListBusinessIncomesDocumentsQueryVariables) => ['ListBusinessIncomesDocuments', variables];

export const useInfiniteListBusinessIncomesDocumentsQuery = <
      TData = InfiniteData<ListBusinessIncomesDocumentsQuery>,
      TError = unknown
    >(
      variables: ListBusinessIncomesDocumentsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessIncomesDocumentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessIncomesDocumentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessIncomesDocumentsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessIncomesDocuments.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessIncomesDocumentsQuery, ListBusinessIncomesDocumentsQueryVariables>(ListBusinessIncomesDocumentsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessIncomesDocumentsQuery.getKey = (variables: ListBusinessIncomesDocumentsQueryVariables) => ['ListBusinessIncomesDocuments.infinite', variables];

export const ListBusinessIncomesDocumentsDetailedDocument = `
    query ListBusinessIncomesDocumentsDetailed($input: ListBusinessIncomesDocumentsInput!) {
  listBusinessIncomesDocuments(input: $input) {
    items {
      id
      businessId
      incomeType
      description
      reportId
      currency
      currencyRate
      priceIncludingVat
      price
      vat
      incomeDate
      invoiceNumber
      incomeProvider
    }
    total
  }
}
    `;

export const useListBusinessIncomesDocumentsDetailedQuery = <
      TData = ListBusinessIncomesDocumentsDetailedQuery,
      TError = unknown
    >(
      variables: ListBusinessIncomesDocumentsDetailedQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessIncomesDocumentsDetailedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessIncomesDocumentsDetailedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessIncomesDocumentsDetailedQuery, TError, TData>(
      {
    queryKey: ['ListBusinessIncomesDocumentsDetailed', variables],
    queryFn: amplifyFetcher<ListBusinessIncomesDocumentsDetailedQuery, ListBusinessIncomesDocumentsDetailedQueryVariables>(ListBusinessIncomesDocumentsDetailedDocument, variables),
    ...options
  }
    )};

useListBusinessIncomesDocumentsDetailedQuery.document = ListBusinessIncomesDocumentsDetailedDocument;

useListBusinessIncomesDocumentsDetailedQuery.getKey = (variables: ListBusinessIncomesDocumentsDetailedQueryVariables) => ['ListBusinessIncomesDocumentsDetailed', variables];

export const useInfiniteListBusinessIncomesDocumentsDetailedQuery = <
      TData = InfiniteData<ListBusinessIncomesDocumentsDetailedQuery>,
      TError = unknown
    >(
      variables: ListBusinessIncomesDocumentsDetailedQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessIncomesDocumentsDetailedQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessIncomesDocumentsDetailedQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessIncomesDocumentsDetailedQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessIncomesDocumentsDetailed.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessIncomesDocumentsDetailedQuery, ListBusinessIncomesDocumentsDetailedQueryVariables>(ListBusinessIncomesDocumentsDetailedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessIncomesDocumentsDetailedQuery.getKey = (variables: ListBusinessIncomesDocumentsDetailedQueryVariables) => ['ListBusinessIncomesDocumentsDetailed.infinite', variables];

export const ListBusinessIndustriesDocument = `
    query ListBusinessIndustries($input: ListBusinessIndustriesInput!) {
  listBusinessIndustries(input: $input) {
    items {
      id
      name
      irsCode
    }
    total
  }
}
    `;

export const useListBusinessIndustriesQuery = <
      TData = ListBusinessIndustriesQuery,
      TError = unknown
    >(
      variables: ListBusinessIndustriesQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessIndustriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessIndustriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessIndustriesQuery, TError, TData>(
      {
    queryKey: ['ListBusinessIndustries', variables],
    queryFn: amplifyFetcher<ListBusinessIndustriesQuery, ListBusinessIndustriesQueryVariables>(ListBusinessIndustriesDocument, variables),
    ...options
  }
    )};

useListBusinessIndustriesQuery.document = ListBusinessIndustriesDocument;

useListBusinessIndustriesQuery.getKey = (variables: ListBusinessIndustriesQueryVariables) => ['ListBusinessIndustries', variables];

export const useInfiniteListBusinessIndustriesQuery = <
      TData = InfiniteData<ListBusinessIndustriesQuery>,
      TError = unknown
    >(
      variables: ListBusinessIndustriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessIndustriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessIndustriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessIndustriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessIndustries.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessIndustriesQuery, ListBusinessIndustriesQueryVariables>(ListBusinessIndustriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessIndustriesQuery.getKey = (variables: ListBusinessIndustriesQueryVariables) => ['ListBusinessIndustries.infinite', variables];

export const ListBusinessPendingDocumentsToUploadDocument = `
    query ListBusinessPendingDocumentsToUpload($input: ListBusinessPendingDocumentsToUploadInput!) {
  listBusinessPendingDocumentsToUpload(input: $input) {
    items {
      id
      businessName
      firstName
      lastName
      registrationNumber
      advanceTaxRate
      bituahLeumiPayment
      businessExemption
      businessCertificate
      approvedAt
      businessIndustry
    }
    total
  }
}
    `;

export const useListBusinessPendingDocumentsToUploadQuery = <
      TData = ListBusinessPendingDocumentsToUploadQuery,
      TError = unknown
    >(
      variables: ListBusinessPendingDocumentsToUploadQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessPendingDocumentsToUploadQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessPendingDocumentsToUploadQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessPendingDocumentsToUploadQuery, TError, TData>(
      {
    queryKey: ['ListBusinessPendingDocumentsToUpload', variables],
    queryFn: amplifyFetcher<ListBusinessPendingDocumentsToUploadQuery, ListBusinessPendingDocumentsToUploadQueryVariables>(ListBusinessPendingDocumentsToUploadDocument, variables),
    ...options
  }
    )};

useListBusinessPendingDocumentsToUploadQuery.document = ListBusinessPendingDocumentsToUploadDocument;

useListBusinessPendingDocumentsToUploadQuery.getKey = (variables: ListBusinessPendingDocumentsToUploadQueryVariables) => ['ListBusinessPendingDocumentsToUpload', variables];

export const useInfiniteListBusinessPendingDocumentsToUploadQuery = <
      TData = InfiniteData<ListBusinessPendingDocumentsToUploadQuery>,
      TError = unknown
    >(
      variables: ListBusinessPendingDocumentsToUploadQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessPendingDocumentsToUploadQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessPendingDocumentsToUploadQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessPendingDocumentsToUploadQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessPendingDocumentsToUpload.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessPendingDocumentsToUploadQuery, ListBusinessPendingDocumentsToUploadQueryVariables>(ListBusinessPendingDocumentsToUploadDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessPendingDocumentsToUploadQuery.getKey = (variables: ListBusinessPendingDocumentsToUploadQueryVariables) => ['ListBusinessPendingDocumentsToUpload.infinite', variables];

export const ListBusinessRecentIncomeItemsDocument = `
    query ListBusinessRecentIncomeItems($input: ListBusinessRecentIncomeItemsInput!) {
  listBusinessRecentIncomeItems(input: $input) {
    items {
      description
      unitPrice
    }
  }
}
    `;

export const useListBusinessRecentIncomeItemsQuery = <
      TData = ListBusinessRecentIncomeItemsQuery,
      TError = unknown
    >(
      variables: ListBusinessRecentIncomeItemsQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessRecentIncomeItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessRecentIncomeItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessRecentIncomeItemsQuery, TError, TData>(
      {
    queryKey: ['ListBusinessRecentIncomeItems', variables],
    queryFn: amplifyFetcher<ListBusinessRecentIncomeItemsQuery, ListBusinessRecentIncomeItemsQueryVariables>(ListBusinessRecentIncomeItemsDocument, variables),
    ...options
  }
    )};

useListBusinessRecentIncomeItemsQuery.document = ListBusinessRecentIncomeItemsDocument;

useListBusinessRecentIncomeItemsQuery.getKey = (variables: ListBusinessRecentIncomeItemsQueryVariables) => ['ListBusinessRecentIncomeItems', variables];

export const useInfiniteListBusinessRecentIncomeItemsQuery = <
      TData = InfiniteData<ListBusinessRecentIncomeItemsQuery>,
      TError = unknown
    >(
      variables: ListBusinessRecentIncomeItemsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessRecentIncomeItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessRecentIncomeItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessRecentIncomeItemsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessRecentIncomeItems.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessRecentIncomeItemsQuery, ListBusinessRecentIncomeItemsQueryVariables>(ListBusinessRecentIncomeItemsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessRecentIncomeItemsQuery.getKey = (variables: ListBusinessRecentIncomeItemsQueryVariables) => ['ListBusinessRecentIncomeItems.infinite', variables];

export const ListBusinessReportsDocument = `
    query ListBusinessReports($input: ListBusinessReportsInput!) {
  listBusinessReports(input: $input) {
    items {
      id
      reportName
      reportStatus
      startDate
      endDate
      pendingApprovalExpenses
      isThereVatReportForCurrentYear
      advanceTaxRate
      sumOfIncomesIncludingVat
      advancedPaymentAmount
      sumOfVatPayment
      business {
        id
        businessName
        businessType
        registrationNumber
        isImportDocuments
        user {
          firstName
          lastName
        }
      }
      bituahLeumiPayments {
        id
        reportId
        bituahLeumiPayment
        startDate
        endDate
        bituahLeumiType
      }
    }
    total
  }
}
    `;

export const useListBusinessReportsQuery = <
      TData = ListBusinessReportsQuery,
      TError = unknown
    >(
      variables: ListBusinessReportsQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessReportsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessReportsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessReportsQuery, TError, TData>(
      {
    queryKey: ['ListBusinessReports', variables],
    queryFn: amplifyFetcher<ListBusinessReportsQuery, ListBusinessReportsQueryVariables>(ListBusinessReportsDocument, variables),
    ...options
  }
    )};

useListBusinessReportsQuery.document = ListBusinessReportsDocument;

useListBusinessReportsQuery.getKey = (variables: ListBusinessReportsQueryVariables) => ['ListBusinessReports', variables];

export const useInfiniteListBusinessReportsQuery = <
      TData = InfiniteData<ListBusinessReportsQuery>,
      TError = unknown
    >(
      variables: ListBusinessReportsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessReportsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessReportsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessReportsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessReports.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessReportsQuery, ListBusinessReportsQueryVariables>(ListBusinessReportsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessReportsQuery.getKey = (variables: ListBusinessReportsQueryVariables) => ['ListBusinessReports.infinite', variables];

export const ListBusinessReportsCompleteDocument = `
    query ListBusinessReportsComplete($input: ListBusinessReportsInput!) {
  listBusinessReports(input: $input) {
    items {
      id
      reportName
      reportStatus
      startDate
      endDate
      pendingApprovalExpenses
      business {
        id
      }
    }
  }
}
    `;

export const useListBusinessReportsCompleteQuery = <
      TData = ListBusinessReportsCompleteQuery,
      TError = unknown
    >(
      variables: ListBusinessReportsCompleteQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessReportsCompleteQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessReportsCompleteQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessReportsCompleteQuery, TError, TData>(
      {
    queryKey: ['ListBusinessReportsComplete', variables],
    queryFn: amplifyFetcher<ListBusinessReportsCompleteQuery, ListBusinessReportsCompleteQueryVariables>(ListBusinessReportsCompleteDocument, variables),
    ...options
  }
    )};

useListBusinessReportsCompleteQuery.document = ListBusinessReportsCompleteDocument;

useListBusinessReportsCompleteQuery.getKey = (variables: ListBusinessReportsCompleteQueryVariables) => ['ListBusinessReportsComplete', variables];

export const useInfiniteListBusinessReportsCompleteQuery = <
      TData = InfiniteData<ListBusinessReportsCompleteQuery>,
      TError = unknown
    >(
      variables: ListBusinessReportsCompleteQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessReportsCompleteQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessReportsCompleteQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessReportsCompleteQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessReportsComplete.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessReportsCompleteQuery, ListBusinessReportsCompleteQueryVariables>(ListBusinessReportsCompleteDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessReportsCompleteQuery.getKey = (variables: ListBusinessReportsCompleteQueryVariables) => ['ListBusinessReportsComplete.infinite', variables];

export const ListBusinessReportsMonthlyDocument = `
    query ListBusinessReportsMonthly($input: ListBusinessReportsMonthlyInput!) {
  listBusinessReportsMonthly(input: $input) {
    items {
      businessId
      vatReportId
      startDate
      sumOfBusinessTurnover
      calculatedAdvancePayments
      advancedPaymentAmount
      sumOfPermittedExpenseDeductions
      chargeableBusinessIncome
      withheldTax
      sumOfVatInExpenses
      sumOfIncomesExemptOfVat
      sumOfIncomesWithZeroVat
      sumOfExpensesIncludingVat
      sumOfIncomesExemptOfVatOrZeroVat
      sumOfIncomesIncludingVat
      sumOfIncomesLiabledToVat
      sumOfVatAmountOnIncomes
      sumOfExpensesWithoutVat
      sumOfExpensesAfterVatDeductions
      sumOfInputsOnFixedEquipment
      sumOfInputsOnOtherExpenses
      sumOfVatPayment
      advanceTaxPercentage
      advanceTaxRate
      bituahLeumiPayments {
        id
        reportId
        bituahLeumiPayment
        startDate
        endDate
        bituahLeumiType
      }
    }
    total
  }
}
    `;

export const useListBusinessReportsMonthlyQuery = <
      TData = ListBusinessReportsMonthlyQuery,
      TError = unknown
    >(
      variables: ListBusinessReportsMonthlyQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessReportsMonthlyQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessReportsMonthlyQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessReportsMonthlyQuery, TError, TData>(
      {
    queryKey: ['ListBusinessReportsMonthly', variables],
    queryFn: amplifyFetcher<ListBusinessReportsMonthlyQuery, ListBusinessReportsMonthlyQueryVariables>(ListBusinessReportsMonthlyDocument, variables),
    ...options
  }
    )};

useListBusinessReportsMonthlyQuery.document = ListBusinessReportsMonthlyDocument;

useListBusinessReportsMonthlyQuery.getKey = (variables: ListBusinessReportsMonthlyQueryVariables) => ['ListBusinessReportsMonthly', variables];

export const useInfiniteListBusinessReportsMonthlyQuery = <
      TData = InfiniteData<ListBusinessReportsMonthlyQuery>,
      TError = unknown
    >(
      variables: ListBusinessReportsMonthlyQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessReportsMonthlyQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessReportsMonthlyQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessReportsMonthlyQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessReportsMonthly.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessReportsMonthlyQuery, ListBusinessReportsMonthlyQueryVariables>(ListBusinessReportsMonthlyDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessReportsMonthlyQuery.getKey = (variables: ListBusinessReportsMonthlyQueryVariables) => ['ListBusinessReportsMonthly.infinite', variables];

export const ListBusinessSubscriptionsDocument = `
    query ListBusinessSubscriptions($input: PaginatedListInput!) {
  listBusinessSubscriptions(input: $input) {
    items {
      id
      startDate
      endDate
      cancelled
      subscriptionPlan {
        price
        discountPercentage
        printName
      }
    }
  }
}
    `;

export const useListBusinessSubscriptionsQuery = <
      TData = ListBusinessSubscriptionsQuery,
      TError = unknown
    >(
      variables: ListBusinessSubscriptionsQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessSubscriptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessSubscriptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessSubscriptionsQuery, TError, TData>(
      {
    queryKey: ['ListBusinessSubscriptions', variables],
    queryFn: amplifyFetcher<ListBusinessSubscriptionsQuery, ListBusinessSubscriptionsQueryVariables>(ListBusinessSubscriptionsDocument, variables),
    ...options
  }
    )};

useListBusinessSubscriptionsQuery.document = ListBusinessSubscriptionsDocument;

useListBusinessSubscriptionsQuery.getKey = (variables: ListBusinessSubscriptionsQueryVariables) => ['ListBusinessSubscriptions', variables];

export const useInfiniteListBusinessSubscriptionsQuery = <
      TData = InfiniteData<ListBusinessSubscriptionsQuery>,
      TError = unknown
    >(
      variables: ListBusinessSubscriptionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessSubscriptionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessSubscriptionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessSubscriptionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessSubscriptions.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessSubscriptionsQuery, ListBusinessSubscriptionsQueryVariables>(ListBusinessSubscriptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessSubscriptionsQuery.getKey = (variables: ListBusinessSubscriptionsQueryVariables) => ['ListBusinessSubscriptions.infinite', variables];

export const ListBusinessesBaseDocument = `
    query ListBusinessesBase($input: ListBusinessesBaseInput!) {
  listBusinessesBase(input: $input) {
    items {
      id
      createdAt
      updatedAt
      userId
      businessType
      registrationNumber
      city
      streetAddress
      businessName
      businessStatus
      approvalStatus
      user {
        firstName
        lastName
        mobile
      }
    }
    total
  }
}
    `;

export const useListBusinessesBaseQuery = <
      TData = ListBusinessesBaseQuery,
      TError = unknown
    >(
      variables: ListBusinessesBaseQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessesBaseQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessesBaseQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessesBaseQuery, TError, TData>(
      {
    queryKey: ['ListBusinessesBase', variables],
    queryFn: amplifyFetcher<ListBusinessesBaseQuery, ListBusinessesBaseQueryVariables>(ListBusinessesBaseDocument, variables),
    ...options
  }
    )};

useListBusinessesBaseQuery.document = ListBusinessesBaseDocument;

useListBusinessesBaseQuery.getKey = (variables: ListBusinessesBaseQueryVariables) => ['ListBusinessesBase', variables];

export const useInfiniteListBusinessesBaseQuery = <
      TData = InfiniteData<ListBusinessesBaseQuery>,
      TError = unknown
    >(
      variables: ListBusinessesBaseQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessesBaseQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessesBaseQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessesBaseQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessesBase.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessesBaseQuery, ListBusinessesBaseQueryVariables>(ListBusinessesBaseDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessesBaseQuery.getKey = (variables: ListBusinessesBaseQueryVariables) => ['ListBusinessesBase.infinite', variables];

export const ListBusinessesCrmDocument = `
    query ListBusinessesCrm($input: ListBusinessesCrmInput!) {
  listBusinessesCrm(input: $input) {
    items {
      id
      businessName
      businessStatus
      businessType
      registrationNumber
      createdAt
      user {
        firstName
        lastName
        mobile
        email
      }
    }
    total
  }
}
    `;

export const useListBusinessesCrmQuery = <
      TData = ListBusinessesCrmQuery,
      TError = unknown
    >(
      variables: ListBusinessesCrmQueryVariables,
      options?: Omit<UseQueryOptions<ListBusinessesCrmQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListBusinessesCrmQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListBusinessesCrmQuery, TError, TData>(
      {
    queryKey: ['ListBusinessesCrm', variables],
    queryFn: amplifyFetcher<ListBusinessesCrmQuery, ListBusinessesCrmQueryVariables>(ListBusinessesCrmDocument, variables),
    ...options
  }
    )};

useListBusinessesCrmQuery.document = ListBusinessesCrmDocument;

useListBusinessesCrmQuery.getKey = (variables: ListBusinessesCrmQueryVariables) => ['ListBusinessesCrm', variables];

export const useInfiniteListBusinessesCrmQuery = <
      TData = InfiniteData<ListBusinessesCrmQuery>,
      TError = unknown
    >(
      variables: ListBusinessesCrmQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListBusinessesCrmQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListBusinessesCrmQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListBusinessesCrmQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListBusinessesCrm.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListBusinessesCrmQuery, ListBusinessesCrmQueryVariables>(ListBusinessesCrmDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListBusinessesCrmQuery.getKey = (variables: ListBusinessesCrmQueryVariables) => ['ListBusinessesCrm.infinite', variables];

export const ListCompanySubscriptionPlanDocument = `
    query ListCompanySubscriptionPlan($input: ListCompanySubscriptionPlanInput!) {
  listCompanySubscriptionPlan(input: $input) {
    items {
      id
      companyName
      referralId
      planType
      planTypeFree
      createdAt
    }
  }
}
    `;

export const useListCompanySubscriptionPlanQuery = <
      TData = ListCompanySubscriptionPlanQuery,
      TError = unknown
    >(
      variables: ListCompanySubscriptionPlanQueryVariables,
      options?: Omit<UseQueryOptions<ListCompanySubscriptionPlanQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListCompanySubscriptionPlanQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListCompanySubscriptionPlanQuery, TError, TData>(
      {
    queryKey: ['ListCompanySubscriptionPlan', variables],
    queryFn: amplifyFetcher<ListCompanySubscriptionPlanQuery, ListCompanySubscriptionPlanQueryVariables>(ListCompanySubscriptionPlanDocument, variables),
    ...options
  }
    )};

useListCompanySubscriptionPlanQuery.document = ListCompanySubscriptionPlanDocument;

useListCompanySubscriptionPlanQuery.getKey = (variables: ListCompanySubscriptionPlanQueryVariables) => ['ListCompanySubscriptionPlan', variables];

export const useInfiniteListCompanySubscriptionPlanQuery = <
      TData = InfiniteData<ListCompanySubscriptionPlanQuery>,
      TError = unknown
    >(
      variables: ListCompanySubscriptionPlanQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListCompanySubscriptionPlanQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListCompanySubscriptionPlanQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListCompanySubscriptionPlanQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListCompanySubscriptionPlan.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListCompanySubscriptionPlanQuery, ListCompanySubscriptionPlanQueryVariables>(ListCompanySubscriptionPlanDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListCompanySubscriptionPlanQuery.getKey = (variables: ListCompanySubscriptionPlanQueryVariables) => ['ListCompanySubscriptionPlan.infinite', variables];

export const ListDiscountPhoneNumbersDocument = `
    query ListDiscountPhoneNumbers($input: ListDiscountPhoneNumbersInput!) {
  listDiscountPhoneNumbers(input: $input) {
    items {
      mobile
      planType
      planTypeFree
      createdAt
    }
    total
  }
}
    `;

export const useListDiscountPhoneNumbersQuery = <
      TData = ListDiscountPhoneNumbersQuery,
      TError = unknown
    >(
      variables: ListDiscountPhoneNumbersQueryVariables,
      options?: Omit<UseQueryOptions<ListDiscountPhoneNumbersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListDiscountPhoneNumbersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListDiscountPhoneNumbersQuery, TError, TData>(
      {
    queryKey: ['ListDiscountPhoneNumbers', variables],
    queryFn: amplifyFetcher<ListDiscountPhoneNumbersQuery, ListDiscountPhoneNumbersQueryVariables>(ListDiscountPhoneNumbersDocument, variables),
    ...options
  }
    )};

useListDiscountPhoneNumbersQuery.document = ListDiscountPhoneNumbersDocument;

useListDiscountPhoneNumbersQuery.getKey = (variables: ListDiscountPhoneNumbersQueryVariables) => ['ListDiscountPhoneNumbers', variables];

export const useInfiniteListDiscountPhoneNumbersQuery = <
      TData = InfiniteData<ListDiscountPhoneNumbersQuery>,
      TError = unknown
    >(
      variables: ListDiscountPhoneNumbersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListDiscountPhoneNumbersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListDiscountPhoneNumbersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListDiscountPhoneNumbersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListDiscountPhoneNumbers.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListDiscountPhoneNumbersQuery, ListDiscountPhoneNumbersQueryVariables>(ListDiscountPhoneNumbersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListDiscountPhoneNumbersQuery.getKey = (variables: ListDiscountPhoneNumbersQueryVariables) => ['ListDiscountPhoneNumbers.infinite', variables];

export const ListOpenfrmtFilesDocument = `
    query ListOpenfrmtFiles($input: ListOpenfrmtFilesInput!) {
  listOpenfrmtFiles(input: $input) {
    name
  }
}
    `;

export const useListOpenfrmtFilesQuery = <
      TData = ListOpenfrmtFilesQuery,
      TError = unknown
    >(
      variables: ListOpenfrmtFilesQueryVariables,
      options?: Omit<UseQueryOptions<ListOpenfrmtFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListOpenfrmtFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListOpenfrmtFilesQuery, TError, TData>(
      {
    queryKey: ['ListOpenfrmtFiles', variables],
    queryFn: amplifyFetcher<ListOpenfrmtFilesQuery, ListOpenfrmtFilesQueryVariables>(ListOpenfrmtFilesDocument, variables),
    ...options
  }
    )};

useListOpenfrmtFilesQuery.document = ListOpenfrmtFilesDocument;

useListOpenfrmtFilesQuery.getKey = (variables: ListOpenfrmtFilesQueryVariables) => ['ListOpenfrmtFiles', variables];

export const useInfiniteListOpenfrmtFilesQuery = <
      TData = InfiniteData<ListOpenfrmtFilesQuery>,
      TError = unknown
    >(
      variables: ListOpenfrmtFilesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListOpenfrmtFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListOpenfrmtFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListOpenfrmtFilesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListOpenfrmtFiles.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListOpenfrmtFilesQuery, ListOpenfrmtFilesQueryVariables>(ListOpenfrmtFilesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListOpenfrmtFilesQuery.getKey = (variables: ListOpenfrmtFilesQueryVariables) => ['ListOpenfrmtFiles.infinite', variables];

export const ListPopularProvidersDocument = `
    query ListPopularProviders($input: ListPopularProvidersInput!) {
  listPopularProviders(input: $input) {
    items {
      id
      createdAt
      updatedAt
      name
      isIsraelProvider
      nickname
      registrationNumber
      source
    }
    total
  }
}
    `;

export const useListPopularProvidersQuery = <
      TData = ListPopularProvidersQuery,
      TError = unknown
    >(
      variables: ListPopularProvidersQueryVariables,
      options?: Omit<UseQueryOptions<ListPopularProvidersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListPopularProvidersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListPopularProvidersQuery, TError, TData>(
      {
    queryKey: ['ListPopularProviders', variables],
    queryFn: amplifyFetcher<ListPopularProvidersQuery, ListPopularProvidersQueryVariables>(ListPopularProvidersDocument, variables),
    ...options
  }
    )};

useListPopularProvidersQuery.document = ListPopularProvidersDocument;

useListPopularProvidersQuery.getKey = (variables: ListPopularProvidersQueryVariables) => ['ListPopularProviders', variables];

export const useInfiniteListPopularProvidersQuery = <
      TData = InfiniteData<ListPopularProvidersQuery>,
      TError = unknown
    >(
      variables: ListPopularProvidersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListPopularProvidersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListPopularProvidersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListPopularProvidersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListPopularProviders.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListPopularProvidersQuery, ListPopularProvidersQueryVariables>(ListPopularProvidersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListPopularProvidersQuery.getKey = (variables: ListPopularProvidersQueryVariables) => ['ListPopularProviders.infinite', variables];

export const ListProvidersDocument = `
    query ListProviders($input: ListProvidersInput!) {
  listProviders(input: $input) {
    items {
      id
      name
      isIsraelProvider
      nickname
      registrationNumber
    }
    total
  }
}
    `;

export const useListProvidersQuery = <
      TData = ListProvidersQuery,
      TError = unknown
    >(
      variables: ListProvidersQueryVariables,
      options?: Omit<UseQueryOptions<ListProvidersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListProvidersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListProvidersQuery, TError, TData>(
      {
    queryKey: ['ListProviders', variables],
    queryFn: amplifyFetcher<ListProvidersQuery, ListProvidersQueryVariables>(ListProvidersDocument, variables),
    ...options
  }
    )};

useListProvidersQuery.document = ListProvidersDocument;

useListProvidersQuery.getKey = (variables: ListProvidersQueryVariables) => ['ListProviders', variables];

export const useInfiniteListProvidersQuery = <
      TData = InfiniteData<ListProvidersQuery>,
      TError = unknown
    >(
      variables: ListProvidersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListProvidersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListProvidersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListProvidersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListProviders.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListProvidersQuery, ListProvidersQueryVariables>(ListProvidersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListProvidersQuery.getKey = (variables: ListProvidersQueryVariables) => ['ListProviders.infinite', variables];

export const ListStaffsDocument = `
    query ListStaffs($input: ListStaffsInput!) {
  listStaffs(input: $input) {
    items {
      id
      updatedAt
      createdAt
      type
      email
      mobile
      lastName
      firstName
      idNumber
    }
    total
  }
}
    `;

export const useListStaffsQuery = <
      TData = ListStaffsQuery,
      TError = unknown
    >(
      variables: ListStaffsQueryVariables,
      options?: Omit<UseQueryOptions<ListStaffsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListStaffsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListStaffsQuery, TError, TData>(
      {
    queryKey: ['ListStaffs', variables],
    queryFn: amplifyFetcher<ListStaffsQuery, ListStaffsQueryVariables>(ListStaffsDocument, variables),
    ...options
  }
    )};

useListStaffsQuery.document = ListStaffsDocument;

useListStaffsQuery.getKey = (variables: ListStaffsQueryVariables) => ['ListStaffs', variables];

export const useInfiniteListStaffsQuery = <
      TData = InfiniteData<ListStaffsQuery>,
      TError = unknown
    >(
      variables: ListStaffsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListStaffsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListStaffsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListStaffsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListStaffs.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListStaffsQuery, ListStaffsQueryVariables>(ListStaffsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListStaffsQuery.getKey = (variables: ListStaffsQueryVariables) => ['ListStaffs.infinite', variables];

export const ListStaffsBasicDocument = `
    query ListStaffsBasic($input: ListStaffsInput!) {
  listStaffs(input: $input) {
    items {
      id
      firstName
      lastName
    }
    total
  }
}
    `;

export const useListStaffsBasicQuery = <
      TData = ListStaffsBasicQuery,
      TError = unknown
    >(
      variables: ListStaffsBasicQueryVariables,
      options?: Omit<UseQueryOptions<ListStaffsBasicQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListStaffsBasicQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListStaffsBasicQuery, TError, TData>(
      {
    queryKey: ['ListStaffsBasic', variables],
    queryFn: amplifyFetcher<ListStaffsBasicQuery, ListStaffsBasicQueryVariables>(ListStaffsBasicDocument, variables),
    ...options
  }
    )};

useListStaffsBasicQuery.document = ListStaffsBasicDocument;

useListStaffsBasicQuery.getKey = (variables: ListStaffsBasicQueryVariables) => ['ListStaffsBasic', variables];

export const useInfiniteListStaffsBasicQuery = <
      TData = InfiniteData<ListStaffsBasicQuery>,
      TError = unknown
    >(
      variables: ListStaffsBasicQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListStaffsBasicQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListStaffsBasicQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListStaffsBasicQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListStaffsBasic.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListStaffsBasicQuery, ListStaffsBasicQueryVariables>(ListStaffsBasicDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListStaffsBasicQuery.getKey = (variables: ListStaffsBasicQueryVariables) => ['ListStaffsBasic.infinite', variables];

export const ListStaffsByParentIdDocument = `
    query ListStaffsByParentId($input: ListStaffsByParentIdInput!) {
  listStaffsByParentId(input: $input) {
    items {
      id
      updatedAt
      createdAt
      type
      email
      mobile
      lastName
      firstName
      idNumber
    }
    total
  }
}
    `;

export const useListStaffsByParentIdQuery = <
      TData = ListStaffsByParentIdQuery,
      TError = unknown
    >(
      variables: ListStaffsByParentIdQueryVariables,
      options?: Omit<UseQueryOptions<ListStaffsByParentIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListStaffsByParentIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListStaffsByParentIdQuery, TError, TData>(
      {
    queryKey: ['ListStaffsByParentId', variables],
    queryFn: amplifyFetcher<ListStaffsByParentIdQuery, ListStaffsByParentIdQueryVariables>(ListStaffsByParentIdDocument, variables),
    ...options
  }
    )};

useListStaffsByParentIdQuery.document = ListStaffsByParentIdDocument;

useListStaffsByParentIdQuery.getKey = (variables: ListStaffsByParentIdQueryVariables) => ['ListStaffsByParentId', variables];

export const useInfiniteListStaffsByParentIdQuery = <
      TData = InfiniteData<ListStaffsByParentIdQuery>,
      TError = unknown
    >(
      variables: ListStaffsByParentIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListStaffsByParentIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListStaffsByParentIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListStaffsByParentIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListStaffsByParentId.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListStaffsByParentIdQuery, ListStaffsByParentIdQueryVariables>(ListStaffsByParentIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListStaffsByParentIdQuery.getKey = (variables: ListStaffsByParentIdQueryVariables) => ['ListStaffsByParentId.infinite', variables];

export const ListTaxCategoriesDocument = `
    query ListTaxCategories($input: ListTaxCategoriesInput!) {
  listTaxCategories(input: $input) {
    items {
      taxCategoryNumber
      categoryName
      taxDeductionPercentage
      vatDeductionPercentage
      expenseCategory
    }
    total
  }
}
    `;

export const useListTaxCategoriesQuery = <
      TData = ListTaxCategoriesQuery,
      TError = unknown
    >(
      variables: ListTaxCategoriesQueryVariables,
      options?: Omit<UseQueryOptions<ListTaxCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListTaxCategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListTaxCategoriesQuery, TError, TData>(
      {
    queryKey: ['ListTaxCategories', variables],
    queryFn: amplifyFetcher<ListTaxCategoriesQuery, ListTaxCategoriesQueryVariables>(ListTaxCategoriesDocument, variables),
    ...options
  }
    )};

useListTaxCategoriesQuery.document = ListTaxCategoriesDocument;

useListTaxCategoriesQuery.getKey = (variables: ListTaxCategoriesQueryVariables) => ['ListTaxCategories', variables];

export const useInfiniteListTaxCategoriesQuery = <
      TData = InfiniteData<ListTaxCategoriesQuery>,
      TError = unknown
    >(
      variables: ListTaxCategoriesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListTaxCategoriesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListTaxCategoriesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListTaxCategoriesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListTaxCategories.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListTaxCategoriesQuery, ListTaxCategoriesQueryVariables>(ListTaxCategoriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListTaxCategoriesQuery.getKey = (variables: ListTaxCategoriesQueryVariables) => ['ListTaxCategories.infinite', variables];

export const ListUserNotesDocument = `
    query ListUserNotes($input: ListUserNotesInput!) {
  listUserNotes(input: $input) {
    items {
      id
      userId
      note
      createdBy
      completed
      noteType
      createdAt
      updatedAt
      handledBy
    }
    total
  }
}
    `;

export const useListUserNotesQuery = <
      TData = ListUserNotesQuery,
      TError = unknown
    >(
      variables: ListUserNotesQueryVariables,
      options?: Omit<UseQueryOptions<ListUserNotesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListUserNotesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListUserNotesQuery, TError, TData>(
      {
    queryKey: ['ListUserNotes', variables],
    queryFn: amplifyFetcher<ListUserNotesQuery, ListUserNotesQueryVariables>(ListUserNotesDocument, variables),
    ...options
  }
    )};

useListUserNotesQuery.document = ListUserNotesDocument;

useListUserNotesQuery.getKey = (variables: ListUserNotesQueryVariables) => ['ListUserNotes', variables];

export const useInfiniteListUserNotesQuery = <
      TData = InfiniteData<ListUserNotesQuery>,
      TError = unknown
    >(
      variables: ListUserNotesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ListUserNotesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ListUserNotesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ListUserNotesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ListUserNotes.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<ListUserNotesQuery, ListUserNotesQueryVariables>(ListUserNotesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteListUserNotesQuery.getKey = (variables: ListUserNotesQueryVariables) => ['ListUserNotes.infinite', variables];

export const SearchCustomersDocument = `
    query SearchCustomers($input: GetBusinessInput!) {
  getBusiness(input: $input) {
    customers {
      id
      customerName
      phone
      registrationNumber
      address
      email
      bankName
      bankBranch
      bankAccount
    }
  }
}
    `;

export const useSearchCustomersQuery = <
      TData = SearchCustomersQuery,
      TError = unknown
    >(
      variables: SearchCustomersQueryVariables,
      options?: Omit<UseQueryOptions<SearchCustomersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchCustomersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchCustomersQuery, TError, TData>(
      {
    queryKey: ['SearchCustomers', variables],
    queryFn: amplifyFetcher<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, variables),
    ...options
  }
    )};

useSearchCustomersQuery.document = SearchCustomersDocument;

useSearchCustomersQuery.getKey = (variables: SearchCustomersQueryVariables) => ['SearchCustomers', variables];

export const useInfiniteSearchCustomersQuery = <
      TData = InfiniteData<SearchCustomersQuery>,
      TError = unknown
    >(
      variables: SearchCustomersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchCustomersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchCustomersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<SearchCustomersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SearchCustomers.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchCustomersQuery.getKey = (variables: SearchCustomersQueryVariables) => ['SearchCustomers.infinite', variables];

export const AnnualReportGetAnnualReportBoDocument = `
    query AnnualReportGetAnnualReportBo($input: AnnualReportGetOneInput!) {
  annualReportGetAnnualReportBo(input: $input) {
    id
    businessId
    year
    formMobile
    formBo
    status
    comment
    lockedBy
    lockedAt
    lastBusinessInteractionAt
    fieldsFilesMap {
      formFieldPath
      fileNames
    }
  }
}
    `;

export const useAnnualReportGetAnnualReportBoQuery = <
      TData = AnnualReportGetAnnualReportBoQuery,
      TError = unknown
    >(
      variables: AnnualReportGetAnnualReportBoQueryVariables,
      options?: Omit<UseQueryOptions<AnnualReportGetAnnualReportBoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnualReportGetAnnualReportBoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnualReportGetAnnualReportBoQuery, TError, TData>(
      {
    queryKey: ['AnnualReportGetAnnualReportBo', variables],
    queryFn: amplifyFetcher<AnnualReportGetAnnualReportBoQuery, AnnualReportGetAnnualReportBoQueryVariables>(AnnualReportGetAnnualReportBoDocument, variables),
    ...options
  }
    )};

useAnnualReportGetAnnualReportBoQuery.document = AnnualReportGetAnnualReportBoDocument;

useAnnualReportGetAnnualReportBoQuery.getKey = (variables: AnnualReportGetAnnualReportBoQueryVariables) => ['AnnualReportGetAnnualReportBo', variables];

export const useInfiniteAnnualReportGetAnnualReportBoQuery = <
      TData = InfiniteData<AnnualReportGetAnnualReportBoQuery>,
      TError = unknown
    >(
      variables: AnnualReportGetAnnualReportBoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnnualReportGetAnnualReportBoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnnualReportGetAnnualReportBoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<AnnualReportGetAnnualReportBoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnnualReportGetAnnualReportBo.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<AnnualReportGetAnnualReportBoQuery, AnnualReportGetAnnualReportBoQueryVariables>(AnnualReportGetAnnualReportBoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteAnnualReportGetAnnualReportBoQuery.getKey = (variables: AnnualReportGetAnnualReportBoQueryVariables) => ['AnnualReportGetAnnualReportBo.infinite', variables];

export const AnnualReportGetFieldFileContentsBoDocument = `
    query AnnualReportGetFieldFileContentsBo($input: AnnualReportSpecificFieldFileMobileInput!) {
  annualReportGetFieldFileContentsBo(input: $input) {
    base64FileContents
  }
}
    `;

export const useAnnualReportGetFieldFileContentsBoQuery = <
      TData = AnnualReportGetFieldFileContentsBoQuery,
      TError = unknown
    >(
      variables: AnnualReportGetFieldFileContentsBoQueryVariables,
      options?: Omit<UseQueryOptions<AnnualReportGetFieldFileContentsBoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnualReportGetFieldFileContentsBoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnualReportGetFieldFileContentsBoQuery, TError, TData>(
      {
    queryKey: ['AnnualReportGetFieldFileContentsBo', variables],
    queryFn: amplifyFetcher<AnnualReportGetFieldFileContentsBoQuery, AnnualReportGetFieldFileContentsBoQueryVariables>(AnnualReportGetFieldFileContentsBoDocument, variables),
    ...options
  }
    )};

useAnnualReportGetFieldFileContentsBoQuery.document = AnnualReportGetFieldFileContentsBoDocument;

useAnnualReportGetFieldFileContentsBoQuery.getKey = (variables: AnnualReportGetFieldFileContentsBoQueryVariables) => ['AnnualReportGetFieldFileContentsBo', variables];

export const useInfiniteAnnualReportGetFieldFileContentsBoQuery = <
      TData = InfiniteData<AnnualReportGetFieldFileContentsBoQuery>,
      TError = unknown
    >(
      variables: AnnualReportGetFieldFileContentsBoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnnualReportGetFieldFileContentsBoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnnualReportGetFieldFileContentsBoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<AnnualReportGetFieldFileContentsBoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnnualReportGetFieldFileContentsBo.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<AnnualReportGetFieldFileContentsBoQuery, AnnualReportGetFieldFileContentsBoQueryVariables>(AnnualReportGetFieldFileContentsBoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteAnnualReportGetFieldFileContentsBoQuery.getKey = (variables: AnnualReportGetFieldFileContentsBoQueryVariables) => ['AnnualReportGetFieldFileContentsBo.infinite', variables];

export const AnnualReportListAnnualReportsBoDocument = `
    query AnnualReportListAnnualReportsBo($input: AnnualReportListBoInput!) {
  annualReportListAnnualReportsBo(input: $input) {
    items {
      id
      businessId
      year
      status
      lastBusinessInteractionAt
    }
    nextToken
  }
}
    `;

export const useAnnualReportListAnnualReportsBoQuery = <
      TData = AnnualReportListAnnualReportsBoQuery,
      TError = unknown
    >(
      variables: AnnualReportListAnnualReportsBoQueryVariables,
      options?: Omit<UseQueryOptions<AnnualReportListAnnualReportsBoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnualReportListAnnualReportsBoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnualReportListAnnualReportsBoQuery, TError, TData>(
      {
    queryKey: ['AnnualReportListAnnualReportsBo', variables],
    queryFn: amplifyFetcher<AnnualReportListAnnualReportsBoQuery, AnnualReportListAnnualReportsBoQueryVariables>(AnnualReportListAnnualReportsBoDocument, variables),
    ...options
  }
    )};

useAnnualReportListAnnualReportsBoQuery.document = AnnualReportListAnnualReportsBoDocument;

useAnnualReportListAnnualReportsBoQuery.getKey = (variables: AnnualReportListAnnualReportsBoQueryVariables) => ['AnnualReportListAnnualReportsBo', variables];

export const useInfiniteAnnualReportListAnnualReportsBoQuery = <
      TData = InfiniteData<AnnualReportListAnnualReportsBoQuery>,
      TError = unknown
    >(
      variables: AnnualReportListAnnualReportsBoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnnualReportListAnnualReportsBoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnnualReportListAnnualReportsBoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<AnnualReportListAnnualReportsBoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnnualReportListAnnualReportsBo.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<AnnualReportListAnnualReportsBoQuery, AnnualReportListAnnualReportsBoQueryVariables>(AnnualReportListAnnualReportsBoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteAnnualReportListAnnualReportsBoQuery.getKey = (variables: AnnualReportListAnnualReportsBoQueryVariables) => ['AnnualReportListAnnualReportsBo.infinite', variables];

export const GetDinVeHeshbonDataBoDocument = `
    query GetDinVeHeshbonDataBO($input: GetDinVeHeshbonDataInput!) {
  getDinVeHeshbonDataBO(input: $input) {
    data {
      firstName
      lastName
      idNumber
      mobilePhoneNumber
      businessCity
      businessStreetAddress
      familyStatus
      familyStatusSinceDate
      partnerFirstName
      partnerLastName
      partnerIdNumber
      city
      streetAddress
      addressNumber
      apartmentNumber
      bankName
      bankBranchName
      bankBranchNumber
      bankAccountNumber
      occupationsLastTwoYears {
        occupation
        fromDate
        isCurrentlyWorkingInThisJob
        upToDate
      }
      sourceOfIncomes {
        incomeSource
        incomeNis
      }
      selfEmployedStart {
        dateOfStarting
        averageWorkingHours
        averageIncomeNis
      }
      isApproveMessages
    }
  }
}
    `;

export const useGetDinVeHeshbonDataBoQuery = <
      TData = GetDinVeHeshbonDataBoQuery,
      TError = unknown
    >(
      variables: GetDinVeHeshbonDataBoQueryVariables,
      options?: Omit<UseQueryOptions<GetDinVeHeshbonDataBoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetDinVeHeshbonDataBoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetDinVeHeshbonDataBoQuery, TError, TData>(
      {
    queryKey: ['GetDinVeHeshbonDataBO', variables],
    queryFn: amplifyFetcher<GetDinVeHeshbonDataBoQuery, GetDinVeHeshbonDataBoQueryVariables>(GetDinVeHeshbonDataBoDocument, variables),
    ...options
  }
    )};

useGetDinVeHeshbonDataBoQuery.document = GetDinVeHeshbonDataBoDocument;

useGetDinVeHeshbonDataBoQuery.getKey = (variables: GetDinVeHeshbonDataBoQueryVariables) => ['GetDinVeHeshbonDataBO', variables];

export const useInfiniteGetDinVeHeshbonDataBoQuery = <
      TData = InfiniteData<GetDinVeHeshbonDataBoQuery>,
      TError = unknown
    >(
      variables: GetDinVeHeshbonDataBoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetDinVeHeshbonDataBoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetDinVeHeshbonDataBoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetDinVeHeshbonDataBoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetDinVeHeshbonDataBO.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetDinVeHeshbonDataBoQuery, GetDinVeHeshbonDataBoQueryVariables>(GetDinVeHeshbonDataBoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetDinVeHeshbonDataBoQuery.getKey = (variables: GetDinVeHeshbonDataBoQueryVariables) => ['GetDinVeHeshbonDataBO.infinite', variables];

export const GetListYearsForBusinessBoDocument = `
    query GetListYearsForBusinessBo($input: GetListYearsForBusinessInput!) {
  getListYearsForBusinessBo(input: $input) {
    years
  }
}
    `;

export const useGetListYearsForBusinessBoQuery = <
      TData = GetListYearsForBusinessBoQuery,
      TError = unknown
    >(
      variables: GetListYearsForBusinessBoQueryVariables,
      options?: Omit<UseQueryOptions<GetListYearsForBusinessBoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetListYearsForBusinessBoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetListYearsForBusinessBoQuery, TError, TData>(
      {
    queryKey: ['GetListYearsForBusinessBo', variables],
    queryFn: amplifyFetcher<GetListYearsForBusinessBoQuery, GetListYearsForBusinessBoQueryVariables>(GetListYearsForBusinessBoDocument, variables),
    ...options
  }
    )};

useGetListYearsForBusinessBoQuery.document = GetListYearsForBusinessBoDocument;

useGetListYearsForBusinessBoQuery.getKey = (variables: GetListYearsForBusinessBoQueryVariables) => ['GetListYearsForBusinessBo', variables];

export const useInfiniteGetListYearsForBusinessBoQuery = <
      TData = InfiniteData<GetListYearsForBusinessBoQuery>,
      TError = unknown
    >(
      variables: GetListYearsForBusinessBoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetListYearsForBusinessBoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetListYearsForBusinessBoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetListYearsForBusinessBoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetListYearsForBusinessBo.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetListYearsForBusinessBoQuery, GetListYearsForBusinessBoQueryVariables>(GetListYearsForBusinessBoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetListYearsForBusinessBoQuery.getKey = (variables: GetListYearsForBusinessBoQueryVariables) => ['GetListYearsForBusinessBo.infinite', variables];

export const AnnualReportGetAnnualReportMobileDocument = `
    query AnnualReportGetAnnualReportMobile($input: AnnualReportGetOneInput!) {
  annualReportGetAnnualReportMobile(input: $input) {
    id
    businessId
    year
    formMobile
    status
    comment
    lockedBy
    lockedAt
    lastBusinessInteractionAt
    fieldsFilesMap {
      formFieldPath
      fileNames
    }
  }
}
    `;

export const useAnnualReportGetAnnualReportMobileQuery = <
      TData = AnnualReportGetAnnualReportMobileQuery,
      TError = unknown
    >(
      variables: AnnualReportGetAnnualReportMobileQueryVariables,
      options?: Omit<UseQueryOptions<AnnualReportGetAnnualReportMobileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnualReportGetAnnualReportMobileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnualReportGetAnnualReportMobileQuery, TError, TData>(
      {
    queryKey: ['AnnualReportGetAnnualReportMobile', variables],
    queryFn: amplifyFetcher<AnnualReportGetAnnualReportMobileQuery, AnnualReportGetAnnualReportMobileQueryVariables>(AnnualReportGetAnnualReportMobileDocument, variables),
    ...options
  }
    )};

useAnnualReportGetAnnualReportMobileQuery.document = AnnualReportGetAnnualReportMobileDocument;

useAnnualReportGetAnnualReportMobileQuery.getKey = (variables: AnnualReportGetAnnualReportMobileQueryVariables) => ['AnnualReportGetAnnualReportMobile', variables];

export const useInfiniteAnnualReportGetAnnualReportMobileQuery = <
      TData = InfiniteData<AnnualReportGetAnnualReportMobileQuery>,
      TError = unknown
    >(
      variables: AnnualReportGetAnnualReportMobileQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnnualReportGetAnnualReportMobileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnnualReportGetAnnualReportMobileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<AnnualReportGetAnnualReportMobileQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnnualReportGetAnnualReportMobile.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<AnnualReportGetAnnualReportMobileQuery, AnnualReportGetAnnualReportMobileQueryVariables>(AnnualReportGetAnnualReportMobileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteAnnualReportGetAnnualReportMobileQuery.getKey = (variables: AnnualReportGetAnnualReportMobileQueryVariables) => ['AnnualReportGetAnnualReportMobile.infinite', variables];

export const AnnualReportGetFieldFileContentsMobileDocument = `
    query AnnualReportGetFieldFileContentsMobile($input: AnnualReportSpecificFieldFileMobileInput!) {
  annualReportGetFieldFileContentsMobile(input: $input) {
    base64FileContents
  }
}
    `;

export const useAnnualReportGetFieldFileContentsMobileQuery = <
      TData = AnnualReportGetFieldFileContentsMobileQuery,
      TError = unknown
    >(
      variables: AnnualReportGetFieldFileContentsMobileQueryVariables,
      options?: Omit<UseQueryOptions<AnnualReportGetFieldFileContentsMobileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnualReportGetFieldFileContentsMobileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnualReportGetFieldFileContentsMobileQuery, TError, TData>(
      {
    queryKey: ['AnnualReportGetFieldFileContentsMobile', variables],
    queryFn: amplifyFetcher<AnnualReportGetFieldFileContentsMobileQuery, AnnualReportGetFieldFileContentsMobileQueryVariables>(AnnualReportGetFieldFileContentsMobileDocument, variables),
    ...options
  }
    )};

useAnnualReportGetFieldFileContentsMobileQuery.document = AnnualReportGetFieldFileContentsMobileDocument;

useAnnualReportGetFieldFileContentsMobileQuery.getKey = (variables: AnnualReportGetFieldFileContentsMobileQueryVariables) => ['AnnualReportGetFieldFileContentsMobile', variables];

export const useInfiniteAnnualReportGetFieldFileContentsMobileQuery = <
      TData = InfiniteData<AnnualReportGetFieldFileContentsMobileQuery>,
      TError = unknown
    >(
      variables: AnnualReportGetFieldFileContentsMobileQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnnualReportGetFieldFileContentsMobileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnnualReportGetFieldFileContentsMobileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<AnnualReportGetFieldFileContentsMobileQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnnualReportGetFieldFileContentsMobile.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<AnnualReportGetFieldFileContentsMobileQuery, AnnualReportGetFieldFileContentsMobileQueryVariables>(AnnualReportGetFieldFileContentsMobileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteAnnualReportGetFieldFileContentsMobileQuery.getKey = (variables: AnnualReportGetFieldFileContentsMobileQueryVariables) => ['AnnualReportGetFieldFileContentsMobile.infinite', variables];

export const AnnualReportListAnnualReportsMobileDocument = `
    query AnnualReportListAnnualReportsMobile($input: AnnualReportListMobileInput!) {
  annualReportListAnnualReportsMobile(input: $input) {
    items {
      id
      businessId
      year
      status
      lastBusinessInteractionAt
    }
  }
}
    `;

export const useAnnualReportListAnnualReportsMobileQuery = <
      TData = AnnualReportListAnnualReportsMobileQuery,
      TError = unknown
    >(
      variables: AnnualReportListAnnualReportsMobileQueryVariables,
      options?: Omit<UseQueryOptions<AnnualReportListAnnualReportsMobileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<AnnualReportListAnnualReportsMobileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<AnnualReportListAnnualReportsMobileQuery, TError, TData>(
      {
    queryKey: ['AnnualReportListAnnualReportsMobile', variables],
    queryFn: amplifyFetcher<AnnualReportListAnnualReportsMobileQuery, AnnualReportListAnnualReportsMobileQueryVariables>(AnnualReportListAnnualReportsMobileDocument, variables),
    ...options
  }
    )};

useAnnualReportListAnnualReportsMobileQuery.document = AnnualReportListAnnualReportsMobileDocument;

useAnnualReportListAnnualReportsMobileQuery.getKey = (variables: AnnualReportListAnnualReportsMobileQueryVariables) => ['AnnualReportListAnnualReportsMobile', variables];

export const useInfiniteAnnualReportListAnnualReportsMobileQuery = <
      TData = InfiniteData<AnnualReportListAnnualReportsMobileQuery>,
      TError = unknown
    >(
      variables: AnnualReportListAnnualReportsMobileQueryVariables,
      options: Omit<UseInfiniteQueryOptions<AnnualReportListAnnualReportsMobileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<AnnualReportListAnnualReportsMobileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<AnnualReportListAnnualReportsMobileQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['AnnualReportListAnnualReportsMobile.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<AnnualReportListAnnualReportsMobileQuery, AnnualReportListAnnualReportsMobileQueryVariables>(AnnualReportListAnnualReportsMobileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteAnnualReportListAnnualReportsMobileQuery.getKey = (variables: AnnualReportListAnnualReportsMobileQueryVariables) => ['AnnualReportListAnnualReportsMobile.infinite', variables];

export const GetCurrentBusinessMobileDocument = `
    query GetCurrentBusinessMobile($input1: GetBusinessInput!, $input2: GetListYearsForBusinessInput!) {
  getBusiness(input: $input1) {
    businessName
    businessType
    reportType
    businessStatus
    approvalStatus
    representationRequestNumber
    referralId
    registrationNumber
  }
  getListYearsForBusinessMobile(input: $input2) {
    years
  }
}
    `;

export const useGetCurrentBusinessMobileQuery = <
      TData = GetCurrentBusinessMobileQuery,
      TError = unknown
    >(
      variables: GetCurrentBusinessMobileQueryVariables,
      options?: Omit<UseQueryOptions<GetCurrentBusinessMobileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCurrentBusinessMobileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCurrentBusinessMobileQuery, TError, TData>(
      {
    queryKey: ['GetCurrentBusinessMobile', variables],
    queryFn: amplifyFetcher<GetCurrentBusinessMobileQuery, GetCurrentBusinessMobileQueryVariables>(GetCurrentBusinessMobileDocument, variables),
    ...options
  }
    )};

useGetCurrentBusinessMobileQuery.document = GetCurrentBusinessMobileDocument;

useGetCurrentBusinessMobileQuery.getKey = (variables: GetCurrentBusinessMobileQueryVariables) => ['GetCurrentBusinessMobile', variables];

export const useInfiniteGetCurrentBusinessMobileQuery = <
      TData = InfiniteData<GetCurrentBusinessMobileQuery>,
      TError = unknown
    >(
      variables: GetCurrentBusinessMobileQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCurrentBusinessMobileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCurrentBusinessMobileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetCurrentBusinessMobileQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetCurrentBusinessMobile.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetCurrentBusinessMobileQuery, GetCurrentBusinessMobileQueryVariables>(GetCurrentBusinessMobileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCurrentBusinessMobileQuery.getKey = (variables: GetCurrentBusinessMobileQueryVariables) => ['GetCurrentBusinessMobile.infinite', variables];

export const GetDinVeHeshbonDataMobileDocument = `
    query GetDinVeHeshbonDataMobile($input: GetDinVeHeshbonDataInput!) {
  getDinVeHeshbonDataMobile(input: $input) {
    data {
      firstName
      lastName
      idNumber
      mobilePhoneNumber
      businessCity
      businessStreetAddress
      familyStatus
      familyStatusSinceDate
      partnerFirstName
      partnerLastName
      partnerIdNumber
      city
      streetAddress
      addressNumber
      apartmentNumber
      bankName
      bankBranchName
      bankBranchNumber
      bankAccountNumber
      occupationsLastTwoYears {
        occupation
        fromDate
        isCurrentlyWorkingInThisJob
        upToDate
      }
      sourceOfIncomes {
        incomeSource
        incomeNis
      }
      selfEmployedStart {
        dateOfStarting
        averageWorkingHours
        averageIncomeNis
      }
      isApproveMessages
    }
  }
}
    `;

export const useGetDinVeHeshbonDataMobileQuery = <
      TData = GetDinVeHeshbonDataMobileQuery,
      TError = unknown
    >(
      variables: GetDinVeHeshbonDataMobileQueryVariables,
      options?: Omit<UseQueryOptions<GetDinVeHeshbonDataMobileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetDinVeHeshbonDataMobileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetDinVeHeshbonDataMobileQuery, TError, TData>(
      {
    queryKey: ['GetDinVeHeshbonDataMobile', variables],
    queryFn: amplifyFetcher<GetDinVeHeshbonDataMobileQuery, GetDinVeHeshbonDataMobileQueryVariables>(GetDinVeHeshbonDataMobileDocument, variables),
    ...options
  }
    )};

useGetDinVeHeshbonDataMobileQuery.document = GetDinVeHeshbonDataMobileDocument;

useGetDinVeHeshbonDataMobileQuery.getKey = (variables: GetDinVeHeshbonDataMobileQueryVariables) => ['GetDinVeHeshbonDataMobile', variables];

export const useInfiniteGetDinVeHeshbonDataMobileQuery = <
      TData = InfiniteData<GetDinVeHeshbonDataMobileQuery>,
      TError = unknown
    >(
      variables: GetDinVeHeshbonDataMobileQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetDinVeHeshbonDataMobileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetDinVeHeshbonDataMobileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetDinVeHeshbonDataMobileQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetDinVeHeshbonDataMobile.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetDinVeHeshbonDataMobileQuery, GetDinVeHeshbonDataMobileQueryVariables>(GetDinVeHeshbonDataMobileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetDinVeHeshbonDataMobileQuery.getKey = (variables: GetDinVeHeshbonDataMobileQueryVariables) => ['GetDinVeHeshbonDataMobile.infinite', variables];

export const GetListYearsForBusinessMobileDocument = `
    query GetListYearsForBusinessMobile($input: GetListYearsForBusinessInput!) {
  getListYearsForBusinessMobile(input: $input) {
    years
  }
}
    `;

export const useGetListYearsForBusinessMobileQuery = <
      TData = GetListYearsForBusinessMobileQuery,
      TError = unknown
    >(
      variables: GetListYearsForBusinessMobileQueryVariables,
      options?: Omit<UseQueryOptions<GetListYearsForBusinessMobileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetListYearsForBusinessMobileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetListYearsForBusinessMobileQuery, TError, TData>(
      {
    queryKey: ['GetListYearsForBusinessMobile', variables],
    queryFn: amplifyFetcher<GetListYearsForBusinessMobileQuery, GetListYearsForBusinessMobileQueryVariables>(GetListYearsForBusinessMobileDocument, variables),
    ...options
  }
    )};

useGetListYearsForBusinessMobileQuery.document = GetListYearsForBusinessMobileDocument;

useGetListYearsForBusinessMobileQuery.getKey = (variables: GetListYearsForBusinessMobileQueryVariables) => ['GetListYearsForBusinessMobile', variables];

export const useInfiniteGetListYearsForBusinessMobileQuery = <
      TData = InfiniteData<GetListYearsForBusinessMobileQuery>,
      TError = unknown
    >(
      variables: GetListYearsForBusinessMobileQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetListYearsForBusinessMobileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetListYearsForBusinessMobileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<GetListYearsForBusinessMobileQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetListYearsForBusinessMobile.infinite', variables],
      queryFn: (metaData) => amplifyFetcher<GetListYearsForBusinessMobileQuery, GetListYearsForBusinessMobileQueryVariables>(GetListYearsForBusinessMobileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteGetListYearsForBusinessMobileQuery.getKey = (variables: GetListYearsForBusinessMobileQueryVariables) => ['GetListYearsForBusinessMobile.infinite', variables];
